<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C2" :fill="fill">
      <path
        class="st3"
        d="M301.4,117.1c-0.1,0.9,0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8c0.1,0,0.1,0.1,0.2,0.2l0,0v-2.9V118v-4
		c-1,0.3-2,0.6-3,0.9C302.1,115.4,301.5,116.1,301.4,117.1z"
      />
      <path
        class="st3"
        d="M228.5,143.8L228.5,143.8C228.5,143.8,228.6,143.8,228.5,143.8L228.5,143.8L228.5,143.8
		C228.5,143.8,228.5,143.9,228.5,143.8C228.5,143.9,228.5,143.8,228.5,143.8z"
      />
      <path
        class="st3"
        d="M250.2,139.8C250.2,139.8,250.2,139.7,250.2,139.8C250.1,139.7,250.1,139.7,250.2,139.8L250.2,139.8z"
      />
      <path
        class="st3"
        d="M103.7,301.5c-0.7,0.4-1.2,0.6-1.7,0.9c-0.9,0.7-1.7,1.4-2.6,2.1c-0.6,0.5-0.4,1.2,0.3,1.3
		c0.9,0.1,1.4,0.6,2,1c0.5,0.4,1,0.6,1.5,0.7c0.7,0.1,1.4,0,2.2-0.2c0.3-0.1,0.6-0.2,1-0.4c0,0.6,0,1.1,0.1,1.6
		c0.3,1.4,1.8,2.3,3.4,2.2c0.3,0,0.7,0,1-0.1c1.8-0.4,3-1.8,3-3.4c0-0.1,0-0.2,0-0.4c-0.3-1.8-2.1-2.8-4.2-2.4c-0.1,0-0.1,0-0.2,0.1
		c-0.4,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.4,0.2-0.7,0.2c0.1-0.2,0.1-0.3,0.1-0.5c0.2-1.1-0.4-2-1.2-2.7c-0.1-0.1-0.3-0.2-0.4-0.2
		c-0.5-0.1-0.9-0.2-1.5-0.2c0.2-0.4,0.3-0.7,0.6-1.2c0.4,0.5,0.7,0.9,1.1,1.2c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0,0.7,0.1,1.1,0.1
		c1.2,0.1,2.2-0.3,2.9-1c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.8-0.6-1.9-0.8-3.1-0.5
		c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4c-0.2,0.5-0.6,1-0.7,1.6
		C103.3,300.5,103.6,301,103.7,301.5z"
      />
      <path
        class="st3"
        d="M86.9,321.3c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.5,0-2.2,0c-0.2-0.3-0.4-0.6-0.6-0.9
		l-0.1-0.1c-0.5-0.5-1.4-0.6-2-0.2c-0.4,0.2-0.6,0.5-0.8,0.7c-0.7,0.8-0.4,1.7,0.7,2.4c0.1,0,0.1,0.1,0.2,0.2
		c-1.3,1.2-1.3,1.2-0.5,2.5c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1c0-0.1,0-0.2,0-0.3
		c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6c0.7-0.3,0.5-0.8,0.4-1.2C87,322.2,86.9,321.8,86.9,321.3z"
      />
      <path
        class="st3"
        d="M168.8,272.1c0.5-0.1,1.1-0.1,1.6-0.3c0.6-0.3,1.2-0.6,1.8-0.8c-0.1,0-0.1,0-0.2-0.1c-0.5-0.1-1.1,0-1.6,0.1
		c-0.7,0.2-1.2,0.4-1.7,0.7C168.7,271.9,168.8,272,168.8,272.1z"
      />
      <path
        class="st3"
        d="M167.3,275.1c0.3,1.8,2.5,2.8,4.6,2.3c0.1,0,0.2-0.1,0.3-0.1c-0.3-0.3-0.5-0.6-0.8-0.9
		c-1.2-1.3-2.4-2.6-3.6-3.8C167.3,273.2,167.1,274.1,167.3,275.1z"
      />
      <path
        class="st3"
        d="M173.8,271.6c-1.2,0.6-2.5,1.1-3.7,1.7c1.1,1.2,2,2.1,2.9,3.1c0.2,0.2,0.3,0.3,0.4,0.4c1.3-0.8,2-2.2,1.7-3.5
		c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.5C174,271.7,173.9,271.7,173.8,271.6z"
      />
      <path
        class="st3"
        d="M179.7,278.4c-0.4-0.8-1.2-1.3-2.2-1.5c-0.9,0.4-1.8,0.8-2.7,1.3c0.3,0.4,0.5,0.7,0.7,0.9c1,1,1.9,2,2.9,3
		c0.7-0.5,1.2-1.1,1.4-1.8c0.1-0.4,0.1-0.8,0.1-1.2C179.9,278.8,179.9,278.6,179.7,278.4z"
      />
      <path
        class="st3"
        d="M173,279.1C173,279.1,172.9,279.1,173,279.1c-0.3,0.5-0.4,1-0.3,1.5c0.3,1.5,2.4,2.6,4.3,2.2
		c0.1,0,0.2-0.1,0.3-0.1c-0.9-1-1.8-1.9-2.8-2.9C174.2,279.4,173.4,279,173,279.1z"
      />
      <path
        class="st3"
        d="M102.1,308.4c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.4,0.2-0.8,0.5-1.1,0.7c-0.4-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.2-1.3,0
		c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6,0,1.3,0.7,1.6c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0,0.5-0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1c0.8-0.8,1.5-1.5,2.2-2.2
		c0.4,0.2,0.8,0.4,1.2,0.5c1.2,0.4,2.1,0.3,2.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1
		c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3-0.1-0.4C102.5,308.9,102.3,308.6,102.1,308.4z"
      />
      <path
        class="st3"
        d="M174.2,261.2c-0.5-0.1-1.1-0.1-1.7,0c-1.4,0.3-2.3,1.3-2.5,2.3c-0.1,0.3-0.1,0.6,0,0.9c0.2,1.1,1.1,1.8,2.3,2
		c0.5,0.1,1,0.1,1.5,0c1.3-0.3,2.3-1.2,2.6-2.3c0.1-0.3,0.1-0.7,0-1.1C176.1,262.1,175.3,261.4,174.2,261.2z"
      />
      <path
        class="st3"
        d="M148,337.3c-1.4,0.2-2.4,1.1-2.6,2.1h5.9c0-0.1,0-0.2,0-0.3C151.1,337.9,149.6,337,148,337.3z"
      />
      <path
        class="st3"
        d="M246.3,237c-1.3,0.6-2.5,1.1-3.8,1.7l0,0c0.2,0.2,0.4,0.3,0.6,0.5c1.2-0.5,2.4-1.1,3.6-1.6
		C246.6,237.3,246.4,237.1,246.3,237z"
      />
      <path
        class="st3"
        d="M250.6,237.2c-0.1,0-0.2,0-0.2,0c-1.1,0.5-2.2,1-3.3,1.5c0.1,0.4,0.3,0.7,0.6,0.9c0.2,0.1,0.5,0.2,0.8,0.3
		c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.3,1-0.5c0.1,0.3,0.1,0.5,0.1,0.7c1.1-0.2,1.8-0.4,2.2-0.7s0.5-0.8,0.4-1.6
		c-0.6-0.1-1.2-0.1-1.8-0.2C250.7,237.2,250.7,237.2,250.6,237.2z"
      />
      <path
        class="st3"
        d="M243.6,236.4c-0.7,0.2-1.3,0.6-1.9,0.8c0,0.2,0.1,0.3,0.1,0.4c1.1-0.5,2.2-1,3.3-1.4
		C244.7,236.1,244.1,236.2,243.6,236.4z"
      />
      <path
        class="st3"
        d="M232.8,294.9c0.2-0.5,0.2-1,0.1-1.4c-1.5,0.9-3,1.7-4.5,2.6c0.3,0.2,0.7,0.4,1.1,0.4
		C230.9,296.8,232.3,296.1,232.8,294.9z"
      />
      <path
        class="st3"
        d="M231.3,292.1c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6c-0.1-0.2-0.4-0.4-0.7-0.4s-0.7,0-1,0.2
		c-0.2,0.1-0.2,0.5-0.2,0.7l0,0c0.1,0.3,0.4,0.6,0.6,0.9c-0.2,0.4-0.4,0.8-0.5,1.2c-0.1,0.4,0,0.8,0.1,1.2c1.5-0.9,3-1.8,4.6-2.7
		C232,292.4,231.6,292.2,231.3,292.1z"
      />
      <path
        class="st3"
        d="M186.2,256.4c1.1,0.4,2.6,0,3.4-0.8c0.8-0.8,1-2,0.4-2.9c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9
		c-0.1,0.4-0.3,0.8-0.4,1.2C184.3,255,184.9,256,186.2,256.4z"
      />
      <path
        class="st3"
        d="M194.4,260.6c0.2-0.3,0.4-0.6,0.7-0.8c-0.4,0.2-0.9,0.4-1.3,0.6C194,260.4,194.2,260.5,194.4,260.6z"
      />
      <path
        class="st3"
        d="M194.3,257.8c-0.1-0.4-0.7-0.8-1.2-1c-0.9-0.3-1.8-0.4-2.7-0.6c-0.8-0.1-1.5,0.1-2,0.7
		c-0.6,0.6-0.5,1.3-0.2,1.9c0.3,0.5,1,0.7,1.9,0.5c0.4-0.1,0.8-0.2,1.3-0.3c0.2,0.3,0.3,0.5,0.5,0.8c1-0.4,2-0.9,3-1.3
		C194.6,258.4,194.4,258.2,194.3,257.8z"
      />
      <path
        class="st3"
        d="M225.9,294.5c-0.2-0.1-0.5-0.3-0.7-0.3c-0.5-0.1-1-0.2-1.5-0.3c0.2-0.7,0.3-1.2,0-1.7
		c-0.2-0.4-0.5-0.8-1.1-1.1c-0.4,0.4-0.6,0.8-0.6,1.1c-0.1,0.7,0.5,1.3,0.9,1.9c-0.4,0.4-0.8,0.7-1.1,1.1c0.3,0.9,0.9,1.5,1.5,2
		c0.1,0.1,0.3,0.2,0.4,0.3c1-0.6,2.1-1.2,3.1-1.8C226.7,295.2,226.4,294.8,225.9,294.5z"
      />
      <path
        class="st3"
        d="M224.9,298.4C224.9,298.4,225,298.4,224.9,298.4c0.9,0.2,1.4-0.3,1.7-0.8c0.1-0.1,0.1-0.2,0.2-0.4v-0.1
		c-0.7,0.4-1.4,0.8-2.1,1.2C224.8,298.3,224.9,298.3,224.9,298.4z"
      />
      <path
        class="st3"
        d="M91.4,307.2c0,0.3,0.2,0.6,0.3,0.9c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6
		c0.2-0.4,0.2-0.7,0.2-1.1c-0.2-1.2-1.6-2-3.1-1.7C92.2,304.8,91.2,305.9,91.4,307.2z"
      />
      <path
        class="st3"
        d="M183.4,266c1.6-0.7,3.1-1.4,4.7-2.1c0,0,0,0,0-0.1c-0.1-0.3-0.3-0.5-0.5-0.7c-1.6,0.7-3.1,1.4-4.7,2.1
		C183,265.5,183.1,265.7,183.4,266z"
      />
      <path
        class="st3"
        d="M184.7,266.7c0.9,0.2,1.7,0,2.6-0.7c0.5-0.4,1-0.7,1.7-1.2C187.5,265.4,186.1,266.1,184.7,266.7z"
      />
      <path
        class="st3"
        d="M183.1,263.9c1.1-0.5,2.2-1,3.3-1.5c-0.3-0.1-0.7-0.1-1-0.1C184.4,262.4,183.4,263.1,183.1,263.9z"
      />
      <path
        class="st3"
        d="M90.1,299.9c0.3,0.3,0.6,0.5,1,0.6c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1
		c0.7-0.8,0.8-2,0.2-2.7l0,0c-0.6-0.8-1.9-1-3.1-0.6c-0.5,0.2-1,0.4-1.4,0.7c-0.1,0.4-0.3,0.8-0.4,1.1
		C89.5,298.8,89.7,299.4,90.1,299.9z"
      />
      <path
        class="st3"
        d="M1.2,311c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1c0.1-0.4,0.2-0.7,0.1-1.1c0-0.1-0.1-0.3-0.1-0.4
		c-0.3-0.6-0.8-1-1.4-1.1v1.1v1.5v0.8v0.7c0.1-0.1,0.3-0.1,0.4-0.2C0.7,311.5,1,311.3,1.2,311z"
      />
      <path
        class="st3"
        d="M85.7,312.4c-0.1,0-0.2,0-0.4,0c-0.3,0.1-0.6,0.2-1,0.4c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5
		c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9c0.7,0.3,1.3,0.1,2.3-0.5C86.6,314.6,86.2,313.5,85.7,312.4z"
      />
      <path
        class="st3"
        d="M90.7,314.2c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3c-0.3-0.6-0.6-1.1-0.9-1.3c0.5,1,0.9,2.1,1.4,3.1
		c0.7,0.4,1.2,0.4,1.7,0C90.9,315.5,91.1,314.8,90.7,314.2z"
      />
      <path
        class="st3"
        d="M273.6,247.1c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5c-0.2-1.2-1.6-2-3-1.7c-0.1,0-0.1,0-0.1,0
		c-1.2,0.3-2.1,1.3-2,2.4c0,0.1,0,0.1,0,0.2c0.1,0.9,1,1.6,2,1.7c0.3,0,0.7,0,1,0c0.2,0,0.5-0.1,0.7-0.2
		C272.9,248.2,273.4,247.7,273.6,247.1z"
      />
      <path
        class="st3"
        d="M4.5,310.9c-0.4,0.1-0.8,0.3-1.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.6,0.7-0.7,1.2
		c-0.1,0.2-0.1,0.5,0,0.7c0,0.1,0,0.1,0.1,0.2c0.2,0.8,1,1.3,2,1.4c0.3,0,0.6,0,0.9,0c0.5-0.1,0.9-0.3,1.2-0.5
		c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.4,0.7-1,0.6-1.5c0-0.1,0-0.2,0-0.3C7.2,311.3,5.9,310.6,4.5,310.9z"
      />
      <path
        class="st3"
        d="M88.4,294.6c-0.4-1.1-2.4-1.5-3.5-0.7c-0.4,0.3-0.8,0.9-0.8,1.5c0,0.1,0,0.2,0,0.2c0,0.1,0,0.3,0.1,0.4
		c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.6,0.3,0.9,0.3c0.2,0,0.4,0,0.6,0l0,0c0.3,0,0.6,0,0.8,0.1
		c1,0.4,1.8,0.2,2.7-0.3c0.1-0.2,0.2-0.4,0.3-0.7c-0.6-0.2-1.1-0.3-1.6-0.4C88.6,295.4,88.5,295,88.4,294.6z"
      />
      <path
        class="st3"
        d="M90,297L90,297L90,297C89.9,297,89.9,297.1,90,297C90,297.1,90,297.1,90,297z"
      />
      <path
        class="st3"
        d="M249.4,264.9c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C248.8,265.6,249.1,265.3,249.4,264.9z"
      />
      <path
        class="st3"
        d="M207.3,269c-0.5-0.7-0.1-1.2,0.2-1.8c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9
		c-0.9,0.1-1.4,0.6-2,1.2c0.2,0.5,0.3,0.9,0.5,1.3s0.4,0.8,0.7,1.2c0.2,0.3,0.6,0.5,0.9,0.5C206.1,270.6,207.6,269.4,207.3,269z"
      />
      <path
        class="st3"
        d="M108,311.7c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3c0.3,1.1,1.5,1.6,2.8,1.3
		c1.2-0.3,1.9-1.3,1.7-2.3C108.2,312.2,108.1,311.9,108,311.7z"
      />
      <path
        class="st3"
        d="M249.4,282.5c0.9-0.5,1.8-1,2.7-1.6c0.2-0.4,0.2-0.8,0.1-1.2c-0.1-0.4-0.4-0.7-0.9-0.9
		c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7C248.3,282.8,248.8,282.7,249.4,282.5z"
      />
      <path
        class="st3"
        d="M10.3,306c-0.4-0.2-1-0.3-1.5-0.2c-1.3,0.2-2.1,1.3-1.9,2.4c0.2,1,1.3,1.6,2.5,1.3c0.6-0.1,1.2-0.4,1.5-0.8
		s0.5-0.9,0.4-1.4C11.3,306.8,10.9,306.3,10.3,306z"
      />
      <path
        class="st3"
        d="M278.5,267c-0.9,0.5-1.7,1-2.6,1.5c0.5,0,0.9,0,1.3,0s0.7,0,1.1,0c0.2,0,0.5,0,0.7,0
		C278.9,267.8,278.7,267.4,278.5,267z"
      />
      <path
        class="st3"
        d="M277.3,266c-0.1,0-0.3-0.1-0.4-0.1c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9
		c0.1,0,0.2,0,0.3,0c1.4-0.8,2.8-1.6,4.2-2.4C277.4,266.1,277.4,266,277.3,266z"
      />
      <path
        class="st3"
        d="M3.4,306.5c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.3-1-1.4-1.6-2.6-1.3c-0.8,0.2-1.4,0.7-1.7,1.4
		c-0.1,0.3-0.2,0.7-0.1,1v0.1C1.2,306.2,2.3,306.7,3.4,306.5z"
      />
      <path
        class="st3"
        d="M202,266.2c0.5-0.2,0.6-0.6,0.5-1c-0.5,0.2-1.1,0.5-1.6,0.7C201.2,266.2,201.5,266.4,202,266.2z"
      />
      <path
        class="st3"
        d="M200.3,264.2c0,0.1-0.1,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.4c0.7-0.3,1.5-0.7,2.2-1c1.2-1.4,0.4-2.5-0.6-3.6
		C200.6,261.5,199.4,262.6,200.3,264.2z"
      />
      <path
        class="st3"
        d="M15,301.8C15,301.8,15,301.7,15,301.8v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.7
		c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9c0.2,0.2,0.5,0.2,1,0.3
		c0.2-0.1,0.3-0.3,0.5-0.4c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.2-0.2
		c0.3-0.2,0.6-0.4,0.9-0.6C15.2,303,15.3,302.3,15,301.8z"
      />
      <path
        class="st3"
        d="M164.9,303.8c-1.2,0.3-1.9,1.4-1.6,2.4c0.3,0.9,1.4,1.4,2.5,1.1c1.2-0.3,2-1.4,1.7-2.3
		C167.2,304.1,166,303.5,164.9,303.8z"
      />
      <path
        class="st3"
        d="M295.5,254.4h0.1c0.5-0.1,1-0.4,1.3-0.7c0.4-0.4,0.6-0.9,0.5-1.5c-0.2-0.9-1.2-1.5-2.4-1.3
		c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0.3-1.4,1.1-1.3,2c0,0.2,0.1,0.3,0.1,0.4C293.7,254.1,294.6,254.6,295.5,254.4z"
      />
      <path
        class="st3"
        d="M256.9,249.9L256.9,249.9c-0.1-0.2-0.3-0.3-0.4-0.4c-0.3-0.3-0.6-0.5-1-0.7c-0.1,0-0.2-0.1-0.3-0.1
		c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7
		c0.2,0.1,0.4,0.2,0.6,0.3c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.5-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.3l0.1-0.1
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.2-0.1-0.2-0.2C257.2,250.2,257,250.1,256.9,249.9z"
      />
      <path
        class="st3"
        d="M195,250.8c0.2,0,0.4,0.1,0.5,0.2l0,0c0.3,0.2,0.5,0.3,0.7,0.3s0.4-0.2,0.7-0.8c-0.1-0.1-0.2-0.1-0.3-0.2l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.3c0.4-1.3,0.3-1.8-0.5-2.2c-0.9-0.5-1.8-0.2-2.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		C192.4,250.3,192.7,250.6,195,250.8z"
      />
      <path
        class="st3"
        d="M283.4,249.2c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5s-0.8-0.2-1.3-0.1c-0.3,1.2-0.6,2.4-0.8,3.5
		c-0.1,0.4,0.4,0.9,0.9,0.6c0.9-0.4,1.8-0.9,2.6-1.5C283.8,250.3,283.7,249.6,283.4,249.2z"
      />
      <path
        class="st3"
        d="M247.6,244.6c0.2-0.2,0.5-0.3,0.7-0.5s0.4-0.3,0.6-0.5l0,0c-0.9,0.4-1.8,0.8-2.7,1.3
		C246.7,245,247.2,244.8,247.6,244.6z"
      />
      <path
        class="st3"
        d="M248.2,241.4c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.4-0.6-0.8-1.2-0.7c-0.1,0-0.1,0-0.2,0c-0.3,0.3-0.5,0.6-0.7,0.9
		c-0.4,0.6-0.5,1.3-0.8,2c-0.1,0.2,0,0.4,0,0.6c1.1-0.5,2.2-1,3.3-1.5C248.5,242.1,248.3,241.8,248.2,241.4z"
      />
      <path
        class="st3"
        d="M260.3,256.9h0.1c0.5-0.1,0.9-0.5,1.2-0.9c0.3-0.4,0.4-0.8,0.3-1.1l0,0c-0.2-0.9-1.3-1.5-2.4-1.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0.2-1,0.5-1.2,0.9c-0.1,0.3-0.2,0.6-0.1,1c0,0.2,0.1,0.3,0.2,0.4
		C258.5,256.8,259.4,257.2,260.3,256.9z"
      />
      <path
        class="st3"
        d="M244.6,254.5c0.3,0.3,0.6,0.5,1,0.7c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2h0.1
		c0.6-0.2,1.1-0.3,1.7-0.4c0.6-0.2,1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6,0.1c-0.5-1-0.6-1.1-1.5-1.3
		c0,0,0,0-0.1,0s-0.2,0-0.4-0.1c-0.3,0-0.5-0.2-0.7-0.3c-0.7-0.6-1.3-0.3-2,0.1c0.1,0.5,0.3,1,0.6,1.4
		C244.5,254.3,244.5,254.4,244.6,254.5z"
      />
      <path
        class="st3"
        d="M41.2,332.3c-1.1,0.3-1.8,1.2-1.5,2c0.2,0.8,1.2,1.3,2.2,1.1c1.1-0.2,1.9-1.1,1.7-2
		C43.3,332.5,42.3,332,41.2,332.3z"
      />
      <path
        class="st3"
        d="M36.6,338.3c-0.8,0.1-1.4,0.6-1.6,1.1h3.7C38.6,338.7,37.6,338.1,36.6,338.3z"
      />
      <path
        class="st3"
        d="M140,276c-0.3-0.1-0.7-0.1-1,0c-0.8,0.2-1.4,0.8-1.6,1.4c0,0.1,0,0.3,0,0.4c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C141,276.6,140.6,276.2,140,276z"
      />
      <path
        class="st3"
        d="M21.1,304.9c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0.1,0.7,0.7,1.1,1.5,1.1c0.2,0,0.4,0,0.6-0.1
		c1.1-0.2,1.7-1,1.5-1.9C21.1,305,21.1,305,21.1,304.9z"
      />
      <path
        class="st3"
        d="M8.4,298.1c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C9.1,298.6,8.8,298.3,8.4,298.1z"
      />
      <path
        class="st3"
        d="M176.2,289.8c-0.2-0.8-1.2-1.3-2.2-1c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0.2,0.8,1.2,1.3,2.2,1.1
		c0.5-0.1,0.9-0.4,1.2-0.8c0.1-0.1,0.2-0.3,0.2-0.4C176.3,290.3,176.3,290.1,176.2,289.8L176.2,289.8z"
      />
      <path
        class="st3"
        d="M276.4,255.6c0.1,0.8,1,1.3,1.9,1.2c1-0.2,1.9-1.2,1.7-2c-0.1-0.7-1.4-1.2-2.3-1
		C276.9,254,276.3,254.8,276.4,255.6z"
      />
      <path
        class="st3"
        d="M222.3,276c-0.2,0.4-0.4,0.9-0.6,1.3c0.8,1.3,0.8,1.3,2.4,1.5c0.8,0.1,1.3-0.3,1.1-1c-0.1-0.4-0.5-0.8-0.4-1.1
		c0.4-0.8-0.1-1.1-0.5-1.5c-1.1,0.3-0.6,0.8-0.6,1.3c-0.4-0.2-0.8-0.4-1.2-0.6C222.4,275.9,222.3,275.9,222.3,276z"
      />
      <path
        class="st3"
        d="M220.6,301.1c-0.7,0.2-1.3,0.6-2,0.9c-0.1,0.4,0,0.7,0.1,1c0.2,0.4,0.5,0.8,1,1.1c0.9-0.4,1.6-0.8,2.3-1.1
		c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.4-0.4,0.4-0.8c-0.4-0.2-0.8-0.5-1.3-0.7C221.3,301,220.9,301,220.6,301.1z"
      />
      <path
        class="st3"
        d="M0.4,316.9c-0.1,0-0.3,0.1-0.4,0.2v2.6c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.5-1.1,1.3-1.8
		C2.3,317.1,1.3,316.6,0.4,316.9z"
      />
      <path
        class="st3"
        d="M272.9,264.7c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C272.2,264.3,272.5,264.6,272.9,264.7z"
      />
      <path
        class="st3"
        d="M286.4,288.1c0-0.2-0.2-0.4-0.3-0.6c-0.4-0.3-0.9-0.5-1.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.2,0.9-1.1,1.5
		c0.1,0.8,0.9,1.3,1.8,1.1C285.8,289.7,286.6,288.9,286.4,288.1z"
      />
      <path
        class="st3"
        d="M213,315.3c-0.5-0.1-1.1-0.1-1.6-0.1c-0.8,0-1.5,0-2.3,0.1c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0
		c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8c0.3,0,0.6-0.1,0.9-0.2C211.6,316.3,212.3,315.9,213,315.3z"
      />
      <path
        class="st3"
        d="M278.3,289.4c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.2,0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9c0.2,0,0.5,0.1,0.8,0
		c0.9-0.2,1.4-1,1.3-1.7C280,289.6,279.3,289.2,278.3,289.4z"
      />
      <path
        class="st3"
        d="M111.7,314.7c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C113.5,314.9,112.5,314.4,111.7,314.7z"
      />
      <path
        class="st3"
        d="M211.7,317.1c-0.8,0.2-1.3,0.9-1.2,1.6s1,1.2,1.9,1s1.4-1,1.3-1.7C213.4,317.2,212.6,316.8,211.7,317.1z"
      />
      <path
        class="st3"
        d="M296.1,256.9c-0.1,0-0.2,0-0.3,0c-0.5,0.3-1,0.6-1.5,0.9c-0.1,0.1-0.1,0.2-0.2,0.3c0.3,0.3,0.5,0.7,0.8,0.9
		c0.3,0.2,0.6,0.3,0.9,0.2c0.6-0.3,1.1-0.7,1.7-1c0-0.1,0.1-0.3,0-0.5C297.3,257.2,296.8,256.9,296.1,256.9z"
      />
      <path
        class="st3"
        d="M238,255c0,0,0,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.2,0.3,0.3,0.5,0.3c0.3,0.1,0.6,0.1,0.9-0.1
		c0.7-0.3,0.8-0.8,0.7-1.4c-0.1-0.2-0.3-0.5-0.5-0.7c-0.5-0.5-1.3-0.6-1.9-0.1S237.6,254.5,238,255z"
      />
      <path
        class="st3"
        d="M11.8,295.3c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C10.1,295.1,10.9,295.5,11.8,295.3z"
      />
      <path
        class="st3"
        d="M0,336.6v2.4c0.1,0,0.3,0,0.4,0c0.8-0.2,1.4-0.9,1.2-1.5C1.5,336.9,0.7,336.5,0,336.6z"
      />
      <path
        class="st3"
        d="M1.5,325.5c-0.1-0.3-0.3-0.5-0.6-0.7c-0.3-0.1-0.6-0.2-0.9-0.2v0.7v1.6c0.1,0,0.2,0,0.3,0
		C1,326.8,1.6,326.1,1.5,325.5z"
      />
      <path
        class="st3"
        d="M261,258.8c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5c-0.3-0.2-0.7-0.2-1.1-0.2c-0.1,0-0.3,0.1-0.4,0.1
		c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9C260.2,259.8,260.7,259.3,261,258.8z"
      />
      <path
        class="st3"
        d="M17.8,336.9L17.8,336.9c-0.2,0.1-0.4,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3
		c0.6-0.2,1-0.4,1.2-0.7C18.4,338.3,18.4,337.7,17.8,336.9C17.9,336.9,17.8,336.9,17.8,336.9z"
      />
      <path
        class="st3"
        d="M278.4,285.7c-1.4,0.1-2.6,0.3-4,0.4c0.7,1.2,1.1,1.5,2.2,1.3C277.6,287.2,278.2,286.7,278.4,285.7z"
      />
      <path
        class="st3"
        d="M286.7,292.4c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7c0.7-0.2,1.1-0.8,1-1.3
		C288.1,292.6,287.4,292.3,286.7,292.4z"
      />
      <path
        class="st3"
        d="M212.7,305.3c-0.5,0.3-1,0.6-1.5,0.9c0,0.1-0.1,0.3-0.1,0.4c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0
		s0.5-0.2,0.7-0.4c0.3-0.2,0.4-0.6,0.3-0.9C213.6,305.6,213.2,305.3,212.7,305.3z"
      />
      <path
        class="st3"
        d="M16.4,311c0.2-0.5,0-0.9-0.5-1.1c-0.9-0.3-1.5,0.1-2,0.6c0,0.7,0.3,1.3,1.2,1.4
		C15.6,311.9,16.1,311.5,16.4,311z"
      />
      <path
        class="st3"
        d="M216.3,312.3c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		C217.1,312,216.7,312.1,216.3,312.3z"
      />
      <path
        class="st3"
        d="M183.9,273.9c-0.5,0.2-0.9,0.4-1.4,0.7c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7
		c0.1,0,0.2-0.1,0.3-0.2c0.5-0.3,0.7-0.7,0.6-1.2C184.7,274.2,184.3,274,183.9,273.9z"
      />
      <path
        class="st3"
        d="M261.1,268.8C261.1,268.8,261,268.8,261.1,268.8c-0.2,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.2,0.8,0.1,1.3
		c0.3,0.4,0.8,0.6,1.4,0.3c0.4-0.2,0.7-0.4,1.2-0.7c-0.2-0.3-0.3-0.4-0.4-0.6C262.7,268.7,261.8,268.5,261.1,268.8z"
      />
      <path
        class="st3"
        d="M283.4,265.9c0-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.5-0.1-0.7,0
		c-0.4,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.5-0.1,0.8c0.2,0.5,0.7,0.8,1.3,0.7c0.3-0.1,0.5-0.3,0.8-0.4c0.2-0.2,0.3-0.4,0.3-0.6
		C283.4,266.1,283.4,266,283.4,265.9z"
      />
      <path
        class="st3"
        d="M158,309.3c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.8,0.9,1.5,0.7c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C159.4,309.5,158.6,309.1,158,309.3z"
      />
      <path
        class="st3"
        d="M195.5,269.1c0.4-0.4,0.7-0.7,1-1c-0.4,0.2-0.8,0.4-1.2,0.6C195.4,268.8,195.4,268.9,195.5,269.1z"
      />
      <path
        class="st3"
        d="M197,265.8c-0.2,0.4-0.5,0.7-0.7,1.1c0.5-0.2,1-0.5,1.5-0.7C197.6,266,197.4,265.8,197,265.8z"
      />
      <path
        class="st3"
        d="M217,271.1c0.8,0.9,0.9,0.9,2.2,0.5c-0.1-0.1-0.1-0.2-0.2-0.4c-0.4-0.8-0.9-1.5-0.9-2.3c0-0.2-0.4-0.4-0.7-0.7
		c0.2,1.3,0.2,1.3-0.6,2.6C216.9,271,217,271.1,217,271.1z"
      />
      <path
        class="st3"
        d="M85.6,317.5c-0.6,0.1-1.1,0.7-1,1.2c0,0.6,0.7,1,1.4,0.8c0.6-0.1,1.1-0.6,1-1.1
		C86.9,317.8,86.3,317.4,85.6,317.5z"
      />
      <path
        class="st3"
        d="M305.7,287.7c0.4-0.1,0.7-0.3,0.8-0.5v-1c-0.6,0.4-1.2,0.8-1.8,1.3C305,287.7,305.3,287.8,305.7,287.7z"
      />
      <path
        class="st3"
        d="M212.8,269.8c0-0.1-0.6-0.1-0.9-0.1c-0.2,0.7-0.3,1.5,0.6,1.9c0.3-0.2,0.7-0.5,0.8-0.4c0.8,0.5,1-0.1,1.1-0.5
		c0.1-0.3-0.1-0.6-0.1-0.8C213.7,269.8,213.1,270.6,212.8,269.8z"
      />
      <path
        class="st3"
        d="M189.7,248.8c-0.6,0.3-0.7,0.8-0.6,1.2c0.1,0.5,0.3,1,1.2,0.8c0.3-0.7,0.6-1.4,0.9-2
		C190.8,248,190.2,248.5,189.7,248.8z"
      />
      <path
        class="st3"
        d="M233.7,285.4c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C234.5,285.2,233.9,285.2,233.7,285.4z"
      />
      <path
        class="st3"
        d="M231,273c0.2,0.3,0.4,0.6,0.6,0.8c0.5,0,0.9,0,1.2,0c1.1-0.8,0.5-1.3,0-1.8C232.1,272.2,231.3,272.1,231,273z"
      />
      <path
        class="st3"
        d="M88,309.4c0.4,0.7,1,0.8,1.7,0.5c0.3-0.1,0.5-0.2,0.6-0.4c0.4-0.3,0.6-0.8,0.5-1.5c-0.5,0.2-0.9,0.3-1.3,0.5
		c-0.3,0.1-0.5,0.2-0.8,0.4C88.5,309,88.2,309.2,88,309.4L88,309.4z"
      />
      <path
        class="st3"
        d="M167.9,301.1c-0.3-0.5-0.6-0.8-1-1.3c-0.5,0.5-0.8,0.9-1.2,1.2c0.3,0.5,0.5,0.9,0.9,1.6
		C167.1,302,167.5,301.5,167.9,301.1z"
      />
      <path
        class="st3"
        d="M248.7,320.9c0.4,0,0.7,0.1,1.1,0.1c0-0.5,0.1-1,0.1-1.5C248.9,320.1,248.6,320.3,248.7,320.9z"
      />
      <path
        class="st3"
        d="M249.6,323.4c0-0.4,0.1-0.8,0.1-1.2c-0.2,0-0.4-0.1-0.6-0.1C249.2,322.5,249.4,323,249.6,323.4z"
      />
      <path
        class="st3"
        d="M229.3,273.8c0.1-0.3,0-0.6,0-0.9s0.1-0.7,0.2-1.1c-0.5,0-0.9,0-1.3-0.1c0.1-0.2,0.2-0.4,0.5-0.8
		c-0.5,0.2-0.8,0.3-1.1,0.4l0,0l0,0C227.8,272.3,228.4,273.1,229.3,273.8z"
      />
      <path
        class="st3"
        d="M201.4,259.6c-0.2-0.1-0.4-0.1-0.6-0.2c-0.5,0.2-1.1,0.5-1.6,0.7c-0.1,0.3,0,0.6,0.4,0.7s0.9,0,1.3-0.2
		C201.2,260.4,201.2,260,201.4,259.6z"
      />
      <path
        class="st3"
        d="M203.5,243.3c0.3-0.4,0.6-0.8,0.9-1.2c-0.4-0.1-0.9,0.2-0.9-0.3c-0.6,0.1-1.1,0.2-1.7,0.4
		C202.1,243,202.1,243,203.5,243.3z"
      />
      <path
        class="st3"
        d="M74.7,326.9c1-0.6,1.8-1.1,2.7-1.6C75.7,324.7,75.2,325,74.7,326.9z"
      />
      <path
        class="st3"
        d="M27.9,336.7c0.5-0.1,0.8-0.3,1-0.4c-0.1-0.4-0.2-0.8-0.3-1.2C28,335.5,27.9,335.7,27.9,336.7z"
      />
      <path
        class="st3"
        d="M210.3,268.2c-0.1,0.1-0.3,0.4-0.2,0.5c0.1,0.8,0.7,1.1,1.8,0.9c-0.2-0.5-0.5-1-0.8-1.5
		C211,268.1,210.5,268.1,210.3,268.2z"
      />
      <path
        class="st3"
        d="M215.8,294.9c0,0.5,0.5,0.8,1.1,0.7c0.6-0.1,0.9-0.4,0.9-0.8c0-0.6-0.5-0.9-1.1-0.8
		C216.1,294.1,215.8,294.4,215.8,294.9z"
      />
      <path
        class="st3"
        d="M217.8,278.3c-0.2-0.2-0.4-0.3-0.8-0.5c-0.4,0.9-0.4,1.4,0.2,1.7c0.2,0.1,0.6,0.3,1,0.4
		C218.3,279.3,218.2,278.7,217.8,278.3z"
      />
      <path
        class="st3"
        d="M251.6,283.2c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C251.8,283.1,251.7,283.1,251.6,283.2z"
      />
      <path
        class="st3"
        d="M232.2,298.3c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.4-0.4,0.7-0.5,1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3
		c0.2,0.2,0.7,0.3,1,0.2c0.6-0.1,0.9-0.5,0.7-0.9C233.2,298.8,232.8,298.6,232.2,298.3z"
      />
      <path
        class="st3"
        d="M227.4,273c-0.2-0.1-0.4-0.2-0.6-0.2c-0.5-0.2-0.9-0.3-1.4-0.5c-0.1,0-0.5,0.3-0.5,0.4
		c0.1,0.2,0.3,0.4,0.5,0.5l0,0c0.5,0.2,1.1,0.4,1.8,0.6C227.6,273.6,227.8,273.2,227.4,273z"
      />
      <path
        class="st3"
        d="M194.1,254.9L194.1,254.9c-0.2-0.2-0.5-0.3-0.7-0.3h-0.1c-0.3,0.1-0.6,0.5-0.6,0.7c0,0.4,0.2,0.8,0.6,1
		c0.4,0.3,0.9,0,1.3-0.5C194.5,255.5,194.3,255.2,194.1,254.9z"
      />
      <path
        class="st3"
        d="M137.6,283.5c0.1,0.9,0.1,0.9,0.8,1.3c0.6-0.2,1.2-0.6,0.9-1.2C139,283.2,138.3,283.2,137.6,283.5z"
      />
      <path
        class="st3"
        d="M233.5,279.7c1,0.3,1.1,1.7,2.7,1.1c-0.3-0.5-0.6-1-0.9-1.5C234.7,279.5,234.2,279.6,233.5,279.7z"
      />
      <path
        class="st3"
        d="M116,310c-0.3,0.2-0.6,0.5-0.7,0.8c-0.1,0.4,0.5,0.7,1,0.6s0.9-0.5,0.8-0.9C117,310.1,116.4,309.8,116,310z"
      />
      <path
        class="st3"
        d="M30.2,303.1c-0.1-0.1-0.3-0.3-0.5-0.3c-0.1,0-0.3-0.1-0.4-0.1c-0.5,0-1,0.5-0.7,0.9c0.1,0.2,0.3,0.3,0.4,0.4
		s0.3,0.2,0.4,0.2C30.2,303.8,30.5,303.5,30.2,303.1z"
      />
      <path
        class="st3"
        d="M152.8,304.1c-0.3,0.2-0.7,0.6-0.7,0.8c0.1,0.2,0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C153.9,304.2,153.3,303.9,152.8,304.1z"
      />
      <path
        class="st3"
        d="M287.2,275.8c0.6,0.6,0.6,1.5,2.1,1.2C288.6,275.6,288.6,275.6,287.2,275.8z"
      />
      <path
        class="st3"
        d="M74.5,317c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4C74.4,317.1,74.4,317.1,74.5,317z"
      />
      <path
        class="st3"
        d="M220.2,272.1c0.6,0.4-0.4,1.3,0.6,1.6h-0.1c0,0,0,0,0,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2
		C221.7,272.8,221.5,272.4,220.2,272.1z"
      />
      <path
        class="st3"
        d="M235.4,282.1c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C236.5,283.1,236.1,282.6,235.4,282.1z"
      />
      <path
        class="st3"
        d="M232.2,277.6c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.6,0.2,0.9,0.5,1.2c0.1,0.1,0.5,0.1,0.7,0c0,0,0,0,0.1,0
		s0.2-0.4,0.2-0.5C233.1,278.5,232.7,278.1,232.2,277.6z"
      />
      <path
        class="st3"
        d="M240.4,263.3c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.4,0.1-0.9,0.2c0.5,0.6,0.4,1.4,1.5,1.4l0,0c0,0,0,0,0.1,0l0,0
		C241.1,264.2,240,263.8,240.4,263.3z"
      />
      <path
        class="st3"
        d="M205.4,253.5c-0.2-0.6-0.5-1.2-0.9-2.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		c0.2,0.3,0.3,0.7,0.8,0.7C205,253.5,205.2,253.5,205.4,253.5z"
      />
      <path
        class="st3"
        d="M251.6,275c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5c-0.3,0.4-0.6,0.7-0.6,1
		C250.9,274.8,251.5,275.1,251.6,275z"
      />
      <path
        class="st3"
        d="M250.3,235.2c-0.6,0.3-1.3,0.6-1.9,0.9l0.1,0.1c0.6-0.3,1.3-0.5,2-0.9C250.4,235.2,250.4,235.2,250.3,235.2z"
      />
      <path
        class="st3"
        d="M78.6,331.5c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C79.3,331.7,78.9,331.6,78.6,331.5z"
      />
      <path
        class="st3"
        d="M305,230.2c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C305.8,230.3,305.5,229.9,305,230.2z"
      />
      <path
        class="st3"
        d="M206,250.9c1.1,0.7,1.1,0.7,1.8-0.1C207.1,250.7,206.7,250,206,250.9z"
      />
      <path
        class="st3"
        d="M79.2,325.7c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C78.7,326.1,79.2,325.9,79.2,325.7z"
      />
      <path
        class="st3"
        d="M206.6,245c0.7-0.4,0.4-1,0.4-1.5C205.9,243.9,205.8,244.1,206.6,245z"
      />
      <path
        class="st3"
        d="M252,242.2c-0.3,0.1-0.6,0.3-0.9,0.4c-0.2,0.4-0.4,0.8-0.3,1.3C251.2,243.4,251.8,242.9,252,242.2z"
      />
      <path
        class="st3"
        d="M227.1,279.8c-0.3,0.3-0.5,0.5-0.7,0.8c0.3,0.1,0.6,0.4,0.8,0.3c0.3-0.1,0.5-0.4,0.6-0.7
		C227.8,280.2,227.4,280,227.1,279.8z"
      />
      <path
        class="st3"
        d="M233.3,245.2c-0.4,0.4-0.8,0.8-1.1,1.2c0.7,0.5,1.1-0.3,1.7-0.3c0.1-0.2,0.1-0.4,0.2-0.6
		C233.8,245.4,233.6,245.3,233.3,245.2z"
      />
      <path
        class="st3"
        d="M241.7,258c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0,0.1,0,0.1,0c0.5,0,0.9,0,1.2-0.2
		s0.5-0.4,0.6-0.8C242.5,257.3,242.1,257.6,241.7,258z"
      />
      <path
        class="st3"
        d="M46.1,327.4c-0.2,0-0.3,0.4-0.4,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7
		C46.7,327.5,46.4,327.4,46.1,327.4z"
      />
      <path
        class="st3"
        d="M12,327.2c0.7-0.7,0.8-1.2,0.2-1.9C11.4,326,11.5,326.5,12,327.2z"
      />
      <path
        class="st3"
        d="M226.6,290.8c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.1-0.5,0-0.7s-0.4-0.4-0.9-0.5l0,0l0,0c0,0,0,0,0,0.1
		c0,0.4,0,0.7,0.2,0.9C226.1,290.6,226.3,290.7,226.6,290.8z"
      />
      <path
        class="st3"
        d="M114.3,301.6c-0.2,0.4-0.6,0.7-0.5,0.9c0.1,0.2,0.5,0.3,0.8,0.4c0.1,0,0.5-0.4,0.4-0.6
		C115,302.1,114.6,301.9,114.3,301.6z"
      />
      <path
        class="st3"
        d="M188.9,268.5c1.3-0.8,0.1-1.1,0.1-1.7C187.7,267.6,188.9,267.8,188.9,268.5z"
      />
      <path
        class="st3"
        d="M277.4,272.8c0.5,0.4,0.3,1.1,1.3,1.3C278.6,272.8,278.6,272.8,277.4,272.8z"
      />
      <path
        class="st3"
        d="M259.8,277.9c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.2-0.1-0.4-0.2C260,277.7,259.9,277.8,259.8,277.9z"
      />
      <path
        class="st3"
        d="M228.7,241.9c-0.5,0.4-0.8,0.6-1.2,0.9c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4
		C229.2,243.1,228.9,242.6,228.7,241.9z"
      />
      <path
        class="st3"
        d="M90.4,317.2c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C91.6,316.4,91,316.8,90.4,317.2z"
      />
      <path
        class="st3"
        d="M248.7,245.3c-0.4,0.3-0.6,0.5-1,0.7c0.5,0.5,0.9,0.7,1.4,0.2C249.2,246.1,248.8,245.7,248.7,245.3z"
      />
      <path
        class="st3"
        d="M256.1,286c0.1,0.8,0.1,0.8,0.9,1.3C256.9,286.8,256.9,286.3,256.1,286z"
      />
      <path
        class="st3"
        d="M205.7,321.1c0,0.7,0.2,1.1,1,1.7C206.8,321.8,206.6,321.4,205.7,321.1z"
      />
      <path
        class="st3"
        d="M231,244.2C230.9,244.3,230.9,244.3,231,244.2c-0.2,0.1-0.3,0.3-0.4,0.5c0.5-0.2,0.9-0.4,1.4-0.6
		C231.5,244.1,231.1,244.2,231,244.2z"
      />
      <path
        class="st3"
        d="M212.2,287c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C212.8,287.4,212.5,287.2,212.2,287z"
      />
      <path
        class="st3"
        d="M81.9,328.6c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C82.2,328.1,82.1,328.4,81.9,328.6z"
      />
      <path
        class="st3"
        d="M289.1,270.6c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2,0.2-0.5,0.4-0.4,0.5c0.2,0.2,0.4,0.4,0.8,0.6
		C288.9,270.9,289.1,270.7,289.1,270.6z"
      />
      <path
        class="st3"
        d="M252.3,261.2c-0.2-0.7-0.3-1.2-1.2-1.2C251,260.6,251.4,260.9,252.3,261.2z"
      />
      <path
        class="st3"
        d="M233.4,274.1c0.4,0.3,0.8,0.5,1.2,0.8c0.1-0.1,0.2-0.2,0.3-0.4C234.7,274,234.3,273.8,233.4,274.1z"
      />
      <path
        class="st3"
        d="M47.2,337.8c0.2-0.5,0.4-1,0.7-1.6C46.8,337,46.8,337,47.2,337.8z"
      />
      <path
        class="st3"
        d="M273.2,251.3c-0.4-0.2-0.7-0.3-1-0.4c-0.1,0.2-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.3,0.8,0.3
		C272.8,251.8,273,251.5,273.2,251.3z"
      />
      <path
        class="st3"
        d="M215.4,272c0.1,1,0.1,1.2,0.7,1.3c0.1,0,0.3,0.1,0.5,0.1c-0.2-0.2-0.3-0.4-0.5-0.6
		C216,272.7,215.7,272.4,215.4,272z"
      />
      <path
        class="st3"
        d="M240.6,235.7c-0.2,0.3-0.5,0.6-0.4,0.7c0.1,0.2,0.4,0.2,0.6,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		C241.2,236,240.9,235.9,240.6,235.7z"
      />
      <path
        class="st3"
        d="M31.9,302.5c-0.4-0.2-0.7-0.3-1-0.4c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0.1-0.2,0.3-0.1,0.4
		c0.1,0.2,0.4,0.3,0.7,0.3C31.4,303.1,31.6,302.8,31.9,302.5z"
      />
      <path
        class="st3"
        d="M74.6,328.9c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C75.2,329,74.9,328.8,74.6,328.9z"
      />
      <path
        class="st3"
        d="M16.2,301.2c0.3,0.1,0.5,0,0.6-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1
		C15.9,301.1,16,301.2,16.2,301.2z"
      />
      <path
        class="st3"
        d="M29.3,322.3c0.8-0.2,0.9-0.5,0.6-1.2C29.4,321.5,29,321.8,29.3,322.3z"
      />
      <path
        class="st3"
        d="M208.7,254.2c0.1-0.2,0.1-0.4,0.2-0.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0.3-0.1,0.5,0.1,0.9
		c0.1,0,0.1-0.1,0.2-0.1C208.6,254.5,208.6,254.3,208.7,254.2z"
      />
      <path
        class="st3"
        d="M210,276c0.1-0.4,0.2-0.8,0.4-1.1c-0.2,0-0.4,0-0.6-0.1c-0.1,0.4-0.1,0.8-0.2,1.2C209.8,276,209.9,276,210,276
		z"
      />
      <path
        class="st3"
        d="M233,296.2l0.1,0.1c0.1-0.1,0.3-0.2,0.4-0.2c-0.1-0.1-0.3-0.2-0.5-0.2C233,296,233,296.1,233,296.2z"
      />
      <path
        class="st3"
        d="M233.9,297.3l0.1,0.1C234,297.3,234,297.3,233.9,297.3C234,297.2,234,297.3,233.9,297.3z"
      />
      <path
        class="st3"
        d="M89.3,321.3c0.1,0.2,0.3,0.3,0.5,0.4c-0.1-0.2-0.2-0.5-0.3-0.7C89.3,321.2,89.2,321.3,89.3,321.3z"
      />
      <path
        class="st3"
        d="M182.3,281.1c0.6-0.2,1.1-0.5,0.7-1.3C182.7,280.4,182.5,280.7,182.3,281.1z"
      />
      <path
        class="st3"
        d="M203.2,239.7c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C202.9,238.8,203,239.2,203.2,239.7z"
      />
      <path
        class="st3"
        d="M202.2,241.2c-0.3,0-0.5,0-0.7,0.1s-0.3,0.3-0.5,0.6C201.6,241.9,202.1,241.9,202.2,241.2z"
      />
      <path
        class="st3"
        d="M193.1,251.9c0.7,0.2,1.1,0.3,1.8,0.5C194.4,251.7,194,251.6,193.1,251.9z"
      />
      <path
        class="st3"
        d="M184.2,259c0.4,0.2,0.8,0.4,1.5,0.8C185.3,259,184.9,258.9,184.2,259z"
      />
      <path
        class="st3"
        d="M213.5,289.7c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C213.6,289,213.6,289.3,213.5,289.7z"
      />
      <path
        class="st3"
        d="M252.7,254.4c0.7-0.1,1.1-0.1,1.9-0.2C253.8,254,253.4,253.7,252.7,254.4z"
      />
      <path
        class="st3"
        d="M14,312.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.4,0.4,0.5,0.6c0,0,0.1-0.1,0.2-0.2l0.1-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C14.2,312.4,14.1,312.3,14,312.2z"
      />
      <path
        class="st3"
        d="M180.2,288.2c0.3-0.5,0.4-0.8,0.6-1.1C180.3,287.3,179.8,287.6,180.2,288.2z"
      />
      <path
        class="st3"
        d="M195.5,252.6c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3c-0.2,0.4-0.4,0.6-0.6,0.9
		C195.4,252.7,195.4,252.6,195.5,252.6z"
      />
      <path
        class="st3"
        d="M292.2,237.8L292.2,237.8c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C292.8,237.7,292.4,237.5,292.2,237.8z"
      />
      <path
        class="st3"
        d="M216.3,275.7c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.2,0.7-0.7
		C216.7,275.7,216.5,275.7,216.3,275.7z"
      />
      <path
        class="st3"
        d="M44.9,320.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.6,0.4c0.1-0.3,0.3-0.4,0.3-0.6
		C45.3,320.4,45,320.3,44.9,320.3z"
      />
      <path
        class="st3"
        d="M31,337.8c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.3,0.7-0.6,1-0.9c-0.1-0.1-0.1-0.1-0.2-0.2
		C31.6,337.2,31.3,337.5,31,337.8z"
      />
      <path
        class="st3"
        d="M254.1,255.9c-0.2,0.5,0,0.7,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0-0.3,0-0.5
		C254.8,256.1,254.5,256,254.1,255.9z"
      />
      <path
        class="st3"
        d="M289.8,256.1c-0.1-0.4-0.3-0.8,0.3-0.9c-0.2,0-0.5,0-1-0.1C289.4,255.6,289.6,255.8,289.8,256.1z"
      />
      <path
        class="st3"
        d="M78,319.6c0.3,0.1,0.5,0.3,0.7,0.2c0.2-0.1,0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3
		C78.3,319.1,78.2,319.3,78,319.6z"
      />
      <path
        class="st3"
        d="M250.8,245.7c0,0-0.1-0.1-0.1-0.3c-0.4,0.1-0.7,0.3-1.1,0.5C250,246.5,250.4,246.1,250.8,245.7z"
      />
      <path
        class="st3"
        d="M67.5,323.4c-0.3-0.3-0.5-0.5-0.7-0.7C66.5,323.5,66.5,323.5,67.5,323.4z"
      />
      <path
        class="st3"
        d="M272.4,265.2C272.4,265.2,272.4,265.1,272.4,265.2c-0.2,0-0.3,0-0.3,0.1l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0
		c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1l0,0C272.7,265.6,272.6,265.4,272.4,265.2z"
      />
      <path
        class="st3"
        d="M92.5,292.2c0-0.1-0.2-0.2-0.4-0.3c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C92.4,292.5,92.6,292.3,92.5,292.2z"
      />
      <path
        class="st3"
        d="M221.5,311.5c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C221.8,311.2,221.7,311.3,221.5,311.5z"
      />
      <path
        class="st3"
        d="M36.9,306.1c-0.3-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2,0.2-0.3,0.3c0.2,0.1,0.3,0.2,0.5,0.2
		C36.6,306.4,36.7,306.2,36.9,306.1z"
      />
      <path
        class="st3"
        d="M82.6,334.5c0,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.4,0.5c0.2-0.3,0.4-0.5,0.4-0.6
		C83.1,334.6,82.8,334.5,82.6,334.5z"
      />
      <path
        class="st3"
        d="M204.1,249.7L204.1,249.7L204.1,249.7c-0.3,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8c0.3-0.2,0.5-0.3,0.6-0.4
		v0.1l0,0c0.1,0.2,0.1,0.4,0.2,0.6c1.1-0.9,1.1-0.9,0.5-1.4C204.4,249.4,204.3,249.6,204.1,249.7z"
      />
      <path
        class="st3"
        d="M205.5,242.9l0.2,0.1c0.1-0.1,0.3-0.3,0.4-0.4c-0.2-0.1-0.3-0.1-0.4-0.2C205.6,242.6,205.5,242.7,205.5,242.9z
		"
      />
      <path
        class="st3"
        d="M252.5,256.9c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C253,256.5,252.8,256.7,252.5,256.9z"
      />
      <path
        class="st3"
        d="M93.1,317.8c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C93.2,317.5,93,317.7,93.1,317.8z"
      />
      <path
        class="st3"
        d="M303,281.8c0.2,0.1,0.3,0.3,0.5,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.4-0.2-0.5-0.1
		C303.3,281.6,303.2,281.7,303,281.8z"
      />
      <path
        class="st3"
        d="M245.7,240.5c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.1,0.9-0.2c0-0.2,0.1-0.3,0.2-0.7
		C246.4,240.1,246.1,240.3,245.7,240.5z"
      />
      <path
        class="st3"
        d="M9.9,296c0.1,0.1,0.3,0.3,0.4,0.4c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4C10.1,295.8,10,295.9,9.9,296z
		"
      />
      <path
        class="st3"
        d="M200.4,278.2c0.1,0,0.2,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.7c-0.1,0-0.3-0.1-0.4-0.1
		C200.5,277.7,200.5,278,200.4,278.2z"
      />
      <path
        class="st3"
        d="M299.5,272.4c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C299.9,272.5,299.6,272.5,299.5,272.4z"
      />
      <path
        class="st3"
        d="M209.6,270.2c0,0.1,0.1,0.3,0.2,0.4c0.1-0.2,0.2-0.4,0.2-0.6c-0.1,0-0.2,0-0.3,0
		C209.7,270.1,209.6,270.2,209.6,270.2z"
      />
      <path
        class="st3"
        d="M238,245.5c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0,0.5,0.1,0.6,0
		c0.2,0,0.4-0.2,0.5-0.5C238,245.7,238,245.6,238,245.5z"
      />
      <path
        class="st3"
        d="M234.6,247.2c0.3-0.1,0.6-0.2,0.9-0.3c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.2-0.6,0.3-0.9,0.5
		C234.6,247,234.6,247.1,234.6,247.2z"
      />
      <path
        class="st3"
        d="M214.4,280.6c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C214.5,280.1,214.4,280.3,214.4,280.6z"
      />
      <path
        class="st3"
        d="M305,237c0,0.3,0,0.6,0,0.9C305.4,237.6,305.5,237.3,305,237z"
      />
      <path
        class="st3"
        d="M305,237.9L305,237.9c-0.1,0.1-0.1,0.1-0.1,0.1C305,238,305,237.9,305,237.9L305,237.9z"
      />
      <path
        class="st3"
        d="M25.4,329.8c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C25.5,329.7,25.5,329.7,25.4,329.8z"
      />
      <path
        class="st3"
        d="M245.2,249.8c0.1-0.1,0.3-0.2,0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.3,0.1-0.4,0.2
		C245.1,249.6,245.1,249.7,245.2,249.8z"
      />
      <path
        class="st3"
        d="M199.4,251.4c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6
		C199.7,251.4,199.5,251.4,199.4,251.4z"
      />
      <path
        class="st3"
        d="M83.5,317.7c0.1,0,0.2,0,0.3-0.1c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0-0.2,0-0.3,0.1
		C83.4,317.3,83.4,317.5,83.5,317.7z"
      />
      <path
        class="st3"
        d="M205.9,257.5c0.1,0.1,0.3,0.2,0.4,0.1c0.1,0,0.2-0.2,0.3-0.4c-0.2-0.1-0.4-0.1-0.5-0.1
		C206,257.2,205.8,257.4,205.9,257.5z"
      />
      <path
        class="st3"
        d="M265.8,245.8c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C265.9,245.9,265.8,245.9,265.8,245.8z"
      />
      <path
        class="st3"
        d="M265.3,246.4c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0S265.3,246.4,265.3,246.4z"
      />
      <path
        class="st3"
        d="M230,270.6c-0.1,0.1-0.3,0.2-0.3,0.3c0,0.1,0.2,0.2,0.4,0.3c0.1-0.2,0.2-0.3,0.1-0.4
		C230.3,270.6,230.1,270.5,230,270.6z"
      />
      <path
        class="st3"
        d="M201,330.8c0.2,0.2,0.4,0.4,0.6,0.6C201.6,331.1,201.9,330.7,201,330.8z"
      />
      <path
        class="st3"
        d="M201.6,331.4L201.6,331.4c0,0.1,0.1,0.1,0.1,0.1C201.7,331.5,201.6,331.5,201.6,331.4L201.6,331.4z"
      />
      <path
        class="st3"
        d="M93.1,301.4c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.2-0.3,0.3-0.2,0.4c0,0.1,0.2,0.1,0.4,0.1
		C93,301.7,93.2,301.5,93.1,301.4z"
      />
      <path
        class="st3"
        d="M229.1,314.4c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C229.2,314.2,229.1,314.3,229.1,314.4z"
      />
      <path
        class="st3"
        d="M263.2,232.8c0,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.3-0.2-0.4-0.2
		C263.3,232.6,263.1,232.7,263.2,232.8z"
      />
      <path
        class="st3"
        d="M303.1,234.9c-0.1,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.2,0.1h0.1l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4
		C303.2,234.8,303.2,234.9,303.1,234.9z"
      />
      <path
        class="st3"
        d="M213.7,278.7c-0.2,0-0.4,0-0.6-0.1c0.1,0.1,0.2,0.3,0.4,0.4C213.5,278.9,213.6,278.8,213.7,278.7z"
      />
      <path
        class="st3"
        d="M306.2,232.2v-0.5c-0.1,0-0.1,0-0.2,0s-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2
		C306.1,232.3,306.1,232.3,306.2,232.2z"
      />
      <path
        class="st3"
        d="M204.2,256.6c0.1-0.1,0.2-0.1,0.3-0.2s0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C204.3,256.3,204.2,256.4,204.2,256.6z"
      />
      <path
        class="st3"
        d="M202.1,269.1c0.2,0,0.3,0.1,0.5,0c0.1,0,0.2-0.2,0.5-0.4c-0.4,0-0.5,0-0.6,0.1
		C202.3,268.9,202.2,269,202.1,269.1z"
      />
      <path
        class="st3"
        d="M304.7,233.2c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5c-0.1,0.3-0.2,0.5-0.1,0.6
		C304.4,233.1,304.6,233.2,304.7,233.2z"
      />
      <path
        class="st3"
        d="M204.9,280.7c0.1,0,0.2,0,0.3,0c0.1-0.2,0.2-0.4,0.3-0.7c-0.1,0-0.2,0-0.4,0
		C205,280.2,204.9,280.4,204.9,280.7z"
      />
      <path
        class="st3"
        d="M127,296.9c0.2,0.2,0.4,0.5,0.6,0.8C127.9,296.9,127.4,297,127,296.9z"
      />
      <path
        class="st3"
        d="M127,296.9C127,296.9,127,296.8,127,296.9c-0.1-0.1-0.1-0.1-0.1-0.1l0,0C127,296.9,127,296.9,127,296.9z"
      />
      <path
        class="st3"
        d="M183.9,283.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C184.1,283.5,184,283.4,183.9,283.3z"
      />
      <path
        class="st3"
        d="M30.2,310.7c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.2,0-0.3,0C30.3,310.6,30.3,310.6,30.2,310.7z"
      />
      <path
        class="st3"
        d="M212.8,278c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C213,278,212.9,278,212.8,278z"
      />
      <path
        class="st3"
        d="M213.1,278.6C213.1,278.6,213,278.5,213.1,278.6c-0.1-0.1-0.1-0.1-0.1-0.1v0.1
		C213,278.6,213,278.6,213.1,278.6z"
      />
      <path
        class="st3"
        d="M244.2,260.5l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1h-0.1c-0.1,0-0.3,0-0.4,0
		C244.3,260.5,244.3,260.5,244.2,260.5z"
      />
      <path
        class="st3"
        d="M198.1,274.3l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C198.2,274.1,198.1,274.2,198.1,274.3z"
      />
      <path
        class="st3"
        d="M248.5,251.5c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.4
		C248.8,251.6,248.5,251.5,248.5,251.5z"
      />
      <path
        class="st3"
        d="M90.9,312.1c-0.1,0-0.2-0.1-0.4-0.1l-0.1,0.2c0.1,0.1,0.2,0.1,0.4,0.2C90.8,312.3,90.9,312.3,90.9,312.1z"
      />
      <path
        class="st3"
        d="M203.7,241.2c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C203.9,241.3,203.8,241.3,203.7,241.2z"
      />
      <path
        class="st3"
        d="M238.7,290.6l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C238.8,290.4,238.7,290.5,238.7,290.6z"
      />
      <path
        class="st3"
        d="M290.9,255.5c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C291,255.6,291,255.6,290.9,255.5z"
      />
      <path
        class="st3"
        d="M58.7,312.1c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C58.9,312.1,58.8,312.1,58.7,312.1z"
      />
      <path
        class="st3"
        d="M58.7,312.5C58.6,312.5,58.6,312.5,58.7,312.5c-0.1,0.1-0.1,0.1-0.1,0.2h0.1C58.7,312.6,58.7,312.5,58.7,312.5
		z"
      />
      <path
        class="st3"
        d="M238.2,246.6C238.3,246.6,238.2,246.5,238.2,246.6c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.1,0,0.2,0,0.3
		C237.9,246.7,238.1,246.7,238.2,246.6z"
      />
      <path
        class="st3"
        d="M297.5,236.6c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1-0.1-0.1-0.2-0.1C297.5,236.2,297.5,236.3,297.5,236.6z"
      />
      <path
        class="st3"
        d="M129.9,335c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C130,335.1,130,335,129.9,335z"
      />
      <path
        class="st3"
        d="M108.7,277.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1
		C108.9,277.1,108.8,277.2,108.7,277.3z"
      />
      <path
        class="st3"
        d="M67.2,310.7c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C67.2,310.6,67.2,310.7,67.2,310.7z"
      />
      <path
        class="st3"
        d="M230.7,271.4c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.4,0.1
		C230.5,271.6,230.6,271.5,230.7,271.4z"
      />
      <path
        class="st3"
        d="M248.2,250.8c-0.6,0.2-0.8,0.3-1,0.3c0.1,0.1,0.1,0.2,0.2,0.3C247.6,251.4,247.8,251.3,248.2,250.8z"
      />
      <path
        class="st3"
        d="M292.5,256.1c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C292.6,256.2,292.5,256.2,292.5,256.1z"
      />
      <path
        class="st3"
        d="M304.9,238c-0.1,0.1-0.3,0.3-0.4,0.4c0.1,0,0.2,0.1,0.3,0.1C304.8,238.4,304.9,238.2,304.9,238z"
      />
      <path
        class="st3"
        d="M162.2,310.7C162.2,310.7,162.3,310.7,162.2,310.7c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C162.3,310.6,162.3,310.6,162.2,310.7z"
      />
      <path
        class="st3"
        d="M251.6,254.1C251.6,254.2,251.6,254.2,251.6,254.1c0.1,0.2,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2l0,0
		c-0.1-0.1-0.1-0.2-0.2-0.2C251.7,254,251.5,254.1,251.6,254.1z"
      />
      <path
        class="st3"
        d="M62.5,321c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C62.7,320.7,62.6,320.8,62.5,321z"
      />
      <path
        class="st3"
        d="M209.4,266.8c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
		C209.6,266.6,209.5,266.7,209.4,266.8z"
      />
      <path
        class="st3"
        d="M195.7,272.9c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C195.7,272.7,195.6,272.8,195.7,272.9z"
      />
      <path
        class="st3"
        d="M119.2,284.4c0.1-0.1,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2-0.1l-0.1,0.1l0.1,0.1
		C119.1,284.2,119.1,284.3,119.2,284.4z"
      />
      <path
        class="st3"
        d="M297.9,255.7v0.1l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2h-0.1
		C298,255.6,298,255.6,297.9,255.7z"
      />
      <path
        class="st3"
        d="M291.9,256.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C292.1,257.1,292,257,291.9,256.9z"
      />
      <path
        class="st3"
        d="M293.7,282.7c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C293.8,282.4,293.8,282.6,293.7,282.7z"
      />
      <path
        class="st3"
        d="M249.2,266L249.2,266C249.3,266,249.3,265.9,249.2,266C249.3,265.9,249.2,266,249.2,266L249.2,266z"
      />
      <path
        class="st3"
        d="M249,266.3c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1C248.9,266.2,248.9,266.2,249,266.3z"
      />
      <path
        class="st3"
        d="M249.2,240.3c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1C249.3,240.4,249.3,240.3,249.2,240.3z"
      />
      <path
        class="st3"
        d="M40,311.2c-0.1,0-0.2-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0V311.2z"
      />
      <path
        class="st3"
        d="M201.8,331.9c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C201.7,331.6,201.8,331.8,201.8,331.9z"
      />
      <path
        class="st3"
        d="M227.9,243.9c0.1-0.1,0.2-0.2,0.4-0.3c-0.2,0-0.3,0.1-0.5,0.1C227.8,243.8,227.9,243.9,227.9,243.9z"
      />
      <path
        class="st3"
        d="M228.3,243.6h0.1C228.4,243.5,228.4,243.5,228.3,243.6C228.3,243.5,228.3,243.5,228.3,243.6
		C228.3,243.5,228.3,243.6,228.3,243.6z"
      />
      <path
        class="st3"
        d="M259,241.3l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C259.2,241.3,259.1,241.3,259,241.3z"
      />
      <path
        class="st3"
        d="M253.5,236.3l0.1,0.1c0.1,0,0.1,0,0.2,0c-0.1,0-0.1-0.1-0.2-0.1H253.5z"
      />
      <path
        class="st3"
        d="M198,247.4c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2C197.9,247.5,198,247.5,198,247.4
		C198,247.5,198,247.4,198,247.4z"
      />
      <path
        class="st3"
        d="M192.7,248.3c0,0,0.1,0.1,0.1,0.2l0,0l0,0C192.7,248.4,192.7,248.3,192.7,248.3z"
      />
      <path
        class="st3"
        d="M114.6,296.9l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1C114.4,297,114.5,296.9,114.6,296.9z"
      />
      <path
        class="st3"
        d="M10.7,316.2l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2L11,316C10.9,316.1,10.8,316.1,10.7,316.2z"
      />
      <path
        class="st3"
        d="M207,243.1v0.1c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.2C207.1,243.2,207,243.1,207,243.1z"
      />
      <path
        class="st3"
        d="M200.9,240.8l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C201.1,240.8,201,240.8,200.9,240.8z"
      />
      <path
        class="st3"
        d="M144.2,292.6l0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C144.4,292.5,144.3,292.6,144.2,292.6z"
      />
      <path
        class="st3"
        d="M121.9,297.8c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C121.9,297.7,121.8,297.8,121.9,297.8z"
      />
      <path
        class="st3"
        d="M204.3,310.1L204.3,310.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c0-0.1-0.1-0.1-0.1-0.2
		C204.4,310,204.4,310.1,204.3,310.1z"
      />
      <path
        class="st3"
        d="M188.9,260.6c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C188.8,260.7,188.9,260.7,188.9,260.6z"
      />
      <path
        class="st3"
        d="M225.8,277.1c0,0.2,0,0.3,0.1,0.5c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.3-0.1-0.4
		C225.9,277.1,225.9,277.1,225.8,277.1z"
      />
      <path
        class="st3"
        d="M88.2,307.3c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2C88.4,307.4,88.2,307.3,88.2,307.3
		z"
      />
      <path
        class="st3"
        d="M236.1,275.7c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C236.1,275.5,236.1,275.6,236.1,275.7z"
      />
      <path
        class="st3"
        d="M254.3,259.6c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0,0,0-0.1-0.1-0.1C254.5,259.5,254.4,259.6,254.3,259.6z"
      />
      <path
        class="st3"
        d="M230.1,278.8C230.1,278.8,230,278.8,230.1,278.8c-0.1,0.1,0,0.1,0,0.2l0,0l0,0
		C230.1,278.9,230.1,278.8,230.1,278.8L230.1,278.8z"
      />
      <path
        class="st3"
        d="M240.2,262.1c0.1,0,0.2,0,0.3,0l0,0c0,0,0-0.1,0.1-0.1c-0.1,0-0.2,0-0.3,0C240.3,262,240.3,262,240.2,262.1
		C240.3,262,240.3,262.1,240.2,262.1z"
      />
      <path
        class="st3"
        d="M201.8,270.6c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C201.9,270.5,201.8,270.6,201.8,270.6z"
      />
      <path
        class="st3"
        d="M195.3,272.2c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C195.3,272,195.3,272.1,195.3,272.2z"
      />
      <path
        class="st3"
        d="M25.2,308.7c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1l0.1-0.1c0,0,0-0.1-0.1-0.1C25.2,308.8,25.2,308.7,25.2,308.7z"
      />
      <path
        class="st3"
        d="M161.9,310.1c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C161.9,309.9,161.9,310,161.9,310.1z"
      />
      <path
        class="st3"
        d="M267.4,246.7l-0.1,0.1c0.1,0,0.2,0,0.3,0.1l0.1-0.1C267.6,246.7,267.5,246.7,267.4,246.7z"
      />
      <path
        class="st3"
        d="M216.4,283.7c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0C216.4,283.8,216.4,283.7,216.4,283.7z"
      />
      <path
        class="st3"
        d="M243.1,252.7c0,0,0-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C243,252.6,243.1,252.7,243.1,252.7z"
      />
      <path
        class="st3"
        d="M277.8,245.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1
		C277.9,245.8,277.9,245.7,277.8,245.7z"
      />
      <path
        class="st3"
        d="M222.6,282.8v-0.1h-0.1C222.5,282.7,222.5,282.7,222.6,282.8C222.5,282.8,222.5,282.8,222.6,282.8z"
      />
      <path
        class="st3"
        d="M223.1,283.4c-0.1,0-0.2,0-0.3,0c0.1,0,0.1,0,0.2,0C223,283.5,223,283.4,223.1,283.4z"
      />
      <path
        class="st3"
        d="M50.9,321.9L51,322c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0L50.9,321.9z"
      />
      <path
        class="st3"
        d="M198.5,264.1c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C198.6,264,198.5,264,198.5,264.1z"
      />
      <path
        class="st3"
        d="M252.2,252.3L252.2,252.3c-0.5,0-0.6,0-0.8,0c0,0.1,0,0.1,0,0.2C251.6,252.5,251.8,252.5,252.2,252.3
		L252.2,252.3z"
      />
      <path
        class="st3"
        d="M52.8,296.4c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C52.7,296.5,52.8,296.5,52.8,296.4z"
      />
      <path
        class="st3"
        d="M274.1,248.3c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C274.2,248.2,274.1,248.2,274.1,248.3z"
      />
      <path
        class="st3"
        d="M274.5,248.5C274.5,248.5,274.4,248.5,274.5,248.5C274.4,248.5,274.4,248.6,274.5,248.5
		C274.5,248.6,274.5,248.6,274.5,248.5C274.5,248.6,274.5,248.6,274.5,248.5C274.5,248.6,274.5,248.6,274.5,248.5
		C274.5,248.6,274.5,248.6,274.5,248.5z"
      />
      <path
        class="st3"
        d="M243.2,255.1C243.2,255.2,243.2,255.2,243.2,255.1c0.2,0.1,0.4,0.1,0.6,0.1c0-0.1,0-0.1,0-0.2
		C243.5,255,243.4,255.1,243.2,255.1z"
      />
      <path
        class="st3"
        d="M279.6,273c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0L279.6,273z"
      />
      <path
        class="st3"
        d="M268.4,250c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0-0.1-0.1-0.1L268.4,250z"
      />
      <path
        class="st3"
        d="M268.3,249.9c-0.4-0.2-0.9-0.5-1.3-0.7c-0.7-0.3-1.5-0.3-2.2-0.1c-0.3,0.1-0.5,0.2-0.7,0.4
		c-0.9,0.6-1.1,1.6-0.6,2.5c0.2,0.4,0.6,0.7,0.8,1.1c0.4,0,0.7-0.1,1-0.1c1.5-0.1,2.3-0.7,2.7-1.8c0-0.2,0.1-0.3,0.1-0.5
		C268,250.4,268.2,250.2,268.3,249.9C268.3,250,268.3,250,268.3,249.9C268.3,250,268.3,249.9,268.3,249.9L268.3,249.9z"
      />
      <path
        class="st3"
        d="M274.5,248.8c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C274.5,248.7,274.5,248.8,274.5,248.8z"
      />
      <path
        class="st3"
        d="M260.6,277.9h-0.1C260.5,277.9,260.5,277.9,260.6,277.9c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0.1,0v-0.1
		C260.9,278.1,260.8,278,260.6,277.9z"
      />
      <path
        class="st3"
        d="M261.2,278.5c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C261.1,278.3,261.2,278.4,261.2,278.5z"
      />
      <polygon class="st3" points="60.1,322.3 60.2,322.3 60.2,322.2 	" />
      <path
        class="st3"
        d="M204.5,265.9c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1
		C204.4,265.8,204.5,265.8,204.5,265.9z"
      />
      <path
        class="st3"
        d="M97.2,314c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C97.3,314.1,97.2,314.1,97.2,314L97.2,314
		z"
      />
      <path
        class="st3"
        d="M269.2,252l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C269.2,251.9,269.2,252,269.2,252z"
      />
      <path
        class="st3"
        d="M2,311.1L2,311.1C2.1,311.2,2.1,311.2,2,311.1L2,311.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1
		C2.1,311,2,311,2,311.1z"
      />
      <path
        class="st3"
        d="M89.6,292.3c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C89.7,292.4,89.6,292.4,89.6,292.3z"
      />
      <path
        class="st3"
        d="M25.3,303.4l-0.1-0.1c0,0.1,0,0.1,0,0.2C25.2,303.4,25.3,303.4,25.3,303.4z"
      />
      <path
        class="st3"
        d="M12.9,304.8L12.9,304.8L12.9,304.8c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C13,304.7,13,304.7,12.9,304.8z"
      />
      <path
        class="st3"
        d="M196.7,264.8v0.1V264.8c0.1,0,0.1-0.1,0.1-0.1C196.7,264.7,196.7,264.8,196.7,264.8z"
      />
      <path
        class="st3"
        d="M45.1,295.9c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2H45C45,296,45.1,296,45.1,295.9z"
      />
      <polygon class="st3" points="246.1,260.6 245.9,260.5 245.9,260.6 	" />
      <polygon class="st3" points="240.2,251.1 240.1,251.2 240.2,251.2 	" />
      <path
        class="st3"
        d="M272.2,244c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C272.1,243.9,272.2,243.9,272.2,244z"
      />
      <path
        class="st3"
        d="M272.6,243.3L272.6,243.3c-0.1,0.1-0.2,0.3-0.3,0.4l0,0C272.4,243.6,272.5,243.5,272.6,243.3
		C272.6,243.4,272.6,243.3,272.6,243.3z"
      />
      <path
        class="st3"
        d="M272.7,243.1c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1C272.8,243.2,272.7,243.2,272.7,243.1z"
      />
      <path
        class="st3"
        d="M246.2,248.5C246.3,248.4,246.3,248.4,246.2,248.5C246.2,248.4,246.2,248.4,246.2,248.5
		C246.2,248.4,246.2,248.5,246.2,248.5z"
      />
      <path
        class="st3"
        d="M246.3,248.3c0,0,0,0.1-0.1,0.1C246.3,248.4,246.3,248.4,246.3,248.3L246.3,248.3z"
      />
      <path
        class="st3"
        d="M207.7,256.4l0.1-0.1l0,0C207.7,256.3,207.7,256.4,207.7,256.4C207.6,256.4,207.7,256.4,207.7,256.4z"
      />
      <polygon class="st3" points="290.8,252.7 290.8,252.8 290.9,252.7 	" />
      <polygon class="st3" points="304.5,234.5 304.5,234.4 304.3,234.4 	" />
      <path
        class="st3"
        d="M240.9,264.7c-0.1,0-0.2,0-0.3,0c0,0.1,0.1,0.1,0.1,0.2C240.8,264.9,240.8,264.8,240.9,264.7z"
      />
      <polygon class="st3" points="9,297.5 9.1,297.5 9,297.4 	" />
      <path
        class="st3"
        d="M199.9,274l0.1,0.1l0.1-0.1l-0.1-0.1C200,273.9,199.9,273.9,199.9,274z"
      />
      <path
        class="st3"
        d="M45.9,307.9c0,0.1,0,0.1,0,0.2L46,308C46,307.9,46,307.9,45.9,307.9z"
      />
      <path
        class="st3"
        d="M194.3,256.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C194.3,256.6,194.3,256.7,194.3,256.7z"
      />
      <path
        class="st3"
        d="M290.4,255.1c-0.1,0-0.2,0-0.3,0C290.2,255.2,290.3,255.2,290.4,255.1c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C290.7,255.3,290.6,255.2,290.4,255.1z"
      />
      <path
        class="st3"
        d="M204.4,254.2c0,0.1-0.1,0.1-0.1,0.2l0,0c0,0,0,0,0.1,0C204.4,254.3,204.4,254.2,204.4,254.2z"
      />
      <polygon class="st3" points="296.4,234 296.3,233.9 296.3,234 	" />
      <polygon class="st3" points="42.2,310 42.3,310.1 42.3,310 	" />
      <path
        class="st3"
        d="M290.3,256.5h0.1C290.3,256.5,290.3,256.5,290.3,256.5c-0.1-0.1-0.2-0.2-0.4-0.3c0,0,0-0.1-0.1-0.1
		c0,0.1,0,0.1,0,0.2C290,256.3,290.1,256.4,290.3,256.5z"
      />
      <path
        class="st3"
        d="M240.6,267.5l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C240.5,267.4,240.5,267.5,240.6,267.5z"
      />
      <path
        class="st3"
        d="M290.5,256.5h-0.1l0,0C290.4,256.6,290.5,256.5,290.5,256.5z"
      />
      <path
        class="st3"
        d="M234,246.2c0,0-0.1-0.1-0.2-0.1l0,0l0,0C233.9,246.2,234,246.2,234,246.2z"
      />
      <path
        class="st3"
        d="M249.3,265.9c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C249.3,265.8,249.3,265.9,249.3,265.9z"
      />
      <path
        class="st3"
        d="M141.4,263.1l0.1,0.1l0.1-0.1l-0.1-0.1C141.5,263,141.5,263.1,141.4,263.1z"
      />
      <path
        class="st3"
        d="M252.6,237.3L252.6,237.3c-0.1,0.1-0.1,0.1-0.1,0.1l0,0L252.6,237.3z"
      />
      <path
        class="st3"
        d="M240.1,239.9l-0.1-0.1l-0.1,0.1l0.1,0.1L240.1,239.9z"
      />
      <path
        class="st3"
        d="M263,234.7c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0.1,0.2C262.9,234.7,263,234.7,263,234.7z"
      />
      <path
        class="st3"
        d="M201.2,246.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C201.3,246.6,201.3,246.7,201.2,246.7z"
      />
      <polygon class="st3" points="203.5,244.7 203.6,244.7 203.6,244.6 	" />
      <path
        class="st3"
        d="M220.7,273.8l0.1,0.1C220.8,273.9,220.8,273.8,220.7,273.8L220.7,273.8z"
      />
      <path
        class="st3"
        d="M220.8,274C220.8,274,220.8,273.9,220.8,274L220.8,274c0.1,0,0.3,0,0.4-0.1l0,0l0,0
		C221.1,273.9,221,274,220.8,274z"
      />
      <path
        class="st3"
        d="M114.8,297.6l-0.1,0.1l0.1,0.1l0.1-0.1C114.9,297.7,114.8,297.7,114.8,297.6z"
      />
      <polygon class="st3" points="85.2,306 85.3,306 85.2,305.9 	" />
      <polygon class="st3" points="179.8,286.8 179.9,286.8 179.9,286.7 	" />
      <path
        class="st3"
        d="M235.9,274.9c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C235.8,275.1,235.8,275,235.9,274.9z"
      />
      <path
        class="st3"
        d="M292,265.7l0.1,0.1l0.1-0.1l-0.1-0.1C292.1,265.6,292,265.6,292,265.7z"
      />
      <path
        class="st3"
        d="M292.6,266.3l-0.1,0.1l0.1,0.1l0.1-0.1C292.7,266.4,292.7,266.3,292.6,266.3z"
      />
      <polygon class="st3" points="237.7,279 237.8,279 237.8,278.9 	" />
      <polygon
        class="st3"
        points="172.1,302.2 172.2,302.3 172.2,302.2 172.3,302.2 172.2,302.2 	"
      />
      <path
        class="st3"
        d="M278,283.4c0.1,0,0.2,0.1,0.2,0.1h0.1c0,0,0,0,0-0.1C278.1,283.5,278.1,283.5,278,283.4z"
      />
      <path
        class="st3"
        d="M44.1,334.7c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C44.1,334.6,44.1,334.7,44.1,334.7z"
      />
      <path
        class="st3"
        d="M224.9,298.6L224.9,298.6c0.1-0.1,0.1-0.1,0.1-0.1l0,0L224.9,298.6z"
      />
      <path
        class="st3"
        d="M296.9,289.1c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1,0-0.2c0,0,0,0.1-0.1,0.1C296.9,288.9,296.9,289,296.9,289.1z"
      />
      <path
        class="st3"
        d="M203.7,316.1l0.1,0.1l0.1-0.1C203.9,316,203.8,316,203.7,316.1C203.8,316,203.7,316,203.7,316.1z"
      />
      <path
        class="st3"
        d="M229.4,313.7l-0.1-0.1l-0.1,0.1l0.1,0.1C229.3,313.8,229.3,313.7,229.4,313.7z"
      />
      <polygon class="st3" points="193.8,333.6 193.9,333.6 193.9,333.5 	" />
      <path
        class="st3"
        d="M228.1,267.9c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C228.2,267.8,228.2,267.9,228.1,267.9z"
      />
      <path
        class="st3"
        d="M57.7,144.1c0.6,0.6,1.4,0.7,2.3,0.4c1.9-0.5,3.2-2,3.1-3.6c0-0.4-0.2-0.9-0.3-1.4c2,0.2,3.5-0.1,4.6-0.7
		c-0.3,0-0.7,0.1-1,0.1c-0.6,0.1-1.2,0-1.9,0c0-0.2,0-0.4,0-0.6c1.3-0.1,2.6-0.3,4-0.4l0,0c0.1-0.2,0.3-0.4,0.4-0.6
		c0.2-0.4,0.3-0.7,0.4-1.1c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7c-1-0.1-2,0-2.9,0.4
		c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5c-0.7,0-1.2-0.1-1.7-0.1
		c-1.9,0.2-3.3,1.2-3.8,2.7c-0.2,0.6-0.1,1.1,0.4,1.5C56.5,142.9,57.1,143.5,57.7,144.1z"
      />
      <path
        class="st3"
        d="M120.4,135.3c0.2,0.3,0.5,0.5,0.9,0.8c0.8-0.3,1.6-0.5,2.4-0.9c1.1-0.6,0.6-1.6,0.9-2.5c1.6,0.2,2.8,0.8,4,1.3
		c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9c0.5,1.3,0.8,2.5,1.2,3.6c0,0.1,0.1,0.3,0.1,0.4c-1.2,0.2-1.9,0.6-2.2,1.2
		c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,1.1,1.2,2,1.1c0.1,0,0.1,0,0.2,0c1.2-0.3,1.7-1.2,1.3-2.9
		c1,0.1,2,0.2,3.2,0.2c-0.8-0.8-1-1-0.9-1.7c0-0.2,0.1-0.4,0.2-0.7c1.8,0.5,3.7,1.1,5.6,1.7c0-0.4,0.1-0.5,0-0.6
		c-0.5-0.9-1.2-1.6-1.1-2.8c0.1-0.9-1.4-1.4-2.4-0.8c-0.8,0.5-1.5,0.4-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.3c-1-0.3-1.9-0.7-2.9-1.1
		c-2.4,0.3-4.8,0.5-7.3,0.8c-0.1,0.1-0.2,0.2-0.2,0.3C119.7,134,119.8,134.6,120.4,135.3z"
      />
      <path
        class="st3"
        d="M121.8,131.5L121.8,131.5c0,0.5-0.4,0.6-0.7,0.8c1.7-0.2,3.4-0.4,5.1-0.5c-0.1,0-0.1-0.1-0.2-0.1
		c0.6-0.2,0.9-0.3,1.7-0.6c-0.7-0.1-1.4-0.3-2-0.4c-0.7-0.1-1.3-0.2-1.9-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C122.3,130.3,121.8,130.7,121.8,131.5z"
      />
      <path
        class="st3"
        d="M4.6,180.4c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.7-0.1,1.4-0.2,1.9-0.5
		c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4c0-0.1,0-0.2,0-0.4
		c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.5-0.1-0.7c-0.1-1.3-0.9-2.3-2.2-3c-0.1,0-0.1,0-0.2-0.1c-2.4-1.1-5.4-0.3-6.6,1.9
		C4.1,179,4.1,179.7,4.6,180.4C4.6,180.3,4.6,180.3,4.6,180.4z"
      />
      <path
        class="st3"
        d="M91.2,120.3c-0.2-1.2-1.3-2.2-2.7-2.5c0.9,0.9,1.8,1.9,2.7,2.8C91.2,120.5,91.2,120.4,91.2,120.3z"
      />
      <path
        class="st3"
        d="M82.9,122L82.9,122c2.4-0.2,4.9-0.4,7.3-0.6c-0.4-0.5-0.7-0.9-1-1.2c-0.8-0.8-1.6-1.7-2.4-2.6
		c-0.1,0-0.3,0-0.4,0.1C83.8,118.2,82.5,120.3,82.9,122z"
      />
      <path
        class="st3"
        d="M90.9,122.4c-0.4-0.1-0.8-0.2-1.2-0.1c-2.2,0.2-4.3,0.4-6.5,0.6c0.7,1.5,2.5,2.2,4.5,1.8
		C89.2,124.3,90.3,123.4,90.9,122.4z"
      />
      <path
        class="st3"
        d="M193.3,109.8c0.8,0.9,1.6,1.9,3.1,2c0.2,0,0.4,0.2,0.5,0.3c0,0.1,0,0.1,0,0.2c0.3,0,0.5,0,0.8-0.1
		c0.3-0.4,0.6-0.7,1-1c0.1-0.1,0.2-0.1,0.3-0.2c0.4-0.2,0.7-0.6,1-1l0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1
		c0.3-0.7,0.3-1.6-0.3-2.1s-1.4-1-2.2-1.3c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C192.9,109.1,193,109.5,193.3,109.8z"
      />
      <path
        class="st3"
        d="M196.6,113.2c-0.2,0.3-0.4,0.5-0.8,0.7c-1.2,0.8-1.3,2-0.3,2.8c0.8,0.7,1.9,0.6,2.8-0.2
		c0.9-0.8,0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8c0-0.1,0.1-0.2,0.1-0.2C197,113.1,196.8,113.2,196.6,113.2z"
      />
      <path
        class="st3"
        d="M181.9,115c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1c1,0.6,1.7,1.4,1.4,2.6c0,0.2,0.5,0.4,0.8,0.6
		c0.2-0.3,0.6-0.6,0.6-0.9c0-0.4-0.2-0.7-0.4-1.1c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.3,1.6,2.6,2.5,3.9
		c0.4,0.6,0.6,1,0.1,1.7s0,1.3,0.4,1.8c0.1,0.1,0.3,0.3,0.4,0.4c0.5-0.1,1.1-0.1,1.6-0.2c0.1-0.3,0.2-0.6,0.2-0.9
		c0.2,0,0.4,0,0.8,0.1c0-0.4,0.2-0.8,0-1c-0.4-0.8-0.3-2-1.6-2.3c-0.2-0.8-0.8-1.4-1.7-1.8c-0.1,0,0.1-0.3,0.1-0.4
		c-0.9-0.3-1.1-1.1-1.6-1.7c-0.2-0.2-0.5-0.5-0.8-0.5c-1.3-0.2-2.1-0.8-2.4-1.7v-0.1c-0.8,0.1-1.6,0.1-2.4,0.2
		C181.8,114.6,181.8,114.8,181.9,115z M191.3,123.6c-0.5-0.4-0.6-0.9-0.8-1.4C191,122.6,191.1,122.7,191.3,123.6z"
      />
      <path
        class="st3"
        d="M180.8,110c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0,1.1-0.1,1.6c-0.1,0.2,0,0.5,0.1,1c0.3-0.7,0.4-1.1,0.6-1.6
		c0.5,0.6,0.4,1.1,0.3,1.7c0,0.1,0,0.2,0,0.2s0,0,0,0.1c0.7-0.1,1.3-0.1,2-0.2c-0.2-0.4-0.3-0.7-0.5-1.1c-0.1-0.3-0.4-0.6-0.3-0.8
		c0.3-1.3-0.6-2.1-1.4-2.9c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C180.7,109,180.5,109.5,180.8,110z"
      />
      <path
        class="st3"
        d="M96.8,125.1c-0.3,0-0.7,0.1-1,0.1c-0.3-0.3-0.7-0.6-1-0.8c0.4,0.4,0.8,0.9,1.3,1.3l0,0
		c0.3-0.1,0.6-0.3,0.9-0.4C96.9,125.3,96.9,125.2,96.8,125.1z"
      />
      <path
        class="st3"
        d="M88.6,127.9c0.6,1.5,2.4,2.4,4.3,2c1.5-0.3,2.5-1.2,3-2.7c-1.1-1.2-2.3-2.4-3.4-3.6c-0.6,0-1.3,0.1-2,0.5
		C88.9,124.9,88.1,126.6,88.6,127.9z"
      />
      <path
        class="st3"
        d="M65.8,148.9c2-0.4,3.5-2.1,3.2-3.8c-0.3-1.8-2.3-2.8-4.4-2.4c-2.1,0.5-3.4,2.1-3,3.8
		C61.8,148.2,63.7,149.3,65.8,148.9z"
      />
      <path
        class="st3"
        d="M226.4,132.9l-0.1,0.1c-0.3,0.2-0.6,0.4-0.8,0.7c-0.6,0.7-0.8,1.6-0.5,2.5c0,0.1,0.1,0.1,0.1,0.1
		c0,0.1,0.1,0.2,0.1,0.2c0.2,0.5,0.6,0.8,1.1,1.1c0.3,0.2,0.7,0.3,1.1,0.4c0.1,0,0.2,0,0.3,0c1.2,0.2,2.4,0,3.3-1
		c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.3-0.9,0.4-1.3c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.9-0.6-1.3-0.9c0,0,0,0-0.1,0c-0.3-0.1-0.5-0.2-0.8-0.3c-1,0.1-1.9,0.3-2.9,0.4
		C226.5,132.9,226.4,132.9,226.4,132.9z"
      />
      <path
        class="st3"
        d="M99.8,124.6c1.5-0.3,3.5-2.3,3.5-3.4v-0.1c-2.3,0.2-4.7,0.4-7.1,0.6c-0.1,0.7,0,1.4,0.5,2
		C97.5,124.5,98.7,124.8,99.8,124.6z"
      />
      <path
        class="st3"
        d="M102.1,119.7c-0.7-0.2-1.5-0.4-2.3-0.4c-1.3-0.1-2.4,0.4-3.2,1.4c-0.1,0.1-0.1,0.2-0.1,0.2
		c2.2-0.2,4.4-0.4,6.5-0.6C102.9,120,102.6,119.8,102.1,119.7z"
      />
      <path
        class="st3"
        d="M296.4,112.2c-0.5,1.5,0.6,3,2.4,3.3c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4c0.1-0.9-1.6-2.6-2-2.8
		c-1.1-0.3-2.2-0.1-3.1,0.5C297.1,111,296.7,111.5,296.4,112.2z"
      />
      <path
        class="st3"
        d="M94.2,133.1c0.2,0.9,1.1,1.5,2.1,1.8c0.9-0.1,1.8-0.2,2.7-0.3c0.6-0.3,1-0.7,1.3-1.2c0.2-0.3,0.3-0.7,0.3-1
		c-0.9-0.9-1.7-1.8-2.5-2.7c-0.4-0.1-0.9-0.1-1.3,0C95.1,130.1,93.9,131.7,94.2,133.1z"
      />
      <path
        class="st3"
        d="M104,124.9c-1.7,0.4-2.8,1.8-2.6,3.2c0.3,1.5,1.9,2.4,3.7,2c1.8-0.4,3-1.8,2.6-3.3
		C107.4,125.4,105.8,124.5,104,124.9z"
      />
      <path
        class="st3"
        d="M220.4,116.1c0.6-0.2,1.2-0.5,1.6-0.9c-0.6-0.5-1.1-1-1.6-1.6c-0.9-1-1.8-1.5-2.8-1.8c-0.7,0.6-1.2,1.5-1,2.4
		C216.8,115.7,218.6,116.6,220.4,116.1z"
      />
      <path
        class="st3"
        d="M222.7,114.3c0.2-0.4,0.3-0.9,0.2-1.4c-0.2-0.9-1-1.5-2-1.8c-0.5,0-1,0.1-1.6,0.1
		C220.5,112.3,221.6,113.3,222.7,114.3z"
      />
      <path
        class="st3"
        d="M93.2,136.1c-2,0.2-3.9,0.4-5.9,0.6c-0.1,0.4-0.2,0.8-0.1,1.2c0.2,0.8,0.8,1.4,1.6,1.7
		c0.6,0.3,1.4,0.4,2.1,0.2c1-0.2,1.9-0.9,2.3-1.7c0.3-0.5,0.4-1,0.2-1.6C93.3,136.4,93.2,136.2,93.2,136.1z"
      />
      <path
        class="st3"
        d="M90,134.6c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6c-0.2,0.2-0.4,0.4-0.6,0.6c1.6-0.2,3.3-0.4,4.9-0.5
		C92,134.8,91.1,134.5,90,134.6z"
      />
      <path
        class="st3"
        d="M40.3,162.7c0.5,0.2,1,0.1,1.5-0.1c0.8-0.3,1.3-1,1.4-1.6l0,0c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.3-0.2-0.5
		c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0c-0.3-0.3-0.6-0.5-0.9-0.7c-1,0.1-2.1,0.3-3.1,0.4
		c0.3,0.6,0.5,1,0.8,1.3c0.3,0.5,0.7,1,1,1.5c0.2,0,0.5,0,0.7,0C39.3,162.2,39.9,162.5,40.3,162.7z"
      />
      <path
        class="st3"
        d="M35.6,160c0,0.1,0,0.3,0,0.4c0.1,0.5,0.4,0.8,0.9,1C36.2,161,35.9,160.5,35.6,160L35.6,160z"
      />
      <path
        class="st3"
        d="M109.9,130.8c-1.2,0.1-2.1,0.7-2.6,1.6c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.1,0.4,0.3,0.6,0.5
		c1.8-0.2,3.6-0.4,5.4-0.6c0-0.1,0-0.2,0-0.3c0-0.6-0.3-1.2-0.7-1.5C111.3,131,110.6,130.8,109.9,130.8z"
      />
      <path
        class="st3"
        d="M106.1,136.4C106.1,136.4,106.2,136.4,106.1,136.4c1.2,0.2,1.7-0.5,2-1.1c0.7,0.1,1.2,0.2,1.8,0.1
		c0.3,0,0.6-0.1,0.9-0.2c0.7-0.2,1.1-0.7,1.4-1.2h-0.1c-2.1,0.2-4.3,0.5-6.6,0.8c-0.2,0.2-0.3,0.4-0.2,0.7c0,0,0,0,0,0.1
		C105.6,135.8,105.9,136.1,106.1,136.4z"
      />
      <path
        class="st3"
        d="M293.2,110.7c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.9-1,0-3.2-0.2-3.3c-0.4-0.1-0.8-0.3-1.1-0.3
		c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5C291.6,109,292.1,110.1,293.2,110.7z"
      />
      <path
        class="st3"
        d="M228,110.9c0.3-0.1,0.6-0.3,0.9-0.5l0,0c-1.3,0.1-2.6,0.2-3.9,0.3c0.1,0.1,0.3,0.2,0.4,0.3
		C226.3,111.3,227.2,111.3,228,110.9z"
      />
      <path
        class="st3"
        d="M229.5,109.6c0.3-0.6,0.4-1.4,0-2c-0.2-0.3-0.4-0.6-0.6-1c0-0.1-0.1-0.1-0.1-0.2s-0.1-0.1-0.1-0.2
		c-0.6,0-1.3,0-2,0.1c-1,0.1-1.8,0.6-2.2,1.2c-0.2,0.2-0.3,0.5-0.4,0.8c-0.2,0.6-0.1,1.2,0.2,1.7C226,109.9,227.8,109.7,229.5,109.6
		z"
      />
      <path
        class="st3"
        d="M25.4,135.7c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9s-1.8-2-3.2-1.7
		C26.3,133.2,25.2,134.5,25.4,135.7z"
      />
      <path
        class="st3"
        d="M93.1,141.8c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3
		c0.1,0.6,0.4,1.1,0.6,1.8c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c0.1,0,0.3,0,0.4,0c1.2-0.1,2.3-0.7,2.7-1.7
		c0.1-0.3,0.2-0.6,0.1-1c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.8-0.6-2-0.6-3-0.1H94c-0.2,0.1-0.4,0.2-0.6,0.4
		C93.5,141.4,93.3,141.6,93.1,141.8z"
      />
      <path
        class="st3"
        d="M100.5,136.7c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5
		c0.3-0.1,0.6-0.2,0.8-0.3c0.5-0.3,0.9-0.7,1.1-1.2c0.2-0.4,0.2-0.8,0.1-1.2c0-0.1,0-0.1-0.1-0.2c-0.3-0.4-0.7-0.7-1-1.1
		c-0.1-0.1-0.1-0.1-0.2-0.2c-0.3-0.1-0.6-0.2-0.9-0.2s-0.7,0-1,0.1s-0.6,0.2-0.8,0.3C101,136.3,100.8,136.5,100.5,136.7z"
      />
      <path
        class="st3"
        d="M35.7,142.7c0,0,0.1-0.2,0.2-0.3c-1.4,0.2-2.8,0.3-4.2,0.5c0.7,0.9,2.1,1.4,3.3,0.9
		C35.5,143.5,36.1,143.3,35.7,142.7z"
      />
      <path
        class="st3"
        d="M36.8,141.5c0-0.2-0.1-0.3,0-0.4c-0.3-1.4-1.8-2.1-3.3-1.6c-1.4,0.4-2.3,1.6-2.1,2.7
		C33.2,141.9,35,141.7,36.8,141.5z"
      />
      <path
        class="st3"
        d="M59.2,133.9c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1.5,0.3-2.6,1.5-2.4,2.8
		C56.4,133.4,57.7,134.1,59.2,133.9z"
      />
      <path
        class="st3"
        d="M246.1,74.9c0.1,0.7,0.8,1,1.6,1c0.6,0,1.3,0,1.8-0.2c-0.9-0.7-1.7-1.1-2.9-1c-0.2,0-0.4,0-0.6,0
		C246.1,74.8,246.1,74.9,246.1,74.9z"
      />
      <path
        class="st3"
        d="M246.3,73.1c-0.1,0.1-0.1,0.2-0.2,0.4c0.2,0,0.3,0,0.5,0C246.6,73.3,246.5,73.2,246.3,73.1z"
      />
      <path
        class="st3"
        d="M251.1,74.6c-0.2,0-0.4,0-0.6,0c-0.1,0.1-0.2,0.3-0.4,0.4c0.1,0.1,0.2,0.1,0.2,0.2c0.1-0.1,0.3-0.2,0.4-0.3
		C251,74.8,251.1,74.7,251.1,74.6z"
      />
      <path
        class="st3"
        d="M247.7,72.6c0.6,0.5,1.6,0.9,2.5,0.9c0.5,0,1,0,1.5,0c0-0.3-0.1-0.5-0.2-0.8c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.2,0.1-0.7,0.3-1.2,0.5C247.4,72.4,247.6,72.5,247.7,72.6z"
      />
      <path
        class="st3"
        d="M299.2,123.5c0.5-0.1,1-0.4,1.4-0.7c-1.1,0.2-2.3,0.3-3.4,0.5C297.7,123.6,298.4,123.7,299.2,123.5z"
      />
      <path
        class="st3"
        d="M301.4,120.9c-0.2-1.2-1.5-2-3-1.7c-1,0.2-1.7,0.8-2.1,1.5c-0.2,0.3-0.2,0.7-0.2,1c0,0.1,0,0.1,0,0.2
		c0,0.2,0.2,0.4,0.3,0.6c1.6-0.2,3.3-0.5,4.9-0.7C301.4,121.6,301.4,121.3,301.4,120.9z"
      />
      <path
        class="st3"
        d="M211.2,104.3c0.5,0,1-0.1,1.4-0.1c0.2,0,0.4-0.1,0.6-0.1c0.9-0.3,1.3-1.2,1.1-2c0-0.2-0.1-0.4-0.2-0.6
		c0,0,0,0-0.1,0c-1.2,0.1-2.4,0.2-3.8,0.3c-0.1,0.1-0.1,0.1-0.1,0.2c-0.2,0.3-0.2,0.7-0.3,1l0.1,0.1
		C210.3,103.5,210.8,103.9,211.2,104.3z"
      />
      <path
        class="st3"
        d="M210.6,105.3c-0.6-0.5-1.2-1-1.8-1.5h-0.1c-0.1,0-0.1,0.1-0.1,0.1c-0.8,0.6-0.7,1.2,0.1,1.8
		c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0,0.3,0,0.4-0.1C210.1,105.8,210.4,105.6,210.6,105.3z"
      />
      <path
        class="st3"
        d="M102.2,149.8c-0.9,0.1-1.7,0.2-2.6,0.4c0.4,0.2,1,0.2,1.5,0.1C101.5,150.2,101.9,150,102.2,149.8z"
      />
      <path
        class="st3"
        d="M97.8,147.2c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.4,1.2,2.1c1.4-0.2,2.7-0.4,4.1-0.6l0.1-0.1
		c0.3-0.8,0-1.4-0.7-1.9c-0.4-0.2-0.8-0.4-1.3-0.6c0-0.4,0.3-0.9-0.4-1.1c-0.9-0.2-1.4,0.1-2.3,1.3c0.2,0.3,0.5,0.6,0.7,0.9
		c-0.1,0.1-0.1,0.1-0.2,0.2C98.4,147.5,98.1,147.4,97.8,147.2z"
      />
      <path
        class="st3"
        d="M19.5,164.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.7-1.5-1.4-3.1-2-4.6c-0.1,0.1-0.2,0.3-0.1,0.4
		c0.2,0.6-0.2,0.9-0.6,1.3c-0.9,0.9-1,1.8-0.5,2.7C17.2,164.7,18.3,164.9,19.5,164.1z"
      />
      <path
        class="st3"
        d="M19.4,159.7c0.2-0.4-0.1-0.7-0.5-0.8c0.2,0.3,0.3,0.7,0.5,1C19.3,159.9,19.4,159.8,19.4,159.7z"
      />
      <path
        class="st3"
        d="M21,163c-0.2-0.3-0.3-0.7-0.5-1.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.1-0.2-0.2-0.2-0.3c0.4,0.9,0.8,1.7,1.1,2.6
		C20.8,163.1,20.9,163,21,163z"
      />
      <path
        class="st3"
        d="M66,179.3c0.2,0.3,0.6,0.7,1.3,1c0.3-0.1,0.6-0.1,0.9-0.2c0.5-0.4,0.8-0.9,0.9-1.6c0-0.1,0-0.2,0-0.3
		c-0.1-0.7-0.9-1-1.6-1.3c0.2-0.2,0.3-0.3,0.4-0.4l0.1-0.1c0.4-0.5,0.3-0.7-0.1-1.3l-0.1-0.1c0-0.1-0.1-0.2,0-0.2
		c0.6-0.4,0.1-0.8-0.1-1c-0.3-0.2-0.7-0.4-1.1-0.5h-0.1c-0.6-0.1-1.3,0.4-1.1,0.8c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.6,0.1,1.3,0.6,1.8
		c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2l-0.1,0.1C66,178,65.7,178.7,66,179.3z"
      />
      <path
        class="st3"
        d="M70.7,168.1c-0.6,0.5-1.2,1.1-1.9,1.7c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0.1,0.7,0.2,1,0.3l0,0
		c0.1,0,0.3,0.1,0.4,0.1c0.8,0.4,1.6,0.5,2.4,0c1,1.3,1,1.3,2.6,1c0.1-0.5,0.2-1,0.3-1.6c0,0,0,0-0.1,0c-0.7-0.1-1.3-0.3-2-0.4
		c-0.3-0.9-0.7-1.4-1.6-1.7c-0.1,0-0.1,0-0.2-0.1C72.1,167.9,71.4,168,70.7,168.1z"
      />
      <path
        class="st3"
        d="M231.5,104.4c0.2,1.1,1.6,1.8,3,1.5s2.2-1.4,2-2.5s-1.5-1.7-2.9-1.5C232.3,102.2,231.3,103.3,231.5,104.4z"
      />
      <path
        class="st3"
        d="M251.5,99.4C251.5,99.4,251.5,99.3,251.5,99.4c-1.5,0-3,0.1-4.5,0.2c0,0.7,0.4,1.3,1.2,1.5
		c0.4,0.1,0.8,0.2,1.2,0.3c0.5,0.1,1,0.3,1.4,0.6c0.1,0.1,0.6-0.1,0.8-0.2c0.1-0.1,0.2-0.5,0.1-0.5c-0.2-0.2-0.3-0.3-0.3-0.5
		C251.2,100.3,251.4,99.8,251.5,99.4z"
      />
      <path
        class="st3"
        d="M248.8,97.5c-0.6,0.1-1.1,0.5-1.4,0.9c1.2-0.1,2.5-0.1,3.7-0.2C250.6,97.6,249.7,97.3,248.8,97.5z"
      />
      <path
        class="st3"
        d="M105.7,143.5c-0.4,0.9,0.5,1.8,1.6,1.9c0.8,0.1,1.5-0.1,2-0.5c0.1-0.1,0.3-0.3,0.4-0.4
		c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.4,0.3-0.8,0.2-1.2c-0.1-0.5-0.5-0.9-1.1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1
		c-0.7-1.1-0.7-1.1-2.3-1.2C105.8,141.5,106.3,142.3,105.7,143.5z"
      />
      <path
        class="st3"
        d="M238.8,107.5c-0.8,0.2-1.5,0.7-1.8,1.4c1.5-0.1,2.9-0.3,4.4-0.4C240.9,107.8,239.9,107.3,238.8,107.5z"
      />
      <path
        class="st3"
        d="M238.3,111.5c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.7-0.8,2-1.6c0.1-0.2,0.1-0.4,0.1-0.6l0,0
		c-1.6,0.1-3.2,0.3-4.8,0.4c0,0.1,0,0.3,0,0.4C237,110.7,237.6,111.3,238.3,111.5z"
      />
      <path
        class="st3"
        d="M266.5,89c-0.6,0.2-1.2,0.6-1.7,1c-0.7,0.6-0.8,1.5-0.3,2.1s1.8,0.9,2.6,0.6c0.8-0.3,1.5-0.7,2.2-1.1
		c-0.2-1.1-0.5-1.6-0.9-2.2C268,88.9,267.3,88.7,266.5,89z"
      />
      <path
        class="st3"
        d="M126,110c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.2,0.2-0.5,0.3-0.8,0.4C125.2,109.5,125.5,109.9,126,110z"
      />
      <path
        class="st3"
        d="M65.1,128.1c1.3-0.3,2.1-1.4,1.8-2.4c-0.2-0.7-0.9-1.2-1.8-1.4c-0.4,0-0.8,0.1-1.2,0.1
		c-1.1,0.4-1.9,1.5-1.6,2.4C62.6,127.9,63.8,128.4,65.1,128.1z"
      />
      <path
        class="st3"
        d="M82.2,117.5c1.2-0.3,2.1-1.4,1.9-2.4c0-0.2-0.2-0.4-0.3-0.5c-0.1-0.1-0.2-0.2-0.3-0.3
		c-0.5-0.5-1.4-0.7-2.2-0.5c-1.2,0.3-2.1,1.5-1.8,2.5C79.8,117.1,81,117.7,82.2,117.5z"
      />
      <path
        class="st3"
        d="M282.8,128.3c0.5,0,1-0.2,1.4-0.1c0.8,0.3,1.6,0.1,2.4-0.1c0.2-0.7,0.7-1.4-0.1-2.1c-0.8-0.6-1.6-0.1-2.5,0.1
		c-0.2-0.9-0.9-0.9-1.7-0.9c-0.4,0.1-0.8,0.1-1.2,0.2c-0.2,0.3-0.4,0.6-0.6,0.9C281.3,127,282,127.7,282.8,128.3z"
      />
      <path
        class="st3"
        d="M68.5,131.5c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3
		c-1.3,0.2-2.1,1.1-2,2.2C68.4,131.2,68.4,131.3,68.5,131.5z"
      />
      <path
        class="st3"
        d="M95.8,153.5c0-0.2,0.1-0.4,0-0.6c-0.2-1.1-1.3-1.7-2.6-1.5c-1,0.2-1.8,0.9-1.9,1.7c0,0.2,0,0.3,0,0.5
		c0.2,1.1,1.3,1.7,2.6,1.5c0.1,0,0.2-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5C95.5,154.2,95.7,153.9,95.8,153.5z"
      />
      <path
        class="st3"
        d="M255.5,97.9c0.2,0,0.3,0,0.5,0c0-0.1-0.1-0.1-0.2-0.2c-0.4-0.4-0.8-0.9-1.3-1.2c-0.3-0.2-0.6-0.4-1-0.5
		c-0.3,0-0.7,0-1,0c-0.7,0.9-0.9,1.6-0.6,2.1C253.1,98,254.3,98,255.5,97.9z"
      />
      <path
        class="st3"
        d="M253.8,99.2c0.3,0.1,0.5,0.1,0.8,0.2c-0.2,1,0.1,1.7,1.2,2.2c0.6-1.2,0.6-1.2-0.5-2.5l0,0
		C254.8,99.1,254.3,99.1,253.8,99.2z"
      />
      <path
        class="st3"
        d="M286.2,121.7c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C285.9,121.4,286.1,121.5,286.2,121.7z"
      />
      <path
        class="st3"
        d="M27.8,145.9c0.1,0.1,0.2,0.3,0.3,0.4C28,146.2,27.9,146,27.8,145.9z"
      />
      <path
        class="st3"
        d="M26,145.2c-0.1,0-0.2,0-0.3,0c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c-0.7,0.5-1.2,1.3-1.1,2c0.2,1,1.4,1.5,2.6,1.3
		c0.6-0.1,1.1-0.4,1.4-0.8C27.2,147.1,26.6,146.2,26,145.2z"
      />
      <path
        class="st3"
        d="M81.2,128.1c-0.4-1.6-0.1-3.4-0.8-5c-2.1,0.8-3,1.8-2.6,3.2C78.1,127.7,79.2,128.3,81.2,128.1z"
      />
      <path
        class="st3"
        d="M34.1,152.9c-0.3-1-1.3-1.5-2.5-1.2c0.6,1,1.3,2,1.9,3C34,154.2,34.2,153.5,34.1,152.9z"
      />
      <path
        class="st3"
        d="M32.3,155.3c0.1,0,0.1,0,0.2-0.1c-0.7-1-1.3-2-2-3.1c-0.6,0.5-0.9,1.1-0.8,1.8
		C29.9,154.9,31.2,155.5,32.3,155.3z"
      />
      <path
        class="st3"
        d="M43.3,157c1.1-0.2,2.2-0.3,3.3-0.5c0.1-0.1,0.3-0.3,0.3-0.5c0-0.1,0.1-0.1,0.1-0.2c0.3-1.1-0.7-1.6-1.5-2.1
		c-0.9,0.4-1.6,0.7-2.4,1.1C43.3,155.5,43.3,156.2,43.3,157z"
      />
      <path
        class="st3"
        d="M43.4,157.8c0.1,0.4,0.2,0.8,0.4,1.2c0.3-0.5,0.5-0.9,0.8-1.3C44.1,157.7,43.8,157.7,43.4,157.8z"
      />
      <path
        class="st3"
        d="M83,132.1c0.2,0.9,1.5,1.5,2.5,1.2c1.1-0.3,1.9-1.3,1.7-2.2c-0.2-0.9-1.3-1.5-2.4-1.3
		C83.6,130.1,82.7,131.2,83,132.1z"
      />
      <path
        class="st3"
        d="M259.2,114.4c0.9-0.5,1.5-0.7,2.2-1.1c0.2,0.2,0.4,0.5,0.6,0.7c1-1,1.2-2.3,2.9-2.3h0.1c0,0,0-0.1-0.1-0.1
		c-0.1-0.3-0.2-0.5-0.3-0.8c-0.7,0.4-1.4,0.8-2,1.2c0.2-0.5,0.5-0.8,0.8-1.1c0.4-0.4,0.8-0.8,0.3-1.2c-0.4-0.3-0.9,0-1.3,0.3
		c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4-0.2-0.7-0.3-1.6-0.6c0.6,1.2,0.3,2-0.5,2.7C259.3,113.3,259.3,113.7,259.2,114.4z"
      />
      <path
        class="st3"
        d="M2.2,133C2,132.1,1,131.6,0,131.7v3.6c0.2,0,0.3,0,0.5-0.1C1.7,135,2.5,133.9,2.2,133z"
      />
      <path
        class="st3"
        d="M269.7,121c0.3,0.3,0.6,0.6,0.9,0.9c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2
		c-0.4,0.1-0.8,0.3-1.1,0.5c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5C270.5,119.6,270,120.2,269.7,121L269.7,121z"
      />
      <path
        class="st3"
        d="M88.7,149.9C88.8,149.9,88.8,149.9,88.7,149.9c0.5,0.2,1.1,0.1,1.7-0.2c-0.7-1.2-0.1-2.8-1.6-3.9
		c-0.6,0.4-1.2,0.7-1.5,1.1c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.8-0.3,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.3,0.6,0.6,0.9,0.9
		C88.4,149.7,88.5,149.8,88.7,149.9z"
      />
      <path
        class="st3"
        d="M70.6,138.9c-0.1,0-0.3,0.1-0.4,0.2c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c1,0.7,1.9,1.4,2.9,2
		c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		C71.9,139,71.2,138.8,70.6,138.9z"
      />
      <path
        class="st3"
        d="M62.2,170.3c0-0.3-0.1-0.5-0.2-0.7c-1.4,0.2-2.8,0.5-4.1,0.7c-0.1,0.2-0.1,0.4-0.1,0.6
		c0.1,0.5,0.4,0.9,0.8,1.3c0.5,0.4,1.2,0.5,2,0.2c0.1-0.9-1.7-1.1-0.5-2.2C60.6,170.5,61.3,171,62.2,170.3z"
      />
      <path
        class="st3"
        d="M143.3,128.4c0,0.1,0.1,0.1,0.2,0.2c0.7,0.2,1.5,0.3,2.3,0.5c0.1-0.3,0.2-0.5,0.2-0.6s0.1-0.2,0.1-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.5,1-0.7
		c0.2-0.1,0.5-0.2,0.7-0.2c-0.6-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.7,0.5-1.3,0.8-1.8,1.3c-0.2,0.1-0.2,0.3-0.3,0.4
		c-0.1,0.3,0.1,0.7,0.2,1c0,0.1-0.2,0.3-0.4,0.5C143.1,128,143.2,128.3,143.3,128.4z"
      />
      <path
        class="st3"
        d="M236.2,121.3c0.4,0.2,0.9,0.3,1.4,0.2c0.8-0.2,1.4-0.8,1.6-1.4c-1.2,0.1-2.4,0.3-3.6,0.4
		C235.7,120.8,235.9,121.1,236.2,121.3z"
      />
      <path
        class="st3"
        d="M237.8,118.4c-0.3,0-0.5,0-0.8,0c-0.8,0.1-1.3,0.6-1.5,1.2c1.2-0.1,2.4-0.2,3.6-0.4
		C238.9,118.9,238.4,118.5,237.8,118.4z"
      />
      <path
        class="st3"
        d="M190.7,96.6c-0.9,0.2-1.4,0.6-1.5,1.1c1.3-0.1,2.6-0.1,3.8-0.2C192.6,96.7,191.8,96.3,190.7,96.6z"
      />
      <path
        class="st3"
        d="M192.9,98.6c-1.1,0-2.2,0.1-3.3,0.1c0.5,0.4,1.2,0.6,2.1,0.4C192.2,99.1,192.6,98.9,192.9,98.6z"
      />
      <path
        class="st3"
        d="M249.4,104.5c-1,0.2-1.7,1.1-1.5,1.9s1.2,1.2,2.1,1c1.2-0.3,1.8-1,1.6-1.8
		C251.4,104.8,250.4,104.3,249.4,104.5z"
      />
      <path
        class="st3"
        d="M136.3,100c0.2,0,0.4,0,0.6,0c0.4-0.3,0.8-0.6,1.2-0.9c0.2,0.3,0.4,0.6,0.6,0.8c0.8,0,1.5-0.1,2.3-0.1
		c0-0.3,0-0.6-0.2-0.7c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5
		C135.2,99.1,135.6,99.7,136.3,100z"
      />
      <path
        class="st3"
        d="M274.3,121.9c0.1,0.3,0.2,0.6,0,0.8c-0.9,1.2-0.4,2,0.6,2.8c0.1,0,0.2,0,0.4-0.1l0.1-0.1l0.1-0.1
		c0.6-0.6,1.4-1.2,1-1.9c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.6-1.2-0.7
		C274.2,121.5,274.2,121.5,274.3,121.9z"
      />
      <path
        class="st3"
        d="M120,142.9c-1,0.2-1.6,0.9-1.6,1.7c0,0.1,0,0.2,0.1,0.3c0.2,0.6,0.9,1,1.6,1c0.1,0,0.3,0,0.4,0
		c1-0.2,1.7-1.1,1.5-1.9C121.8,143.2,120.9,142.7,120,142.9z"
      />
      <path
        class="st3"
        d="M58.7,126.6c0.9-0.2,1.6-1,1.6-1.7v-0.1c-1.2,0.1-2.4,0.2-3.5,0.3c0,0.1-0.1,0.2,0,0.3
		C56.7,126.2,57.7,126.8,58.7,126.6z"
      />
      <path
        class="st3"
        d="M58.2,123.7c-0.6,0.1-1,0.4-1.3,0.8c1-0.1,2-0.2,3-0.3C59.5,123.8,58.9,123.5,58.2,123.7z"
      />
      <path
        class="st3"
        d="M300.5,87.6c0.4,0.5,1.1,0.8,1.9,0.7c0.5-0.1,0.9-0.4,1.2-0.7C302.5,87.6,301.5,87.6,300.5,87.6z"
      />
      <path
        class="st3"
        d="M303.3,85.7c-0.4-0.3-0.9-0.4-1.5-0.4c-0.7,0.1-1.2,0.6-1.5,1.1c1.1,0,2.2-0.1,3.4-0.1
		C303.7,86.1,303.6,85.9,303.3,85.7z"
      />
      <path
        class="st3"
        d="M26.3,163.5c-0.1-0.4-0.5-0.7-0.7-1.1c-0.6,0.1-1,0.1-1.4,0.3c-1,0.3-1.5,1.1-1.2,1.9c0.3,0.7,1.3,1.1,2.2,0.8
		C26,165.1,26.6,164.3,26.3,163.5z"
      />
      <path
        class="st3"
        d="M280.6,135.3c1.5,0.6,1.5,0.6,2.9-0.2c0.1-0.5,0.2-1.1,0.3-1.5c-0.2-0.2-0.4-0.3-0.6-0.4
		c-0.9,0.2-1.9,0.3-2.8,0.5C280.6,134.2,280.1,134.8,280.6,135.3z"
      />
      <path
        class="st3"
        d="M111.3,149.5c0.1,0.8,0.9,1.3,1.9,1.2c0.1,0,0.1,0,0.1,0c1-0.2,1.6-1,1.4-1.8c-0.1-0.3-0.2-0.5-0.4-0.7l0,0
		c-0.1,0-0.1,0-0.2,0c-0.9,0.1-1.8,0.2-2.6,0.4C111.4,148.8,111.3,149.1,111.3,149.5z"
      />
      <path
        class="st3"
        d="M235,101.3c0.5-0.2,1-0.6,1.2-1.1c-1.1,0.1-2.2,0.1-3.3,0.2v0.1C233.1,101,234.4,101.4,235,101.3z"
      />
      <path
        class="st3"
        d="M234.7,98.3c-0.5,0.1-1,0.5-1.3,0.9c1-0.1,2-0.1,3-0.2C236,98.4,235.4,98.1,234.7,98.3z"
      />
      <path
        class="st3"
        d="M42.6,135.8c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C41.5,134.4,41.8,135.2,42.6,135.8z"
      />
      <path
        class="st3"
        d="M192.2,117.6c0.6-0.3,1.1-0.7,1.6-0.9c0-0.9,0-1.7,0-2.8c-0.9,0.5-1.6,0.8-2.1,1.2c-0.7,0.4-1.1,1-1.1,1.7
		C190.7,117.7,191.4,118,192.2,117.6z"
      />
      <path
        class="st3"
        d="M24.1,160.3h0.1c0.9-0.3,1.5-1,1.3-1.8c-0.2-0.7-1-1.1-1.9-1c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.6,1.1-1.4,1.8
		C22.2,160.1,23.2,160.5,24.1,160.3z"
      />
      <path
        class="st3"
        d="M51.2,142.6c0.3-1.9-0.6-2.7-3-2.8C47.5,141.8,48.4,142.8,51.2,142.6z"
      />
      <path
        class="st3"
        d="M75.3,130c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8C73.6,129.8,74.4,130.2,75.3,130z"
      />
      <path
        class="st3"
        d="M94.5,117.7c0.9-0.2,1.4-1,1.3-1.7s-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7C92.7,117.5,93.6,117.9,94.5,117.7z"
      />
      <path
        class="st3"
        d="M71.5,176.3c0.4,0,0.7,0,0.9-0.1c0.7-0.1,0.8-0.4,1.3-1.5c-0.6-0.3-1.2-0.7-1.7-1c-0.5,0.2-0.8,0.2-1,0.4l0,0
		c-0.3,0.2-0.6,0.5-1,0.8c-0.5,0.3-0.8,0.7-0.6,1.2l0,0l0,0c-0.1,0.2-0.1,0.4-0.1,0.6l0.3,0.1c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0
		C70.5,176.3,71,176.3,71.5,176.3z"
      />
      <path
        class="st3"
        d="M105.4,118.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C105.9,117.1,105.3,117.8,105.4,118.6z"
      />
      <path
        class="st3"
        d="M104.2,115C104.2,115,104.3,115,104.2,115c1-0.2,1.5-0.9,1.4-1.6c0-0.1,0-0.2-0.1-0.3
		c-0.2-0.6-0.9-0.9-1.7-0.8c-0.9,0.1-1.6,1-1.5,1.7C102.5,114.7,103.3,115.2,104.2,115z"
      />
      <path
        class="st3"
        d="M245.4,124.6c0.7,0.9,1.2,0.8,2.1-0.3c-0.7-1.1-2-1.5-3.3-1.9c-0.3-0.1-0.9,0-1.2,0.2c-0.4,0.3-0.2,0.6,0,0.9
		c0.1,0.1,0.1,0.3,0.2,0.5C244.2,123.9,244.9,123.9,245.4,124.6z"
      />
      <path
        class="st3"
        d="M31.4,164.6c-0.3-0.6-0.9-0.9-1.7-0.9c-0.9,0.1-1.5,0.4-1.7,1.3c0.8,0.5,1.5,1.1,2.4,1.7
		C31.4,166.1,31.8,165.4,31.4,164.6z"
      />
      <path
        class="st3"
        d="M133.4,100.1c0.5-0.6,0.7-1.2,0.5-1.8c-0.2-0.8-1.3-0.8-2.3-0.5c-0.3,0.9-0.3,1.6,0,2.4
		C132.2,100.2,132.8,100.2,133.4,100.1z"
      />
      <path
        class="st3"
        d="M271.4,93.8c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0,0.4,0,0.6,0c0.3-0.1,0.5-0.2,0.8-0.4c0.4-0.3,0.7-0.7,1-1.2
		c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3
		C270.9,93.4,271.1,93.7,271.4,93.8z"
      />
      <path
        class="st3"
        d="M40.5,150c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.4,0.7-0.4,1.4,0.1,2.1C38.3,150.1,39,150.3,40.5,150z"
      />
      <path
        class="st3"
        d="M154.3,139.3c-1-0.7-1.2-0.7-1.7,0.2c-0.2,0.4-0.7,0.4-0.9,0.7c-0.3,0.3-0.7,0.7-0.7,1s0.5,0.6,0.8,0.8
		c0.1,0.1,0.3,0.1,0.5,0.1s0.4,0,0.5-0.1c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.2-0.7,0.4-1s0.4-0.6,0.6-1
		C154,139.7,154.2,139.5,154.3,139.3z"
      />
      <path
        class="st3"
        d="M72.6,149.8c-0.2-0.7-1-1.1-1.8-0.8c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3
		c0.3,0.4,0.9,0.6,1.5,0.4C72.3,151.1,72.8,150.5,72.6,149.8z"
      />
      <path
        class="st3"
        d="M295.8,101c0.8-0.1,1.4-0.8,1.3-1.5s-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4C294.2,100.7,295,101.2,295.8,101
		z"
      />
      <path
        class="st3"
        d="M255.8,115c0.1-0.7,0.2-1.1,0.3-1.5c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.7-1.5,0.4-2.1-1.1-2.2c-0.1,0-0.3,0-0.4,0
		c-0.7,0-1.1,0.4-0.8,0.9s0.5,0.9,0.4,1.4C254.9,114.3,255.4,114.5,255.8,115z"
      />
      <path
        class="st3"
        d="M131.3,145.8c0.3,0.4,1,0.7,1.6,0.5c0.5-0.1,0.9-0.5,1.1-0.9c-0.7,0.1-1.3,0.2-2,0.3
		C131.8,145.7,131.5,145.8,131.3,145.8z"
      />
      <path
        class="st3"
        d="M132.4,143.9c-0.7,0.1-1.1,0.6-1.2,1.1c0.9-0.1,1.9-0.3,2.8-0.4C133.7,144.1,133.1,143.8,132.4,143.9z"
      />
      <path
        class="st3"
        d="M59.2,158.8c-0.3,0.9,0,1.5,0.8,1.9c0.7,0.4,1.5,0.5,2.3-0.1C61.9,158.9,61.4,158.6,59.2,158.8z"
      />
      <path
        class="st3"
        d="M42.6,148c0.1-1.6-0.4-2.1-2.6-2.4C39.8,147.5,40.5,148.1,42.6,148z"
      />
      <path
        class="st3"
        d="M37.1,167.4c0.1-0.1,0.2-0.2,0.3-0.2c0.9-0.7,1.1-1.1,0.8-1.6c-0.1-0.1-0.2-0.2-0.3-0.3
		c-0.3-0.3-0.7-0.4-1.2-0.3c-0.7,0.1-1.1,0.5-1.2,1.1C35.4,167,36.1,167.3,37.1,167.4z"
      />
      <path
        class="st3"
        d="M256.2,93.5c0.7-0.4,1.3-0.7,1.9-0.9c0.1-0.8-0.2-1.3-1.2-1.8c-0.1,1.1-2.1,0.7-2.2,2.1
		C255.3,93.1,255.8,93.3,256.2,93.5z"
      />
      <path
        class="st3"
        d="M141.1,135.8c0.1-0.8,0.1-1.5,0.2-2.3c-0.6,0.3-1.2,0.5-1.7,0.8c-0.6,0.2-1.1,0.5-1.7,0.7
		c0.4,0.4,0.7,1.1,1.2,1.2C139.7,136.3,140.4,136,141.1,135.8z"
      />
      <path
        class="st3"
        d="M123.7,149.9c0.4,0.5,0.7,0.8,1.1,1c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8s-1.2-0.4-2.1,0.2
		C124.2,149.5,124,149.7,123.7,149.9z"
      />
      <path
        class="st3"
        d="M10.1,187.8c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7c-0.1-0.2-0.1-0.4-0.3-0.5
		c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C9,187.1,9.3,187.6,10.1,187.8z"
      />
      <path
        class="st3"
        d="M19.2,170.6c0.7-0.2,1.2-0.9,1.1-1.5s-0.9-1-1.6-0.8s-1.3,0.8-1.2,1.4c0,0.3,0.3,0.6,0.6,0.7
		c0.2,0.1,0.4,0.2,0.7,0.2C18.9,170.6,19,170.6,19.2,170.6z"
      />
      <path
        class="st3"
        d="M65.9,164.8c0.6,0.4,1.3,0.5,2,0.3c0.2-0.1,0.3-0.1,0.5-0.2c0-0.1,0-0.1-0.1-0.2c-0.5-1.5-1-1.7-2.9-1.6
		C64.8,163.9,65.3,164.4,65.9,164.8z"
      />
      <path
        class="st3"
        d="M262,81.4c0.6-0.1,1.2-0.1,1.8-0.2c1.1-0.1,2.3-0.2,3.5-0.3c-1.5-1.2-3-1.3-4.3-0.5
		C262.7,80.7,262.3,81,262,81.4z"
      />
      <path
        class="st3"
        d="M111.3,138.3c0-0.1-0.1-0.1-0.1-0.1c-0.2-0.5-0.9-0.8-1.6-0.6s-1.1,0.7-1,1.3c0,0.1,0.1,0.2,0.1,0.3
		c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.2,0.7,0.3,1.2,0.2c0.3-0.1,0.6-0.2,0.8-0.4C111.3,139.1,111.4,138.7,111.3,138.3z"
      />
      <path
        class="st3"
        d="M86.8,150.6c-0.1-0.6-0.8-1-1.6-0.8c-0.8,0.1-1.3,0.8-1.2,1.4c0,0.1,0.1,0.2,0.1,0.3c0.4-0.1,0.8-0.1,1.2-0.2
		c0.5-0.1,0.9-0.1,1.4-0.2C86.9,150.9,86.9,150.8,86.8,150.6z"
      />
      <path
        class="st3"
        d="M244.2,112.3c0.5-0.3,1-0.6,1.5-0.9c0.4,0.5,1,0.4,1.6,0c-0.5-0.9-1.4-1-2.5-1c-0.8,0-1.2,0.2-1.5,0.7
		c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3C243.5,112,243.8,112.2,244.2,112.3z"
      />
      <path
        class="st3"
        d="M132.1,121.4c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C131.6,122.4,132,122,132.1,121.4z"
      />
      <path
        class="st3"
        d="M203.1,107.2c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.4-0.3,0.6-0.7,0.6-1.1
		c-0.1-0.6-0.9-1-1.6-0.8C203.5,106,203,106.7,203.1,107.2z"
      />
      <path
        class="st3"
        d="M207.2,111.1c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.8-1.1,0.9-1.5,0.3-1.9l0,0
		c-0.4-0.3-0.8-0.4-1.3-0.2h-0.1c-0.5,0.2-0.8,0.5-0.8,1C206.3,110.6,206.5,110.9,207.2,111.1z"
      />
      <path
        class="st3"
        d="M110.1,111.7c0.7-0.2,1.1-0.8,0.9-1.4c-0.2-0.5-0.9-0.9-1.5-0.7c-0.7,0.2-1.1,0.8-1,1.4S109.4,112,110.1,111.7
		z"
      />
      <path
        class="st3"
        d="M262.8,79.8c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C261.3,79.6,262.1,79.9,262.8,79.8z"
      />
      <path
        class="st3"
        d="M16.1,175.4c0.6-0.1,1.2-0.8,1-1.3c-0.1-0.5-0.7-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.2
		C14.7,175.1,15.4,175.5,16.1,175.4z"
      />
      <path
        class="st3"
        d="M110.5,122.5c-0.1,0.2-0.1,0.4,0,0.5c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3
		c-0.1-0.3-0.4-0.6-0.8-0.7c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1C110.9,121.9,110.6,122.2,110.5,122.5z"
      />
      <path
        class="st3"
        d="M26.5,110.8c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.6-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C25.2,110.5,25.9,110.9,26.5,110.8z"
      />
      <path
        class="st3"
        d="M139.6,124.2c-0.7,0.2-1.3,0.5-1.3,1.2c0.5,0.5,1,0.9,1.5,1.5c0.7,0,1.1-0.3,1-0.8
		C140.6,125.4,140.4,124.7,139.6,124.2z"
      />
      <path
        class="st3"
        d="M145.7,133.9c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.5,0.1-1,0.4-1,1
		c0,0.4,0.1,0.8,0.7,0.9c0.6,0,1.2-0.1,1.7-0.1C146.2,134.8,146.3,134.2,145.7,133.9z"
      />
      <path
        class="st3"
        d="M146.2,135.4C146.2,135.4,146.2,135.3,146.2,135.4C146.1,135.3,146.1,135.3,146.2,135.4
		C146.1,135.4,146.1,135.4,146.2,135.4C146.1,135.4,146.2,135.4,146.2,135.4z"
      />
      <path
        class="st3"
        d="M100.6,97.9c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C99.2,97.6,99.9,98,100.6,97.9z"
      />
      <path
        class="st3"
        d="M245,133.3c0.5-0.1,1-0.7,0.9-1.1c0-0.1,0-0.1-0.1-0.2c-0.2-0.5-1-1-1.4-0.9c-0.5,0.1-0.9,0.6-0.8,1.1l0,0
		c0.4,0.3,0.8,0.7,1.2,1C244.8,133.2,244.9,133.3,245,133.3z"
      />
      <path
        class="st3"
        d="M77.8,122c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C76.6,121.8,77.2,122.1,77.8,122z"
      />
      <path
        class="st3"
        d="M208.6,108c1.2-0.2,1.5-1.1,0.6-2c-0.5,0.2-1.1,0.4-1.6,0.7c-0.2,0.2-0.4,0.8-0.2,0.9
		C207.7,107.9,208.3,108.1,208.6,108z"
      />
      <path
        class="st3"
        d="M146.8,135.9c0.5,0.1,0.9,0.2,1.1,0.6c0.2,0.4,0.7,0.5,1.2,0.2c0.4-0.2,0.4-0.9-0.1-1.2s-1.1-0.6-1.7-0.9
		c-0.4,0.2-0.7,0.4-1.1,0.6C146.4,135.6,146.6,135.9,146.8,135.9z"
      />
      <path
        class="st3"
        d="M85.1,176.9c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.3,0-0.7-0.2-0.9c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.1-0.9,0l-0.1,0.1
		c-0.4,0.3-0.9,0.7-0.9,1.2c0,0.2,0,0.4,0.2,0.5C83.9,177.1,84.5,177,85.1,176.9z"
      />
      <path
        class="st3"
        d="M24.1,127.1c-0.2,1.2-0.3,2.4-0.4,3.5C25.6,129.2,25.7,128.2,24.1,127.1z"
      />
      <path
        class="st3"
        d="M238.4,132.9c0.4,0.6,0.7,1.2,1.5,1.3c0.3,0.1,0.7-0.2,1.1-0.3C240.1,132.2,240,132.1,238.4,132.9z"
      />
      <path
        class="st3"
        d="M136.8,150.4L136.8,150.4c-0.3,0.5-0.1,1.1,0.5,1.2c0.7,0.2,1.2-0.1,1.9-1.4c-0.2-0.1-0.4-0.1-0.6-0.2
		c-0.3-0.1-0.5-0.1-0.7-0.1s-0.3,0-0.4,0C137.2,149.9,137,150.1,136.8,150.4z"
      />
      <path
        class="st3"
        d="M2.8,184.7c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C2.8,184.6,2.8,184.7,2.8,184.7z"
      />
      <path
        class="st3"
        d="M48.6,153.8c-0.4-1.3-0.4-1.4-2.2-1.8C46.3,153.7,47,154.1,48.6,153.8z"
      />
      <path
        class="st3"
        d="M246.7,70.8c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C245.6,70.5,246.1,70.9,246.7,70.8z"
      />
      <path
        class="st3"
        d="M136.1,103.3c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2S135.4,103.2,136.1,103.3z"
      />
      <path
        class="st3"
        d="M129.7,100.1c-0.2,0-0.3,0.1-0.4,0.3c0.4,0,0.8,0,1.2-0.1C130.3,100.1,130,100,129.7,100.1z"
      />
      <path
        class="st3"
        d="M130.2,102.2c0.4-0.1,0.6-0.4,0.7-0.7c-0.6,0-1.2,0.1-1.9,0.1C129.2,102,129.7,102.3,130.2,102.2z"
      />
      <path
        class="st3"
        d="M82.4,171.6c-1.6,1.4-1.6,1.4-0.7,2.4C83.6,172.6,83.6,172.6,82.4,171.6z"
      />
      <path
        class="st3"
        d="M180.3,105.2c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C181,105.9,181,105.6,180.3,105.2z"
      />
      <path
        class="st3"
        d="M211.4,107.4c-0.8,0.2-1.3,0.6-1.5,1.5c1.2-0.2,2.3-0.2,3.3-0.7C212.8,107.5,212.2,107.2,211.4,107.4z"
      />
      <path
        class="st3"
        d="M91.6,162.8c-0.4,0.1-0.7,0.3-0.9,0.5c-0.1,0.1-0.1,0.2-0.1,0.4c0.7-0.1,1.4-0.2,2.1-0.3
		c0-0.1-0.1-0.2-0.1-0.2C92.4,162.9,92,162.8,91.6,162.8z"
      />
      <path
        class="st3"
        d="M288.2,113c0.1,0.4,0.7,0.7,1.2,0.6s0.9-0.6,0.9-1.1c0-0.4-0.6-0.8-1.1-0.7C288.6,112,288.1,112.5,288.2,113z"
      />
      <path
        class="st3"
        d="M259.2,84.1L259.2,84.1c-0.4-0.3-0.7-0.7-1.1-1c-0.2,0.2-0.4,0.3-0.6,0.6C257.9,84.2,258.5,84.3,259.2,84.1z"
      />
      <path
        class="st3"
        d="M260.1,82.5c-0.3,0-0.5,0-0.7,0.1c0.2,0.2,0.5,0.4,0.7,0.6C260.1,83,260.1,82.8,260.1,82.5z"
      />
      <path
        class="st3"
        d="M94.4,157c0.7-0.6,0.5-0.9-0.9-1.5c-1.1,1.1-1.1,1.3,0,2c0.2-0.1,0.3-0.2,0.4-0.2
		C94.1,157.2,94.3,157.1,94.4,157z"
      />
      <path
        class="st3"
        d="M264.1,88.5c-0.7,0-1.4,0-2.1,0.1c0,0.1,0,0.2,0,0.3c0.1,0.4,0.7,0.7,1.3,0.6
		C263.7,89.3,264.1,88.9,264.1,88.5z"
      />
      <path
        class="st3"
        d="M39.4,128.7c-0.1-0.9-0.7-1.4-1.9-1.6C37.1,128.8,37.7,129.2,39.4,128.7z"
      />
      <path
        class="st3"
        d="M187.6,110.2c0.5-0.1,1.1-0.7,0.8-1.1c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-1,0.5-0.9,1
		C186.5,110,187.1,110.3,187.6,110.2z"
      />
      <path
        class="st3"
        d="M179.2,113.4c0.2-0.3,0.2-0.7,0.1-1l-0.1-0.1c-0.2,0-0.6,0-0.8,0c-0.5,0.2-0.9,0.5-1.4,0.9
		c0.4,0.3,0.7,0.5,1,0.6C178.4,114,178.8,113.9,179.2,113.4z"
      />
      <path
        class="st3"
        d="M201.3,103.1c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.5-0.2-0.8-0.4-1.2-0.6c-0.3,0-0.6,0-0.9,0.1
		C201.4,102.4,201.2,102.8,201.3,103.1z"
      />
      <path
        class="st3"
        d="M186.8,121.9c0.2-0.8,0.2-1.5-1-2.2c0.1,1.1-0.8,2.1,0.3,3.1C186.4,122.5,186.7,122.2,186.8,121.9z"
      />
      <path
        class="st3"
        d="M87.3,144.3c-0.1-0.4-0.7-0.7-1.2-0.6c-0.5,0.1-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6
		C86.9,145.3,87.4,144.7,87.3,144.3z"
      />
      <path
        class="st3"
        d="M261.6,117.3c0,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C262.1,117.9,261.9,117.6,261.6,117.3z"
      />
      <path
        class="st3"
        d="M50.5,158.2c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C50.8,157.9,50.6,158,50.5,158.2z"
      />
      <path
        class="st3"
        d="M278.8,121c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C278.5,120.9,278.6,121,278.8,121z"
      />
      <path
        class="st3"
        d="M170.1,101.7c-0.2-0.9-0.8-1.4-2.1-1.1C168.5,102.1,168.7,102.2,170.1,101.7z"
      />
      <path
        class="st3"
        d="M176.6,130.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1c-0.1-0.5-0.6-0.5-1.8,0
		C176.4,130.5,176.5,130.8,176.6,130.9z"
      />
      <path
        class="st3"
        d="M107.2,103.7c-1.3,0.9-1.3,0.9-0.8,2C108,104.6,108,104.6,107.2,103.7z"
      />
      <path
        class="st3"
        d="M150.2,133.3c-0.5,0.1-1,0.2-1.5,0.3c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2
		C150.1,134.3,150.4,134,150.2,133.3z"
      />
      <path
        class="st3"
        d="M114.9,110.9c-0.3-0.7-0.8-1-1.5-1c-0.2,0-0.5,0.1-0.6,0.3c-0.1,0.1-0.1,0.4,0,0.6
		C113.2,111.2,113.7,111.3,114.9,110.9z"
      />
      <path
        class="st3"
        d="M286.5,133.8c0.1-0.6-0.2-0.9-1.1-1c-0.2,0.6-0.4,1.2-0.7,2.2C285.8,134.8,286.4,134.5,286.5,133.8z"
      />
      <path
        class="st3"
        d="M246.2,82.2c0.3-0.5,0.7-0.8,0.7-1.2c0-0.4-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C245.4,81.8,245.8,81.9,246.2,82.2z"
      />
      <path
        class="st3"
        d="M264.6,117.3c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3c0,0.1,0.3,0.2,0.4,0.3c0.6-0.6,0.9,0.3,1.4,0.1
		c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2C264.8,117.2,264.7,117.3,264.6,117.3z"
      />
      <path
        class="st3"
        d="M247.1,106.8c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C246.4,107,247,106.9,247.1,106.8z"
      />
      <path
        class="st3"
        d="M129.4,129.8c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C128.4,129.5,128.9,130,129.4,129.8z"
      />
      <path
        class="st3"
        d="M1.3,173c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1v1.3c0.2,0.1,0.5,0.3,0.7,0.5
		C1,173.7,1.3,173.3,1.3,173z"
      />
      <path
        class="st3"
        d="M128.7,88.9c0.4-0.9,0.4-1.1-0.4-1.5c-0.2,0-0.3,0-0.5,0C127.6,88.5,127.6,88.6,128.7,88.9z"
      />
      <path
        class="st3"
        d="M2.7,122.3c0.4-0.2,0.6-0.5,0.5-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c0,0,0,0-0.1,0.1c0.2,0.3,0.3,0.6,0.5,0.9
		C2.6,122,2.6,122.1,2.7,122.3z"
      />
      <path
        class="st3"
        d="M186.7,115c0.6,0.3,1,0,1.5-0.6c-0.3-0.3-0.5-0.4-0.6-0.5c-0.3,0-0.7,0.1-1,0.1
		C186.2,114.4,186.1,114.8,186.7,115z"
      />
      <path
        class="st3"
        d="M251.5,117.1c0,0.1,0,0.1,0,0.2c0,0.3,0.2,0.5,0.5,0.6c0.1,0,0.2,0,0.3,0c0.2,0,0.5,0,0.8,0
		c-0.1-0.4-0.3-0.7-0.6-1.1c-0.3-0.3-0.6-0.7-1-1C251.5,116.4,251.6,116.8,251.5,117.1z"
      />
      <path
        class="st3"
        d="M277.2,126c-0.4,0.1-0.9,0.1-1.3,0.2c0.1,0.1,0.1,0.2,0.2,0.2C276.8,126.6,277,126.3,277.2,126z"
      />
      <path
        class="st3"
        d="M276,125.4c0.3,0,0.6-0.1,0.9-0.1C276.4,125.1,276.1,125.2,276,125.4z"
      />
      <path
        class="st3"
        d="M138.4,97.5c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9
		C137.7,97.2,138.1,97.3,138.4,97.5z"
      />
      <path
        class="st3"
        d="M275.1,139.7c-0.1,0.2-0.3,0.4-0.4,0.6c0.6-0.1,1.1-0.2,1.7-0.3C276.1,139.7,275.6,139.7,275.1,139.7z"
      />
      <path
        class="st3"
        d="M56.2,155.2c-0.5-0.5-1-0.9-1.8-0.9c0,0.6,0,1,0.2,1.2C55.1,155.4,55.6,155.3,56.2,155.2z"
      />
      <path
        class="st3"
        d="M119.3,105.9c0-0.1,0-0.2,0-0.2c-0.4-0.3-1-0.5-1.6,0c0,0.1,0.1,0.2,0.1,0.2
		C118.3,105.9,118.8,105.9,119.3,105.9z"
      />
      <path
        class="st3"
        d="M179.6,109.6c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C178.4,109.6,179,109.5,179.6,109.6z"
      />
      <path
        class="st3"
        d="M177.6,118.2c0.2-0.3,0.4-0.5,0-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.4-1.2,0.9c0.4,0.2,0.6,0.4,1,0.7
		C177.2,118.6,177.4,118.4,177.6,118.2z"
      />
      <path
        class="st3"
        d="M127.5,118.3c0.2,0,0.3-0.1,0.4-0.1c0.1-0.1,0.3-0.4,0.2-0.5c0,0,0,0-0.1-0.1c-0.2-0.2-0.5-0.3-0.7-0.3
		c-0.4,0-0.8,0.2-1.3,0.3c0.3,0.2,0.5,0.5,0.7,0.6c0.1,0,0.1,0.1,0.2,0.1s0.2,0,0.3,0S127.4,118.3,127.5,118.3z"
      />
      <path
        class="st3"
        d="M260.4,98.9c0.1,0,0.2-0.1,0.3-0.1c-0.2,0-0.4,0-0.6,0C260.1,98.9,260.3,98.9,260.4,98.9z"
      />
      <path
        class="st3"
        d="M128.3,103.7c0.3,0.3,0.7,0.6,1.1,0.9c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3
		c-0.1-0.1-0.7-0.1-0.9,0C128.2,103.1,128.2,103.5,128.3,103.7z"
      />
      <path
        class="st3"
        d="M281.5,129.1c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C282.2,128.5,281.7,128.5,281.5,129.1z"
      />
      <path
        class="st3"
        d="M253.2,115.8L253.2,115.8c-0.4,1,0.1,1.3,1.9,1C254.9,116,253.8,116.4,253.2,115.8L253.2,115.8z"
      />
      <path
        class="st3"
        d="M13.2,165.7c1-1,0.8-1.3-0.7-1.4C12.5,164.9,12.6,165.4,13.2,165.7z"
      />
      <path
        class="st3"
        d="M121.7,100.5c0.3-1.1,0.3-1.1-1.3-1.4C120.4,99.8,120.6,100.3,121.7,100.5z"
      />
      <path
        class="st3"
        d="M266.7,119.5l0.1,0.1c0.1,0.1,0.6,0.2,0.8,0.1c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C265.9,118.8,266.3,119.2,266.7,119.5z"
      />
      <path
        class="st3"
        d="M231.9,79c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C231.5,79.4,231.9,79.2,231.9,79z"
      />
      <path
        class="st3"
        d="M0.9,152.8c-0.7,1.2-0.6,1.5,0.7,1.6C1.8,153.7,1.9,153,0.9,152.8z"
      />
      <path
        class="st3"
        d="M24.5,155c0.2-0.4,0.5-0.6,0.5-0.8c0-0.4-0.4-0.6-0.9-0.5s-0.7,0.5-0.5,0.8C23.7,154.7,24.1,154.8,24.5,155z"
      />
      <path
        class="st3"
        d="M74.6,173.7c0.1-1-0.2-1.4-1.2-1.8c0.3,0.3,0.7,0.6,0.6,0.9C73.9,173.2,73.8,173.6,74.6,173.7z"
      />
      <path
        class="st3"
        d="M247.9,95c-0.5-0.1-0.8-0.3-1.1-0.2c0,0-0.1,0-0.1,0.1c0.3,0.1,0.7,0.1,1.1,0.1C247.8,95,247.8,95,247.9,95z"
      />
      <path
        class="st3"
        d="M101.9,151.5c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.1,0.5c0.2,0.6,0.7,0.7,1.4,0.2
		C102.2,151.9,102.1,151.6,101.9,151.5z"
      />
      <path
        class="st3"
        d="M124.8,120.5c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C123.9,121.1,124.5,121.2,124.8,120.5z"
      />
      <path
        class="st3"
        d="M5.1,201.1c-0.4-0.2-0.7-0.5-0.9-0.4c-0.2,0.1-0.6,0.5-0.5,0.7c0,0.2,0.4,0.3,0.7,0.5
		C4.6,201.6,4.8,201.4,5.1,201.1z"
      />
      <path
        class="st3"
        d="M218.3,108.1c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.2,0.4-0.4,0.8-0.8c0,0-0.1,0-0.1-0.1c-0.4-0.2-0.7-0.4-1-0.4
		c-0.1,0-0.2,0.1-0.3,0.3c-0.1,0.1-0.2,0.3-0.1,0.3c0,0.1,0.1,0.1,0.2,0.2C218.2,108,218.3,108,218.3,108.1z"
      />
      <path
        class="st3"
        d="M154.6,98.5c-0.4,0.4-0.6,0.6-0.7,0.7c0.3,0,0.6,0,1,0C155,99,154.9,98.7,154.6,98.5z"
      />
      <path
        class="st3"
        d="M165.6,117.3c0.2,0.1,0.4,0.2,0.6,0.3c-0.1-0.5,0.2-0.9-0.1-1.3l0,0c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0,0-0.1,0.1
		s-0.2,0.2-0.3,0.3c-0.4,0.4-0.5,0.6-0.2,0.8C165.4,117.2,165.5,117.3,165.6,117.3z"
      />
      <path
        class="st3"
        d="M135,139.1c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6c0.2,0.6,0.4,0.9,0.8,1
		C134.2,139.3,134.6,139.2,135,139.1z"
      />
      <path
        class="st3"
        d="M117.6,108.2c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C116.6,108,116.9,108.4,117.6,108.2z"
      />
      <path
        class="st3"
        d="M258.6,117.2c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5c0.3,0.5,0.5,0.9,0.7,1.3
		C258.5,117,258.6,117.1,258.6,117.2z"
      />
      <path
        class="st3"
        d="M203.4,117.4L203.4,117.4c-0.6-0.5-0.7-1.1-1.7-1c0.2,0.5,0.3,0.8,0.5,0.9
		C202.5,117.5,202.8,117.5,203.4,117.4z"
      />
      <path
        class="st3"
        d="M245.4,108.1c0,0,0,0.1-0.1,0.1C245.4,108.2,245.5,108.2,245.4,108.1C245.5,108.2,245.5,108.2,245.4,108.1
		C245.5,108.1,245.4,108.1,245.4,108.1z"
      />
      <path
        class="st3"
        d="M245.4,109.1c0.2,0.1,0.4,0.3,0.8,0.5c0-0.3,0-0.5,0-0.7C245.9,108.9,245.6,108.9,245.4,109.1
		C245.3,109,245.3,109.1,245.4,109.1z"
      />
      <path
        class="st3"
        d="M175.7,112.3c-0.4,0.3-0.8,0.5-1.2,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.3-0.4,0.6-0.8,0.8-1.2
		C176,112.7,175.8,112.6,175.7,112.3z"
      />
      <path
        class="st3"
        d="M202.3,83c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C201.7,83.6,202,83.4,202.3,83z"
      />
      <path
        class="st3"
        d="M94.3,137.9c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C93.9,137,93.9,137,94.3,137.9z"
      />
      <path
        class="st3"
        d="M123.3,110.9c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C123.6,110.5,123.3,110.8,123.3,110.9z"
      />
      <path
        class="st3"
        d="M132.6,96.9c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4
		C131.9,96.4,131.9,96.8,132.6,96.9z"
      />
      <path
        class="st3"
        d="M123.6,141.8c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C123.8,141.2,123.5,141.7,123.6,141.8z"
      />
      <path
        class="st3"
        d="M247.8,112.2c0.2,0.3,0.5,0.8,1.3,0.3c-0.3-0.4-0.6-0.8-1.2-1.4C247.8,111.8,247.6,112.1,247.8,112.2z"
      />
      <path
        class="st3"
        d="M32.7,169.3c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.4,0.1-0.7-0.2-1.1c-0.2,0.2-0.3,0.4-0.3,0.5
		C32.2,168.8,32.3,168.9,32.7,169.3z"
      />
      <path
        class="st3"
        d="M65.6,157.8c0,0.3,0,0.5,0,0.6c0.2,0.3,0.6,0.4,1.2,0.4c0-0.6-0.3-0.8-0.8-1C66,157.8,65.8,157.8,65.6,157.8z"
      />
      <path
        class="st3"
        d="M122.4,94.4c0.4-0.9-0.2-1.1-1-1.3C121.4,93.8,121.4,94.3,122.4,94.4z"
      />
      <path
        class="st3"
        d="M135.2,147.1c0.5,0.1,0.8,0.3,1.2,0.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.3-0.4-0.5-0.8-0.9-1.4
		C135.5,146.4,135.3,146.7,135.2,147.1z"
      />
      <path
        class="st3"
        d="M183.4,122.4c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C183.6,122,183.3,122.3,183.4,122.4z"
      />
      <path
        class="st3"
        d="M272.7,131.4c0.3,0.6,0.6,1,0.9,1.7C274,131.8,274,131.8,272.7,131.4z"
      />
      <path
        class="st3"
        d="M285.9,119.4c-0.2-0.3-0.4-0.6-0.8-1.1C284.6,119.2,285,119.4,285.9,119.4z"
      />
      <path
        class="st3"
        d="M273.3,134.8C273.4,134.8,273.4,134.8,273.3,134.8c0.2,0,0.4-0.1,0.6-0.1C273.7,134.8,273.5,134.8,273.3,134.8
		z"
      />
      <path
        class="st3"
        d="M184.7,120.2c-0.2-0.1-0.6-0.3-0.7-0.2c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C184.3,120.7,184.5,120.5,184.7,120.2z"
      />
      <path
        class="st3"
        d="M24.5,177c0.6,0,0.9,0,1.2,0l0,0c-0.1-0.3-0.2-0.5-0.4-0.8c-0.1,0.1-0.2,0.2-0.3,0.3
		C24.8,176.6,24.6,176.8,24.5,177z"
      />
      <path
        class="st3"
        d="M135.7,124.6c0,0,0-0.1,0.1-0.3c-1-0.3-1.1-0.3-1.3,0c-0.1,0.1-0.1,0.3-0.1,0.4
		C134.9,125.1,135.3,124.9,135.7,124.6z"
      />
      <path
        class="st3"
        d="M188.6,80.1c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C187.8,80.1,188.2,80.2,188.6,80.1z"
      />
      <path
        class="st3"
        d="M138.3,138.3c0.3,0,0.7,0,1,0.1c0-0.2,0.1-0.3,0.1-0.5c-0.3,0-0.7-0.1-1-0.1
		C138.3,138,138.3,138.2,138.3,138.3z"
      />
      <path
        class="st3"
        d="M130.9,111c0.1,0,0.4-0.1,0.4-0.2c0.2-0.5-0.1-0.7-0.8-0.8C130.4,110.5,130.3,110.9,130.9,111z"
      />
      <path
        class="st3"
        d="M157,99.1C157.1,99.1,157.1,99.1,157,99.1c0.2-0.2,0.4-0.5,0.4-0.7c0-0.1-0.3-0.2-0.6-0.4
		c-0.1,0.4-0.3,0.7-0.3,0.9C156.6,98.9,156.8,99,157,99.1z"
      />
      <path
        class="st3"
        d="M170.3,105.5c-0.4-0.1-0.7-0.2-0.8-0.2c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2C169.7,106,169.9,105.8,170.3,105.5z"
      />
      <path
        class="st3"
        d="M87.1,145.9c-0.8-0.2-1.2,0-1.4,0.6C86.4,146.8,86.8,146.6,87.1,145.9z"
      />
      <path
        class="st3"
        d="M135.1,128c0.2-0.1,0.4-0.3,0.7-0.5c-0.3-0.1-0.6-0.3-0.7-0.3c-0.2,0.1-0.4,0.3-0.5,0.5
		C134.6,127.7,135,128,135.1,128z"
      />
      <path
        class="st3"
        d="M134.2,116.4c0.1,0,0.3,0,0.4-0.1c0.1,0,0.1-0.3,0.1-0.4l0,0c-0.2-0.1-0.4-0.2-0.7-0.2c-0.2,0-0.4,0.2-0.7,0.4
		c0.2,0.1,0.4,0.3,0.6,0.3C134,116.4,134.1,116.4,134.2,116.4z"
      />
      <path
        class="st3"
        d="M12.9,156.6c-0.1-0.6-0.2-1-0.3-1.4C12,155.8,12.1,156.2,12.9,156.6z"
      />
      <path
        class="st3"
        d="M7.7,169.5c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C6.6,168.6,6.7,169,7.7,169.5z"
      />
      <path
        class="st3"
        d="M272.4,133.6c-0.4-0.4-0.8-0.6-1.6,0.1c0.2,0.1,0.5,0.2,0.7,0.3c0.2,0,0.4-0.1,0.7-0.1
		C272.3,133.8,272.3,133.7,272.4,133.6z"
      />
      <path
        class="st3"
        d="M193,122.1c-0.2,0.1-0.3,0.4-0.4,0.6c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.4,0.6-0.6
		C193.4,122.2,193.1,122,193,122.1z"
      />
      <path
        class="st3"
        d="M84.4,169.9C84.5,169.9,84.5,169.9,84.4,169.9c0.2-0.1,0.4-0.4,0.6-0.6c-0.4-0.1-0.7-0.2-0.8-0.1
		c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.2,0.3C84.1,169.8,84.3,170,84.4,169.9z"
      />
      <path
        class="st3"
        d="M87,166.9c0.3-0.3,0.5-0.6,0.7-0.9C86.8,166.4,86.8,166.4,87,166.9z"
      />
      <path
        class="st3"
        d="M164.7,109.6c-0.2-0.1-0.5-0.1-0.9-0.3c0.2,0.5,0.3,0.8,0.4,1.1C164.9,109.9,165,109.8,164.7,109.6z"
      />
      <path
        class="st3"
        d="M171,118.5c-0.7,0.5-1,1-0.6,1.6C170.7,119.6,171.2,119.1,171,118.5z"
      />
      <path
        class="st3"
        d="M267.6,76c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C267.3,76.1,267.4,76,267.6,76z"
      />
      <path
        class="st3"
        d="M159.1,108.9c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C158.7,108.7,159,108.8,159.1,108.9z"
      />
      <path
        class="st3"
        d="M243.9,125.1c-0.2-0.3-0.4-0.7-0.6-1c-0.1,0-0.2,0-0.4,0C242.4,124.9,243.1,125,243.9,125.1z"
      />
      <path
        class="st3"
        d="M252.3,110.6c0,0.1,0.2,0.2,0.5,0.4c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.5-0.3
		C252.6,110.2,252.4,110.4,252.3,110.6z"
      />
      <path
        class="st3"
        d="M87.3,173.8c0-0.5-0.2-0.8-0.5-0.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1
		C86.5,173.4,86.8,173.6,87.3,173.8z"
      />
      <path
        class="st3"
        d="M272.4,138.4c-0.5,0.5-0.5,0.9,0,1.3C273,139.2,272.9,138.8,272.4,138.4z"
      />
      <path
        class="st3"
        d="M131.3,125.8c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C130.7,125.5,131,125.6,131.3,125.8z"
      />
      <path
        class="st3"
        d="M264.9,104.4c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C264.6,104.3,264.8,104.4,264.9,104.4z"
      />
      <path
        class="st3"
        d="M174.3,115.4c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.4,0C174.1,115.1,174.2,115.2,174.3,115.4
		C174.3,115.4,174.3,115.4,174.3,115.4z"
      />
      <path
        class="st3"
        d="M175,114.2c0,0,0-0.1,0.1-0.1c-0.3,0-0.6,0.1-0.7,0.2C174.6,114.2,174.8,114.2,175,114.2z"
      />
      <path
        class="st3"
        d="M235.4,131.7c0.2,0,0.4-0.1,0.6-0.1c-0.3,0-0.5,0.1-0.8,0.1C235.3,131.7,235.4,131.7,235.4,131.7z"
      />
      <path
        class="st3"
        d="M236.6,131.5c0.4,0.7,0.5,0.6,1.4-0.2l0,0C237.5,131.4,237,131.4,236.6,131.5z"
      />
      <path
        class="st3"
        d="M234.7,129c-0.2,0.3-0.5,0.6-0.7,0.9c-0.2,0.4-0.2,0.8,0,1.1c0.7-0.1,1.4-0.2,2.2-0.3c0.3,0,0.6-0.1,0.9-0.1
		C236.9,129.6,236.3,128.9,234.7,129z"
      />
      <path
        class="st3"
        d="M33.2,171.4c0-0.2-0.3-0.3-0.7-0.5c-0.2,0.3-0.3,0.6-0.3,0.8c0,0.1,0.4,0.3,0.5,0.3
		C32.9,171.7,33.2,171.5,33.2,171.4z"
      />
      <path
        class="st3"
        d="M95.3,99.6c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C95,100,95.1,99.8,95.3,99.6z"
      />
      <path
        class="st3"
        d="M49.8,148.9c-0.3,0.3-0.6,0.5-0.8,0.8c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1C50,149,49.9,149,49.8,148.9z
		"
      />
      <path
        class="st3"
        d="M27.3,172.8l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3C26.9,173.3,27.1,173,27.3,172.8z"
      />
      <path
        class="st3"
        d="M246.8,115.6c0,0.8,0.8,0.6,1.2,0.8C247.9,115.9,247.6,115.5,246.8,115.6z"
      />
      <path
        class="st3"
        d="M104.5,131.6c0.3,0.4,0.4,0.7,0.7,1.2C105.5,132,105.4,131.6,104.5,131.6z"
      />
      <path
        class="st3"
        d="M241.4,129.8c0.2,0,0.3,0.1,0.5,0.1l0,0c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C241.7,129.5,241.5,129.6,241.4,129.8z"
      />
      <path
        class="st3"
        d="M128.3,114.1C128.2,114.1,128.2,114.1,128.3,114.1c-0.1,0-0.1,0.1-0.1,0.1S128.2,114.2,128.3,114.1
		C128.2,114.1,128.3,114.1,128.3,114.1z"
      />
      <path
        class="st3"
        d="M128.3,114.1c0.6-0.1,1.1-0.2,1.7-0.4C129.2,113.3,129.1,113.3,128.3,114.1z"
      />
      <path
        class="st3"
        d="M75.8,168.3c0-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3s0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.4,0.1
		c-0.1,0.1-0.2,0.2-0.2,0.3s0,0.2,0,0.2C75.6,168,75.7,168.1,75.8,168.3z"
      />
      <path
        class="st3"
        d="M131.1,123.9c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C130.8,124.3,131.1,124.1,131.1,123.9z"
      />
      <path
        class="st3"
        d="M111.6,147.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.1,0.1,0.1,0.1,0.2,0.2C111,147.6,111.3,147.5,111.6,147.3z"
      />
      <path
        class="st3"
        d="M28.8,176.2c0.5-0.1,0.7-0.3,0.6-0.8c0-0.1-0.4-0.2-0.4-0.1C28.5,175.6,28.4,175.9,28.8,176.2z"
      />
      <path
        class="st3"
        d="M262.3,115.3c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C262.8,115.9,262.6,115.7,262.3,115.3z"
      />
      <path
        class="st3"
        d="M169.3,114.6c-0.2,0-0.3-0.1-0.4-0.1c-0.2-0.1-0.3-0.1-0.4-0.1c-0.1,0.1-0.2,0.2-0.2,0.4
		C168.6,114.7,168.9,114.7,169.3,114.6L169.3,114.6z"
      />
      <path
        class="st3"
        d="M175.5,128.3C175.5,128.4,175.5,128.4,175.5,128.3c0.1,0,0.1,0,0.1,0S175.6,128.3,175.5,128.3L175.5,128.3z"
      />
      <path
        class="st3"
        d="M175.6,128.4c0.1,0.4,0.2,0.8,0.8,0.7c0.1,0,0.3-0.3,0.3-0.4C176.6,128.1,176,128.3,175.6,128.4z"
      />
      <path
        class="st3"
        d="M177.5,128c0.2,0,0.4,0.1,0.4,0.1c0.2-0.2,0.3-0.4,0.5-0.6c-0.3-0.1-0.4-0.2-0.5-0.2
		C177.8,127.5,177.6,127.7,177.5,128z"
      />
      <path
        class="st3"
        d="M55.7,151.8c0,0.1,0,0.2,0,0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0s0.5-0.1,0.7-0.2c0-0.1,0-0.2,0-0.2
		c-0.4,0-0.8,0-1.3,0.1C55.8,151.8,55.8,151.8,55.7,151.8z"
      />
      <path
        class="st3"
        d="M283.3,123.9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C282.5,124.2,282.9,124.1,283.3,123.9z"
      />
      <path
        class="st3"
        d="M63.7,175.8c0.3,0.3,0.7,0.6,1,1c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.3-0.6-0.6-0.9-1
		C63.9,175.6,63.8,175.7,63.7,175.8z"
      />
      <path
        class="st3"
        d="M233.6,127.7c-0.1,0.6,0.3,0.8,1,1.1C234.5,128.1,234.2,127.8,233.6,127.7z"
      />
      <path
        class="st3"
        d="M126.1,88c-0.1,0-0.1,0-0.2,0.1c0.1,0.1,0.2,0.2,0.4,0.4C126.3,88.3,126.2,88.2,126.1,88z"
      />
      <path
        class="st3"
        d="M79.5,179.4c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.7,0.2-1,0.3C78.9,179.7,79.3,180,79.5,179.4z"
      />
      <path
        class="st3"
        d="M252.1,102c0.3,0.5,0.5,0.8,0.7,1.1c0.1-0.1,0.3-0.2,0.4-0.2C253.2,102.5,253.1,102.1,252.1,102z"
      />
      <path
        class="st3"
        d="M75.6,177.5c0.3,0.2,0.7,0.4,1,0c0,0,0-0.1,0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5,0.1-0.8,0.1
		C75.4,177.4,75.5,177.4,75.6,177.5z"
      />
      <path
        class="st3"
        d="M76.7,177.2c0,0,0,0.1-0.1,0.2l0,0c0,0,0,0,0.1,0C76.7,177.3,76.7,177.2,76.7,177.2z"
      />
      <path
        class="st3"
        d="M267.6,113.3c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0
		C267.5,113.9,267.6,113.6,267.6,113.3z"
      />
      <path
        class="st3"
        d="M250.6,118c0.1,0,0.2,0,0.3,0c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.2,0.1-0.3,0.1C250.5,118,250.6,118,250.6,118z"
      />
      <path
        class="st3"
        d="M282.7,132c-0.3-0.1-0.6-0.1-0.9-0.2c0,0.1-0.1,0.2-0.1,0.3c0.1,0,0.3,0,0.4,0.1
		C282.3,132.2,282.5,132.1,282.7,132C282.7,132.1,282.7,132,282.7,132z"
      />
      <path
        class="st3"
        d="M130.1,113.8L130.1,113.8C130,113.7,130,113.7,130.1,113.8C130,113.8,130,113.8,130.1,113.8
		C130,113.8,130.1,113.8,130.1,113.8z"
      />
      <path
        class="st3"
        d="M130.1,115.1c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C130.2,114.7,130.1,114.9,130.1,115.1z"
      />
      <path
        class="st3"
        d="M142.6,129.1c-0.3-0.2-0.4-0.4-0.6-0.6c0,0-0.4,0.2-0.4,0.3C141.5,129.3,141.9,129.3,142.6,129.1z"
      />
      <path
        class="st3"
        d="M167.5,111.8c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C167.2,112.1,167.4,111.9,167.5,111.8z"
      />
      <path
        class="st3"
        d="M178.2,88.1c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C177.6,88.6,178,88.6,178.2,88.1z"
      />
      <path
        class="st3"
        d="M217.5,117.8c0.2-0.3,0.5-0.5,0.7-0.8c0,0,0,0,0.1-0.1l0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.3,0.3-0.7,0.6-1,1
		C217.3,117.7,217.4,117.7,217.5,117.8z"
      />
      <path
        class="st3"
        d="M178.1,121.7c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0C178,121.8,178.1,121.7,178.1,121.7z"
      />
      <path
        class="st3"
        d="M177.5,122.9c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C177.5,122.1,177.4,122.5,177.5,122.9z"
      />
      <path
        class="st3"
        d="M135.4,132C135.5,132,135.5,132,135.4,132c0.3,0,0.5-0.2,0.6-0.3l0,0c0,0-0.1-0.1-0.2-0.2
		c-0.2,0-0.3,0-0.5,0.1c-0.1,0.1-0.2,0.2-0.2,0.3C135.1,131.8,135.3,131.9,135.4,132z"
      />
      <path
        class="st3"
        d="M227.4,130.6c-0.2,0.1-0.3,0.3-0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C227.8,130.8,227.5,130.6,227.4,130.6z"
      />
      <path
        class="st3"
        d="M159,143.4c0.1-0.2,0.2-0.4,0.2-0.5s-0.2-0.2-0.5-0.5c-0.1,0.4-0.3,0.6-0.2,0.7
		C158.6,143.2,158.9,143.3,159,143.4z"
      />
      <path
        class="st3"
        d="M102.1,156c-0.1-0.3-0.2-0.6-0.3-0.9C101.3,155.8,101.3,155.8,102.1,156z"
      />
      <path
        class="st3"
        d="M173.5,114.3h0.1c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2
		C173.4,114.3,173.5,114.3,173.5,114.3z"
      />
      <path
        class="st3"
        d="M246.8,98c-0.2-0.3-0.5-0.5-0.8-1C245.9,97.7,246.1,98,246.8,98z"
      />
      <path
        class="st3"
        d="M247.5,108.8c-0.2,0.1-0.3,0.2-0.5,0.3c0,0,0.1,0.2,0.2,0.3c0.2-0.2,0.5-0.4,0.7-0.6l-0.1-0.1
		C247.7,108.8,247.6,108.8,247.5,108.8z"
      />
      <path
        class="st3"
        d="M136.7,133c0,0,0-0.2,0-0.3c-0.3,0.1-0.6,0.1-0.9,0.2c0,0.1,0.1,0.2,0.1,0.3
		C136.2,133.2,136.5,133.1,136.7,133z"
      />
      <path
        class="st3"
        d="M179.8,125.5c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.2-0.2-0.3-0.3-0.4-0.4
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.4C179.5,125.3,179.7,125.5,179.8,125.5z"
      />
      <path
        class="st3"
        d="M279.5,115.9c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1
		c0,0,0,0.1,0.1,0.1C279.2,115.4,279.4,115.6,279.5,115.9z"
      />
      <path
        class="st3"
        d="M288.7,125.6c0.4,0.2,0.6,0.3,1,0.4C289.4,125.5,289.4,125.5,288.7,125.6z"
      />
      <path
        class="st3"
        d="M142.3,126c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5c0.1,0.1,0.3,0.2,0.4,0.1
		C141.9,126.3,142,126.1,142.3,126z"
      />
      <path
        class="st3"
        d="M80.8,167.6c0.1,0,0.2-0.1,0.3-0.1h0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.3-0.3-0.4c0,0,0,0-0.1-0.1
		c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1,0.1,0.2C80.7,167.2,80.8,167.4,80.8,167.6z"
      />
      <path
        class="st3"
        d="M232.4,137.7c-0.7-0.3-1.1-0.4-1.5-0.6C231,137.6,231.3,137.9,232.4,137.7z"
      />
      <path
        class="st3"
        d="M230.9,137.1C230.9,137.1,230.9,137,230.9,137.1C230.9,137,230.9,137,230.9,137.1
		C230.8,137.1,230.8,137.1,230.9,137.1L230.9,137.1z"
      />
      <path
        class="st3"
        d="M144.8,103.2c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8
		C144.5,103.2,144.7,103.2,144.8,103.2z"
      />
      <path
        class="st3"
        d="M124,98c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5C123.9,98.2,124,98.1,124,98z"
      />
      <path
        class="st3"
        d="M127,94.3c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C126.8,94.4,127,94.3,127,94.3z"
      />
      <path
        class="st3"
        d="M237,132.2c-0.5,0.3-0.8,0.5-1.3,0.8C236.6,132.9,236.6,132.9,237,132.2z"
      />
      <path
        class="st3"
        d="M33.3,160.3c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c0.2,0,0.3,0,0.5,0C33.3,160.9,33.3,160.6,33.3,160.3
		z"
      />
      <path
        class="st3"
        d="M82.8,166.3c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.3,0-0.4,0.1C82.6,166.2,82.7,166.3,82.8,166.3z"
      />
      <path
        class="st3"
        d="M27.6,162.8c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.3,0-0.4,0c0,0.2,0,0.4,0,0.6C27.4,162.8,27.5,162.8,27.6,162.8z
		"
      />
      <path
        class="st3"
        d="M233.6,144.6c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4c0.1,0.1,0.2,0.3,0.2,0.3
		C233,144.9,233.3,144.8,233.6,144.6z"
      />
      <path
        class="st3"
        d="M251.3,140.7c0.6-0.3,1-0.5,1.4-0.6C252.1,139.9,251.6,139.9,251.3,140.7z"
      />
      <path
        class="st3"
        d="M231.8,131.2c-0.1,0.1-0.2,0.1-0.2,0.2c0.1,0,0.2,0,0.4-0.1C231.9,131.3,231.9,131.3,231.8,131.2z"
      />
      <path
        class="st3"
        d="M232.3,133.6c0.3-0.1,0.7-0.1,1-0.2v-0.1c-0.3,0.1-0.7,0.1-1,0.2C232.3,133.5,232.3,133.5,232.3,133.6z"
      />
      <path
        class="st3"
        d="M155.9,76.1c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3
		C155.7,76,155.8,76.1,155.9,76.1z"
      />
      <path
        class="st3"
        d="M289.8,107.9c-0.1,0-0.3,0-0.4-0.1c0,0.2-0.1,0.3-0.1,0.5c0.1,0.1,0.2,0.1,0.2,0.2
		C289.6,108.3,289.7,108.1,289.8,107.9z"
      />
      <path
        class="st3"
        d="M196.2,68.4h-0.4C195.9,68.4,196,68.5,196.2,68.4C196.1,68.5,196.2,68.5,196.2,68.4z"
      />
      <path
        class="st3"
        d="M171.2,111.7c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C171,112.1,171.1,111.9,171.2,111.7z"
      />
      <path
        class="st3"
        d="M147.4,125.1c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.3-0.3-0.4-0.4C147.6,124.9,147.5,125,147.4,125.1z"
      />
      <path
        class="st3"
        d="M127.7,97.4c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C127.8,97.2,127.7,97.3,127.7,97.4z"
      />
      <path
        class="st3"
        d="M304.6,83c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C304.5,83,304.5,83,304.6,83z"
      />
      <path
        class="st3"
        d="M243.8,106c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.1-0.1-0.2-0.1v0.1c-0.1,0.1-0.1,0.2-0.1,0.3
		C243.6,105.9,243.8,106,243.8,106z"
      />
      <path
        class="st3"
        d="M272.2,129c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1,0-0.1,0.1-0.2,0.1
		C271.9,128.5,272,128.8,272.2,129z"
      />
      <path
        class="st3"
        d="M134.1,96.8c-0.1-0.3-0.1-0.7-0.7-0.7C133.5,96.5,133.5,96.9,134.1,96.8z"
      />
      <path
        class="st3"
        d="M263.2,102.3c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0
		C263.4,102.8,263.3,102.6,263.2,102.3C263.3,102.3,263.3,102.3,263.2,102.3C263.3,102.3,263.3,102.3,263.2,102.3z"
      />
      <path
        class="st3"
        d="M129.7,115.9c-0.3-0.2-0.5-0.3-0.7-0.5C129,115.7,129,116.1,129.7,115.9z"
      />
      <path
        class="st3"
        d="M128.7,115.2L128.7,115.2l0.1,0.2C128.9,115.4,128.9,115.3,128.7,115.2C128.8,115.3,128.8,115.2,128.7,115.2z"
      />
      <path
        class="st3"
        d="M83.2,142.3l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3C83,142.1,83.1,142.2,83.2,142.3z"
      />
      <path
        class="st3"
        d="M82.1,169.6c-0.1,0.1-0.1,0.1-0.2,0.2l0.1,0.1c0.2,0.2,0.3,0.3,0.5,0.5c0.1-0.1,0.2-0.2,0.3-0.2
		c-0.2-0.1-0.3-0.3-0.5-0.4C82.2,169.7,82.1,169.7,82.1,169.6z"
      />
      <path
        class="st3"
        d="M77.1,109.5c-0.1,0-0.1,0-0.2,0C76.9,109.5,76.9,109.5,77.1,109.5C77,109.6,77.1,109.5,77.1,109.5z"
      />
      <path
        class="st3"
        d="M212.2,81.3c0.1-0.2,0.2-0.3,0.2-0.4s-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2S212,81.1,212.2,81.3z"
      />
      <path
        class="st3"
        d="M274.3,118.5c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2s-0.2,0.2-0.2,0.3c0.1,0,0.1,0.1,0.2,0.1
		C274,118.8,274.1,118.7,274.3,118.5L274.3,118.5z"
      />
      <path
        class="st3"
        d="M145.7,130.3c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.2,0.2,0.4,0.4c0.1-0.4,0.2-0.5,0.2-0.6h-0.1
		C145.9,130.2,145.8,130.3,145.7,130.3z"
      />
      <path
        class="st3"
        d="M131.8,115.6c-0.1,0-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3
		C132.1,115.7,131.9,115.6,131.8,115.6z"
      />
      <path
        class="st3"
        d="M161,94.8c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2,0.2-0.1,0.2
		C160.7,94.6,160.8,94.7,161,94.8z"
      />
      <path
        class="st3"
        d="M76.2,174c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.2,0.2
		C76,174.2,76.1,174.1,76.2,174z"
      />
      <path
        class="st3"
        d="M225.4,114.4L225.4,114.4c-0.1-0.1-0.4-0.2-0.6-0.4c0,0.1,0.1,0.2,0.2,0.3
		C225.1,114.3,225.2,114.4,225.4,114.4z"
      />
      <path
        class="st3"
        d="M255.1,84.8c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C255.1,85,255.1,84.9,255.1,84.8z"
      />
      <path
        class="st3"
        d="M171.2,91.6l-0.1,0.1c0.1,0,0.2,0.1,0.2,0.1C171.3,91.7,171.2,91.6,171.2,91.6z"
      />
      <path
        class="st3"
        d="M224,113.5c0,0.1-0.1,0.2-0.1,0.3c0.2,0,0.5,0.1,0.7,0.1C224.4,113.8,224.2,113.6,224,113.5z"
      />
      <path
        class="st3"
        d="M224.8,114C224.8,114,224.7,113.9,224.8,114c-0.1-0.1-0.1-0.1-0.2-0.1C224.6,113.9,224.7,113.9,224.8,114
		C224.7,114,224.7,114,224.8,114z"
      />
      <path
        class="st3"
        d="M158.6,96.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C158.4,96.3,158.5,96.2,158.6,96.1z"
      />
      <path
        class="st3"
        d="M78.3,174c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.2l0.1-0.1C78.5,174.1,78.4,174,78.3,174z"
      />
      <path
        class="st3"
        d="M231,76.7c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C231.1,76.6,231.1,76.6,231,76.7z"
      />
      <path
        class="st3"
        d="M126.5,103.8c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C126.2,103.6,126.3,103.7,126.5,103.8z"
      />
      <path
        class="st3"
        d="M235,109.9c0,0.1,0.1,0.1,0.1,0.2c0.2-0.1,0.4-0.2,0.6-0.2v-0.1c-0.2,0-0.3,0-0.5,0
		C235.2,109.9,235.1,109.9,235,109.9z"
      />
      <path
        class="st3"
        d="M270,130.4c0,0.4,0.1,0.7,0.1,0.9C270.6,131.1,270.3,130.8,270,130.4z"
      />
      <path
        class="st3"
        d="M267.9,118.1c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.3,0c-0.1,0,0,0.2-0.1,0.2
		C267.8,118.1,267.9,118.1,267.9,118.1z"
      />
      <path
        class="st3"
        d="M25.6,172.9c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.3,0.1l0,0c0.1,0.1,0.1,0.2,0.2,0.2
		C25.4,173.1,25.5,173,25.6,172.9z"
      />
      <path
        class="st3"
        d="M124.5,137c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C124.6,137.1,124.6,137.1,124.5,137z"
      />
      <path
        class="st3"
        d="M0.4,203.1c-0.1,0-0.1-0.1-0.2-0.1s-0.1,0-0.2,0.1v0.1c0.1,0.1,0.2,0.1,0.3,0.2C0.3,203.2,0.4,203.1,0.4,203.1
		z"
      />
      <path
        class="st3"
        d="M0.3,202.2c-0.1-0.2-0.1-0.3-0.2-0.5H0v0.2c0,0.1,0.1,0.2,0.1,0.3C0.2,202.2,0.3,202.2,0.3,202.2z"
      />
      <path
        class="st3"
        d="M83.7,173.4C83.8,173.5,83.8,173.5,83.7,173.4c0.1,0.2,0.2,0.2,0.2,0.3c0.1-0.1,0.1-0.1,0.2-0.2
		c0-0.1-0.1-0.2-0.1-0.2C84,173.3,83.9,173.4,83.7,173.4C83.8,173.4,83.8,173.4,83.7,173.4z"
      />
      <path
        class="st3"
        d="M178.8,120.9c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C178.4,121.3,178.6,121.1,178.8,120.9z"
      />
      <path
        class="st3"
        d="M185.9,124.6C185.9,124.6,185.8,124.5,185.9,124.6c-0.1-0.1-0.1-0.1-0.1-0.2v0.1
		C185.8,124.6,185.9,124.6,185.9,124.6z"
      />
      <path
        class="st3"
        d="M185.8,124.4c0-0.1,0-0.2-0.1-0.4c0,0-0.1,0-0.1,0.1C185.6,124.2,185.7,124.3,185.8,124.4z"
      />
      <path
        class="st3"
        d="M173.4,108.5c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C173.1,108.6,173.2,108.6,173.4,108.5z"
      />
      <path
        class="st3"
        d="M277,141.1c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.1,0.2,0.1,0.2,0.1C276.8,141.3,276.9,141.2,277,141.1z"
      />
      <path
        class="st3"
        d="M186.5,124.7c-0.2,0-0.4-0.1-0.6-0.1c0.1,0.1,0.3,0.3,0.4,0.4C186.4,124.9,186.4,124.8,186.5,124.7z"
      />
      <path
        class="st3"
        d="M74.6,143.3c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C74.5,143.2,74.6,143.2,74.6,143.3z"
      />
      <path
        class="st3"
        d="M75.1,143c0.1,0,0.2,0,0.2-0.1v-0.1c0,0,0,0-0.1,0.1C75.2,142.9,75.2,142.9,75.1,143z"
      />
      <path
        class="st3"
        d="M189.7,117.8c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C189.6,118.1,189.6,117.9,189.7,117.8
		z"
      />
      <path
        class="st3"
        d="M31.6,158.4c-0.1,0.1-0.2,0.1-0.2,0.2C31.5,158.6,31.6,158.6,31.6,158.4C31.6,158.5,31.6,158.5,31.6,158.4z"
      />
      <path
        class="st3"
        d="M159.9,113.6l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1
		C160,113.3,159.9,113.4,159.9,113.6C159.8,113.5,159.8,113.6,159.9,113.6z"
      />
      <path
        class="st3"
        d="M200.2,114.1c-0.1,0-0.3-0.1-0.4-0.1l-0.1,0.2c0,0.1,0.2,0.2,0.3,0.3C200,114.4,200.1,114.3,200.2,114.1z"
      />
      <path
        class="st3"
        d="M249.7,113.5c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		C249.6,113.4,249.7,113.5,249.7,113.5z"
      />
      <path
        class="st3"
        d="M120.9,108.8c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.2,0-0.3c0-0.1-0.2,0-0.3-0.1
		C120.9,108.7,120.8,108.8,120.9,108.8z"
      />
      <path
        class="st3"
        d="M120.8,131c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1C120.7,131.2,120.8,131.2,120.8,131
		z"
      />
      <path
        class="st3"
        d="M233.8,120.8c0,0,0-0.1-0.1-0.1s-0.2,0-0.4,0c0,0.1-0.1,0.1-0.1,0.2s0.1,0.1,0.2,0.2
		C233.6,121,233.7,120.9,233.8,120.8z"
      />
      <path
        class="st3"
        d="M238.3,135.4c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C238.2,135.5,238.2,135.5,238.3,135.4z"
      />
      <path
        class="st3"
        d="M114.7,112.9c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1l-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1
		C114.9,112.7,114.8,112.8,114.7,112.9z"
      />
      <path
        class="st3"
        d="M220,89.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C220,90.3,220,90.1,220,89.9z"
      />
      <path
        class="st3"
        d="M81.2,162.6c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1c-0.1,0.1-0.2,0.2-0.3,0.3C80.9,162.5,81,162.6,81.2,162.6z"
      />
      <path
        class="st3"
        d="M275.1,111c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C275,111.3,275.1,111.1,275.1,111z"
      />
      <path
        class="st3"
        d="M234.4,134.7c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.2-0.1-0.3,0C234.4,134.5,234.4,134.6,234.4,134.7z
		"
      />
      <path
        class="st3"
        d="M185.5,110c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.3,0C185.7,110.4,185.6,110.2,185.5,110z"
      />
      <path
        class="st3"
        d="M141.6,137.6c0.1,0,0.2-0.2,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		C141.4,137.5,141.5,137.7,141.6,137.6z"
      />
      <path
        class="st3"
        d="M240.9,132c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C241.1,131.9,241,132,240.9,132z"
      />
      <path
        class="st3"
        d="M270.8,109.5c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.1-0.2
		C270.9,109.4,270.8,109.4,270.8,109.5z"
      />
      <path
        class="st3"
        d="M23.2,178.5c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.2
		c0-0.1,0-0.2-0.1-0.2C23.3,178.5,23.2,178.5,23.2,178.5z"
      />
      <path
        class="st3"
        d="M188.1,100.7c0.1,0,0.3,0.1,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0-0.2-0.1-0.3-0.1
		C188.2,100.5,188.1,100.6,188.1,100.7z"
      />
      <path
        class="st3"
        d="M288.4,105.9c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C288.2,105.8,288.3,105.9,288.4,105.9z"
      />
      <path
        class="st3"
        d="M150.5,137.2c0-0.1,0.1-0.2,0.1-0.3s-0.1-0.1-0.2-0.2l0,0l0,0c0,0,0,0,0,0.1c-0.1,0.1-0.2,0.3-0.3,0.4l0,0
		C150.2,137.2,150.3,137.2,150.5,137.2z"
      />
      <path
        class="st3"
        d="M168.6,118.4c0.1,0,0.2,0,0.2-0.1c-0.1-0.2-0.2-0.3-0.2-0.5h-0.1C168.5,118.1,168.5,118.2,168.6,118.4z"
      />
      <path
        class="st3"
        d="M140.8,123.7L140.8,123.7C140.8,123.6,140.7,123.6,140.8,123.7C140.7,123.7,140.7,123.8,140.8,123.7
		C140.8,123.7,140.8,123.7,140.8,123.7z"
      />
      <path
        class="st3"
        d="M141.8,122.5c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C142,122.6,141.9,122.5,141.8,122.5z"
      />
      <path
        class="st3"
        d="M165.6,119.8c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C165.5,119.7,165.6,119.8,165.6,119.8z"
      />
      <path
        class="st3"
        d="M84.1,137.9c0-0.1,0.1-0.1,0.1-0.2C84.2,137.7,84.1,137.8,84.1,137.9c-0.1,0-0.2,0.1-0.2,0.1
		C84,137.9,84,137.9,84.1,137.9z"
      />
      <path
        class="st3"
        d="M105.9,133.3c0.2,0,0.3,0,0.5,0h0.1c0,0,0,0-0.1-0.1C106.3,133.3,106.1,133.3,105.9,133.3z"
      />
      <path
        class="st3"
        d="M183.8,109.4c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1C183.7,109.6,183.7,109.5,183.8,109.4z"
      />
      <path
        class="st3"
        d="M76,141l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C75.9,141.2,75.9,141.1,76,141z"
      />
      <path
        class="st3"
        d="M75.5,142.5c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2c0.1-0.1,0.1-0.1,0.1-0.2V142.5z"
      />
      <path
        class="st3"
        d="M75.1,166.2c0.1,0,0.1,0,0.2,0l0.1-0.1c0-0.1-0.1-0.1-0.2-0.3c-0.1,0.1-0.1,0.2-0.1,0.2
		C75,166.1,75.1,166.2,75.1,166.2z"
      />
      <path
        class="st3"
        d="M196.7,104.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C196.6,104.8,196.6,104.8,196.7,104.8z"
      />
      <path
        class="st3"
        d="M171.3,123.2h0.1C171.4,123.2,171.4,123.1,171.3,123.2C171.4,123.1,171.3,123.1,171.3,123.2L171.3,123.2z"
      />
      <path
        class="st3"
        d="M112,120.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2C111.7,120.8,111.8,120.8,112,120.7
		C111.9,120.8,112,120.7,112,120.7z"
      />
      <path
        class="st3"
        d="M132.6,115.3c0,0,0.1,0,0.2,0C132.8,115.3,132.8,115.2,132.6,115.3C132.6,115.2,132.6,115.2,132.6,115.3
		C132.5,115.2,132.5,115.3,132.6,115.3z"
      />
      <path
        class="st3"
        d="M171.3,125.3c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C171.3,125.2,171.3,125.3,171.3,125.3z"
      />
      <path
        class="st3"
        d="M148.6,130.6c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C148.6,130.7,148.6,130.6,148.6,130.6L148.6,130.6z"
      />
      <path
        class="st3"
        d="M139.9,113.4c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C140.1,113.4,140,113.4,139.9,113.4z"
      />
      <path
        class="st3"
        d="M163.5,107.7c0.1,0,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0c0,0.1-0.1,0.1-0.1,0.2
		C163.3,107.7,163.4,107.8,163.5,107.7z"
      />
      <path
        class="st3"
        d="M290.9,102.3C290.9,102.4,290.9,102.4,290.9,102.3c-0.1,0.2-0.1,0.3-0.1,0.3
		C290.8,102.6,290.9,102.5,290.9,102.3C290.9,102.4,290.9,102.4,290.9,102.3z"
      />
      <path
        class="st3"
        d="M291,102c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C291.1,102,291.1,102,291,102z"
      />
      <path
        class="st3"
        d="M30.6,159.6l-0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C30.7,159.7,30.7,159.6,30.6,159.6z"
      />
      <path
        class="st3"
        d="M119,141c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C118.9,141.2,118.9,141.1,119,141z"
      />
      <path
        class="st3"
        d="M273.5,140.3c-0.1,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.2l0.1,0.1C273.3,140.4,273.4,140.3,273.5,140.3z"
      />
      <path
        class="st3"
        d="M31.7,160.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C31.7,160.9,31.7,160.8,31.7,160.8z"
      />
      <path
        class="st3"
        d="M188,127l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2l0.1-0.1C188.2,127.1,188.1,127.1,188,127z"
      />
      <path
        class="st3"
        d="M122.4,115.4c0,0.1,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1
		C122.5,115.2,122.4,115.3,122.4,115.4z"
      />
      <path
        class="st3"
        d="M253.9,112.9c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C254,112.9,254,112.8,253.9,112.9
		C254,112.8,253.9,112.9,253.9,112.9z"
      />
      <path
        class="st3"
        d="M245.5,114.8l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C245.7,114.8,245.6,114.8,245.5,114.8z"
      />
      <path
        class="st3"
        d="M76.9,178c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C77.1,178,77,178,76.9,178z"
      />
      <path
        class="st3"
        d="M109.7,145.8L109.7,145.8C109.6,145.8,109.6,145.9,109.7,145.8c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C109.9,145.8,109.8,145.8,109.7,145.8L109.7,145.8z"
      />
      <path
        class="st3"
        d="M10,167.8H9.9v0.1c0.1,0,0.1,0,0.2,0C10,167.9,10,167.9,10,167.8z"
      />
      <path
        class="st3"
        d="M33.6,131.4v0.1C33.7,131.5,33.7,131.5,33.6,131.4C33.7,131.4,33.7,131.4,33.6,131.4z"
      />
      <path
        class="st3"
        d="M220.1,90.6l-0.1-0.1c0,0,0,0,0-0.1v0.1C220,90.6,220.1,90.6,220.1,90.6z"
      />
      <path
        class="st3"
        d="M220.4,90.9c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4C220.4,91,220.4,90.9,220.4,90.9z"
      />
      <path
        class="st3"
        d="M71.5,155.2c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0.1
		C71.6,155.2,71.6,155.2,71.5,155.2z"
      />
      <path
        class="st3"
        d="M71.4,155.3L71.4,155.3c0.1,0,0.1,0,0.1-0.1C71.5,155.2,71.5,155.3,71.4,155.3L71.4,155.3z"
      />
      <path
        class="st3"
        d="M71.1,155.7c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2C71,155.6,71,155.6,71.1,155.7z"
      />
      <path
        class="st3"
        d="M248.6,82.8c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C248.6,82.9,248.6,82.8,248.6,82.8z"
      />
      <path
        class="st3"
        d="M228.8,143.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C228.9,143.6,228.8,143.5,228.8,143.5z"
      />
      <path
        class="st3"
        d="M160.1,97.8c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C160,98,160.1,97.9,160.1,97.8z"
      />
      <path
        class="st3"
        d="M26.8,125.9l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C27,125.9,26.9,125.9,26.8,125.9z"
      />
      <path
        class="st3"
        d="M277.3,114.2c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C277.2,114.2,277.3,114.2,277.3,114.2z"
      />
      <path
        class="st3"
        d="M277.8,132.4c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C277.9,132.5,277.8,132.4,277.8,132.4z"
      />
      <path
        class="st3"
        d="M27.7,125.4c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C27.6,125.2,27.7,125.3,27.7,125.4z"
      />
      <path
        class="st3"
        d="M27.5,124.9C27.5,125,27.5,125,27.5,124.9c0.1,0.1,0.1,0.1,0.1,0.1S27.6,125,27.5,124.9
		C27.5,125,27.5,125,27.5,124.9z"
      />
      <path
        class="st3"
        d="M144.3,99l-0.1-0.1l-0.1,0.1l0.1,0.1C144.3,99.1,144.3,99.1,144.3,99z"
      />
      <path
        class="st3"
        d="M11.3,188.5c0,0,0.1,0,0.1-0.1v-0.1c-0.1,0-0.1,0.1-0.2,0.1C11.2,188.4,11.3,188.5,11.3,188.5z"
      />
      <path
        class="st3"
        d="M69,174.5v0.1c0,0,0,0.1,0.1,0.1v-0.1C69,174.6,69,174.6,69,174.5z"
      />
      <path
        class="st3"
        d="M269.9,130.1C269.9,130.1,269.9,130,269.9,130.1c0-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1
		C269.7,130.1,269.8,130.1,269.9,130.1z"
      />
      <path
        class="st3"
        d="M119.8,100.7C119.8,100.8,119.8,100.8,119.8,100.7C119.8,100.8,119.9,100.8,119.8,100.7
		C119.9,100.8,119.8,100.8,119.8,100.7z"
      />
      <path
        class="st3"
        d="M228.3,128.5c-0.1,0-0.2,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1s0.2-0.1,0.2-0.2
		C228.5,128.6,228.4,128.5,228.3,128.5z"
      />
      <path
        class="st3"
        d="M244.3,135.3c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3
		C244.2,135.2,244.3,135.2,244.3,135.3z"
      />
      <path
        class="st3"
        d="M157.6,144.6C157.6,144.6,157.5,144.6,157.6,144.6c-0.1,0.1,0,0.2,0,0.2l0.1-0.1
		C157.6,144.7,157.6,144.7,157.6,144.6z"
      />
      <path
        class="st3"
        d="M243.1,126.2c0,0.1,0,0.1,0.1,0.2l0.1-0.1C243.3,126.2,243.2,126.2,243.1,126.2
		C243.2,126.2,243.2,126.2,243.1,126.2z"
      />
      <path
        class="st3"
        d="M268.3,120.6C268.3,120.7,268.2,120.7,268.3,120.6c0,0.2,0,0.2,0.1,0.2v-0.1
		C268.4,120.7,268.4,120.7,268.3,120.6z"
      />
      <path
        class="st3"
        d="M239.8,127.5l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.1,0.1C239.8,127.7,239.8,127.6,239.8,127.5z"
      />
      <path
        class="st3"
        d="M286,125c0-0.1,0-0.1,0.1-0.2c-0.1,0-0.1,0-0.1,0V125C285.9,124.9,286,124.9,286,125z"
      />
      <path
        class="st3"
        d="M79.9,169l-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.1l0.1,0.1C79.7,169.1,79.8,169,79.9,169z"
      />
      <path
        class="st3"
        d="M93.5,159.5c0,0.1,0.1,0.1,0.2,0.2l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C93.5,159.4,93.5,159.5,93.5,159.5z"
      />
      <path
        class="st3"
        d="M26.3,174.8C26.4,174.8,26.4,174.8,26.3,174.8c0.1-0.1,0-0.1,0-0.1l-0.1-0.1l-0.1,0.1
		C26.2,174.7,26.2,174.8,26.3,174.8C26.3,174.9,26.3,174.9,26.3,174.8z"
      />
      <path
        class="st3"
        d="M65.2,89.5c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C65.2,89.7,65.3,89.6,65.2,89.5z"
      />
      <path
        class="st3"
        d="M14.3,177.6c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C14.2,177.7,14.3,177.7,14.3,177.6z"
      />
      <path
        class="st3"
        d="M18.3,176.9c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1C18.3,176.8,18.3,176.9,18.3,176.9z"
      />
      <path
        class="st3"
        d="M140,150.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C140,150.6,140,150.6,140,150.6z"
      />
      <path
        class="st3"
        d="M277.3,141.6l0.1,0.1l0.1-0.1l-0.1-0.1C277.3,141.5,277.3,141.5,277.3,141.6z"
      />
      <path
        class="st3"
        d="M283.6,135.1c0,0-0.1,0-0.1-0.1l0,0l0,0C283.5,135.1,283.5,135.1,283.6,135.1z"
      />
      <path
        class="st3"
        d="M76.9,180.1L76.9,180.1C76.8,180.1,76.8,180.1,76.9,180.1C76.8,180.2,76.9,180.2,76.9,180.1L76.9,180.1z"
      />
      <path
        class="st3"
        d="M76.9,179.9c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C77.1,179.9,77,179.9,76.9,179.9z"
      />
      <path
        class="st3"
        d="M254.6,140.6h-0.1C254.5,140.7,254.5,140.7,254.6,140.6C254.5,140.7,254.5,140.7,254.6,140.6
		C254.6,140.7,254.6,140.7,254.6,140.6z"
      />
      <path
        class="st3"
        d="M254.7,140.5l-0.1,0.1C254.6,140.6,254.6,140.6,254.7,140.5C254.7,140.6,254.7,140.6,254.7,140.5z"
      />
      <path
        class="st3"
        d="M70.4,179.3C70.4,179.3,70.4,179.2,70.4,179.3c0.1-0.1,0-0.2,0-0.2C70.3,179.2,70.3,179.2,70.4,179.3
		C70.3,179.3,70.3,179.3,70.4,179.3z"
      />
      <path
        class="st3"
        d="M77.7,177c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C77.8,176.9,77.8,176.9,77.7,177z"
      />
      <path
        class="st3"
        d="M280.9,131.6c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.3
		C280.9,131.8,280.9,131.7,280.9,131.6z"
      />
      <polygon class="st3" points="273.5,130.8 273.6,130.8 273.5,130.7 	" />
      <path
        class="st3"
        d="M270,131.6c0-0.1,0.1-0.2,0.1-0.2l0,0l0,0C270,131.4,270,131.5,270,131.6z"
      />
      <path
        class="st3"
        d="M79.4,172.1c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C79.5,172.1,79.4,172.1,79.4,172.1z"
      />
      <path
        class="st3"
        d="M79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.4,172.1,79.3,172.1,79.3,172
		C79.3,172.1,79.3,172.1,79.3,172z"
      />
      <path
        class="st3"
        d="M79.1,172c0.1,0,0.1,0,0.2,0.1V172C79.2,172,79.2,172,79.1,172z"
      />
      <path
        class="st3"
        d="M8.3,187.1h0.1l0.1-0.1l-0.1-0.1C8.3,186.9,8.3,187,8.3,187.1z"
      />
      <path
        class="st3"
        d="M273.4,129.1V129V129.1c-0.1,0-0.1,0.1-0.1,0.1C273.4,129.2,273.4,129.2,273.4,129.1z"
      />
      <polygon class="st3" points="270.6,129.3 270.6,129.2 270.5,129.3 	" />
      <path
        class="st3"
        d="M83.2,166.7L83.2,166.7C83.2,166.7,83.3,166.7,83.2,166.7c0.1,0,0.2,0,0.2,0.1
		C83.4,166.7,83.4,166.7,83.2,166.7C83.3,166.6,83.3,166.7,83.2,166.7z"
      />
      <path
        class="st3"
        d="M83.5,166.8L83.5,166.8c0.1,0.1,0.1,0.1,0.1,0.1C83.6,166.8,83.5,166.8,83.5,166.8L83.5,166.8z"
      />
      <polygon class="st3" points="66.2,170.3 66.1,170.4 66.2,170.4 	" />
      <polygon class="st3" points="32.6,175.6 32.5,175.5 32.4,175.5 	" />
      <path
        class="st3"
        d="M233,131.2C233.1,131.2,233.1,131.2,233,131.2c0.1-0.1,0.1-0.1,0.1-0.2C233.1,131.1,233.1,131.1,233,131.2z"
      />
      <polygon class="st3" points="87.9,159.5 87.9,159.4 87.8,159.4 	" />
      <polygon class="st3" points="153.2,144.6 153.4,144.6 153.3,144.5 	" />
      <path
        class="st3"
        d="M86.5,158.1c-0.1,0-0.2,0-0.2-0.1h-0.1c0,0,0,0,0.1,0.1C86.3,158.1,86.4,158.1,86.5,158.1z"
      />
      <path
        class="st3"
        d="M274.5,117.1c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C274.4,117.2,274.5,117.2,274.5,117.1z"
      />
      <path
        class="st3"
        d="M242.7,124.1c0.1,0,0.1,0,0.2,0C242.8,124.1,242.8,124,242.7,124.1C242.7,124,242.7,124,242.7,124.1z"
      />
      <path
        class="st3"
        d="M85.9,157.8l-0.1,0.1c0.1,0,0.2,0,0.3,0.1C86.1,158,86,157.9,85.9,157.8z"
      />
      <path
        class="st3"
        d="M101.9,154.1c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0-0.1,0.1-0.1,0.1-0.2
		C101.9,154.3,101.9,154.2,101.9,154.1z"
      />
      <path
        class="st3"
        d="M235.3,123.7c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1,0-0.2C235.5,123.6,235.4,123.7,235.3,123.7z"
      />
      <polygon class="st3" points="155.8,140.9 156,141 155.9,140.9 	" />
      <path
        class="st3"
        d="M235.6,123.3c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1l0,0C235.6,123.4,235.6,123.4,235.6,123.3z"
      />
      <path
        class="st3"
        d="M75.7,157.7l-0.1-0.1l-0.1,0.1l0.1,0.1C75.7,157.7,75.7,157.7,75.7,157.7z"
      />
      <path
        class="st3"
        d="M290.3,103.6c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C290.2,103.7,290.3,103.7,290.3,103.6z"
      />
      <path
        class="st3"
        d="M186.9,124.3L186.9,124.3c0-0.1,0.1-0.2,0.1-0.3C186.9,124.2,186.9,124.2,186.9,124.3
		c-0.2,0.1-0.3,0.2-0.4,0.3l0,0c0,0,0,0,0.1,0C186.7,124.6,186.8,124.5,186.9,124.3z"
      />
      <path
        class="st3"
        d="M178.3,126h0.1C178.3,125.9,178.3,125.9,178.3,126C178.3,125.9,178.3,126,178.3,126z"
      />
      <polygon class="st3" points="103.3,141.3 103.4,141.4 103.4,141.3 	" />
      <path
        class="st3"
        d="M182.7,122.9c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C182.6,123,182.6,122.9,182.7,122.9z"
      />
      <path
        class="st3"
        d="M138.3,132.4C138.3,132.4,138.3,132.3,138.3,132.4c0-0.1-0.1-0.1-0.1-0.1C138.1,132.3,138.2,132.3,138.3,132.4
		z"
      />
      <path
        class="st3"
        d="M208.5,113.6c0,0-0.1,0-0.1-0.1c0,0.1,0,0.1,0,0.2C208.4,113.6,208.5,113.6,208.5,113.6z"
      />
      <path
        class="st3"
        d="M74.3,142.5l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1S74.4,142.5,74.3,142.5z"
      />
      <path
        class="st3"
        d="M74.5,142.4C74.5,142.4,74.5,142.3,74.5,142.4c0.1,0,0.1-0.1,0.1-0.1C74.6,142.3,74.5,142.3,74.5,142.4z"
      />
      <path
        class="st3"
        d="M207.9,113.1l0.1-0.1c0,0-0.1,0-0.1-0.1l-0.1,0.1C207.8,113.1,207.9,113.1,207.9,113.1z"
      />
      <polygon class="st3" points="242.8,103.3 242.7,103.3 242.8,103.4 	" />
      <path
        class="st3"
        d="M94.3,135.2L94.3,135.2l0.1-0.1h-0.1C94.3,135.1,94.3,135.1,94.3,135.2L94.3,135.2z"
      />
      <polygon class="st3" points="27.3,149.6 27.3,149.7 27.4,149.7 	" />
      <polygon class="st3" points="242.4,102.8 242.3,102.7 242.3,102.8 	" />
      <polygon class="st3" points="127.2,124.3 127.2,124.2 127.1,124.3 	" />
      <path
        class="st3"
        d="M128.7,116.9l0.1-0.1l-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2C128.6,116.8,128.6,116.8,128.7,116.9z"
      />
      <path
        class="st3"
        d="M269.5,84.9c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C269.4,85,269.4,85,269.5,84.9z"
      />
      <polygon
        class="st3"
        points="227,93.9 227,93.8 227,93.8 226.9,93.8 227,93.8 	"
      />
      <polygon class="st3" points="132.3,114.3 132.1,114.4 132.3,114.4 	" />
      <path
        class="st3"
        d="M195.1,100.2C195.1,100.3,195,100.3,195.1,100.2c-0.1,0.1-0.1,0.2-0.1,0.3C195,100.5,195,100.4,195.1,100.2
		C195.1,100.3,195.1,100.3,195.1,100.2z"
      />
      <path
        class="st3"
        d="M195.2,100c0,0.1-0.1,0.2-0.1,0.2C195.2,100.1,195.3,100.1,195.2,100C195.3,100.1,195.2,100,195.2,100z"
      />
      <polygon class="st3" points="139.9,112.1 139.8,112.1 139.8,112.2 	" />
      <polygon class="st3" points="242.5,89.5 242.4,89.5 242.5,89.6 	" />
      <polygon class="st3" points="226.5,93 226.4,93.1 226.6,93.1 	" />
      <path
        class="st3"
        d="M115.1,116.8L115.1,116.8h0.2H115.1C115.2,116.8,115.1,116.8,115.1,116.8z"
      />
      <polygon class="st3" points="2.6,141.3 2.6,141.2 2.5,141.2 	" />
      <path
        class="st3"
        d="M269.6,80.2c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C269.5,80.3,269.6,80.3,269.6,80.2z"
      />
      <path
        class="st3"
        d="M70.4,120.8L70.4,120.8L70.4,120.8v0.2C70.4,120.9,70.4,120.9,70.4,120.8z"
      />
      <path
        class="st3"
        d="M106.5,110.2C106.5,110.2,106.6,110.2,106.5,110.2h0.2H106.5C106.5,110.1,106.5,110.2,106.5,110.2z"
      />
      <path
        class="st3"
        d="M159.2,97.6l-0.1-0.1l-0.1,0.1l0.1,0.1C159.2,97.7,159.2,97.6,159.2,97.6z"
      />
      <polygon class="st3" points="121.2,105.4 121.2,105.6 121.3,105.5 	" />
      <path
        class="st3"
        d="M157.1,96.4l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C157,96.5,157,96.5,157.1,96.4z"
      />
      <path class="st3" d="M155.9,92.6l0.1-0.1v-0.1L155.9,92.6L155.9,92.6z" />
      <polygon class="st3" points="134.6,97.2 134.6,97.3 134.7,97.3 	" />
      <path
        class="st3"
        d="M218.7,246.9C218.8,246.9,218.8,246.9,218.7,246.9C218.8,246.9,218.8,246.9,218.7,246.9
		C218.8,246.8,218.8,246.8,218.7,246.9L218.7,246.9z"
      />
      <path
        class="st3"
        d="M218.2,247.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C218.4,247,218.3,247,218.2,247.1z"
      />
      <path
        class="st3"
        d="M239.9,231.1c0,0-0.1,0-0.1-0.1l0,0l0,0C239.8,231.1,239.9,231.1,239.9,231.1z"
      />
      <path
        class="st3"
        d="M607.6,49.8c-0.1,0.9,0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8l0,0v-6.9c-0.9,0.3-1.9,0.5-2.8,0.9
		C608.3,48.1,607.7,48.8,607.6,49.8z"
      />
      <path
        class="st3"
        d="M546.5,198.8c-0.1-0.5-0.3-1-0.8-1.2c-0.3,0.6-0.6,1.2-1,1.8c0.2,0.1,0.3,0.1,0.5,0.1
		C545.9,199.7,546.6,199.3,546.5,198.8z"
      />
      <path
        class="st3"
        d="M542.8,187.8L542.8,187.8c0-0.2,0.1-0.4,0-0.5c-0.1-0.3-0.3-0.6-0.5-0.8c-0.4,0.7-0.8,1.3-1.1,2
		c0.2,0.3,0.3,0.5,0.4,0.7C542.1,188.9,542.6,188.3,542.8,187.8z"
      />
      <path
        class="st3"
        d="M540.6,192.9c1.1-0.8,1.1-0.7,3.4,0c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4c-0.9,0-1.8,0.3-2.6-0.1
		c-0.2-0.1-0.7,0.1-1.2,0.3c-0.3,0.5-0.5,0.9-0.8,1.4c-1.7,2.9-3.4,5.8-5,8.7l0.1,0.1c1.3-0.2,2.1-0.8,2.6-1.9
		c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8c0.2,0.5-0.1,0.9-0.7,1.1c-0.4,0.9-0.4,0.9,0.3,2.1c1.1-0.3,1.8,0,2.1,0.8
		c1-0.4,1.8-1,2.5-1.8c-0.1-0.1-0.2-0.3-0.1-0.4c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8c-0.3,0-0.6-0.1-1.1-0.1
		c0.5-0.6,0.9-1.2,1.4-1.9c0.4,0.3,0.7,0.5,0.8,0.7c0.4,0.5,0.8,0.9,1.6,1.1c0.3,0.1,0.5,0.2,0.7,0.3c0.3-0.6,0.5-1.1,0.8-1.7
		c-0.4-0.2-0.8-0.5-1-0.9c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7c0.9-1-0.2-0.8-0.3-1.2c0.2-0.1,0.4-0.2,0.8-0.3
		c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3C540.4,193.4,540.4,193,540.6,192.9z"
      />
      <path
        class="st3"
        d="M361.2,249.8c1-0.1,1.9-0.7,2.5-1.3c0.3-0.4,0.6-0.7,0.7-1.2c0.1-0.2,0.1-0.5,0.2-0.7c0-0.3,0.1-0.5,0.1-0.8
		c-1.8,1.3-3.6,2.5-5.5,3.8C359.8,249.8,360.5,249.9,361.2,249.8z"
      />
      <path
        class="st3"
        d="M544.1,203.3c0.4-0.1,0.8-0.1,1.2-0.2c-0.1-0.3-0.2-0.5-0.4-0.8c-0.4,0.2-0.7,0.3-1,0.4
		c-0.3-0.1-0.4-0.4-0.6-0.6c-0.2,0.4-0.4,0.8-0.7,1.5c0.2,0,0.4-0.1,0.6-0.1c0.2-0.1,0.4-0.3,0.6-0.5
		C543.9,203.1,544,203.2,544.1,203.3z"
      />
      <path
        class="st3"
        d="M534,203.4c0.3-0.2,0.7-0.4,1.3-0.6c-0.4-0.4-0.8-0.7-1-1.1c-0.2-0.2-0.3-0.5-0.4-0.8c-0.6,1-1.2,2-1.8,3.1
		c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.1,0.1,0.1,0.2c0.6-0.3,1.1-0.5,1.6-0.7c0,0,0,0,0-0.1C533.8,203.7,533.8,203.5,534,203.4z"
      />
      <path
        class="st3"
        d="M546.3,204.4c-0.2,0-0.3-0.1-0.5-0.2c-0.7,0.1-1.5,0.3-2.2,0.4c0.1,0.5,0.7,1.1,1.1,1c1-0.3,1.6,0.1,2.2,0.6
		c0.2,0.2,0.7,0.1,1.2,0.1C547.8,205.4,547.5,204.6,546.3,204.4z"
      />
      <path
        class="st3"
        d="M292.5,145.7c0-0.1-0.1-0.3-0.1-0.4c-2.6,0.6-5.1,1.1-7.7,1.7C287.3,146.5,289.9,146.1,292.5,145.7z"
      />
      <path
        class="st3"
        d="M171.4,128.1c0.5-0.2,0.8-0.3,1-0.4c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.4-0.2,0.6-0.3
		c-0.8,0.1-1.7,0.2-2.6,0.4C171.1,127.8,171.2,128,171.4,128.1z"
      />
      <path
        class="st3"
        d="M172.7,129.2c0.9,0.7,1.7,1.5,2.6,2.2c0.1-0.7,0.2-1.4,0.3-2.2c-0.5,0-0.9,0-1.2,0c0.1-0.2,0.1-0.4,0.2-0.5
		c0.3-0.2,0.7-0.3,1-0.5c-0.4-0.2-0.7-0.4-1.3-0.7C174.1,128.6,173.5,129,172.7,129.2z"
      />
      <path
        class="st3"
        d="M291.2,118.2c0.5,0.9,1.2,1.7,1.9,2.5c0.7,0.7,0.7,1.6,0.2,2.3c0.6-0.1,1.1-0.2,1.7-0.2c0-0.1,0-0.2,0-0.3
		c0-1.1-0.3-1.9-1.4-2.6c0.7-0.2,1.2-0.3,1.6-0.5c1.4-0.5,2-1.7,1.8-2.9c-0.7-0.6-1.5-1.3-2.2-1.9c-0.6-0.1-1.2-0.1-1.8,0.2
		C291.2,115.4,290.4,117,291.2,118.2z"
      />
      <path
        class="st3"
        d="M231.6,121.6c-0.2-0.1-0.4-0.1-0.6-0.2c1.4,1.2,2.8,2.4,4.1,3.5l0,0l0,0c0.4,0.3,0.8,0.7,1.2,1
		c0.6,0,1.1,0.1,1.7,0.1c0.7,0,1.2,0,1.7,0.2c0.1-0.5,0.2-0.9,0.4-1.4c0.2-0.6-0.2-0.9-0.8-1.2c-1.2-0.6-2.3,0.1-3.5,0.3
		c-0.2,0.3-0.4,0.7-0.5,1c-0.7-0.9-1.3-1.9-2.1-2.6C232.6,121.9,232.1,121.7,231.6,121.6z"
      />
      <path
        class="st3"
        d="M240.6,118.4c-0.1,0.2,0,0.6,0.2,0.7c0.3,0,0.6-0.1,0.9-0.1c0,0,0.1,0,0.2-0.1c0.3-0.2,0.5-0.4,0.8-0.7
		c0.3,0.1,0.4,0.3,0.7,0.4c0,0.1-0.1,0.1-0.1,0.2c0.5-0.1,1-0.1,1.6-0.2c0.1-0.2,0.2-0.4,0.3-0.6c-0.3-0.6-0.6-1-1.7-0.8
		c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.6-0.2-1-0.4c-0.1,0-0.2-0.1-0.3-0.1C241.1,117.3,240.8,117.9,240.6,118.4z"
      />
      <path
        class="st3"
        d="M226.1,114.9c0.2,0,0.4-0.2,0.9-0.5c0.1,0.4,0.2,0.8,0.4,1.3c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1,0
		c-0.5,0-0.9,0-1.3,0.1c1.4,1.2,2.7,2.4,4.1,3.5c0.6,0.5,1.5,0.7,2.4,0.7c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2
		c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.5-0.3l0,0c0.1,0,0.2-0.1,0.3-0.1c1-0.3,1.9-0.9,2.5-1.6c0.4-0.5,0.7-1,0.8-1.7l0,0
		c0-0.1,0.1-0.3,0.1-0.5c0-0.1,0-0.3,0-0.4c0-1-0.5-1.8-1.3-2.5l0,0c-0.3-0.3-0.7-0.5-1.1-0.6c-0.2-0.1-0.3-0.1-0.5-0.2
		c-1.9-0.6-4.2,0.1-5.5,1.5c-0.3,0.3-0.5,0.6-0.7,0.9c-0.5,0.7-1.2,1.2-2.1,1.4c0,0.1,0.1,0.1,0.1,0.2
		C225.9,114.8,226,114.9,226.1,114.9z"
      />
      <path
        class="st3"
        d="M221.2,117.9l-0.1,0.1c-0.3,0.7-0.5,1.5-0.3,2.4c0,0.2,0.2,0.4,0.2,0.6s-0.2,0.4-0.3,0.5
		c2.4-0.3,4.7-0.5,7.1-0.8c0-0.2,0.1-0.3,0.1-0.5c-1.6-1.3-3.2-2.6-4.8-3.9c0,0,0,0-0.1,0C222.2,116.6,221.6,117.2,221.2,117.9z"
      />
      <path
        class="st3"
        d="M172.1,128.7c0.1-0.1,0.1-0.1,0.2-0.2c-0.2,0-0.4-0.1-0.6-0.2C171.8,128.5,172,128.6,172.1,128.7L172.1,128.7z
		"
      />
      <path
        class="st3"
        d="M155.1,139.4c-0.4,0.4-0.6,0.5-0.6,1c0,0.1,0,0.3,0,0.4c0,0.3,0.1,0.6,0.3,1c0.6-0.1,1.2-0.2,1.8-0.2
		c-0.3-0.1-0.7-0.3-1.1-0.4C155.2,140.8,155.9,139.9,155.1,139.4z"
      />
      <path
        class="st3"
        d="M125,156.4c1,1.1,1.9,1.3,3.3,1.1c19.1-3.2,38.2-6.3,57.3-9.5c1.8-0.3,3.6-0.6,5.6-1c-3.1-2.7-5.9-5.3-8.9-7.8
		c-0.3-0.3-1.1-0.3-1.6-0.2c-3.7,0.5-7.5,1-11.2,1.5c-4.8,0.6-9.7,1.3-14.5,1.9c0,0,0,0,0,0.1c2,0,3.9-0.7,5.9-0.3
		c0.5,1.1,0.5,1.1-1.3,2.3c0.5,0.2,0.9,0.4,1.3,0.6c-0.3,1.4-1.6,0-2.2,0.9c0.3,0.2,0.7,0.4,1,0.6c-0.5,0.5-1,1.1-1.6,1.7
		c-0.5,0.1-1.1,0.1-2.2,0.2c0.5-0.5,0.7-0.7,1-0.9c0.3-0.1,0.7-0.1,0.9-0.3c0.3-0.3,0.6-0.7,0.6-1s-0.4-0.7-0.7-0.7
		c-0.4,0-1,0.2-1.3,0.5s-0.4,0.7-0.6,1.2c-1.3-1.3-1.3-1.3-2.9-0.6c0-0.1,0-0.2,0-0.3s0-0.2,0-0.4s0-0.4-0.1-0.7
		c-0.2,0-0.4,0-0.4,0.1c-0.3,0.6-0.9,0.8-1.7,1c-0.1-0.4-0.2-0.7-0.3-1.1c-0.1-0.5-0.3-1-0.4-1.5c0.4-0.2,0.6-0.5,0.8-0.8
		c-0.8,0.1-1.6,0.2-2.4,0.3c-3.4,0.5-6.7,0.9-10.1,1.4c0.4,0.7,0.8,1.3,1.4,1.8c0.5,0.4,0.7,1,1,1.5c0.1,0.1,0.1,0.2,0.2,0.3
		c0.2,0.3,0.3,0.6-0.2,0.9c-0.1,0.1-0.1,0.3,0,0.4c0.4,0.6,0.1,1.3-0.1,2c-0.1,0.4,0,0.9-0.1,1.3c-0.1,0.3-0.3,0.6-0.4,0.8
		c-0.5-0.1-1-0.3-1.5-0.5h-0.1c-1.3-0.5-2.4-1.1-3.5-1.8c-0.3-0.2-0.7-0.4-1-0.7c-0.7,0.7-1.3,1.3-2,1.9c-1.3-0.3-2.6-0.5-2.7-2
		c-0.5,0.3-0.7,0.5-1,0.6c-0.4,0.2-0.9,0.4-1.3,0.5s-1.8,0.6-2.2,0.7c-0.8,0.3-1.7,0.5-2.5,0.6C123.1,154.4,124.1,155.4,125,156.4z
        M162.3,142.9c0,0,0.1,0,0.1,0.1c-0.1,0-0.2,0.1-0.3,0.1L162,143C162.2,143,162.3,142.9,162.3,142.9z"
      />
      <path
        class="st3"
        d="M158.3,116.6c3.7,3.3,7.2,6.4,10.8,9.5c0.1,0.1,0.3,0.2,0.4,0.3c-0.1-0.1-0.1-0.3,0-0.6
		c0.1-0.3,0.2-0.7,0.2-1.1c0.1-0.5,0.2-0.9,0.7-1.3c-0.2-1.1,1-2.3,0-3.3c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.1-0.2-0.2-0.5
		c-0.9,0.6-2,1-1.9,2.2c-0.9-0.1-1.4-0.9-2.4-0.6c-0.3,0.1-1-0.4-1-0.7c-0.1-0.8-0.9-1-1.5-1.4c0.2-0.3,0.4-0.7,0.7-1.2
		c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.1-0.7-0.3-0.9-0.4
		s-0.6-0.1-0.6-0.2s-0.1-0.2-0.1-0.3c-0.6,0-1.1,0.1-1.7,0.1C159.4,116.3,159,116.4,158.3,116.6z M169.6,120.3
		c0.1-0.1,0.2-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.3l-0.3-0.1C169.5,120.5,169.5,120.4,169.6,120.3z"
      />
      <path
        class="st3"
        d="M167.7,127.8c-3.2,0.3-6.5,0.7-9.7,1c-2.9,0.3-5.8,0.7-8.6,1c0,0.1,0,0.2,0,0.3c0.1,0.5-0.2,1-0.3,1.4
		c-0.5,0.1-0.9,0.2-1.5,0.3c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3c0.3-0.5,0.6-0.8,0.8-1.2c0,0,0-0.1,0.1-0.1l0,0
		c0.9-0.1,1.9,0.5,2.8-0.3c0.1-0.4,0.2-0.9,0.3-1.4c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1c-0.3,0.5-0.5,0.9-0.7,1.2
		c0.2-0.1,0.3-0.1,0.5-0.2l0,0c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0c-0.1,0-0.2,0-0.2-0.1
		c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.5-0.6,1.1-1.1,1.8c0.1,0.1,0.1,0.3,0.2,0.5c0.1,0.2,0.2,0.4,0.4,0.6
		c0.3,0.4,0.7,0.8,0.7,1.3c0.1,0.7,0.7,1.1,1.5,1c1.3-0.2,1.7,0.5,2.3,1.3c0.3-0.1,0.6-0.2,0.9-0.3c0.1,0.1,0.2,0.2,0.1,0.2
		c-0.5,0.6-0.9,1.2-0.8,2l0,0c1.1-0.1,2.3-0.3,3.4-0.4c4.4-0.6,8.9-1.2,13.3-1.8c2.1-0.3,4.2-0.6,6.8-1c-4-3.4-7.5-6.6-11.2-9.7
		C169.4,128,168.4,127.8,167.7,127.8z"
      />
      <path
        class="st3"
        d="M116.9,147.8c0.4,0.4,0.8,0.9,1.2,1.3c-0.1-0.5-0.2-1-0.2-1.4C117.5,147.7,117.2,147.7,116.9,147.8z"
      />
      <path
        class="st3"
        d="M120.5,153.4c-0.7-0.1-1.3-0.2-2.1-0.4c0.4-0.2,0.7-0.2,0.9-0.4c0.1-0.1,0.2-0.2,0.3-0.2
		c-1.3-1.4-2.6-2.7-3.9-4c0,0-0.1,0-0.1-0.1c0,0.7-0.1,1.5-0.2,2.2c-0.1,0.4,0.1,0.7,0.3,1.1c0.4,0.7,0.3,1.3-0.1,1.8
		c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.7,0.2-0.9,0.1c-1.7-0.5-3.6-0.1-5.4-0.2c-0.3-0.4-0.5-0.8-0.8-1.1c-0.5-0.5-1.1-0.6-1.8-0.4
		c-0.8,0.2-1.3,0.7-1.3,1.2c0,0.1,0,0.1,0,0.2c0,0.5-0.1,1-0.2,1.4c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.1,0.1,0.4,0.2,0.7
		c-1.2,0-2.5-1-3.5,0.5c-0.3-0.1-0.7-0.2-1-0.2s-0.6-0.1-0.9,0c-0.2,0-0.3,0.1-0.5,0.2c-0.2,0.1-0.5,0.3-0.7,0.6
		c-0.1,0.1-0.1,0.1-0.1,0.2c-0.5,0.6-0.3,1.2,0.4,2c-0.3,0.9-0.7,1.7-0.6,2.5c6.7-1.1,13.4-2.2,20.1-3.3c2.5-0.4,5.1-0.9,7.9-1.3
		C123.4,156.4,122,154.9,120.5,153.4L120.5,153.4z"
      />
      <path
        class="st3"
        d="M159.8,115.2c-0.1,0.1-0.2,0.2-0.3,0.3c0.4,0,0.8-0.1,1.1-0.1c-0.1,0-0.3-0.1-0.4-0.1
		C160,115.3,159.9,115.2,159.8,115.2z"
      />
      <path
        class="st3"
        d="M118.3,137.3c-0.1-0.1-0.5,0.1-0.7,0.1c-0.8,0.1-1.2-0.1-1.2-0.7c-0.1-1-0.2-2.1-0.3-3.2c-0.3,0-0.7,0.1-1,0.1
		c0,1-0.1,2-0.1,3.1c-1.2,0.4-2.2,1.1-2.2,2.3c0,1.1,0.9,1.6,2.1,1.7c0.2,1,0.4,1.8,0.6,2.7c0,0.3-0.1,0.7-0.3,1
		c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6l0.1,0.1c0.7,0.5,1.4,0.6,2.3,0.6c0,0,0,0,0-0.1c-0.1-0.2-0.1-0.5-0.1-0.7
		c0.1-0.4,0.1-0.7,0.1-1.1c0-0.9-0.3-1.8-0.6-2.7c-0.5-1.3-0.6-2.5,0.4-3.8c0.2,0,0.4,0.1,0.6,0c0.3-0.1,0.6-0.3,0.8-0.5
		C118.8,137.8,118.6,137.5,118.3,137.3z"
      />
      <path
        class="st3"
        d="M137.2,142.7c0.2,0.4,0.4,0.9,0.6,1.4c3.1-0.4,6.2-0.8,9.3-1.3c1.2-0.2,2.4-0.3,3.6-0.5c0-0.1,0-0.2,0-0.3
		c-0.1-0.2-0.1-0.5-0.1-0.8s0-0.6,0.1-0.9c0.1-0.5-1-0.9-0.2-1.5c0.1-0.1-0.3-0.7-0.6-1.2h-0.1c-0.4-0.1-1,0.8-1.5,0.2
		c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.5-0.4,0.9-0.7,1.3c-0.4-0.3-0.8-0.5-1.2-0.7c-0.3-0.2-0.7-0.3-1.3-0.6c0.1,0.6,0.2,0.9,0.3,1.2
		c0,0,0,0,0,0.1c-1.1,0.5-2.1,0.9-3.2,1.4c-0.1,0-0.4-0.2-0.7-0.2c-0.4,0-0.9,0-1.2,0.1c-0.6,0.2-1.4,1.4-1.8,2.4
		c-0.1,0.2-0.1,0.5-0.2,0.7C137.1,142.4,137.1,142.6,137.2,142.7z"
      />
      <path
        class="st3"
        d="M274.1,126.6c-0.3,0.1-0.7,0.4-0.6,1c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1c0-0.3,0-0.7-0.1-1.3
		c0.5,0.6,0.7,0.9,1.1,1.4c0.5,0,1.3-0.6,1.7,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-1.2,1.1-1.6,2.1-1.3,3.1c0.4-0.1,0.8-0.1,1.2-0.2
		c0-0.2-0.1-0.4-0.1-0.6c0.6-0.5,1.2-0.9,2.1-0.9c0.8,0,0.8,0,1.5-1.1c-0.8-0.3-1.5-0.7-2.4-1c-0.1-0.7-0.2-1.3-1.4-1.5
		C275.8,127.8,275.1,127.1,274.1,126.6z"
      />
      <path
        class="st3"
        d="M523.7,198.6c0.5-0.4,0.9-0.6,1.7-0.8c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.2,0.9,0.5
		c-1,0.1-1.6,0.2-2.3,0.3c0.3,0.8,0.7,1.6,1.5,1.6s1.3-0.2,0.8,0.7c-0.2,0.4,1.2,0.1,0.5,0.8c0.7,0.1,0.8,0.6,1,1.1
		c0.1,0.3,0.3,0.6,0.7,0.6c1.1,0,0.8-1.1,1.5-1.2c0.2,0.2,0.4,0.5,0.7,0.7c2.5-4.3,4.9-8.5,7.4-12.8c-0.2,0-0.5-0.1-0.7-0.3l0,0l0,0
		c0.5-0.4,0.7-0.6,0.7-0.8c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0c0.5,0,0.7,0.2,1,0.5
		c1.5-2.7,3.1-5.3,4.6-8c-0.2-0.1-0.4-0.1-0.4,0c-0.3,0.9-1.5,0.6-2,1.2c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6-0.1-1-0.6-1.5-0.8
		c-0.4-0.1-0.8-0.2-1.3,0c0,0.3,0,0.6,0,0.8c-0.1,1-0.8,1.8-2.1,2.4c0.3-0.8,0.7-1.6,1-2.4c-0.8-0.7,1.2-1.7-0.2-2.4
		c-0.7,0.2-0.3,0.8-0.5,1.2c-0.5,0.2-1.1,0.4-1.6,0.6c0-0.1-0.1-0.1-0.1-0.2c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.3
		c-0.6-0.1-1.3-0.2-2.2-0.2c-0.2,0.2-0.7,0.5-1.1,0.8c-0.7-0.5-1.3-1-1.9-1.4c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0
		c-0.3,0.1-0.5,0.7-0.9,0.6c-0.1,0-0.2-0.1-0.3-0.2l0,0c-0.3,0-0.7-0.1-1-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7
		c-0.5-0.2-1.1-0.4-1.7-0.7c-0.2,0.5-0.3,0.9-0.5,1.4c-0.6-0.2-1.1-0.3-1.5-0.4c0.2-0.1,0.4-0.2,0.7-0.4c-0.5-0.1-0.8-0.2-1.1-0.3
		v-0.1c0.5-0.3,1.1-0.7,1.6-1c0.1-0.1,0.5,0.2,0.7,0.4c0.2-0.1,0.4-0.1,0.5-0.2c0.6-1.2,0.3-1.2,1.9-1.3c0.4,0,0.7-0.1,1.1-0.2
		c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0.4,0.4,0.8,0.6,1.1l0,0c0.6-0.4,0.7-0.9,0.8-1.4c0-0.4-0.1-0.8-0.1-1.3c1,0.1,1.1,0.6,1.1,1.4
		c0.3-0.2,0.5-0.4,0.7-0.5s0.4-0.2,0.7-0.4c-0.6-0.5-0.4-1.3-0.1-1.9c0.3-0.6,1.3-1,2.1-1.6c0.2,0,0.7,0.1,1.4,0.2c0-1,0-2,0-2.9
		c0.5,0,1.1,0,1.6,0c-0.5-0.4,0.8-0.9,0.1-1.3c0.4-0.4,0.7-0.8,1.1-1.3c0.8,0.3,1.1-0.1,1.4-0.6c1.2,0.7,0.9,1.7,0.4,2.8
		c-0.7,0.2-1.6,0.5-2.5,0.8c0-0.3,0-0.6-0.5-0.5c-0.1,0.3-0.3,0.8,0.4,0.5c0,0.2-0.1,0.5-0.1,0.7c0.1,0.8,0.3,1.3,0.6,1.7
		c0.6,0.7,1.7,0.9,3.5,0.9c0.4,0.4,0.7,0.8,1.1,1.1c0.2,0.1,0.3,0.2,0.5,0.3c1,0.4,2.3,0,2.7-1.1c0.4-0.9,0.3-1.7-0.5-2.2
		c-0.6-0.4-0.6-0.9-0.1-1.5c-0.6-0.1-1.1-0.3-1.7-0.4c-0.2,0.6-0.5,1.2-0.7,1.7c-0.2-0.3-0.5-0.6-0.7-0.9c0.2-0.4,0.3-0.7,0.5-1.1
		c-0.7,0.1-1.2,0.1-1.8,0.2c0.5-0.6,0.9-1.3,1.5-1.8c0.7-0.5,1.6-0.9,2.3-1.3c0-0.4-0.1-0.8,0.1-1c0.1-0.2,0.6-0.1,0.9-0.2
		c0.6-0.1,1.1-0.2,2-0.4c0.1,0,0.4,0.2,0.8,0.5c0.4-0.2,0.9-0.5,1.4-0.7c-0.1-0.5-0.1-0.9-0.2-1.3c0.3,0.1,0.7,0.1,0.9,0.3
		c0.4,0.3,0.7,0.7,1,1c-1.6,0.4-2.9,1.2-3.9,3c1-0.5,1.8-0.8,2.4-1.3c0.5-0.4,0.9-0.7,1.4-0.9c3.4-5.9,6.9-11.9,10.3-17.8
		c0.2-0.4,0.3-0.8,0.6-1.3c-0.7,0.2-1.2,0.3-1.6,0.4c-5.5,1.5-10.9,3.1-16.4,4.6c-1.4,0.4-2.3,1-3.2,2.1
		c-8.5,10.6-17.1,21.2-25.6,31.8c0.1,0.2,0.3,0.3,0.5,0.5c-0.4,0.7-0.8,1.4-1.2,2.1c-0.1,0.2-0.2,0.4-0.4,0.6
		c0.3-0.1,0.6-0.1,0.9-0.2c0.1,0.2,0.2,0.4,0.3,0.7c-0.9,0.2-1.3,1-2.3,1c-0.3,0-0.7,0-1,0c-0.2,0-0.4-0.1-0.5-0.1
		c-0.7,0.8-1.4,1.7-2,2.5c0.2,0.2,0.4,0.4,0.7,0.5c0.7,0.3,1.3,0.9,1.6,1.5c0.5,0.9,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3
		c-0.1-0.4-0.1-0.9-0.2-1.4c0.5-0.1,0.8-0.1,1.2-0.2c0,0.2,0.1,0.4,0.1,0.5c0.3,1.3,0.5,1.4,2.2,1.6c0.4,0,0.7,0.3,1,0.5
		c0.2,0.1,0.3,0.3,0.4,0.5C522.4,199.2,522.8,199.2,523.7,198.6z M527.5,200c0.1,0.1,0.2,0.1,0.2,0.2c-0.2,0.1-0.4,0.3-0.6,0.4
		c-0.1-0.1-0.1-0.1-0.2-0.2C527.2,200.4,527.4,200.2,527.5,200z M549.8,164.5c0,0.1,0.1,0.1,0.1,0.2c-0.1,0-0.2,0-0.2,0
		C549.7,164.6,549.8,164.6,549.8,164.5z M545.9,163.7c0.6-1.1,1.9-1.3,3-1.9c0.2,0.7,0.3,1.4,0.5,2.3c-0.6-0.5-0.9-0.8-1.2-1
		c-0.5-0.3-1-0.1-1.1,0.4c-0.2,0.5-0.2,1.1-0.3,1.7c-0.9,0.2-1.7,0.4-2.9,0.6C544.7,164.9,545.3,164.3,545.9,163.7z M517.6,194.8
		c0.3-0.3,0.5-0.6,0.7-0.9C518.6,194.7,518.6,194.7,517.6,194.8z"
      />
      <path
        class="st3"
        d="M339.4,129.1c-7.9,1.5-15.8,3-23.7,4.5c-0.6,0.3-1.1,0.6-1.8,1c0,0.4,0,0.9,0,1.4c5.2-1.1,10.4-2.2,15.6-3.3
		c4.7-1,9.5-2,14.2-3c0-0.2,0-0.4,0-0.6C342.2,129.2,340.7,128.8,339.4,129.1z"
      />
      <path
        class="st3"
        d="M300.2,127.5c0.2,0,0.4,0.1,0.6,0c0.8-0.2,1.4-0.1,2.1,0c0.3,0.1,0.6,0,0.9,0c0.5-0.1,0.9-0.4,1.4-0.6
		c-0.4,0.5-0.7,1-1.1,1.4c-0.1,0.1-0.1,0.2-0.2,0.2c1.9-0.3,3.9-0.6,6-1c-1.4-1.2-2.6-2.2-3.8-3.2l0,0c-0.6,0-1.1,0-1.6-0.4
		c-0.1-0.1-0.3-0.2-0.5-0.1c-0.5,0-1.1,0-1.4,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.2,0.4-0.2,0.9-0.1,1.3
		C299.5,127.2,299.8,127.5,300.2,127.5z M305.5,126.5c0.1-0.1,0.3,0,0.4,0c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.3,0.1-0.4,0.2
		C305.4,126.7,305.4,126.6,305.5,126.5z"
      />
      <path
        class="st3"
        d="M399,98.8c-0.1,0-0.2,0-0.3,0v-0.1c0-0.1,0-0.1,0-0.2c0-0.4,0.1-0.8-0.6-0.8c-0.3,0-0.7,0.1-0.8,0.3
		c-0.2,0.2-0.1,0.5-0.1,0.8c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.2,0.3-0.2,0.4s0.1,0.2,0.1,0.3l0,0
		c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.4-0.5,0.4c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0c0.6,0.7,1.4,0.7,2.2,1c-0.3,0.6-0.4,1.4-1.6,1.1
		c0.2,0.3,0.2,0.5,0.3,0.8c-0.3,0.4-0.6,0.8-1,1.2c0.1,0.1,0.2,0.1,0.3,0.2c1.5-1.9,2.9-3.8,4.4-5.6l0,0c0,0,0,0,0.1,0
		C398.9,99,399,98.9,399,98.8z M398.3,99c0.1,0,0.3-0.1,0.4-0.1c0,0.1,0,0.2,0.1,0.2C398.6,99,398.4,99,398.3,99z"
      />
      <path
        class="st3"
        d="M240.1,271.7c-0.6-0.1-1-0.5-0.9-1.1c0-0.3-0.3-0.6-0.5-1c-0.4,0.2-0.7,0.3-1,0.4c-0.5-0.2-0.4-1.1-1.4-0.7
		c-0.1,0.2-0.2,0.4-0.4,0.8c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8c-0.3,0-0.6-0.1-1.1-0.1
		c0.5-0.6,0.9-1.2,1.4-1.9c0.4,0.3,0.7,0.5,0.8,0.7c0.4,0.5,0.8,0.9,1.6,1.1c0.8,0.3,1.4,0.9,2.2,1c0.7,0.1,1.4-0.3,1.3-0.8
		c-0.1-0.5-0.3-1.1-1-1.2c-1-0.1-1.6-0.4-2-1.2c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7c0.9-1-0.2-0.8-0.3-1.2
		c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.3,0.1-0.7,0.3-0.9c1.1-0.8,1.1-0.7,3.4,0
		c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4c-0.9,0-1.8,0.3-2.6-0.1c-0.3-0.2-1.2,0.3-1.9,0.6c-0.7,0.3-1.3,0.5-1.8,0l0,0
		l0,0c0.5-0.4,0.7-0.6,0.7-0.8c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0c1.1,0,1.1,1,1.9,1.4
		c0.2-0.3,0.3-0.7,0.6-1.4c0.2,0.4,0.4,0.6,0.5,0.8c0.6-0.2,1.1-0.8,1.2-1.3v-0.1c0-0.1,0-0.3,0-0.4c-0.2-0.5-0.6-0.9-1-1.4
		l-0.1-0.1c0.2,0,0.4,0,0.7,0c-0.1-0.7,0-1.3,0.3-1.9c0.2-0.5,0.6-0.9,1.1-1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.3,0.3-0.6,0.4-0.9
		c0,0,0,0,0-0.1c-10.5,4.9-21.1,9.8-31.6,14.7c0.5,0.8,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3c-0.1-0.4-0.1-0.9-0.2-1.4
		c0.5-0.1,0.8-0.1,1.2-0.2c0,0.2,0.1,0.4,0.1,0.5c0.3,1.3,0.5,1.4,2.2,1.6c0.4,0,0.7,0.3,1,0.5c0.2,0.1,0.3,0.3,0.4,0.5
		c0.7,0.7,1.1,0.7,2,0.1c0.5-0.4,0.9-0.6,1.7-0.8c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.2,0.9,0.5c-1,0.1-1.6,0.2-2.3,0.3
		c0.3,0.8,0.7,1.6,1.5,1.6s1.3-0.2,0.8,0.7c-0.2,0.4,1.2,0.1,0.5,0.8c0.7,0.1,0.8,0.6,1,1.1c0.1,0.3,0.3,0.6,0.7,0.6
		c1.1,0,0.8-1.1,1.5-1.2c0.4,0.5,0.9,0.9,1.3,1.4c0.1,0.2,0.3,0.3,0.4,0.5c0.6-0.3,1.1-0.5,1.6-0.7c0,0,0,0,0-0.1
		c0.1-0.2,0.1-0.4,0.3-0.5c0.3-0.2,0.7-0.4,1.4-0.6c-0.4-0.4-0.8-0.7-1-1.1c-0.3-0.4-0.5-0.9-0.6-1.3c0-0.1,0.3-0.2,0.5-0.4
		c0.1,0.1,0.2,0.2,0.2,0.3c1.3-0.2,2.1-0.8,2.6-1.9c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8c0.2,0.5-0.1,0.9-0.7,1.1
		c-0.4,0.9-0.4,0.9,0.3,2.1c1.3-0.4,2,0,2.3,1.1c0.2,0.6,0.6,0.8,1.5,1l0.1-0.1c-0.1-0.3-0.1-0.7-0.2-1.1c0.2-0.1,0.7-0.5,0.9-0.5
		c0.9,0.3,1.5-0.1,2-0.8c0.3,0.4,0.5,0.6,0.7,0.8c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.5,0.6,1.5,1.1,1.4c1-0.3,1.6,0.1,2.2,0.6
		c0.2,0.2,0.7,0.1,1.2,0.1C241.6,272.7,241.3,271.9,240.1,271.7z M211.4,262.1c0.3-0.3,0.5-0.6,0.7-0.9
		C212.5,262,212.5,262,211.4,262.1z M221,268c-0.1-0.1-0.1-0.1-0.2-0.2c0.2-0.2,0.4-0.3,0.5-0.5c0.1,0.1,0.2,0.1,0.2,0.2
		C221.4,267.7,221.2,267.8,221,268z"
      />
      <path
        class="st3"
        d="M309.7,121.5c-0.1,0.2-0.1,0.3-0.2,0.4c-0.4,0.1-0.8,0.3-1.2,0.4c-0.2,0.1-0.4,0.1-0.7,0.2
		c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.1,0.2-0.2,0.3c1.3,1.1,2.6,2.2,3.7,3.3c0.8,0.8,1.7,1,2.8,0.7
		c1.8-0.4,3.5-0.6,5.3-0.9c1-0.2,2.1-0.3,3.1-0.5c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.1-0.3-0.4-0.4-0.6c-0.4-0.6-0.6-1.2-1.1-1.7
		c-0.2-0.2-0.4-0.4-0.5-0.5s-0.2-0.2-0.4-0.3c-0.2-0.2-0.5-0.3-0.7-0.3c-0.7-0.2-1.4-0.1-2.5,0.3c-0.3,0.1-0.5,0.2-1.1,0.4
		c0.3-1,0.1-1.6-0.8-2.2c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9c-0.3,0-0.7-0.1-1-0.1c-0.4-0.1-0.7-0.2-1-0.6
		C310,121.5,309.9,121.5,309.7,121.5z M313.6,122.4l-0.1,0.1l-0.1-0.1H313.6z"
      />
      <path
        class="st3"
        d="M324.3,116.5c-0.8,0.5-1.6,1.2-2,1.9c-0.1,0.2-0.2,0.4-0.3,0.7c0.8-0.1,1.6-0.2,2.3-0.3c0,0.2,0.1,0.5,0.1,0.7
		c-0.9,0.1-1.8,0.2-2.7,0.4c-0.1,0.3-0.1,0.6-0.1,0.9s0.1,0.7,0.2,1c0,0.1,0.1,0.2,0.1,0.3c0.2,0.8,0.6,1.4,1.3,1.9
		c0.4,0.3,0.8,0.5,1.3,0.7c-0.1,0.2-0.1,0.3-0.2,0.5c10.9-1.8,21.7-3.5,32.6-5.3c4.1-0.7,8.3-1.3,12.4-2c2.1-0.3,4.1-0.7,6.3-1.1
		c-0.2-0.1-0.3-0.3-0.5-0.4c-0.4-0.5-0.7-1-1.1-1.6c-0.3-0.4-0.6-0.8-1.1-1.1c-0.8,0.1-1.5,0-2.1-0.3c-0.5-0.2-0.9-0.5-1.3-0.9
		c-0.5,0.4-0.9,0.8-1.3,1.2c0-0.9,0.3-1.5,1.1-2c0,0,0.1,0,0.1-0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		c0-0.1-0.1-0.2-0.3-0.3l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0c-0.2-0.8-0.7-1.4-1.4-1.7c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2
		c0.1-0.3,0.1-0.5,0.2-0.7c0-0.2,0.1-0.4,0.2-0.6c-0.6-0.4-1.1-0.9-1.7-1.3c-0.4,0.2-0.7,0.2-1-0.1c-0.8-0.9-2.1-1.2-3.3-1.4l0,0
		c-0.4-0.1-0.9-0.1-1.3-0.2c-0.7-0.2-0.8-0.4-0.9-0.8c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.3,0.7-0.5,0.9-0.8c0.1-0.1,0.2-0.2,0.3-0.3
		c-0.9-0.7-1.9-1.5-2.8-2.2c-0.5-0.4-1.3-0.6-1.9-0.6c-3.5,0.3-7,0.6-10.5,0.9c-0.1,0.2-0.2,0.3-0.3,0.5c-0.3,0.7-0.3,1.5-0.1,2.3
		c0,0.1,0,0.2,0.1,0.3l-0.1,0.1c-0.9,0.2-0.9,0.2-1.3-1.3c-0.5,0.1-1.1,0.2-1.8,0.3c0.2,0.7,0.8,1,1.4,1.2c-0.7,0.9-1.5,1.7-2,2.6
		c-0.5,1-0.2,2,0.7,3c-1.5,0-2.7,0.3-3.5,1.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.5,0.5-0.7,0.9c-0.3-0.4-0.5-0.8-0.9-1.1
		c-0.6-0.5-1.4-0.2-1.7,0.5c-0.1,0.2-0.1,0.4-0.1,0.6l0,0c0,0.3,0.2,0.6,0.5,0.9c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1
		c0.1,0.3,0.2,0.7,0.4,1c0.2,0.5,0.6,1,1.3,1.3c0.4,0.1,0.7,0.4,1,0.7c0.2,0.2,0.5,0.5,0.7,0.7c-0.4,0.4,0,0.6,0.1,0.9
		c0.1,0.2,0.1,0.3,0.1,0.5c0,0.4-0.1,0.7-0.9,0.9c-0.3-0.6-0.8-1.1-1-1.7c-0.8-2.2-1.9-2.5-4.5-1.2c-0.1,0-0.1,0-0.2,0.1
		c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.4-0.1-0.7,0.3-1.1c0.3-0.3,0.3-0.8,0.4-1.2
		c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1c-0.3,0.5-0.7,0.9-0.9,1.4c-0.2,0.6-0.5,0.9-1.3,0.9c-0.5,0-0.9-0.1-1.3-0.4
		c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.7-0.3-1c-0.3,0.9-0.8,1.7-0.2,2.6c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.1-0.4,0.2-0.6,0.3
		c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2C325.6,115.5,325.1,116,324.3,116.5z M366.5,114.9c0.4-0.2,0.7-0.4,1.2-0.7
		c-0.3,0.6-0.6,1-0.8,1.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.1-0.4-0.3-0.5-0.4l0,0
		C366.1,115.1,366.3,115,366.5,114.9z M340.9,117.1C340.9,117.1,340.9,117,340.9,117.1h0.1H340.9z"
      />
      <path
        class="st3"
        d="M72.5,299.4c0.2-0.3,0.4-0.6,0.6-0.9s0.4-0.6,0.6-0.9c0.2,0.3,0.5,0.6,0.8,0.8c0.3,0.4,0.7,0.8,1.1,1.2l0,0
		c-0.9,1.7-0.6,3.1,0.4,4.4c0.3,0.5,0.7,0.9,1.2,1.4c0.3,0.3,0.5,0.5,0.8,0.8c1.6,0.5,3.2,0.5,4.9,0c-5-11.3-10-22.7-15.1-34
		c-4-9-7.9-17.9-11.9-26.9c-9.1-20.5-18.2-41.1-27.3-61.6c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.2-0.3-0.3-0.5
		c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.3,0-0.6,0.2-0.9c-0.1-0.3-0.3-0.7-0.4-1c-0.1,0.2-0.3,0.4-0.4,0.6
		c-0.2,0.6-0.5,0.9-1.3,0.9c-0.5,0-0.9-0.1-1.3-0.4c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.7-0.3-1c-0.3,0.9-0.8,1.7-0.2,2.6
		c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2c-0.4,0.8-1,1.3-1.7,1.8
		c-0.8,0.5-1.6,1.2-2,1.9s-0.5,1.6-0.6,2.3c0,0.3,0.1,0.7,0.2,1c0,0.1,0.1,0.2,0.1,0.3c0.2,0.8,0.6,1.4,1.3,1.9
		c0.4,0.3,0.8,0.5,1.3,0.7c-0.1,0.3-0.2,0.6-0.4,1c-0.2-0.3-0.4-0.5-0.6-0.7c-0.5,0.4-0.4,0.7-0.3,1.1c0.1,0.3,0.2,0.6,0.1,0.8
		c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2l0,0h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2-0.1-0.3
		c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.5-0.1-0.9-0.7-1.1c-0.2-0.1-0.3-0.4-0.4-0.6c-0.4-0.6-0.6-1.2-1.1-1.7c-0.2-0.2-0.4-0.4-0.5-0.5
		s-0.2-0.2-0.4-0.3c-0.2-0.2-0.5-0.3-0.7-0.3c-0.7-0.2-1.4-0.1-2.5,0.3c-0.3,0.1-0.5,0.2-1.1,0.4c0.3-1,0.1-1.6-0.8-2.2
		c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9c-0.3,0-0.7-0.1-1-0.1c-0.5-0.1-1-0.4-1.2-1.1c-0.2,0.5-0.3,0.7-0.4,1
		c-1,0.3-1.9,0.6-2.7,0.9c-0.3,0.3-0.3,0.7-0.6,1v0.3v2.4c0.3,1.6,0.7,3.2,1,4.9c0.7,0.4,1.5,0.8,2.2,1.1c0-0.1,0.1-0.3,0.3-0.7
		c0.7,0.1,1.5,0.3,2.1,0.4c0.4,1,0.2,2.1,1.1,3.1c0.3-1.1-1.2-1.7-0.1-2.8c0.9,0.2,2.2-0.4,3,0.7c0,0.1,0.1,0.1,0.1,0.2
		c0,0-0.1,0-0.1,0.1c-0.6,0.3-1.2,0.7-1.9,1.1c0,1-0.1,2.1-0.1,3.2c0,0.1,0,0.1,0,0.2c-0.5,0-1.1,0-1.6,0c-0.6,0-1.3,0-1.9,0
		c0-0.4,0.1-0.8,0-1.2c-0.1-0.5-0.7-0.7-1.2-0.6c-0.3,0-0.5,0.1-0.8,0.3c0.1,0.6,0.3,1.3,0.4,1.9c0.4,0.1,0.8,0.2,1.3,0.1
		c0.1,0.8,0.5,1.2,1.2,1.4c0.3,0.1,0.7,0.1,1.1,0c-0.1,0.4-0.2,0.7-0.3,1c-0.3,0.6-1,0.7-2.3,0.4c-0.1,0.1-0.2,0.2-0.3,0.3
		c6.3,29.6,12.5,59.2,18.8,88.8c0.3,1.3,0.5,2.6,0.8,3.9c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8
		c0.1-0.1,0.2-0.2,0.3-0.3c0.3,0.1,0.6,0.1,0.9,0.1c1.2,0,2-0.7,2.7-1.5c0.3-0.4,0.6-0.8,1-1.1c0.2,0.1,0.3,0.2,0.5,0.3
		c0,0,0,0,0.1,0c0.6,0.4,1.2,0.8,0.9,1.7c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2,0,0.2,0c0.3,0,0.4,0,0.5,0.1
		c0.1,0.1,0.1,0.3-0.1,0.6c-0.1,0.2,0.8,0.1,0.9,0.7c0.1,0.6,0.5,1.2,0.7,1.9c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5
		c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2c0.1,0.1,0.3,0.1,0.5,0.2c0.4,0.2,0.7,0.4,1,0.3s0.5-0.1,0.7-0.1
		c0.3,0,0.6,0,0.9,0.3c0.3-0.6,1.1-0.3,1.5-0.6c0.2-0.2,0.4-0.3,0.6-0.5c0.3-0.2,0.6-0.4,1.1-0.5c0.2,0,0.3-0.6,0.5-0.8
		c0.3-0.2,0.6-0.3,1-0.5c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.4,0.6-0.7,0.6-0.9
		c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.5,0.1-0.9,0.1-1.3c0-0.3-0.3-0.5-0.4-0.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.1-0.3,0.3c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.7-0.5-1.4-1.1-2.5-1.5c-0.3-0.1-0.6-0.2-1-0.2
		c0.5-0.2,0.8-0.5,1-0.8c0.5-0.5,0.8-1,1.6-1.1c0,0.4-0.1,0.8-0.2,1.2c0.2,0,0.4-0.1,0.6-0.2c0.4-0.2,0.7-0.4,1-0.7
		c0.3-0.3,0.6-0.6,0.9-0.8c1.8,1.8,1.8,1.8,4.5,1.3c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.1,0,0.1-0.1,0.2-0.1h0.1
		c0.4-0.2,0.9-0.5,1.6-0.1c-0.6,0.4-1.1,0.8-1.7,1.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.6,0.6,1,1.5,1.8,1.8c0.2,0.1,0.5,0.1,0.7,0.1
		c0.7,0,1.4-0.1,2.2-0.2c0.4,0.2,1,0.5,1.8,0.8c0.2,0.8,0.7,1.7,0.4,2.7c-2.6,0.2-3.6,0.7-3.9,2.1c-0.2,0.8,0.1,1.4,0.8,1.9
		c0.1,0.1,0.3,0.2,0.4,0.2c0.3,0.1,0.6,0.3,1,0.4c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.4-0.4,0.7-0.7,1.1c-0.3-0.2-0.5-0.4-0.8-0.5
		c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4-0.1-0.7-0.1-1.1-0.1c-0.3,0-0.7,0.1-1.1,0.3c0,0-0.1,0-0.1,0.1
		c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.3
		c0.3,0.2,0.6,0.3,0.9,0.5c0.8,0.3,1.6,0.5,2.7,0.3c0.2,0,0.3,0,0.5-0.1c0,0.2,0,0.3,0,0.5l0,0c0,0.6,0.1,1.1,0.1,1.7
		c-0.4,0.3-0.8,0.5-1.1,0.8c-1.1,1-1.5,2.3-0.9,3.4s2.2,1.8,3.7,1.6c1-0.1,1.9-0.7,2.5-1.3c0.3-0.4,0.6-0.7,0.7-1.2
		c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.1-0.8,0.2-1.2c-0.2,0-0.5,0.1-0.5,0.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1
		c0.5-0.2,0.9-0.3,1.3-0.5c1.7-0.7,2.4-2.2,1.7-3.6c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0
		c0.3,0.3,0.7,0.7,1,1c0.5-0.5,1-1,1.6-1.5c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7c0.8-0.2,1.6-0.8,2-1.7
		c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.2-0.4-0.1-0.6c0-0.8,0.9-1.5,0.9-2.4c0.6,0.1,1,0.2,1.5,0.3c0.1,0,0.1,0,0.2,0
		c0.2-0.7,0.4-1.4,0.4-2c0-0.3,0-0.6,0-0.9C72.6,300.1,72.6,299.7,72.5,299.4z M7.4,189.8L7.4,189.8l0.1-0.1L7.4,189.8z M41.6,291.2
		c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.7-0.7,1-1.1C43.1,290.8,43,291,41.6,291.2z"
      />
      <path
        class="st3"
        d="M370,103.4c-0.5-0.1-1,0-1.6,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.5c-0.3,0.5-0.7,0.9-1.4,0.9
		h-0.1c-0.2,0-0.5,0.1-0.8,0.3c0.5,0.4,0.9,0.7,1.4,1.1c0.1,0,0.1-0.1,0.2-0.1c0.2-0.1,0.5-0.2,0.8-0.3c0.1,0,0.3-0.1,0.4-0.1l0,0
		c0.2-0.2,0.5-0.7,0.6-0.7c1.1,0.2,1.4-0.7,2.2-1.1C371.4,103.9,370.8,103.5,370,103.4z M367.3,106.1L367.3,106.1L367.3,106.1
		L367.3,106.1z"
      />
      <path
        class="st3"
        d="M302.8,136.1c-1.7,0.3-3.4,0.7-5.1,1c0,0.1,0,0.3,0,0.4c2,0.4,3.9,1.2,6.1,0.7c0.8-0.2,1.6-0.3,2.4-0.5v-1.9
		c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1s-0.1,0-0.2,0.1v-0.3C305,135.7,303.9,135.9,302.8,136.1z"
      />
      <path
        class="st3"
        d="M310.3,136.8L310.3,136.8c-0.1-0.5-0.7-0.7-1.2-0.6c-0.3,0.1-0.6,0.2-0.9,0.3l0,0l0,0c0,0,0,0-0.1,0
		c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2
		C308.4,137.2,309.4,137,310.3,136.8z"
      />
      <path
        class="st3"
        d="M284.9,135.4c-0.5,0.9-1,1.7-1.5,2.7c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0-0.1,0.2-0.2,0.3
		c2.2-0.4,4.5-0.9,6.7-1.3C287.6,136.7,286.7,135.6,284.9,135.4z"
      />
      <path
        class="st3"
        d="M290.6,137.2c-0.2-1.8-0.3-3.4-0.5-5.2c-0.2,0-0.3,0.1-0.5,0.1c0,0.1,0.1,0.3,0.1,0.4c0.1,0.7,0.2,1.4,0.4,2.1
		c0.2,0.8,0,1.7-0.1,2.7C290.2,137.3,290.4,137.3,290.6,137.2z"
      />
      <path
        class="st3"
        d="M381.7,113.5c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.5-0.6-0.8-1-1
		c-0.7-0.3-1.6-0.1-2.4,0.6c-0.2,0.2-0.4,0.4-0.6,0.6c1,0.7,1.9,1.5,2.9,2.2C380.4,115.1,381.1,114.3,381.7,113.5z"
      />
      <path
        class="st3"
        d="M377.3,115.4L377.3,115.4c-0.2,0.2-0.4,0.4-0.6,0.6s-0.4,0.5-0.6,0.8c0.8-0.1,1.6-0.3,2.4-0.4
		C378,115.9,377.6,115.6,377.3,115.4z"
      />
      <path
        class="st3"
        d="M352.7,130.3c-2.8,0.6-5.5,1.3-8.3,1.9c-11.3,2.4-22.7,4.8-34,7.1c0.2,0.2,0.5,0.4,0.8,0.5s0.7,0.1,1.1,0l0,0
		c13.8-2.9,27.6-5.9,41.4-8.8c3-0.7,6.1-1.4,9.1-2.1c5.3-1.2,10.7-2.3,16-3.4c2-0.4,4.1-1.1,6.2-1.1c2.2-0.1,4.4,0.5,6.7,0.8
		c5,0.7,10.1,1.4,15.1,2.1c6,0.8,11.9,1.6,17.9,2.3c0.4,0,1.1-0.4,1.1-0.7c0.6-2.9,0.1-3.5-2.8-3.8c-0.1,0-0.1,0-0.2,0
		c-6.9-0.8-13.9-1.7-20.8-2.5c-4.2-0.5-8.3-1-12.5-1.4c-2.4-0.2-4.8-0.5-7.2-0.2c-3.2,0.3-6.3,1.1-9.5,1.7c-6.9,1.3-13.8,2.7-20.7,4
		c-1.6,0.3-3.1,0.6-4.7,0.8c0,0.1,0,0.2,0,0.4c2.2,0.5,4.4,1,6.5,1.5c0,0.2,0,0.5,0,0.7C353.5,130.1,353.1,130.2,352.7,130.3z"
      />
      <path
        class="st3"
        d="M376.9,115c-0.4-0.3-0.8-0.6-1.2-0.9c0.1,0.3,0.1,0.6,0.2,1C376.2,115.1,376.6,115.1,376.9,115z"
      />
      <path
        class="st3"
        d="M312.2,134.3c0.1,0.4,0.3,0.7,0.6,1.1c0.1-0.4-0.1-0.8-0.2-1.2C312.5,134.2,312.4,134.3,312.2,134.3z"
      />
      <path
        class="st3"
        d="M323.7,125.1c-0.1,0.1-0.2,0.2-0.3,0.3c0.2,0,0.3-0.1,0.5-0.1C323.8,125.3,323.8,125.2,323.7,125.1z"
      />
      <path
        class="st3"
        d="M431.9,214.2c0.2,0,0.3,0.1,0.5,0.2c0.4,0.8,0.5,1.7,0.6,2.7c0.3-0.2,0.6-0.5,0.9-0.7
		c-0.4-1.1-0.8-2.1-0.9-3.2c-0.1-0.6-0.1-1-0.1-1.4c-0.4,0.3-0.8,0.6-1.2,0.9c0.1,0.4,0,0.9-0.4,1.5
		C431.5,214.1,431.7,214.2,431.9,214.2z"
      />
      <path
        class="st3"
        d="M388.9,229.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.9,0.6-1.8,1.2-2.7,1.9c0.7,0,0.9,0,1.2-0.1c1.1-0.2,2.3-0.4,3.4-0.6
		c-0.1-0.1-0.2-0.1-0.3-0.2l0,0c-0.2-0.1-0.4-0.3-0.6-0.4C389.4,229.6,389.1,229.5,388.9,229.3z"
      />
      <path
        class="st3"
        d="M401.2,232.8c0,0.2,0,0.4,0.1,0.7c0,0.1,0,0.1,0,0.2c2.2-1.6,4.3-3.2,6.5-4.9c-0.4-0.2-0.6-0.2-0.8-0.2
		c-0.8,0.1-1.7,0.3-2.5,0.4c-0.1,0.1-0.3,0.1-0.4,0.2v-0.1c-0.6,0.1-1.1,0.2-1.7,0.3c0,0.1,0,0.1,0,0.2c0.6-0.1,1.1-0.2,1.6-0.3
		c-0.2,0.7-0.3,1.5-0.6,2.5C402.9,232,402.1,232.4,401.2,232.8z"
      />
      <path
        class="st3"
        d="M448.2,197.1c-0.3-0.1-0.9,0-1-0.2c-0.1-0.3-0.2-0.5-0.4-0.6c-0.3-0.3-0.8-0.4-1.3-0.5c-0.2,0-0.5-0.1-0.7-0.1
		h-0.1c0-0.1,0-0.1,0-0.2c0.1-1,1.5-1.3,2.1-2.2c-0.5,0.1-0.9,0.2-1.3,0.3c-0.8-0.6-1.1-1.3-0.6-2.1c-0.3-0.3-0.6-0.5-1-0.6
		c-0.1,0-0.2-0.1-0.3-0.1c-8.7,6.1-17.5,12.2-26.2,18.3h0.1c1.2-0.3,2.4,0.1,3.5,0c0,0.8-0.9,1.8,0.5,2.3c0.1,0,0.1,0.4,0.1,0.5
		c-0.2,0.8-0.1,1.5,0.8,1.8c1,0.4,1.9-0.1,2.6-0.8c2.6,1.3,4-0.8,5.7-1.8c0.2,0.1,0.3,0.3,0.5,0.4c3.4-2.5,6.8-5,10.2-7.5
		c0-0.2-0.1-0.4-0.1-0.8c0.4,0,0.8,0,1.2,0c2.5-1.8,5-3.7,7.5-5.5C449.3,197.4,448.8,197.2,448.2,197.1z"
      />
      <path
        class="st3"
        d="M411.5,228c-0.7,0.3-1.4,0.6-1.9,1c-2.7,2-5.4,4-8.1,6c0.2,0.8,0.8,1.4,1.9,1.7s2.6-0.1,3.4-0.9
		c0.9-1,1.1-2,0.4-3c-0.1-0.2-0.2-0.3-0.4-0.5c0.9-0.9,2.3-0.7,3.4-1.2c0.5-0.6,1.1-1.2,1.3-1.8C411.7,228.8,411.7,228.4,411.5,228z
		"
      />
      <path
        class="st3"
        d="M308,249.8c-1.6,0.9-3.3,1.9-4.9,2.8c1,0.1,2.1,0,3-0.4v0.1c0.2,0.1,0.5,0.1,0.7,0.1c0.1,0,0.3,0,0.4-0.1h0.1
		c0.3-0.2,0.5-0.3,0.8-0.5c0.4-0.4,0.6-0.9,0.5-1.3C308.6,250.2,308.3,250,308,249.8z"
      />
      <path
        class="st3"
        d="M422.6,219.8c0-0.2,0-0.3,0-0.5c-2.7,2-5.4,4-8,6c-0.3,0.2-0.6,0.3-0.9,0.4l0.1,0.1c0,0,0,0,0.1,0
		c0,0,0,0,0,0.1c0.1,0.1,0.2,0.2,0.2,0.3c2.7-0.5,5.4-0.9,8.1-1.4c0.9-0.2,1.8-0.5,2.5-1.1c0.1-0.1,0.2-0.2,0.3-0.3
		c0-0.1,0-0.2,0.1-0.4c-1,0.8-1,0.8-3.6,0.8c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.2-0.6-0.4-0.9-0.7
		C421.2,220.4,421.2,220.4,422.6,219.8z"
      />
      <path
        class="st3"
        d="M421.1,216.4c-2.1-0.4-2.4,1.3-3.7,1.9c-0.1-0.3-0.2-0.6-0.3-0.9c-0.6-1.5-0.8-1.6-3-1.3
		c0.9-0.7,0.5-1.6,0.1-1.9c-0.8-0.8-0.5-1.4,0.2-2.2c-0.2-0.2-0.5-0.3-0.7-0.4c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.3-0.2,0.7-0.5,0.8
		c-0.5,0.3-1.1,0.5-1.6,0.7c-5.3,3.7-10.7,7.5-16,11.2l0,0c0.4,0.2,0.9,0.4,1.6,0.4c0.4-0.4,1.1-0.9,1.5-1.5
		c0.1-0.1,0.2-0.2,0.2-0.3c0.6-0.6,1.5-0.6,2.3-0.8c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4c-0.4,0.3-0.7,0.8-0.7,1.2
		c-0.1,0.7,0,1.4,0,2.2c0,0.2,0,0.4,0,0.6c0.9-0.2,1.6-0.4,2.4-0.7c0,0.1,0,0.2,0,0.2c0.7-0.1,1.4-0.2,2.1-0.4
		c0.1-0.3,0.2-0.7,0.4-1c0.4-0.9,0.3-1.7-0.2-2.5c0.9,0,1.6-0.1,2.1,0c1,0.1,1.5,0.4,2.2,1.4c0.1-0.1,0.2-0.2,0.2-0.3
		c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.6-0.3,0.6c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0
		c-0.6,0.3-1,0.7-1.3,1.2c1.2-0.2,2.4-0.4,3.6-0.6c0.2,0,0.3-0.1,0.5-0.2c-0.2-0.1-0.4-0.3-0.6-0.5c0.5,0.1,0.8,0.1,1.2,0.2
		c0.2-0.1,0.4-0.2,0.6-0.4c3.5-2.6,6.9-5.1,10.4-7.7c-0.2-0.1-0.3-0.1-0.6-0.2c-0.6-0.1-0.7-0.5-0.6-0.9
		C420.8,217,421,216.7,421.1,216.4z"
      />
      <path
        class="st3"
        d="M433.7,224.3c0-0.1,0.1-0.2,0.1-0.4c-1.5,0.3-3.1,0.5-4.7,0.8c-0.1,0.1-0.2,0.1-0.3,0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-1.1,0.2-2.3,0.4-3.4,0.6c-0.8,0.1-1.6,0.5-2.2,1c-0.7,0.5-1.4,1.1-2.1,1.6c0.6,1.1,0.7,1.1,2.1,1
		c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1c0.3-0.1,0.9-0.1,1.2,0.1c0.8,0.7,1.8,0.3,2.8,0.6c-0.1-0.4-0.2-0.7-0.3-1
		c0.7-0.1,1.5-0.1,2.2-0.2c-0.2-0.4-0.5-0.7-0.8-1.2c0.8-0.3,1.5-0.7,2.2-0.9c-0.5-0.2-1-0.3-1.4-0.6s-0.5-0.7-0.9-1.3
		c0.4,0,0.6,0,0.9,0.1s0.7,0.3,1,0.3c0.2,0,0.5-0.2,0.6-0.3s0.1-0.4-0.1-0.5C434.4,224.7,434,224.5,433.7,224.3z"
      />
      <path
        class="st3"
        d="M420.8,226.2c-2.3,0.4-4.6,0.8-6.9,1.2c0.2,0.2,0.3,0.3,0.5,0.5c0.2,0.1,0.5,0.2,0.8,0.1
		c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.2,0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8
		c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6,0c0.8-0.6,1.5-1.2,2.3-1.8C420.9,226.4,420.9,226.3,420.8,226.2z"
      />
      <path
        class="st3"
        d="M610.2,56.5c-0.5,0-1.1,0-1.4,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.2,0.4-0.2,0.9-0.1,1.3c0.1,0.3,0.4,0.6,0.8,0.7
		c0.2,0,0.4,0.1,0.6,0c0.8-0.2,1.4-0.1,2.1,0c0.3,0.1,0.6,0,0.9,0c0.5-0.1,0.9-0.4,1.4-0.6c-0.4,0.5-0.7,1-1.1,1.4
		c-1.1,1.3-1.4,2.8-1.4,4.3c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.8-0.2-1.4-0.3-2.2-0.5c0.3-0.4,0.5-0.7,0.7-1
		c0.4,0.1,0.8,0.2,1.2,0.3c0.1-0.2,0.2-0.3,0.1-0.4c0-0.1-0.1-0.4-0.2-0.4c-1.3-0.2-1.2-1.9-2.7-2c-0.4,0-0.8-0.4-1-0.7
		c-0.4-0.5-0.7-1.1-1.1-1.7c-0.8-1-1.2-2.2-1.2-3.4c0-1.1-0.3-1.9-1.4-2.6c0.7-0.2,1.2-0.3,1.6-0.5c1.6-0.6,2.4-2.3,1.6-3.6
		c-0.6-1.2-2.4-1.6-3.9-1c-1.7,0.7-2.5,2.2-1.7,3.5c0.5,0.9,1.2,1.7,1.9,2.5c0.9,1,0.7,2.2-0.6,3c-1.5,0.9-2,1.6-1.7,2.7
		c0.3,1,1.2,1.4,3,1.3c0.2,0,0.3,0,0.6,0c0,0.5,0,1,0.1,1.5c0,0-0.1,0.1-0.1,0.3c-0.5-0.2-1.1-0.2-1.5-0.2c-0.5,0-1.1,0.2-1.6,0.5
		c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2-0.1-0.3c-0.3-1.1-1-1.6-2.4-1.6
		c-0.4,0-0.7,0.1-1.1,0.1l0.1-0.1l0,0l0,0c-0.3,0.3-0.6,0.5-0.8,0.8c-0.4,0.4-0.6,0.8-0.6,1.2s0.2,0.8,0.5,1.2
		c0.2,0.3,0.5,0.5,0.8,0.7c0.9,0,1.6-0.1,2.3-0.4c0.2-0.1,0.5-0.2,0.7-0.4c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.7,0.2,1.4,0.4,2.1
		c0.3,1-0.1,2.2-0.2,3.5c-2-0.7-2.8-2.5-5-2.7c-0.5,0.9-1,1.7-1.5,2.7c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0.1-0.2,0.4-0.2,0.6
		c0.3,0.7,0.9,0.5,1.5,0.3l0,0c0.3,0.1,0.5,0.2,0.8,0.2c-1.1,1.5-2.5,1.4-4,1.3c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.1-0.2-0.3-0.5-0.4-0.7c-0.3-0.7-0.6-1.6-0.6-2.4c0-0.1,0-0.2,0-0.3c0-0.8-0.2-1.4-0.9-1.9c-0.2-0.2-0.4-0.4-0.6-0.6
		c-0.3-0.5-0.4-1-0.4-1.6c0.6-0.5,1.2-0.9,2.1-0.9c0.8,0,0.8,0,1.5-1.1c-0.8-0.3-1.5-0.7-2.4-1c-0.1-0.7-0.2-1.3-1.4-1.5
		c-0.9-0.1-1.6-0.8-2.7-1.3c-0.3,0.1-0.7,0.4-0.6,1c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1c0-0.3,0-0.7-0.1-1.3
		c0.5,0.6,0.7,0.9,1.1,1.4c0.5,0,1.3-0.6,1.7,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-1.7,1.5-1.9,2.9-0.5,4.6c0.2,0.2,0.4,0.5,0.6,0.7
		c0.1,0.1,0.2,0.3,0.4,0.4c-0.1,0.4-0.2,0.9-0.2,1.4c0,0.2-0.1,0.5-0.1,0.7c0,0.1-0.3,0.2-0.5,0.3c-0.7,0.4-0.7,0.4-0.1,1
		c0.2-0.2,0.5-0.3,0.9-0.5c0.1,0.6,0.2,1.2,0.3,1.8c0.2,1,0.3,2.1,0.5,3.1c-0.9,0-1.5,0.1-2.3,0.1c-0.1-0.3-0.2-0.6-0.3-1.1
		c-0.3,0.3-0.5,0.4-0.8,0.8c-0.3-0.6-0.5-1.2-0.8-1.9c-0.3,0-0.7-0.2-0.9-0.2c-0.9,0.3-1.2,0-1.8-0.5c-0.2-0.1-0.2-0.3-0.3-0.4
		c-0.1-0.3,0.2-0.7,0.1-1c0-0.1,0-0.1-0.1-0.2c0.2-0.2,0.3-0.3,0.3-0.4v-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1s-0.1-0.1-0.2-0.2l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.4l0,0c-0.1-0.1-0.3-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.3,0.3-0.6,0.5-1c0.3,0.1,0.6,0.2,1,0.3
		c0-0.5,0.1-1,0.1-1.4c-0.9-0.1-1.7-0.2-2.6-0.2c0.3,0.2,0.4,0.4,0.6,0.5c-0.4,0.5-1,0.6-1.7,0.6v-0.1h-0.1c0,0,0,0,0,0.1
		c-0.2,0.2-0.3,0.3-0.5,0.5c-0.7-0.6-0.9,0.2-1.4,0.4c-0.5-0.9,0-1.6,0.8-2.4c0.4-0.4,0.8-0.9,1.1-1.3l0,0c0.2-0.2,0.4-0.5,0.6-0.7
		c0.2-0.2,0.4-0.5,0.6-0.8c-0.1-0.1-0.2-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.4-0.3c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.4-0.9,0.6-1.4
		c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2c0.6-0.8,1.4-1.3,2.2-1.2c0.9,0.2,1.4-0.4,2-0.7c0,0,0.1,0,0.1-0.1
		c0.9-0.3,0.9-1.1,0.2-1.6c-0.5-0.4-1.1-0.7-1.6-1.1c-0.9-0.8-2-1-3.2-0.9c-0.2,0-0.5,0-0.7,0.1c0,0.4,0.5,0.9-0.1,1.2
		c-0.1,0-0.3,0.1-0.5,0.1c-0.1-0.2-0.3-0.5-0.4-0.8c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.4-1.1-0.3c-0.8,0.1-1.1-0.3-1.5-0.6
		l-0.1-0.1c-0.6-0.5-1-0.5-1.6,0.2c-0.4,0.5-0.9,0.3-1.3,0.6c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.3-0.2,0.5-0.3
		c-0.6-0.4-0.5-1.4-1.7-0.9c-0.1,0-0.3-0.2-0.3-0.3c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.7,0.7-1,1.1
		c-0.5-0.4-1-0.8-1.5-1.3c-0.5,0.3-1,0.5-1.4,0.8l0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-1,1c0.5,0.5,1,1,1.5,1.5
		c-0.4,0.8-0.8,1.6-1.2,2.5c-0.4-0.3-0.5-0.7-0.8-0.8c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1c-0.1-0.3-0.3-0.9-1.4-0.7
		c-0.3,0.1-0.7-0.4-1.1-0.7c0.5-0.3,0.9-0.6,1.3-0.8c0.2-0.1,0.4-0.2,0.5-0.3c-0.1-0.3-0.2-0.5-0.3-0.6c-0.3-0.4-0.6-0.3-1.6-0.1
		c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1.2-0.3l0,0l0,0
		c0.1,0.2,0.1,0.4,0.2,0.5c0.1,0.2,0.2,0.5,0.2,0.7c-0.5,0.1-0.9,0.2-1.4,0.3c-0.4,0.1-0.8,0.4-1.5,0.7c0.3-0.6,0.5-1,0.6-1.3
		c-0.3-0.6-0.6-1-1.7-0.8c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.6-0.2-1-0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0.6-0.6,1.1-0.8,1.6
		c-0.1,0.2,0.1,0.7,0.3,0.8s0.7-0.1,1-0.2c0.3-0.2,0.5-0.4,0.8-0.7c0.3,0.1,0.4,0.3,0.7,0.4c-0.4,0.8-1.5,1.4-1.3,2.5
		c0.9-0.2,1-0.9,1.5-1.3c0.7,0.3,1.8-0.6,2.1,0.5c0.4-0.3,0.6-0.5,0.9-0.7c0,0.2,0,0.4,0,0.6c0,0.7,0.1,1.3,1.1,1.5
		c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1c-0.3,0.5-0.6,1-1,1.6
		c0.5,0.4,0.4,1.3,0.6,2c0.1,0.3-0.3,0.8-0.5,1.1c-0.2,0.2-0.5,0.4-0.9,0.7c-0.4-0.1-1-0.3-1.6-0.4c-0.3,0.3-0.5,0.6-0.8,0.9l0,0
		c-0.2,0.3-0.5,0.5-0.7,0.8c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.9,0.1,1.4-0.1c1.2,0.7,2-0.6,3.2-0.6
		c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2,0,0.8-0.9,0.6
		c-0.5-0.1-1,0.7-0.9,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.2-0.1,0.3-0.2c0,0.1-0.1,0.3-0.1,0.4
		c0.1,0.1,0.2,0.1,0.2,0.2c-0.1,0.4-0.4,0.9-0.4,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.4,0.6,0.5c0.1,0,0.2,0.1,0.3,0.1
		c0.2,0,0.5,0.1,0.6,0.3c0.7,1,0.6,1,2,1.2c-0.1-0.9-0.3-1.9,1.2-2.5c-0.2,0.6-0.7,1.4-0.5,1.8c0.3,0.6-0.4,1.2,0.2,1.8
		c-0.8,0.4-1.4,0.8-2.1,1.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.4-0.3,0.8-0.6,1.3-0.8
		c0.9-0.4,1.5-0.9,1.8-1.8c0.8,0,1.7,0.3,2.3-0.6c0.7,0.5,1.4,0.9,2,1.3c0.1-0.4,0.3-0.5,0.7-0.5c0.1,0,0.3,0,0.4,0
		c0.1,0,0.3,0,0.4,0c0.6,0,1.2,0,1.6-0.7c0.3,0.3,0.5,0.5,0.7,0.8c-0.3,0.2-0.7,0.4-1.2,0.8c0.8-0.1,1.2-0.1,1.7-0.1
		c-0.3,0.4-0.6,0.6-0.7,0.8c-0.7-0.1-1.3-0.2-1.9-0.4c-0.5-0.1-1-0.4-1.5-0.6c0,0.6,0,1.2,0,2.2c-0.6-0.6-0.9-0.8-1.1-1.1
		c-0.3,0.4-0.9,0.6-0.6,1.3c0.2,0.5,0,1.2-1,1.3c-0.2-0.3-0.4-0.5-0.6-0.8c-0.7,0.2-0.5,0.7-0.4,1.1c0,0.1,0.3,0.1,0.6,0.1
		c-0.3,0.2-0.6,0.3-1,0.5c2.5,0,5,0,7.5,0.1c0.6,0,1.1,0.4,1.7,0.6c-0.6,0.2-1.1,0.5-1.7,0.5c-2.9,0-5.8-0.1-8.7-0.1
		c0.1,0.1,0.2,0.2,0.3,0.4c-0.3,0.1-0.5,0.2-0.6,0.1c-0.3-0.1-0.4-0.3-0.5-0.5c-3.5,0-6.9,0-10.4-0.1c-1.2,0-1.9,0.3-2.6,1.3
		c-2.1,2.7-4.2,5.4-6.3,8.1c-0.3,0.3-0.5,0.7-1,1.4c1,0,1.7,0,2.4,0c6.1,0.1,12.2,0.1,18.2,0.3c1.3,0,2.2-0.3,2.9-1.4
		c1.2-1.9,2.6-3.7,3.9-5.5c0.2-0.3,0.6-0.3,1-0.4c0,0.4,0,0.7-0.1,1.1c-0.1,0.3-0.3,0.5-0.5,0.8c-4.3,6-8.6,12.1-12.9,18.1
		c-0.3,0.4-0.5,0.7-0.7,1.2c0.4,0.1,0.5,0.1,0.7,0.1c8.1,0.3,16.1,0.6,24.2,0.9c0.7,0,1.4-0.3,2-0.6c7.4-4.4,14.7-8.9,22-13.3
		c0.5-0.3,1.3-0.3,1.9-0.5c0,0.2,0,0.4,0,0.6c-10.7,6.5-21.4,13-32.1,19.5c-5.1,3.1-10.3,6.1-15.4,9.2c-5.6,3.4-11.1,6.8-16.7,10.3
		c-0.3,0.2-0.5,0.4-0.8,0.5c-0.4,0.1-0.7,0-1.1,0.1c0.1-0.4,0.1-0.8,0.3-1.1c1.7-2.3,3.5-4.5,5.3-6.8c4.1-5.3,8.3-10.6,12.4-16
		c0.3-0.4,0.5-0.7,0.8-1.1c-2.5-1.1-4.6-0.5-6,1.5c-4.2,5.9-8.4,11.7-12.5,17.6c-0.4,0.5-0.7,1-1,1.4c0.4,0.5,0.7,0.9,1,1.3
		c-0.5,0.1-0.9,0.2-1.4,0.3c-0.5,0.2-1.1,0.5-1.4,0.9c-1.7,2.3-3.2,4.6-5,6.8c-0.4,0.5-1.3,0.9-1.9,0.8c-18.6-2-37.3-4-55.9-6
		c-12.2-1.3-24.4-2.6-36.6-4c-7-0.8-14.1-1.5-21.1-2.3c-8.1-0.9-16.1-1.8-24.2-2.7c-1.3-0.1-2.5-0.2-3.8-0.3c-1-0.1-1.2-0.6-0.6-1.4
		c0.2-0.3,0.5-0.6,0.7-0.9l-0.1-0.1c-0.4-0.7-1.3-1.1-1.8-1.8c-0.2-0.2-0.6,0-0.9-0.1c-0.3,0.4-0.7,0.8-1,1.2
		c-1.2,1.4-2.4,2.3-4.3,2.5c-6.8,1-13.5,2.1-20.3,3.3c-4.2,0.7-8.3,1.5-12.5,2.1c-1.3,0.2-1.6,0.8-1.5,1.9c0.1,0.6,0,1.2,0,2.1
		c1.7-0.3,3.1-0.4,4.6-0.7c5.7-1.1,11.4-2.2,17.1-3.3c5.8-1.1,11.5-2.4,17.3-3.2c2.6-0.4,5.3,0.3,7.9,0.5c4.3,0.4,8.6,0.8,12.9,1.3
		c7.1,0.8,14.2,1.8,21.3,2.5c3.6,0.4,7.2,0.2,10.8,0.4c2,0.1,4.1,0,5.9,0.6c5,1.7,10.3,1.6,15.5,2.3c13.3,1.6,26.7,3,40.1,4.5
		c8.2,0.9,16.3,1.8,24.5,2.7c0.5,0.1,0.9,0.2,1.4,0.4c0.1,0.2,0.1,0.4,0.2,0.5c-17.6,12.3-35.3,24.6-52.9,36.8
		c0,0.1,0.1,0.2,0.1,0.3c3.5-1,7-1.9,10.4-2.9c0.5-0.2,1.1-0.4,1.6-0.5c6.6-1.1,12.2-4.3,17.4-8.5c6.2-5,12.8-9.6,19.2-14.3
		c0.3-0.2,0.7-0.5,1-0.7c0.2-0.1,0.5,0,0.7,0.2c0.1,0.1,0.1,0.5,0,0.7c-0.3,0.3-0.6,0.5-0.9,0.8c-7.5,5.6-15,11.1-22.5,16.7
		c-0.5,0.4-0.9,0.7-1.4,1.1c5,0.1,7.9-4,11.7-6.1c0.2,0.2,0.3,0.5,0.5,0.7c-1.1,1-2.3,2-3.6,3.1c0.5,0,0.8,0,1.1-0.1
		c12.1-3.4,24.1-6.7,36.1-10.2c0.6-0.2,1.3-0.6,1.7-1.1c4.5-5.5,9-11.1,13.5-16.7c4-5,8.1-9.9,12.1-14.8c4.1-5.1,8.2-10.3,12.3-15.4
		c0.2-0.3,0.4-0.6,0.7-0.8c0.4-0.3,0.9-0.4,1.3-0.6c-0.1,0.4-0.1,1-0.4,1.3c-1.4,1.9-2.9,3.7-4.4,5.5c-4.3,5.3-8.6,10.7-12.8,16
		c-6.6,8.2-13.1,16.3-19.7,24.5c-0.3,0.3-0.5,0.7-1,1.4c2-0.6,3.7-1,5.3-1.5c3.9-1.1,7.8-2.3,11.8-3.3c1.7-0.4,2.9-1.1,3.8-2.9
		c2.4-4.5,5.2-8.9,7.8-13.3c2.9-5.1,5.8-10.2,8.7-15.3c2.1-3.6,4.2-7.2,6.3-10.8c0.2-0.4,0.8-0.6,1.2-0.8c-0.1,0.5,0,1-0.2,1.4
		c-2.2,3.8-4.4,7.5-6.6,11.2c-4.3,7.4-8.5,14.9-12.8,22.3c-1.3,2.2-2.6,4.5-4.2,7c8.1-2,15.8-4.6,23.6-6.4c0.1,0.3,0.2,0.6,0.3,0.8
		c-1,0.4-2,0.8-3.1,1.1c-3.5,1-7.1,2-10.6,3c-3.3,0.9-6.6,1.8-9.8,2.8c-0.7,0.2-1.4,0.7-1.8,1.3c-3.5,6.1-7,12.1-10.5,18.2
		c0.1,0,0.2,0,0.3,0c1.3-0.1,1.9-0.5,2.9-2.1c0.9,0.3,1.3,1.3,2.5,1.1c0.2,0,0.4,0.4,0.5,0.7s0,0.6,0,0.9c0,0.1-0.1,0.2-0.1,0.4
		c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.3,0.2,0.3,0.3c-0.1,0.3-0.3,0.5-0.5,0.8c0.3,0,0.5,0,0.7,0c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.2-0.1c0.1,0,0.3-0.1,0.5-0.1
		c0.1,0.3,0.3,0.6,0.4,0.8c0.2,0,0.3,0,0.4,0c0.3-0.3,0.6-0.5,1-0.8c0.3-0.2,0.6-0.5,0.9-0.7l0,0c0.6-0.5,1-0.9,0.6-1.5l-0.1-0.1
		c0,0,0.3-0.3,0.5-0.5c0.1,0.2,0.1,0.5,0.3,0.6c1,0.4,2.7-0.5,3.2-1.4v-0.1c0-0.1,0.1-0.2,0.1-0.3c0-0.2-0.4-0.3-0.6-0.5
		c0.1-0.3,0.2-0.7,0.3-1.1c1.3,0.2,2.5-0.1,3.3-1c0.1-0.1,0.3-0.3,0.4-0.5h0.1c1.6,0.5,3,1.1,4.9-0.3c-0.2,0.8-0.3,1.3-0.4,1.8
		c-2.3-0.7-3.8-0.5-4.7,0.5l0,0c-0.1,0.1-0.2,0.2-0.3,0.4c-0.8,1.2-0.2,2.4,1.6,3.5c-0.4,0.3-0.8,0.6-1.1,0.8
		c-0.1,0-0.3-0.1-0.3-0.1c-0.3-0.4-0.5-0.7-0.9-0.9c-0.1-0.1-0.3-0.2-0.5-0.3c-0.7-0.4-1.5-0.5-2.3-0.3c-1.1,0.2-1.8,0.7-2.4,1.4
		c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.2,0,0.6,0.2,0.8l0,0c0.1,0.1,0.1,0.1,0.2,0.2
		c0.1,0.1,0.2,0.2,0.3,0.3c0.8,0.8,1.6,1.5,3.2,1.4c-0.3,0.9-0.6,1.7-0.8,2.4c-1.1,0.4-2.1,0.9-3.2,1.4c-0.2-0.2-0.6-0.5-0.9-0.9
		c0.1-0.1,0.1-0.3,0.3-0.4c0.4-0.3,0.6-0.7,0.6-1.1c0-0.2,0-0.3-0.1-0.5c-0.3-0.5-1-0.8-1.6-0.7c-0.8,0.1-1.2,0.6-1.3,1.2
		c-0.3,1.1-0.3,1.2-0.7,1.6c0,0,0,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1,0-0.3,0.1-0.4,0.2
		c-0.4,0.2-0.6,0.4-0.6,0.7c0,0.1,0,0.1,0,0.2c0,0.2,0.4,0.3,0.8,0.6c-0.1,0.2-0.3,0.5-0.6,0.8c0.1,0.1,0.2,0.3,0.4,0.5l0.1,0.1
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.5,0.2-1,0.4-1.5,0.6c-0.5,0.2-1,0.5-1.2,1c0,0,0,0.1-0.1,0.1
		c0.1,0,0.4,0,0.7,0c-0.1,0.2-0.3,0.5-0.4,0.7c0.4,0,0.8,0,1.2,0.1c-0.4,0.3-0.7,0.6-1.1,0.9c0.2,0.3,0.4,0.6,0.7,0.7
		c0.2,0.1,0.6,0,0.8-0.1c0.1,0,0.1-0.1,0.1-0.1c0.2-0.8,1-1.3,1.4-2l0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.7v-0.1l0,0
		c1.4,0.5,2.5-0.2,3.6-0.9c0.2,0.8,0.4,1.4,0.6,2.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0.1,0.2,0.1c0.4,0.1,0.7,0.3,1.1,0.4
		c0.1,0,0.2,0.1,0.4,0.1c0.8,0.3,1.6,0.3,2.4,0.1c1-0.2,1.9-0.7,2.5-1.5c0.4-0.6,0.8-1.2,1.2-1.8c-0.2,0-0.3-0.1-0.4-0.2
		c-0.2-0.2,0-0.6-0.1-1c0.5-0.1,0.9-0.2,1.3-0.2c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4c0.3-0.3,0.5-0.6,0.6-0.9
		c0.2-0.6,0.3-1.3,0.1-2c-0.1-0.4-0.2-0.7,0.4-1c0.3,0.2,0.7,0.4,1,0.6c0.4,0.2,0.8,0.4,1.3,0.7c-0.3,0.3-0.6,0.5-0.8,0.7
		c-0.1,0.2-0.1,0.5-0.1,1.1c0.6-0.4,0.9-0.7,1.2-0.8s0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.5,0.8,0.9,1.1
		s0.9,0.4,1.6,0.4c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3
		c-0.1-0.5,0.1-0.8,0.8-1c0.3-0.1,0.5-0.6,0.8-0.9c0.1-0.2,0.4-0.5,0.5-0.4c1,0.3,1.5-0.6,2.4-0.8c0.6,1.2,1.6,0.3,2.6,0.3
		c0.4-0.8,0.3-1.3-0.5-1.7c-0.8,0-0.3,1.3-1.4,0.9c0.2-0.7,0.3-1.4,0.4-2c0.7-0.6,1.4-1.1,2.3-1.8c0.5,0.1,1.2,0.2,2,0.3
		c1.2,0.3,1.8,0.1,2.3-1c0.1-0.3,0.2-0.7,0.3-1.1c0.2-0.4,0.4-0.7,0.7-1c0.1,0,0.3,0,0.4,0.1c0,0.6,0,1.2,0,1.8
		c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2c0,0,0,0.1-0.1,0.1h0.1c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2
		c0.3-0.4,0.6-0.9,1-1.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.2,0.7l0,0c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3
		c-0.3,0.1-0.6,0.1-0.9,0.2c0.1,0.2,0.1,0.4,0.2,0.6h-0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.3,0.5,0.4,1.2,1,1.5
		c1.4,0.6,0.9,1.6,0.7,2.5c-1.1,0.4-2,0.3-2.9,0.1c-1.8-0.3-3.3,0.2-4.6,1.5l-0.1,0.1c-0.4,0.5-0.7,0.9-0.9,1.4
		c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1c-0.1,0.2,0.2,0.5,0.5,0.7l0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1.7,0.7,3.4,0.1,4-1.3c0.1-0.3,0.2-0.7,0.2-1.1c0-0.5,0.1-0.9,0.5-1.3
		c0.3-0.3,0.6-0.7,0.8-1c0.6-1,0.6-2,0.1-3c-0.1-0.2,0-0.5,0.1-1c1.7,1.9,2.4,2.2,5.4,2.2c-0.3,0.3-0.5,0.6-0.7,1
		c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,0.9-0.6,1.4c0,0.1,0,0.2-0.1,0.3c-0.3,1.8,0.6,3.6,2.7,4.4c1.4,0.6,3,0.6,4.4,0.1v-8.4
		c-0.8-0.1-1.6-0.2-2.4-0.4c-0.1,0-0.2,0-0.3,0c0.3-0.5,0.5-0.9,0.7-1.3c0.5-1,0.6-1.9,0.3-2.6c-0.2-0.5-0.6-1-1.2-1.4
		c0,0,0,0-0.1,0c-0.4-0.3-1-0.6-1.6-1c-1.3-0.1-2.2,0.9-3.3,0.4c-0.8,1.2-0.8,1.2-2.1,1c0-0.2,0-0.4,0.1-0.6c0.6-0.8,0-1.4-0.5-1.9
		c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0.7-1.1,0.2-2.2-0.1-3.3c0.3-0.3,0.6-0.6,1-0.8
		c0.3-0.2,0.6-0.3,0.9-0.2c0.3,0,0.6,0.2,0.8,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.3,0.4,0.5,0.8,0.8,1.2c-0.1,0.2-0.4,0.5-0.4,0.8
		c0,0.2,0.5,0.3,0.8,0.6c0.6-1.2,1.3-2.2,3.1-1.9c-0.4,0.3-0.9,0.5-1.1,0.8c-0.2,0.5,0.3,1.1,1.1,1.5c0.3-0.3,0.7-0.6,1-0.9
		c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3s0-0.1,0-0.2c0-0.2,0.1-0.4,0-0.6c-0.4-0.6-0.4-1.1-0.3-1.5
		c0.1-0.4,0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.3,0.6-0.7,1-0.9h0.1V74V57.1
		c-0.5,0-1-0.1-1.4-0.4C610.6,56.6,610.4,56.5,610.2,56.5z M589.9,72.1L589.9,72.1C589.9,72,589.9,72,589.9,72.1
		C589.9,72,589.9,72,589.9,72.1z M572.8,57.4c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.2-0.3,0.3-0.4,0.4
		c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1C572.6,57.6,572.7,57.5,572.8,57.4z M556.5,63.8c-0.1,0-0.3-0.1-0.4-0.1
		c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0C556.5,63.6,556.5,63.8,556.5,63.8z M565.9,54.6L565.9,54.6h0.2H565.9z M567.7,70.1
		L567.7,70.1L567.7,70.1L567.7,70.1z M568.6,70.8c0.1-0.5,0.1-0.7,0.1-1s-0.2-0.5-0.5-1c0.7,0.1,1.2,0.2,1.6,0.3
		c-0.7,0.6,0.1,0.4,0.5,0.6C569.8,70,569.3,70.3,568.6,70.8z M509.9,157.8l-0.3-0.4c0.8-0.6,1.6-1.3,2.4-1.8c0,0,0.2,0.3,0.6,0.7
		C511.6,156.8,510.8,157.4,509.9,157.8z M560.8,168.3L560.8,168.3C560.8,168.3,560.8,168.2,560.8,168.3
		C560.8,168.2,560.8,168.3,560.8,168.3z M560.8,166.1C560.8,166.1,560.7,166,560.8,166.1c0-0.1,0-0.1,0.1-0.1l0.1,0.1
		C560.9,166.1,560.8,166.1,560.8,166.1z M561.8,165.8C561.9,165.7,561.8,165.7,561.8,165.8C561.9,165.7,561.9,165.7,561.8,165.8
		C561.9,165.7,561.9,165.7,561.8,165.8z M564.3,167.2c0-0.6,0-1.1,0.1-1.8c0.7-0.5,1.2-0.3,1.5,0.3
		C565.3,166.3,564.8,166.8,564.3,167.2z M567.9,159.8c-1.6,0.5-2.2,1.5-2.1,2.9c0,0.1-0.1,0.3-0.2,0.5c-1.6,0.2-2.7,1-3.4,2.2
		c0,0.1-0.2,0.1-0.3,0.1c0-0.6-0.5-0.3-1-0.2c0.3-1,0.5-2,2-2.4c0.7-0.2,1.3-0.8,1.9-1.3c0.6-0.6,1.1-1.3,1.7-2
		c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.4-0.3,0.9-0.2,1.4-0.2C568.5,159.2,568.5,159.7,567.9,159.8z M600.6,170.2
		c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.1-0.4-0.2-0.5C600.5,170.3,600.5,170.3,600.6,170.2z M611.7,59.2
		c0.1-0.1,0.3,0,0.4,0c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.3,0.1-0.4,0.2C611.6,59.4,611.6,59.3,611.7,59.2z"
      />
      <path
        class="st3"
        d="M447.9,186.3c-0.3,0.1-0.5,0.3-0.6,0.5c0.3-0.2,0.5-0.4,0.8-0.6C448,186.2,447.9,186.2,447.9,186.3z"
      />
      <path
        class="st3"
        d="M452.7,197C452.8,197,452.8,197,452.7,197c1.2,0.6,2.4,0.5,3.5-0.2c1-0.7,1.4-1.6,1.1-2.5
		c-0.1-0.2-0.2-0.3-0.2-0.5C455.7,194.8,454.2,195.9,452.7,197z"
      />
      <path
        class="st3"
        d="M450.5,198.7c-1.6,1.2-3.2,2.4-4.8,3.5c0.1,0,0.2,0.1,0.3,0.1c1.3,0.4,2.5,0.2,3.6-0.7
		C450.6,200.8,450.9,199.7,450.5,198.7z"
      />
      <path
        class="st3"
        d="M82.8,296.6c-0.3-0.2-0.5-0.4-0.6-0.8c-0.1-0.2-0.2-0.3-0.4-0.4c-0.4-0.2-1.1-0.2-1.7,0.1l0,0
		c-0.1,0.1-0.3,0.2-0.4,0.3c1.5,3.3,2.9,6.6,4.4,9.9c0.5-0.2,1-0.4,1.4-0.7l0,0c0.9,0.6,1.7,0.9,2.4,0.9c0.6,0,1.2-0.1,1.7-0.4
		c0.9-0.5,1.4-1.7,1.2-2.5c-0.3-1.1-1.4-1.6-3.5-1.5c-0.2-0.1-0.3-0.2-0.4-0.3c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6
		s0-0.5,0-0.7s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.4,0-2-0.5l0,0c-0.2-0.1-0.4-0.3-0.6-0.4
		C83.2,296.9,83,296.7,82.8,296.6z"
      />
      <path
        class="st3"
        d="M434.1,217.7c-0.3,0.3-0.7,0.5-1,0.8c0,0.2,0,0.4,0.1,0.7C433.8,218.7,434,218.2,434.1,217.7z"
      />
      <path
        class="st3"
        d="M171.9,293.6c-0.1-0.3-0.2-0.5-0.4-0.7c-0.7-1-2.3-1.7-4.6-1.8l0,0l0,0c0.1-0.7,0.3-1.5,0.4-2.2
		c0-0.1,0-0.1,0-0.2h0.1c0.9,0,1.7,0,2.6-0.2c0,0,0,0,0.1,0c1.5-0.3,2.7-1.1,3.4-2.2c-0.8-0.8-1.5-1.7-2.3-2.5
		c-2.5-2.8-2.5-2.8-5.9-1.2c-1.7,0.8-3.3,1.6-5,2.3c-0.3,0.1-0.7-0.1-1.1-0.1c0.2-0.3,0.3-0.7,0.6-0.9c0.3-0.3,0.7-0.4,1.1-0.5
		c2.3-1.1,4.5-2.1,7-3.2c-1.4-1.6-2.7-3-4-4.5l-0.1-0.1c-0.4,0.1-0.8,0.2-1.2,0.4c-0.1,0-0.2,0.1-0.3,0.1c-1.8,0.9-2.4,2.1-2.3,3.5
		c0,0.4,0,0.7,0.1,1.1c-0.9-0.3-1.7-0.5-2.5-0.7c0.1-0.5,0.3-1,0.4-1.6c0.1-0.6,0.3-1.1,0.4-1.7c1.4-0.1,2.6-0.5,3.5-1.4
		c0.3-0.4,0.5-0.7,0.7-1.1c-1.5-1.6-2.9-3.2-4.4-4.8c0,0.3,0,0.6,0.1,1c-1.3,0.5-2.5,1.3-3,2.8c-0.4-0.5-0.7-0.8-1-1.1
		c-0.1,0-0.3-0.1-0.4,0c-1.7,0.6-2.9,0.4-3.8-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-1.2-1.3-3.4-1.5-5.1-0.5c-1.6,1-2.1,2.8-1.1,4.2
		c0.2,0.3,0.5,0.5,0.8,0.8c-0.4,1.4-1,2.9-0.7,4.4c0.1,0.4,0.2,0.7,0.4,1.1c-1.4,0.7-2.5,1.7-2.1,3.2c0.3,0.9,1,1.5,2.1,1.6
		c1.6,0.2,2.7-0.5,3.4-1.6c1.7-0.2,3.3-0.3,5-0.5c0.1,0.7,0.1,1.5,0.2,2.3c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0.1-0.1,0.2
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.1-0.9-0.2-1.4-0.3c-2.3-0.4-4.6,0.8-5.2,2.7c-0.6,2,0.8,3.7,3.1,4c0.4,0,0.8,0,1.5,0.1
		c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1c-0.3,1.2-0.4,2.4,0.3,3.5c1.1,1.6,2.8,2.4,5,2.3c2.1-0.1,3.8-1.1,4.9-2.7
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9c1.8,0,3.6-0.2,4.9-1.5l0,0c0.6-0.5,0.9-1.1,1.1-1.8c0.1-0.3,0.2-0.6,0.2-0.9
		c0-0.1,0-0.2,0-0.4C172,294.2,172,293.9,171.9,293.6z M156.9,289.9c-1.1,0-2.2,0.1-3.2,0.1c0-1,0-2,0-2.9c1.1,0.3,2.3,0.6,3.7,0.9
		C157.2,288.5,157,289.2,156.9,289.9z"
      />
      <path
        class="st3"
        d="M127.6,291.6c0.1-0.3,0.2-0.6,0.3-1c-0.3-0.1-0.6-0.2-1.1-0.4c-0.1,0.9-0.7,1.4-1.6,1.2
		c-0.6-0.1-1.1,0-1.6,0.3c1.1,1.7,2.2,3.4,3.3,5.1l0,0c-0.2-0.4-0.5-0.7-0.8-1.2c0.8-0.3,1.5-0.7,2.2-0.9c-0.5-0.2-1-0.3-1.4-0.6
		c-0.4-0.3-0.5-0.7-0.9-1.3c0.4,0,0.6,0,0.9,0.1s0.7,0.3,1,0.3c0.2,0,0.5-0.2,0.6-0.3c0.1-0.1,0.1-0.4-0.1-0.5
		C128.2,292,127.9,291.8,127.6,291.6z"
      />
      <path
        class="st3"
        d="M440.8,205.9c-1.7,1.2-3.3,2.4-5,3.7c1.1-0.3,2.2-0.5,3.3-1.1c-0.4,0-0.8,0-1.3-0.1c0-0.1-0.1-0.2,0-0.2
		c0.4-0.3,0.8-0.6,1.2-0.9c1.3,1,1.9,1.1,2.6,0.5C442.2,207.1,442,206.6,440.8,205.9z"
      />
      <path
        class="st3"
        d="M180.7,266.1c-1.8,0.8-3.5,1.6-5.3,2.4c-0.2,0.1-0.4,0.2-0.7,0.3c-0.1,0.4-0.2,0.7-0.1,1.1c2.2-1,4.4-2,6.6-3
		C181.1,266.6,180.9,266.4,180.7,266.1z"
      />
      <path
        class="st3"
        d="M165.3,275.6c0.4,0.5,0.9,1,1.3,1.4c0.7,0.8,1.2,1.4,1.7,1.7c0.1-0.3,0.1-0.7,0-1c-0.1-0.6-1-1.2-1.7-1.6
		C166.2,275.9,165.8,275.7,165.3,275.6z"
      />
      <path
        class="st3"
        d="M174,285.1c0.1-0.3,0.1-0.6,0.1-1c-0.1-1.8-1.8-3.3-4.1-3.4C171.3,282.2,172.6,283.6,174,285.1z"
      />
      <path
        class="st3"
        d="M181.8,268.1L181.8,268.1c-2.3,0.9-4.5,1.9-6.7,3c0.6,0.9,1.8,1.5,3.1,1.4c0.3,0,0.6,0,1-0.1
		c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.5,0.3-1.1,0.2-1.8
		C181.9,268.5,181.8,268.3,181.8,268.1z"
      />
      <path
        class="st3"
        d="M153.2,270.6c1.6,0.1,3-0.8,3.5-2.2c0-0.1,0.1-0.2,0.1-0.4c-0.9-1-1.9-2.1-2.8-3.1c-0.4,0.1-0.8,0.2-1.2,0.3
		c-1.7,0.5-2.7,1.8-2.5,3.2C150.4,269.6,151.7,270.5,153.2,270.6z"
      />
      <path
        class="st3"
        d="M200.1,257.5c0.5,0.2,0.8,0.3,1.1,0.4c0.8-0.4,1.6-0.7,2.4-1.1c-0.1-0.2-0.3-0.5-0.6-0.7
		c-0.1,0-0.2,0.1-0.3,0.1c0,0.2,0.1,0.3,0.1,0.5c0,0.1-0.3,0.3-0.5,0.5c-0.1-0.2-0.2-0.4-0.3-0.6C201.4,257,200.7,257.2,200.1,257.5
		z"
      />
      <path
        class="st3"
        d="M143.9,258.6c1.2-0.5,1.9-1.3,1.7-2.4v-0.1c0-0.1,0-0.1,0.1-0.2c0,0,0,0,0.1,0c-1-1.1-1.9-2.1-2.9-3.2
		c0.1,0.1,0.2,0.2,0.2,0.3c-0.5,0.2-1,0.3-1.4,0.5c-0.5,0.2-0.8,0.6-0.4,1c0.3,0.4,0.2,0.6-0.1,1c-0.7,0.9-0.6,1.8,0.1,2.6
		C141.9,258.7,143.1,259,143.9,258.6z"
      />
      <path
        class="st3"
        d="M111.2,276.4c0.3-0.1,0.6-0.1,0.9-0.1c-0.5-0.8-1-1.5-1.5-2.3c-0.2,0.1-0.3,0.2-0.5,0.3
		c-0.4,0.5-0.5,1-0.2,1.4C110.2,276.1,110.8,276.5,111.2,276.4z"
      />
      <path
        class="st3"
        d="M145,264.6c0.2-0.1,0.4-0.4,0.6-0.7c0.3,0.1,0.7,0.2,1,0.4c1.2,0.6,2.3,0.5,3.4-0.2c0.9-0.6,1.2-1.3,1.2-2.1
		c-0.6-0.7-1.2-1.3-1.8-2c-0.3-0.1-0.5-0.1-0.8-0.1c-0.2,0-0.4,0-0.5,0c0.1-0.4,0.3-0.6,0.4-0.9c-0.7-0.7-1.4-1.5-2-2.2v0.1
		c0,0.1,0,0.1-0.1,0.2c-0.2,0.5-0.3,1-0.5,1.5c-0.3,0.6-0.6,1.3-0.8,1.9c-0.3,0.6-0.5,1.3-0.7,1.9c-0.6-0.6-0.4-1.7-1.6-2.1
		c-0.1,0.2-0.2,0.4-0.2,0.6c0.1,1.3,1.3,2.3,1.1,3.7C143.6,264.8,144.5,264.9,145,264.6z"
      />
      <path
        class="st3"
        d="M218.6,248.1c0.3-0.2,0.7-0.3,1-0.5c-0.2-0.1-0.5-0.2-0.8-0.3C218.7,247.6,218.7,247.8,218.6,248.1z"
      />
      <path
        class="st3"
        d="M239.4,240c-1.8,0.8-3.7,1.6-5.5,2.5c0.4,0.1,0.9,0.1,1.4,0.1c1.5-0.7,3-1.3,4.5-2
		C239.6,240.4,239.5,240.2,239.4,240z"
      />
      <path
        class="st3"
        d="M240.4,242.9c0.2-0.5,0.2-0.9,0.1-1.3c-1.3,0.6-2.5,1.1-3.8,1.7c0.1,0.1,0.3,0.3,0.4,0.4
		c0.2,0.1,0.3,0.2,0.5,0.3C238.7,244.4,239.9,244,240.4,242.9z"
      />
      <path
        class="st3"
        d="M262.5,231.7c0.8-0.1,1.5-0.4,2.1-1C263.9,231.1,263.2,231.4,262.5,231.7z"
      />
      <path
        class="st3"
        d="M237.7,239.6c0.5-0.2,1-0.4,1.4-0.6c-0.3-0.1-0.7-0.2-1.1-0.3C237.9,239,237.8,239.3,237.7,239.6z"
      />
      <path
        class="st3"
        d="M203.9,258.7c0-0.2,0-0.5,0-0.7c-0.5,0.2-1,0.4-1.5,0.7c0.2,0.2,0.4,0.4,0.6,0.7
		C203.4,259.2,203.9,259,203.9,258.7z"
      />
      <path
        class="st3"
        d="M232.3,250c0.6-0.3,1.2-0.6,1.8-0.8c-0.1-0.1-0.3-0.2-0.4-0.2c-0.4-0.1-0.8-0.2-1.3,0c0,0.3,0,0.6,0,0.8
		C232.4,249.8,232.3,249.9,232.3,250z"
      />
      <path
        class="st3"
        d="M209.9,253.2c-0.2,0.1-0.3,0.1-0.5,0.2c0.2,0.2,0.4,0.4,0.6,0.6c4.9-2.2,9.9-4.4,14.8-6.6
		c-0.1-0.1-0.2-0.1-0.3-0.2c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c-0.3,0.1-0.5,0.7-0.9,0.6c-0.1,0-0.2-0.1-0.3-0.2l0,0
		c-0.1,0-0.2,0-0.3,0c-4.2,1.9-8.4,3.8-12.7,5.6C210,253.1,209.9,253.1,209.9,253.2z"
      />
      <path
        class="st3"
        d="M231.1,247.4c-0.7,0.2-0.3,0.8-0.5,1.2c-0.5,0.2-1.1,0.4-1.6,0.6c0-0.1-0.1-0.1-0.1-0.2
		c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.1-1.3-0.2-2.2-0.2c-0.2,0.2-0.7,0.5-1.1,0.8c-0.2-0.1-0.4-0.3-0.6-0.4
		c-5.2,2.4-10.5,4.7-15.7,7.1c-0.3,0.5-0.5,0.9-0.8,1.4c-0.1,0.2-0.2,0.4-0.4,0.6c0.3-0.1,0.6-0.1,0.9-0.2c0.1,0.2,0.2,0.4,0.3,0.7
		c-0.9,0.2-1.3,1-2.3,1c-0.3,0-0.7,0-1,0c-0.2,0-0.4-0.1-0.5-0.1c-0.9,0.5-1.7,1-2.5,1.4c0.2,0.8,0.4,1.3,1.2,1.6
		c0.3,0.2,0.6,0.4,0.9,0.6c8.3-3.9,16.7-7.8,25-11.7c0.1-0.3,0.3-0.6,0.4-0.9C230.5,249.1,232.5,248,231.1,247.4z"
      />
      <path
        class="st3"
        d="M335,231.7c0.3-0.4,0.6-0.8,1-1.1c0.2,0.1,0.3,0.2,0.5,0.3c0,0,0,0,0.1,0c0.3,0.2,0.5,0.3,0.7,0.5
		c3.1-1.8,6.2-3.6,9.3-5.4c0.4-0.4,0.7-0.7,1.3-0.8c0,0,0,0,0,0.1c3.9-2.3,7.9-4.6,11.8-6.9c21.3-12.4,42.6-24.8,64-37.3
		c0.5-0.3,0.9-0.6,1.6-1c-0.8-0.2-1.3-0.4-1.8-0.5c-12-2.9-24-5.7-36.1-8.6c-0.7-0.2-1.2-0.7-1.8-1c0.7,0,1.4-0.3,2.1-0.1
		c12.2,2.9,24.4,5.7,36.5,8.8c2.9,0.8,4.7-0.6,7-2c-0.7-0.2-1.2-0.3-1.7-0.4c-17.1-3.8-34.1-7.6-51.2-11.3c-0.6-0.1-1.4,0-2.1,0.1
		c-3.1,0.9-6.1,1.9-9.2,2.7c-1.1,0.3-2.3,1.2-3.3-0.2c-0.1-0.1-0.5,0-0.7,0.1c-6,1.1-12,1.4-18,1.3c-0.3,0-0.9,0-1,0.2
		c-0.5,1.1-1.5,0.8-2.4,0.8c-2.8-0.2-5.5-0.3-8.2-0.7c-3.4-0.5-6.9-1.1-9.8-3.2c-0.4-0.2-0.4-0.9-0.7-1.3c0.4,0.1,0.9,0,1.3,0.2
		c1.2,0.5,2.4,1.2,3.5,1.7c0.1-0.1,0.1-0.2,0.2-0.4c-0.5-0.3-1-0.6-1.4-0.9c-2.8-2-3.2-4.7-0.7-7.1c1.1-1.1,2.6-1.9,4-2.8
		c0.3-0.2,0.6-0.4,1.1-0.7c-0.5-0.1-0.7-0.2-1-0.3c-11.3-2.6-22.6-5.3-33.9-7.9c-0.8-0.2-1.6-0.1-2.4,0.1
		c-16.1,3.5-32.1,7-48.2,10.4c-43.6,9.5-87.1,18.9-130.7,28.4c-6.2,1.4-12.5,2.8-18.7,4c-1.9,0.4-1.1,2.1-2,2.9
		c-0.1,0.1,0.3,0.9,0.7,1.3c1.3,1.4,2.7,2.8,4,4.2c0.6,0.7,1.2,0.9,2.1,0.6c6.1-1.5,12.1-2.9,18.2-4.4c11.5-2.8,23.1-5.5,34.6-8.2
		c0.6-0.1,1.2-0.1,1.8-0.1c0,0.3,0.1,0.6,0.1,0.8c-18.2,4.5-36.4,8.7-54.8,13.1c0.6,1.1,1.3,1.6,2.4,1.2c0.9-0.3,1.9-0.5,2.8-0.7
		c30.9-7.6,61.8-15.2,92.7-22.9c1.3-0.3,2.3-0.2,3.5,0.3c6,2.9,12.1,5.8,18.1,8.7c1.5,0.8,3,1.1,4.7,0.7c2.3-0.5,4.6-0.7,7-0.9
		c6-0.5,11.9-0.8,17.8,0.8c3.3,0.9,6.6,2,9.3,4.2c2.4,2.1,2.9,4.6,1,7.2c-1,1.4-2.5,2.4-3.7,3.6c-0.3,0.3-0.7,0.6-1.3,0.9
		c11.5,5.6,22.8,10.8,34,16.4c0,0.2-0.1,0.4-0.1,0.6c-7.7,3.5-15.5,7-23.2,10.4c1.5,0.5,2.9,0.9,4.6-0.4c-0.2,0.8-0.3,1.3-0.4,1.8
		c-2.3-0.7-3.8-0.5-4.7,0.5l0,0c-0.1,0.1-0.2,0.2-0.3,0.4c-0.8,1.2-0.2,2.4,1.6,3.5c-0.4,0.3-0.8,0.6-1.1,0.8
		c-0.1,0-0.3-0.1-0.3-0.1c-0.3-0.4-0.5-0.7-0.9-0.9c-0.1-0.1-0.3-0.2-0.5-0.3c-0.7-0.4-1.5-0.5-2.3-0.3c-1.1,0.2-1.8,0.7-2.4,1.4
		c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.2-0.1,0.2l0,0c0.3-0.2,0.7-0.3,1-0.5c0.8-0.4,1.7-0.6,2.5-0.9
		c0.1,0.2,0.2,0.3,0.3,0.5c-0.6,0.4-1.1,0.9-1.7,1.2s-1.1,0.5-1.7,0.8c0.1,0.1,0.1,0.1,0.2,0.2c0.8,0.8,1.6,1.5,3.2,1.4
		c-0.3,0.9-0.6,1.7-0.8,2.4c-1.1,0.4-2.1,0.9-3.2,1.4c-0.2-0.2-0.6-0.5-0.9-0.9c0.1-0.1,0.1-0.3,0.3-0.4c0.4-0.3,0.6-0.7,0.6-1.1
		c0-0.2,0-0.3-0.1-0.5c-0.3-0.5-1-0.8-1.6-0.7c-0.8,0.1-1.2,0.6-1.3,1.2c-0.3,1.1-0.3,1.2-0.7,1.6c0,0,0,0.1-0.1,0.1
		c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1,0-0.3,0.1-0.4,0.2c-0.4,0.2-0.6,0.4-0.6,0.7c0,0.1,0,0.1,0,0.2
		c0,0.2,0.4,0.3,0.8,0.6c-0.1,0.2-0.3,0.5-0.6,0.8c0.1,0.1,0.2,0.3,0.4,0.5l0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.5,0.2-1,0.4-1.5,0.6c-0.5,0.2-1,0.5-1.2,1c0,0,0,0.1-0.1,0.1c0.1,0,0.4,0,0.7,0
		c-0.1,0.2-0.3,0.5-0.4,0.7c0.4,0,0.8,0,1.2,0.1c-0.4,0.3-0.7,0.6-1.1,0.9c0.2,0.3,0.4,0.6,0.7,0.7c0.2,0.1,0.6,0,0.8-0.1
		c0.1,0,0.1-0.1,0.1-0.1c0.2-0.8,1-1.3,1.4-2l0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.7v-0.1l0,0c1.4,0.5,2.5-0.2,3.6-0.9
		c0.2,0.8,0.4,1.4,0.6,2.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0.1,0.2,0.1c0.4,0.1,0.7,0.3,1.1,0.4c0.1,0,0.2,0.1,0.4,0.1
		c0.8,0.3,1.6,0.3,2.4,0.1c1-0.2,1.9-0.7,2.5-1.5c0.4-0.6,0.8-1.2,1.2-1.8c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2,0-0.6-0.1-1
		c0.5-0.1,0.9-0.2,1.3-0.2c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4c0.3-0.3,0.5-0.6,0.6-0.9c0.2-0.6,0.3-1.3,0.1-2
		c-0.1-0.4-0.2-0.7,0.4-1c0.3,0.2,0.7,0.4,1,0.6c0.4,0.2,0.8,0.4,1.3,0.7c-0.3,0.3-0.6,0.5-0.8,0.7c-0.1,0.2-0.1,0.5-0.1,1.1
		c0.6-0.4,0.9-0.7,1.2-0.8c0.3-0.1,0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.5,0.8,0.9,1.1s0.9,0.4,1.6,0.4
		c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3
		c-0.1-0.5,0.1-0.8,0.8-1c0.3-0.1,0.5-0.6,0.8-0.9c0.1-0.2,0.4-0.5,0.5-0.4c1,0.3,1.5-0.6,2.4-0.8c0.6,1.2,1.6,0.3,2.6,0.3
		c0.4-0.8,0.3-1.3-0.5-1.7c-0.8,0-0.3,1.3-1.4,0.9c0.2-0.7,0.3-1.4,0.4-2c0.7-0.6,1.4-1.1,2.3-1.8c0.5,0.1,1.2,0.2,2,0.3
		c1.2,0.3,1.8,0.1,2.3-1c0.1-0.3,0.2-0.7,0.3-1.1c0.2-0.4,0.4-0.7,0.7-1c0.1,0,0.3,0,0.4,0.1c0,0.6,0,1.2,0,1.8
		c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2c0,0,0,0.1-0.1,0.1h0.1c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2
		c0.3-0.4,0.6-0.9,1-1.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.2,0.7l0,0c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3
		c-0.3,0.1-0.6,0.1-0.9,0.2c0.1,0.2,0.1,0.4,0.2,0.6l0,0l0,0l0,0c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.3,0.5,0.4,1.2,1,1.5
		c1.4,0.6,0.9,1.6,0.7,2.5c-1.1,0.4-2,0.3-2.9,0.1c-1.8-0.3-3.3,0.2-4.6,1.5l-0.1,0.1c-0.4,0.5-0.7,0.9-0.9,1.4
		c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1c-0.1,0.2,0.2,0.5,0.5,0.7l0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1.7,0.7,3.4,0.1,4-1.3c0.1-0.3,0.2-0.7,0.2-1.1c0-0.5,0.1-0.9,0.5-1.3
		c0.3-0.3,0.6-0.7,0.8-1c0.6-1,0.6-2,0.1-3c-0.1-0.2,0-0.5,0.1-1c1.7,1.9,2.4,2.2,5.4,2.2c-0.3,0.3-0.5,0.6-0.7,1
		c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,0.9-0.6,1.4c0,0.1,0,0.2-0.1,0.3c-0.3,1.8,0.6,3.5,2.5,4.4c1.6-0.9,3.1-1.8,4.7-2.7v-3.2v-0.5
		v-0.4v-0.7c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1
		c0.1-0.4,0.2-0.7,0.1-1.1c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.3-0.3-0.5-0.6-0.7l-0.1-0.1l-0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.3v-0.2
		c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.4-0.1,0.7-0.2,1.1c0.1,0,0.3,0,0.5-0.1v0.4v1.5v0.8c-0.9-0.1-1.8-0.3-2.6-0.4c-0.1,0-0.2,0-0.3,0
		c0.3-0.5,0.5-0.9,0.7-1.3c0.5-1.1,0.6-1.9,0.3-2.6c-0.2-0.5-0.6-1-1.2-1.4c0,0,0,0-0.1,0c-0.4-0.3-1-0.6-1.6-1
		c-1.3-0.1-2.2,0.9-3.3,0.4c-0.8,1.2-0.8,1.2-2.1,1c0-0.2,0-0.4,0.1-0.6c0.6-0.8,0-1.4-0.5-1.9c-0.3-0.3-0.9-0.4-1.4-0.6
		c0-0.1,0-0.2-0.1-0.3l0,0l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0.7-1.1,0.2-2.2-0.1-3.3c0.3-0.3,0.6-0.6,1-0.8c0.3-0.2,0.6-0.3,0.9-0.2
		c0.3,0,0.6,0.2,0.8,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.3,0.4,0.5,0.8,0.8,1.2c-0.1,0.2-0.4,0.5-0.4,0.8c0,0.2,0.5,0.3,0.8,0.6
		c0.6-1.2,1.3-2.2,3.1-1.9c-0.4,0.3-0.9,0.5-1.1,0.8c-0.2,0.5,0.3,1.1,1.1,1.5c0.3-0.3,0.7-0.6,1-0.9c0.2,0.1,0.5,0.2,0.8,0.3
		c0.1-0.2,0.3-0.2,0.3-0.3s0-0.1,0-0.2c0-0.2,0.1-0.4,0-0.6c-0.4-0.6-0.4-1.1-0.3-1.5s0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3
		c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.3,0.6-0.7,1-0.9c0.1,0,0.2,0,0.3,0v1.6c0.1,0.1,0.3,0.2,0.5,0.3s0.3,0.1,0.5,0.1
		c0.3,0,0.7,0,1.1-0.2c1-0.4,1.2-1.2,1.2-2c0.7-0.3,1.3-0.6,2-1c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0
		c0.3,0,0.8-0.2,0.8-0.4c0.2-0.9,1.1-1,1.8-1.2c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.9-0.7,1.8-0.6,2.4,0.2
		c0.1,0.1,0.2,0.3,0.2,0.4c0.2,1,0.5,2.1,0.7,3.2c0,0.2,0.1,0.4,0.1,0.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.3,0.3-0.3,0.5
		c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1
		c0,0.1,0,0.1,0,0.2c0.2,0.7,0,1.6,1.2,1.8c0.1,0,0.1,0.3,0.1,0.4v0.1c0,0.6,0.3,1.1,1.1,1.2c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8
		c0.1-0.1,0.2-0.2,0.3-0.3c0.3,0.1,0.6,0.1,0.9,0.1C333.5,233.2,334.3,232.5,335,231.7z M378.3,167.8c1.4,0.3,2.7,0.6,4,1
		c-0.8,0.8-3.9,0.5-4.3-0.1C377.9,168.4,378.2,167.7,378.3,167.8z M347.8,223.7c0.3-0.3,0.7-0.7,1-1.1c0.5,0.8,0.4,1-1,1.3
		c-0.1,0-0.1,0-0.2,0C347.6,223.9,347.7,223.8,347.8,223.7z M294.5,237.5c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1
		c-0.1-0.2-0.1-0.4-0.2-0.5C294.3,237.6,294.4,237.6,294.5,237.5z M321.9,161.5c-0.1,0.1-0.3,0.1-0.5,0.3c-0.2-0.3-0.5-0.7-0.4-0.8
		c0.6-1.1,1.3-2.2,2-3.3c0.1-0.1,0.5-0.1,0.7,0s0.3,0.5,0.2,0.6C323.2,159.4,322.6,160.5,321.9,161.5z"
      />
      <path
        class="st3"
        d="M454.1,135.4c-2.6-0.4-5-0.2-7.3,1c-2.4,1.2-4.8,1.4-7.4,0.9c-2.4-0.5-4.9-0.7-7.3-1
		c-6.5-0.9-12.9-1.8-19.4-2.8c-0.4-0.1-0.8-0.3-1.6-0.6c1.6-0.8,2.9-1.4,4.1-2c0-0.1-0.1-0.3-0.1-0.4c-3.1-0.3-6.2-0.7-9.4-1
		c-2.1-0.2-4.2-0.4-6.3,0.3c-3,1-6.1,1.7-9.1,2.5c-0.5,0.1-1,0.4-1.5,0.7c3.5,0.8,6.9,1.3,10.4,1.8c16.8,2.4,33.7,4.7,50.5,7.2
		c3.5,0.5,6.7,0.5,9.8-1.3c2.3-1.3,4.8-2.3,7.7-3.6c-0.8-0.2-1.1-0.2-1.4-0.3C461.8,136.4,458,136,454.1,135.4z"
      />
      <path
        class="st3"
        d="M439.7,132.6c0-0.2,0.1-0.4,0.1-0.6c-3.5-0.7-7-0.7-10.5-0.8C432.7,131.7,436.2,132.1,439.7,132.6z"
      />
      <path
        class="st3"
        d="M414.6,132.7c1.7,0.3,3.4,0.4,5.1,0.7c7.2,1,14.5,1.9,21.7,3c2.3,0.4,3.9-0.9,5.8-1.4c0-0.1,0-0.3,0-0.4
		c-4-0.5-7.9-1-11.9-1.5c-4.9-0.6-9.7-1.1-14.5-1.9C418.5,130.9,416.5,131.3,414.6,132.7z"
      />
      <path
        class="st3"
        d="M464.2,139.8c0,0.1,0.1,0.2,0.1,0.3c1.8-0.8,3.5-1.5,5.3-2.3c0-0.1-0.1-0.2-0.1-0.3
		C467.8,138.2,466,139,464.2,139.8z"
      />
      <path
        class="st3"
        d="M431.9,129.3c0,0.2,0,0.5-0.1,0.7c2.6,0.3,5.1,0.6,7.7,0.9c0-0.2,0.1-0.4,0.1-0.6
		C437,129.6,434.4,129.6,431.9,129.3z"
      />
      <path
        class="st3"
        d="M338.2,126.5c1.2,0.5,2.6,0.6,3.9,0.9c0-1.4,0-2.6,0-3.9c-1.5,0.2-2.9,0.5-4.6,0.8
		C337.8,125.1,337.8,126.3,338.2,126.5z"
      />
      <path
        class="st3"
        d="M408.5,89.5c-0.3-0.1-0.7-0.1-1,0C407.9,89.4,408.2,89.5,408.5,89.5z"
      />
      <path
        class="st3"
        d="M423.8,140.9c-6.4-0.9-12.8-1.9-19.2-2.8c0,0.1,0,0.3-0.1,0.4C410.6,141.6,417.1,142.2,423.8,140.9z"
      />
      <path
        class="st3"
        d="M439.1,127.2c-3-0.4-5.9-0.6-8.9-0.9c0,0.2-0.1,0.3-0.1,0.5c2.7,3,6.4,1.5,9.8,2.1
		C439.7,128.1,439.4,127.3,439.1,127.2z"
      />
      <path
        class="st3"
        d="M428.2,129.9c0.8-0.4,1.5-0.8,2.3-1.2c-0.8-0.7-1.4-1.2-2.3-1.9C428.2,128,428.2,128.8,428.2,129.9z"
      />
      <path
        class="st3"
        d="M192.9,167.2c28.6-6.2,57.2-12.4,85.7-18.6c1.8-0.4,3.5-1,5.3-1.4c-2.7,0.5-5.4,1.1-8,1.6
		c-28.3,6.1-56.6,12.1-84.9,18.2c-33.4,7.1-66.7,14.2-100.1,21.4c-1.5,0.3-2.9,0.7-4.6,1.1c2.9,3.2,5.7,6.1,8.4,9.1
		c1,1.1,1.8,1.2,3.1,0.4c-2.4-2.6-4.8-5.1-7.2-7.6c-0.4-0.4-0.6-0.9-0.9-1.4c0.5-0.3,1-0.6,1.6-0.7
		C125.1,181.9,159,174.5,192.9,167.2z"
      />
      <path
        class="st3"
        d="M100.1,201.3c-0.9-1-1.8-1.4-3.3-0.5c5.9,6.3,11.7,12.6,17.5,18.9c1.5-1.9,1.5-1.9,0.1-3.4
		C109.6,211.3,104.8,206.3,100.1,201.3z"
      />
      <path
        class="st3"
        d="M111.7,226.5c0.1,0.1,0.3,0.1,0.4,0.2c0.2-0.3,0.4-0.7,0.7-1c2.9-4.6,5.8-9.3,8.6-13.9
		c0.8-1.3,1.3-1.2,2.3-0.3c3.4,3.3,6.9,6.5,10.4,9.8c1.8,1.7,2,1.3,0.6,3.6c0,0.1,0,0.2,0,0.3c1.1-0.7,1.3-0.1,1.4,0.8
		c0.2,3.9,0.4,7.8,0.6,11.8c0,0.7,0.1,1.4,0.1,2.2c0.3-0.2,0.4-0.3,0.4-0.3c-0.1-5.4-0.3-10.8-0.5-16.2c0-0.5-0.4-1.1-0.8-1.5
		c-2.1-2-4.2-4-6.3-6c-2.3-2.2-4.7-4.4-7.1-6.7C118.7,215,115.2,220.8,111.7,226.5z"
      />
      <path
        class="st3"
        d="M187.1,232.1c0.4-0.2,0.9-0.4,1.3-0.6c-0.2-0.2-0.2-0.3-0.3-0.4c-11.4-8.7-22.9-17.5-34.4-26.2
		c-0.4-0.3-1.2-0.4-1.7-0.3c-2,0.5-4,1.1-6,1.7c-6.2,1.8-12.5,3.6-18.8,5.4c0.5,1.2,1.2,1.1,2.1,0.8c7.2-2,14.5-4,21.7-6.1
		c1.2-0.3,2-0.2,2.9,0.6c9.7,7.5,19.5,15,29.2,22.6c0.5,0.4,0.9,0.9,1.3,1.4c-0.5,0.3-1,0.8-1.6,1c-12.4,4.4-24.8,8.8-37.2,13.3
		c-0.5,0.2-0.9,0.4-1.4,0.6c0.6,1.1,1.3,1.4,2.4,1C160.1,241.9,173.6,237,187.1,232.1z"
      />
      <path
        class="st3"
        d="M429,179.9c0.6-0.2,1.3-0.4,1.9-0.7c19.2-11.3,38.3-22.7,57.5-34c1.9-1.1,3.7-2.2,5.6-3.3
		c-0.1-0.1-0.1-0.2-0.2-0.3c-21.7,12.6-43.3,25.2-65,37.8C428.9,179.6,429,179.7,429,179.9z"
      />
      <path
        class="st3"
        d="M354.1,167.6c3.7-0.6,7.5-1.1,11.2-1.7c0-0.1,0-0.2-0.1-0.4c-3.7,0.6-7.5,1.1-11.2,1.7
		C354,167.4,354,167.5,354.1,167.6z"
      />
      <path
        class="st3"
        d="M474.2,137.9c-0.9-0.1-1.8,0.1-2.6,0.4c-5,2.2-10,4.4-15,6.6c-0.7,0.3-1.6,0.5-2.3,0.4
		c-5.7-0.8-11.3-1.6-17-2.4c-3.1-0.4-6-1.1-9.3-0.1c-3.9,1.2-8,1.4-12.1,1.2c-5.9-0.4-11.4-1.9-16.1-5.6c-0.8-0.6-1.8-1.1-2.8-1.2
		c-5.7-0.9-11.3-1.7-17-2.5c-0.5-0.1-0.9-0.3-1.3-0.4c0-0.2,0-0.3,0-0.5c5.5-2.2,11.4-2.9,16.9-5.2c-3.3-0.5-6.6-1-9.9-1.4
		c-0.8-0.1-1.7-0.1-2.6,0.1c-5.6,1.1-11.2,2.3-16.8,3.5c-4.3,0.9-8.5,2-12.8,2.9c-17.1,3.7-34.1,7.4-51.2,11.1
		c-0.3,0.1-0.6,0.2-1.3,0.4c0.7,0.2,1.2,0.3,1.6,0.4c9.5,2.2,18.9,4.4,28.4,6.5c1.4,0.3,2.7,0.4,4.2-0.1c10.5-3,21.3-3.8,32.1-3.5
		c0.4,0,1.2,0.1,1.3,0.3c0.4,1.2,1.4,1,2.3,1.1s1.9,0.1,2.7,0.4c2.6,0.7,5.3,1.3,7.7,2.4c3.1,1.4,3.4,4.3,1.1,6.8
		c-0.6,0.7-1.3,1.2-2,1.9c0.1,0.1,0.2,0.3,0.4,0.4c1.5-1.3,3-2.5,4.3-4c1.2-1.4,0.9-2.8-0.5-4c-0.5-0.4-1-0.7-1.5-1.1
		c-0.2-0.2-0.3-0.6-0.2-0.8c0.1-0.2,0.5-0.3,0.8-0.3c2.5,0.5,4.1,3.8,2.9,6.1c-0.6,1.1-1.5,2.1-2.4,2.9c-0.9,0.8-2,1.5-3.2,2.3
		c0.6,0.2,1,0.3,1.5,0.4c16.8,3.7,33.6,7.4,50.4,11.1c1.2,0.3,2.1,0.1,3.2-0.5c17.2-10.1,34.5-20.1,51.8-30.2
		c1.8-1.1,3.7-2.2,5.8-3.4c-0.6-0.2-0.9-0.2-1.2-0.3C486.2,139.3,480.2,138.6,474.2,137.9z"
      />
      <path
        class="st3"
        d="M380.5,157.7c0.7-1.1,0.7-2.1-0.5-2.7c-1.3-0.7-2.8-1.3-4.2-1.7c-7.3-1.8-14.8-1.8-22.2-1.1
		c-4,0.4-8,1-11.9,1.6c0,0.2,0,0.4,0.1,0.5c0.3,0.1,0.6,0.2,0.9,0.2c4.3,0.9,8.7,1.8,13,2.8c5.4,1.2,10.8,2.6,16.2,3.8
		C374.7,161.8,378.8,160.1,380.5,157.7z"
      />
      <path
        class="st3"
        d="M369,163c-0.6-0.1-1.1-0.3-1.7-0.4c-3-0.7-6-1.3-9-2c-1.7-0.4-3.3-0.8-5.1-0.3c-0.6,0.2-1.5-0.2-2.2-0.5
		c-0.5-0.2-0.9-0.8-1.4-0.9c-4.2-1-8.4-2-12.7-3c-0.4-0.1-1-0.3-1.4-0.1c-3,1-5.9,2.1-8.1,4.4c-1.4,1.5-1.2,2.7,0.7,3.5
		c1.8,0.7,3.7,1.3,5.6,1.7c9,1.6,18.1,1.3,27.1-0.2c2.7-0.5,5.4-1.1,8.2-1.6C368.9,163.3,368.9,163.1,369,163z"
      />
      <path
        class="st3"
        d="M433.3,85.1c1,0,1.6-0.2,2.2-0.9c-0.1-0.2-0.2-0.4-0.2-0.6c-0.5,0.3-0.7,0.5-1,0.6c-0.4,0.2-0.9,0.4-1.3,0.5
		c-0.2,0.1-0.6,0.2-1.1,0.3C432.4,85.1,432.9,85.1,433.3,85.1z"
      />
      <path
        class="st3"
        d="M376.5,233.5c0-0.2,0-0.4-0.1-0.6c0.8-0.2,1.5-0.4,2.3-0.5c0-0.1,0-0.2,0-0.3c0.2-0.3,0.4-0.6,0.6-0.9
		c0.2-0.3,0.4-0.6,0.6-0.9c0.2,0.3,0.5,0.6,0.8,0.8c0.2,0.2,0.5,0.5,0.7,0.8c1.7-0.5,3.2-1.4,4.7-2.4c0.6-0.4,1.2-0.9,1.9-1.3
		c-0.4-0.2-1.1-0.2-1.7,0.1l0,0c-0.3,0.1-0.5,0.4-0.8,0.6l-0.1,0.1c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.1-0.8-0.2-1.4
		c0.3,0.1,0.6,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0.1c0-0.2,0-0.5,0-0.8c0-0.1,0-0.1,0-0.2c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2
		c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3
		c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9c0.4,0,0.9-0.5,1.4-0.8c0.1,0.4,0.3,0.9,0.4,1.5c-0.8,0.3-1.4,0.5-2.3,0.9
		c0,0,0.1,0,0.1,0.1c0.5,0.4,0.8,0.8,1.2,1.2l0.1,0.1c5.2-3.6,10.4-7.2,15.6-10.9c0-0.5,0-1-0.2-1.4c-0.2-0.3-0.6-0.6-1.2-0.7
		c-0.5-0.1-0.8-0.9-1.1-1.3c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6
		c0.2,0,0.5,0.1,0.7,0s0.3-0.3,0.5-0.4c-0.2-0.1-0.5-0.4-0.6-0.3c-0.5,0.1-0.9,0.4-1.3,0.6c-0.1,0.1-0.3,0.1-0.4,0.2
		c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9c-0.5,0-0.9,0-1.7,0c0.3-0.2,0.5-0.4,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0
		c0.2-0.1,0.5-0.3,0.9-0.5c-0.5-0.1-0.8-0.2-1.1-0.3c0.4-0.5,0.1-1.2,1-1.7c0.2,0.4,0.3,0.7,0.6,1c0.7,0.8,2,0.9,2.7,0.1
		c0.7-0.8,1.5-1.1,2.5-1.6c0.5,0.5,0.9,1,1.4,1.5c-0.6,0.8-1.9,1.3-1.7,2.4c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1
		c0.6,0.4,1.3,0.6,2.3,0.3c0.2-0.1,0.5,0.3,0.8,0.4c0.3-0.2,0.6-0.4,0.9-0.6c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.4,0.2,0.7,0.3
		c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.1-0.6,0.2-1c0.6,0.1,1.2,0.1,2,0.2c-0.2-0.4-0.3-0.6-0.5-0.9c0-0.1,0.1-0.2,0.1-0.2
		c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2c0.3,0.3,0.2,0.6-0.3,0.9c-0.3,0.2-0.6,0.4-0.8,0.6c-0.4,0.5-0.5,1-0.2,1.4l0,0
		c8.7-6.1,17.5-12.2,26.2-18.2c-0.4-0.2-0.7-0.5-0.9-1l0.1-0.1c0.4-0.3,0.7-0.6,1.1-0.9l0,0c0.2-0.2,0.5-0.4,0.7-0.6
		c-0.2-0.2-0.5-0.3-0.8-0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.1-0.9-0.2-1.5c0.9,0.2,1.5,0.5,2.2,0.5
		s1.5-0.2,2.1-0.5c0.1,0,0.2-0.1,0.3-0.1c0.2-0.2,0.2-0.3-0.3-0.5c0-0.2,0-0.4,0.1-0.8c0.1,0.1,0.3,0.1,0.4,0.2
		c0.4,0.2,0.9,0.3,1.2,0.5c0.5,0.3,0.9,0.6,1.2,1.2c23.3-16.2,46.5-32.4,69.8-48.6c0.4-0.3,0.9-0.6,1.7-1.2
		c-25.8-2.9-51-5.7-76.7-8.6c0.8,1.1,1.5,1.7,1.7,2.5c0.1,0.7-0.4,1.5-0.7,2.2c0.1,0,0.3,0.1,0.5,0.1c17.5,2.2,35.1,4.4,52.6,6.6
		c0.7,0.1,1.4,0.5,2,0.7c-0.5,0.5-1,1.1-1.6,1.4c-21.8,12.9-43.6,25.8-65.4,38.7c-0.4,0.2-0.8,0.5-1.4,1c1.9,0.5,3.5,0.8,5.1,1.3
		c0.4,0.1,0.8,0.6,1.1,0.9c-0.5,0.1-0.9,0.3-1.4,0.2c-1.7-0.3-3.4-0.7-5.1-1.2c-1-0.3-1.8-0.1-2.7,0.4c-24.8,14.7-49.5,29.3-74.3,44
		c0.1,0,0.1,0,0.1,0c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.1,0,0.1-0.1,0.2-0.1h0.1c0.4-0.2,0.9-0.5,1.6-0.1
		c-0.6,0.4-1.1,0.8-1.7,1.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.6,0.6,1,1.5,1.8,1.8c0.2,0.1,0.5,0.1,0.7,0.1c0.7,0,1.4-0.1,2.2-0.2
		c0.4,0.2,1,0.5,1.8,0.8c0.2,0.8,0.7,1.7,0.4,2.7c-2.6,0.2-3.6,0.7-3.9,2.1c-0.2,0.8,0.1,1.4,0.8,1.9c0.1,0.1,0.3,0.2,0.4,0.2
		c0.3,0.1,0.6,0.3,1,0.4c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.4-0.4,0.7-0.7,1.1c-0.3-0.2-0.5-0.4-0.8-0.5c0,0-0.1,0-0.1-0.1
		c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4-0.1-0.7-0.1-1.1-0.1c-0.3,0-0.7,0.1-1.1,0.3c0,0-0.1,0-0.1,0.1c-0.4,0.2-0.6,0.4-0.9,0.6
		c-0.4,0.4-0.7,0.8-0.9,1.3c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.2,0.6,0.3,0.9,0.5
		c0.8,0.3,1.6,0.5,2.7,0.3c0.2,0,0.3,0,0.5-0.1c0,0.2,0,0.3,0,0.5l0,0c0,0.6,0.1,1.1,0.1,1.7c-0.4,0.3-0.8,0.5-1.1,0.8
		c-1.1,1-1.5,2.3-0.9,3.4c0.1,0.3,0.3,0.5,0.6,0.7c2-1.4,3.9-2.7,5.9-4.1c0-0.1-0.1-0.2-0.1-0.3h0.1c0.4-0.1,0.7-0.3,1-0.4
		c0.6-0.4,1.2-0.8,1.7-1.2c0.6-0.7,0.8-1.7,0.3-2.5c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0
		c0.3,0.3,0.7,0.7,1,1c0.5-0.5,1-1,1.6-1.5c0.2,0.2,0.3,0.4,0.4,0.5c1.9-1.3,3.8-2.6,5.6-3.9c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0
		c0.6-0.4,1.2-0.9,1.9-1.3c0-0.2,0.1-0.3,0.1-0.5s0-0.4,0-0.5C378,233.5,377.2,233.5,376.5,233.5z"
      />
      <path
        class="st3"
        d="M375.8,238c-1.3,0.9-2.5,1.8-3.8,2.6c0.6,0.2,1.2,0.3,1.8,0.2c0.8-0.2,1.6-0.8,2-1.7c0-0.1,0.1-0.2,0.1-0.3
		c-0.1-0.2-0.2-0.4-0.1-0.6C375.8,238.1,375.8,238,375.8,238z"
      />
      <path
        class="st3"
        d="M461.3,72.1c-0.4,0.4-0.6,0.5-0.6,1c0,0.1,0,0.3,0,0.4s0.1,0.3,0.1,0.5c0.4,0,0.9,0,1.3,0
		c-0.1-0.1-0.3-0.1-0.4-0.2C461.4,73.5,462.1,72.6,461.3,72.1z"
      />
      <path
        class="st3"
        d="M446.9,71.8c-0.5,0.6-1,1.3-1.7,2.1c0.9,0,1.4,0,2,0c3.2,0,6.3,0.1,9.5,0.1c0-0.3,0-0.6,0.1-0.9
		c0.1-0.5-1-0.9-0.2-1.5c0.1-0.1-0.3-0.7-0.6-1.2h-0.1c-0.4-0.1-1,0.8-1.5,0.2c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.5-0.4,0.9-0.7,1.3
		c-0.4-0.3-0.8-0.5-1.2-0.7c-0.3-0.2-0.7-0.3-1.3-0.6c0.1,0.6,0.2,0.9,0.3,1.2c0,0,0,0,0,0.1C449.1,71,448.1,71.4,446.9,71.8
		C447.1,71.9,447,71.8,446.9,71.8z"
      />
      <path
        class="st3"
        d="M391.6,237.7c0.9,0.6,1.7,0.9,2.4,0.9c0.2,0,0.4,0,0.6-0.1c0.7-0.5,1.5-1.1,2.2-1.6c0.2-0.4,0.2-0.9,0.1-1.3
		c-0.3-1.1-1.4-1.6-3.5-1.5c-0.2-0.1-0.3-0.2-0.4-0.3c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0-0.7
		s-0.1-0.3-0.1-0.5c-2.8,0.5-5.7,1-8.5,1.5c-0.6,0.1-1.2,0.5-1.8,0.8c-0.3,0.2-0.7,0.5-1,0.7c0,0.9,0.3,1.7,0.8,2.5
		c0.3,0.5,0.7,0.9,1.2,1.4c0.3,0.3,0.5,0.5,0.8,0.8C386.6,239.7,389.2,239.1,391.6,237.7L391.6,237.7z"
      />
      <path
        class="st3"
        d="M403.2,95.6c0,0.1,0.1,0.2,0.1,0.2c2.4,0,4.9,0,7.3,0.2c1.7,0.1,2.9-0.4,3.8-1.8c0.3-0.4,0.6-0.8,1-1.3
		c-0.5-0.1-0.8-0.2-1.1-0.2c-3.7-0.1-7.4-0.3-11-0.4c0.1,0.2,0.3,0.4,0.5,0.6c-0.3,0.9-0.7,1.7-0.6,2.5
		C403.1,95.5,403.1,95.5,403.2,95.6z"
      />
      <path
        class="st3"
        d="M409.3,98.9c0.7-0.4,1.5-0.8,2.3-1.2c-0.1-0.2-0.1-0.4-0.2-0.5c-2.4,0-4.8,0-7.2,0c0,0.1,0.1,0.1,0.1,0.2
		c0.2,0.3,0.5,0.6,0.9,1c-0.8,0.5-1.5,1-2.4,1c0,2.8,0,5.6,0,8.7c1.2-1.5,2.2-2.7,3.2-3.8c-0.4-0.4-0.7-0.6-1.3-1.2
		C407.5,102.8,409.1,101.7,409.3,98.9z"
      />
      <path
        class="st3"
        d="M403.4,90.7c-0.1,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1-0.1,0.1c11.8,0.4,23.7,0.9,35.5,1.4c0.8,0,1.5,0,2.3,0
		c0-0.2,0-0.4,0-0.6c-0.3-0.1-0.6-0.2-0.9-0.2c-12.1-0.4-24.2-0.9-36.3-1.3C403.7,90.5,403.5,90.6,403.4,90.7z"
      />
      <path
        class="st3"
        d="M421.8,86.2c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.7,0.2-0.9,0.1c-1.7-0.5-3.6-0.1-5.4-0.2
		c-0.2-0.3-0.4-0.6-0.6-0.8c-1,0-2,0-3-0.1c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.1,0,0.1,0,0.2c0,0.5-0.1,1-0.2,1.4
		c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.1,0,0.3,0.1,0.5c10.3,0.3,20.7,0.7,31,1c1.1,0,1.8-0.2,2.5-1.1c0.4-0.5,1.1-0.8,1.6-1.2
		c-0.2,0.6-0.4,1.3-0.6,1.9c0,0.1,0,0.2,0.1,0.7c2.8,0,5.6,0,8.5,0c0.3,0,0.8-0.3,0.9-0.6c0.5-1.1,0.9-2.3,1.5-3.8c-3,0-6,0-9-0.1
		l-0.1,0.1c-0.1,0-0.3-0.1-0.4-0.1c-8-0.1-15.9-0.3-23.9-0.4C421.9,86.1,421.9,86.2,421.8,86.2z"
      />
      <path
        class="st3"
        d="M537.8,76L537.8,76c0.2,0.1,0.3,0,0.3,0C538,76,537.9,76,537.8,76z"
      />
      <path
        class="st3"
        d="M478,226.3c-0.1-0.3-0.2-0.5-0.4-0.7c-0.7-1-2.3-1.7-4.6-1.8l0,0l0,0c0.1-0.7,0.3-1.5,0.4-2.2
		c0-0.1,0-0.1,0-0.2h0.1c0.9,0,1.7,0,2.6-0.2c0,0,0,0,0.1,0c2.4-0.5,4.1-2.3,4-4.4c0-0.4-0.1-0.7-0.2-1c-9.3,1.6-18.7,3.3-28,4.9
		v0.1c-0.6,2,0.8,3.7,3.1,4c0.4,0,0.8,0,1.5,0.1c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1c-0.3,1.2-0.4,2.4,0.3,3.5
		c1.1,1.6,2.8,2.4,5,2.3c2.1-0.1,3.8-1.1,4.9-2.7c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9c1.8,0,3.6-0.2,4.9-1.5l0,0
		c0.6-0.5,0.9-1.1,1.1-1.8c0.1-0.3,0.2-0.6,0.2-0.9c0-0.1,0-0.2,0-0.4C478.2,226.9,478.1,226.6,478,226.3z M463,222.6
		c-1.1,0-2.2,0.1-3.2,0.1c0-1,0-2,0-2.9c1.1,0.3,2.3,0.6,3.7,0.9C463.4,221.2,463.2,221.9,463,222.6z"
      />
      <path
        class="st3"
        d="M552.9,69.3c-0.6,0-1.3,0.2-1.8,0.2c-1.3,1.7-2.8,3.5-4.3,5.5c1.3,0,2.2,0,3.1,0c2.6,0,5.2,0.1,7.7,0.1
		c-1-0.6-2.3-0.4-3.5-0.6c0-1,1.1-0.3,1.5-1c-0.5-0.1-1-0.2-1.6-0.3c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0.2-0.4,0.4-0.5
		c-0.3-0.1-0.6-0.3-0.8-0.5C553.1,71.2,553.1,70.2,552.9,69.3z"
      />
      <path
        class="st3"
        d="M142,243.8c0.9,0.7,1.5,1,2.6,0.6c12.2-4.4,24.3-8.7,36.5-13c0.5-0.2,0.9-0.4,1.5-0.6
		c-0.3-0.3-0.5-0.5-0.7-0.6c-9.6-7.4-19.2-14.8-28.8-22.1c-0.5-0.3-1.3-0.4-1.9-0.3c-5.8,1.6-11.6,3.2-17.4,4.9
		c-1.4,0.4-2.9,0.9-4.6,1.4c2.7,2.5,5.2,4.8,7.5,7.2c0.6,0.6,1,1.5,1.1,2.3c0.2,3.6,0.5,7.3,0.2,10.9
		C137.7,238.3,138.9,241.3,142,243.8z"
      />
      <path
        class="st3"
        d="M543.3,76.1c-1,0-1.9,0-2.9,0v0.1v0.1c0.1,0.4,0.3,0.7,0.6,1l0.1,0.1c0.2,0.1,0.2,0.6,0.1,0.8
		c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6c-0.6,0-0.6-0.4-0.6-0.8c0-0.2,0.1-0.4,0.2-0.6c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0
		c-0.6,0-1.3,0.1-1.7,0.5c-0.6,0.5-1.1,0.3-1.6,0.3c0-0.8,0.1-1.6-0.3-2.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.5-0.1-1-0.3-1.5-0.5c-0.1,0-0.2-0.1-0.3-0.1c-13.1-0.1-26.1-0.3-39.2-0.3c-0.5,0-1.3,0.4-1.6,0.8c-2.2,2.7-4.3,5.6-6.5,8.3
		c-0.2,0.3-0.4,0.6-0.6,1c0.7,0,1.2,0.1,1.6,0.1c3,0,5.9,0.1,8.9,0.1c12.9,0.2,25.8,0.4,38.8,0.6c0.7,0,1.6,0,2-0.4
		c2.7-3.3,5.3-6.6,8.1-10.2C543.7,76.1,543.5,76.1,543.3,76.1z M535.1,79.4C535.1,79.4,535.1,79.3,535.1,79.4
		C535.2,79.3,535.2,79.3,535.1,79.4C535.2,79.3,535.1,79.4,535.1,79.4z"
      />
      <path
        class="st3"
        d="M440,83.6c-0.5,0.5-1.1,1.1-1.6,1.6c1.5,0,2.9,0,4.4,0.1c-0.6-0.3-1.2-0.6-1.7-1C440.7,84,440.3,83.8,440,83.6
		z"
      />
      <path
        class="st3"
        d="M443.6,76c0.5,1.2,1,2.4,2.2,3.4c0.5,0.4,0.7,1,1,1.5c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6-0.2,0.9
		c-0.1,0.1-0.1,0.3,0,0.4c0.4,0.6,0.1,1.3-0.1,2c-0.1,0.3-0.1,0.5-0.1,0.8c11.9,0.2,23.9,0.4,35.8,0.6c0.4,0,1-0.3,1.3-0.6
		c2.4-3.1,4.8-6.2,7.6-9.8c-1.5,0-2.6,0-3.7,0c-6.8-0.1-13.5-0.1-20.3-0.2c0.3,0.7,0.1,0.9-1.4,1.9c0.5,0.2,0.9,0.4,1.3,0.6
		c-0.3,1.4-1.6,0-2.2,0.9c0.3,0.2,0.7,0.4,1,0.6c-0.5,0.5-1,1.1-1.6,1.7c-0.5,0.1-1.1,0.1-2.2,0.2c0.5-0.5,0.7-0.7,1-0.9
		c0.3-0.1,0.7-0.1,0.9-0.3c0.3-0.3,0.6-0.7,0.6-1s-0.4-0.7-0.7-0.7c-0.4,0-1,0.2-1.3,0.5s-0.4,0.7-0.6,1.2c-1.3-1.3-1.3-1.3-2.9-0.6
		c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4c0-0.2,0-0.4-0.1-0.7c-0.2,0-0.4,0-0.4,0.1c-0.3,0.6-0.9,0.8-1.7,1c-0.1-0.4-0.2-0.7-0.3-1.1
		c-0.1-0.5-0.3-1-0.4-1.5c0.5-0.4,0.9-0.8,0.9-1.4c-3.8,0-7.7-0.1-11.5-0.1C444.8,75.1,444,75.5,443.6,76L443.6,76z M468.5,75.6
		c0,0,0.1,0,0.1,0.1c-0.1,0-0.2,0.1-0.3,0.1l-0.1-0.1C468.3,75.7,468.4,75.6,468.5,75.6z"
      />
      <path
        class="st3"
        d="M444.8,72.6c0.2-0.3,0.4-0.5,0.6-0.8c-0.1,0-0.1,0-0.2,0c-0.5,0.2-1.1,0.9-1.5,1.7
		C444.1,73.3,444.4,73,444.8,72.6z"
      />
      <path
        class="st3"
        d="M259.1,137.3c0.5,0,0.9,0,1.3-0.4c-0.6,0.1-1.2,0.2-1.8,0.3h0.1C258.8,137.3,259,137.3,259.1,137.3z"
      />
      <path
        class="st3"
        d="M251.1,144.8c-2.1-0.8-2.2-0.9-2.3-3c-0.3,0-0.6,0-0.9,0c0-0.6,0.5-0.6,0.9-0.6c0-0.1,0-0.3,0-0.4
		c-0.3-0.1-0.7-0.1-1-0.2c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0.2-0.4,0.4-0.5c-0.3-0.1-0.6-0.3-0.8-0.5l-0.1-0.1
		c-1.5,0.3-2.9,0.5-4.3,0.7c-4.3,0.7-8.5,1.4-12.8,2c0.4,0.6,0.8,1.1,1.2,1.7c0.8-0.2,0.8-1,1.2-1.4c0.1-0.2,0.3-0.3,0.7-0.2
		c0.5,0.5,0.6,1,0.7,1.6v0.1c0.1,0.4,0.3,0.7,0.6,1l0.1,0.1c0.2,0.1,0.2,0.6,0.1,0.8c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6
		c-0.6,0-0.6-0.4-0.6-0.8c0-0.2,0.1-0.4,0.2-0.6c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0c-0.6,0-1.3,0.1-1.7,0.5
		c-0.6,0.5-1.1,0.3-1.6,0.3c0-0.8,0.1-1.6-0.3-2.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.5-0.1-1-0.3-1.5-0.5
		c-0.3-0.1-0.6-0.2-0.8-0.2c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4-0.1-1,0.1-1.4,0.2c-0.5,0.1-1,0.2-1.5,0.1c-4.6,0.8-9.2,1.6-13.8,2.4
		c-4.7,0.8-9.3,1.5-14,2.3c-0.4,0.1-1.1,0.7-1.1,1c-0.1,2.3-0.1,4.6-0.1,7.2C212.6,152.3,231.9,148.6,251.1,144.8z M229,146.6
		L229,146.6L229,146.6C229,146.7,229,146.6,229,146.6z"
      />
      <path
        class="st3"
        d="M236.2,139.7c3.5-0.6,7-1.2,10.8-1.8c-0.1-0.4-0.2-0.9-0.3-1.3c-1.1,0-2.6,0.8-2.7-1c-0.4,0.4-0.6,0.6-1,0.8
		c-0.2-0.2-0.4-0.4-0.6-0.6c-2,0.6-2.1,0.6-3.4,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.8,0.8c-0.2-0.1-0.5-0.2-0.7-0.3
		c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.4,0.2-0.6,0.3l0,0c-0.2,0.1-0.5,0.2-0.7,0.1c-0.9-0.1-0.9-0.2-1.9,0.2c0,0.4,0,0.8-0.1,1.2
		c-0.1,0-0.2,0-0.3,0c-1.4,0.1-2.6,0.6-3.9,1.4c0.1,0.2,0.2,0.3,0.3,0.5C231.9,140.4,234.1,140.1,236.2,139.7z M236.4,138
		c0-0.2-0.1-0.4-0.1-0.6C236.7,137.6,237,137.7,236.4,138z"
      />
      <path
        class="st3"
        d="M193.3,146.7c2.4-0.4,4.8-0.8,7.2-1.2c5.7-0.9,11.4-1.7,17.2-2.7c1.6-0.3,3.3-0.6,4.9-0.8
		c0.5-0.3,1-0.7,1.2-1.3c0.2-0.5,0.2-1.2,0.1-1.6c-0.1-0.4-0.4-0.7-0.8-1c-0.3-0.2-0.7-0.3-1.1-0.4c-0.6-0.1-1.3-0.1-2,0.1
		c-0.2-0.6-0.6-1.1,0-1.6c-0.5-0.1-1-0.1-1.6-0.2c0.1-0.4,0.2-0.8,0.3-1.2c0.1-0.3,0.1-0.5,0.2-0.8c-0.6,0.1-1.2,0.2-1.8,0.3
		c-9.6,1.3-19.1,2.6-28.7,3.8c-1.5,0.2-3.1,0.4-4.9,0.7c3,2.8,5.8,5.3,8.6,7.8C192.4,146.7,192.9,146.8,193.3,146.7z"
      />
      <path
        class="st3"
        d="M242,121.1c0.9-0.2,1-0.9,1.5-1.3c0.7,0.3,1.8-0.6,2.1,0.5c0.4-0.3,0.6-0.5,0.9-0.7c0,0.2,0,0.4,0,0.6
		c0,0.7,0.1,1.3,1.1,1.5c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1
		c-0.3,0.5-0.6,1-1,1.6c0.5,0.4,0.4,1.3,0.6,2c0.1,0.3-0.3,0.8-0.5,1.1c-0.2,0.2-0.5,0.4-0.9,0.7c-0.4-0.1-1-0.3-1.6-0.4
		c-0.3,0.3-0.5,0.6-0.8,0.9l0,0c-0.2,0.3-0.5,0.5-0.7,0.8c0.3,0.1,0.6,0.2,0.9,0.3c9.5-1.3,19-2.6,28.5-3.9c0-0.3-0.1-0.6-0.5-0.8
		c-0.5-0.4-1.1-0.7-1.6-1.1c-0.9-0.8-2-1-3.2-0.9c-0.2,0-0.5,0-0.7,0.1c0,0.4,0.5,0.9-0.1,1.2c-0.1,0-0.3,0.1-0.5,0.1
		c-0.1-0.2-0.3-0.5-0.4-0.8c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.4-1.1-0.3c-0.8,0.1-1.1-0.3-1.5-0.6l-0.1-0.1
		c-0.6-0.5-1-0.5-1.6,0.2c-0.4,0.5-0.9,0.3-1.3,0.6c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.3-0.2,0.5-0.3c-0.6-0.4-0.5-1.4-1.7-0.9
		c-0.1,0-0.3-0.2-0.3-0.3c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.7,0.7-1,1.1c-0.5-0.4-1-0.8-1.5-1.3
		c-0.3,0.2-0.6,0.3-0.9,0.5c0,0.2,0,0.4,0,0.6c-0.3,0-0.7,0.1-1,0.1c-0.2,0.2-0.4,0.4-0.6,0.6c0.5,0.5,1,1,1.5,1.5
		c-0.4,0.8-0.8,1.6-1.2,2.5c-0.4-0.3-0.5-0.7-0.8-0.8c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1c-0.1-0.2-0.2-0.6-0.7-0.7
		c-2.5,0.3-5.1,0.6-7.7,0.9C242.1,120.1,241.9,120.6,242,121.1z M266.7,124.7c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1
		c-0.2,0.2-0.3,0.3-0.4,0.4c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1C266.5,124.9,266.6,124.7,266.7,124.7z M259.8,121.8
		L259.8,121.8l-0.1,0.1L259.8,121.8z"
      />
      <path
        class="st3"
        d="M256.5,144.1c-0.1-1.8-0.2-3.3-0.3-4.8c-0.2,0.2-0.4,0.5-0.2,0.9c0.2,0.5,0,1.2-1,1.3
		c-0.2-0.3-0.4-0.5-0.6-0.8c-0.7,0.2-0.5,0.7-0.4,1.1c0,0.1,0.3,0.1,0.6,0.1c-0.8,0.4-1.6,0.8-2.5,1.3c0.1,0.1,0.1,0.1,0.2,0.2
		C253.7,143.6,255.1,143.8,256.5,144.1z"
      />
      <path
        class="st3"
        d="M144.2,165.5c15.3-3,30.7-5.9,46-8.9c1.2-0.2,1.7-0.6,1.7-1.9c-0.1-2.1,0-4.2,0-6.4c-3.1,0.5-6,1-8.9,1.4
		c-27.1,4.5-54.2,8.9-81.4,13.4c-1.4,0.2-2.7,0.5-4.1,0.7c0.2,0.3,0.5,0.6,0.7,0.9c0.2,0.3,0.5,0.6,0.9,1c-1.2,0.6-2.1,1.5-3.5,0.8
		c-0.4-0.2-0.8-0.1-1,0.4c-0.2,0.6-0.5,0.7-0.9,0.1c-0.2-0.3-1.1,0.2-1-0.6c0.1-0.1,0.3-0.2,0.4-0.3c-0.2,0-0.3,0-0.5,0V166
		c0-0.1,0-0.1,0-0.2c0-0.4,0.1-0.8-0.6-0.8c-0.3,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.1,0.5-0.1,0.8c-0.2-0.1-0.4-0.1-0.5-0.2
		c-0.2,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.2,0.3-0.2,0.5c0,0.1,0.1,0.2,0.1,0.3l0,0c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.4-0.5,0.4
		c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0c0.6,0.7,1.4,0.7,2.2,1c-0.3,0.6-0.4,1.4-1.6,1.1c0.2,0.3,0.2,0.5,0.3,0.8
		c-0.3,0.4-0.6,0.8-1,1.2c0.2,0.1,0.4,0.3,0.7,0.5c-0.2,0.2-0.5,0.4-0.7,0.7c0.3,0.4,0.6,0.7,0.9,1c0.1,0.3,0,0.6-0.2,0.9
		c-0.3,0.4-0.8,0.8-1.2,1.2c-0.1,0.1-0.2,0.2-0.3,0.3l0,0C106.2,172.8,125.2,169.1,144.2,165.5z M92.5,166.1c0,0.1,0,0.2,0.1,0.2
		c-0.2,0-0.3-0.1-0.5-0.1C92.2,166.2,92.4,166.2,92.5,166.1z"
      />
      <path
        class="st3"
        d="M271.5,136.5c0-0.4,0.1-0.9,0.1-1.4c-0.7,0.1-1.4,0.2-2.1,0.3c-0.4,0.4-1,0.6-1.6,0.5v-0.1h-0.1c0,0,0,0,0,0.1
		c-0.2,0.2-0.3,0.3-0.5,0.5c-0.7-0.6-0.9,0.2-1.4,0.4c-0.1-0.3-0.2-0.5-0.2-0.7c-0.8,0.1-1.5,0.3-2.3,0.4c-0.6,0.5,0.2,0.3,0.6,0.5
		c-0.6,0.4-1.1,0.7-1.8,1.1c0.1-0.5,0.1-0.7,0.1-1c0-0.1-0.1-0.3-0.2-0.4c-0.5,0.1-0.9,0.2-1.4,0.2c0.2,0.2,0.3,0.3,0.4,0.5
		c-0.3,0.2-0.7,0.4-1.2,0.8c0.8-0.1,1.2-0.1,1.7-0.1c-0.3,0.4-0.6,0.6-0.7,0.8c-0.7-0.1-1.3-0.2-1.9-0.4c-0.5-0.1-1-0.4-1.5-0.6
		c0,0.6,0,1.2,0,2.2c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,1.3,0.1,2.5,0.2,3.9c4.5-0.9,9.1-1.7,13.6-2.6l-0.1-0.1c-0.2-0.1-0.2-0.3-0.3-0.4
		c-0.1-0.3,0.2-0.7,0.1-1c0-0.1,0-0.1-0.1-0.2c0.2-0.2,0.3-0.3,0.3-0.4v-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1s-0.1-0.1-0.2-0.2l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.4l0,0c-0.1-0.1-0.3-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.3,0.3-0.6,0.5-1
		C270.8,136.2,271.1,136.3,271.5,136.5z M261.5,137.4L261.5,137.4C261.5,137.4,261.6,137.4,261.5,137.4
		C261.6,137.4,261.5,137.4,261.5,137.4z"
      />
      <path
        class="st3"
        d="M246.8,117.1L246.8,117.1C246.8,117.2,246.8,117.2,246.8,117.1c0,0.2,0.1,0.4,0.2,0.5c0.1,0.2,0.2,0.5,0.2,0.7
		c-0.1,0-0.2,0-0.2,0.1c0.5-0.1,0.9-0.1,1.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c0.5-0.3,0.9-0.6,1.3-0.8c0.2-0.1,0.4-0.2,0.5-0.3
		c-0.1-0.3-0.2-0.5-0.3-0.6c-0.3-0.4-0.6-0.3-1.6-0.1c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4s0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0
		C247.7,117.4,247.4,117.3,246.8,117.1z"
      />
      <path
        class="st3"
        d="M250.4,143c0.4,0.1,0.8,0.1,1.2,0.2c0-0.2,0.1-0.4,0.3-0.5c-0.5-0.6-1.2-0.8-1.9-0.8c0,0.1,0,0.3,0.1,0.4
		C250.1,142.6,250.3,143,250.4,143z"
      />
      <path
        class="st3"
        d="M122.3,292c-0.4-0.3-0.7-0.5-1.2-0.8c-0.2,0.1-0.5,0.1-0.8,0.2c-0.2,0-0.3,0.1-0.5,0.1c0-0.3,0-0.4,0-0.6
		c-0.5,0-1.4,0.5-1-0.6c-1,0.8-1,0.8-3.6,0.8c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.2-0.6-0.4-0.9-0.7
		c0.4-1.2,0.4-1.2,1.8-1.8c-0.1-0.7,0-1.5-1.3-1.6c-0.6-0.1-0.7-0.5-0.6-0.9c0.1-0.3,0.2-0.6,0.4-0.9c-2.1-0.4-2.4,1.3-3.7,1.9
		c-0.1-0.3-0.2-0.6-0.3-0.9c-0.6-1.5-0.8-1.6-3-1.3c0.9-0.7,0.5-1.6,0.1-1.9c-0.8-0.8-0.5-1.4,0.2-2.2c-0.3-0.2-0.5-0.3-0.8-0.5
		c-0.2,0.4-0.3,0.8-0.6,1c-0.9,0.4-1.9,0.7-2.8,1.1c-0.1-0.3-0.2-0.5-0.2-0.6l0,0c0.1-0.6,0.1-1.2-0.2-1.7c-0.2-0.3-0.6-0.6-1.2-0.7
		c-0.5-0.1-0.8-0.9-1.1-1.3c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6
		c0.2,0,0.5,0.1,0.7,0s0.3-0.3,0.5-0.4c-0.2-0.1-0.5-0.4-0.6-0.3c-0.5,0.1-0.9,0.4-1.3,0.6c-0.1,0.1-0.3,0.1-0.4,0.2
		c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9c-0.5,0-0.9,0-1.7,0c0.3-0.2,0.5-0.4,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0
		c0.2-0.1,0.5-0.3,0.9-0.5c-0.5-0.1-0.8-0.2-1.1-0.3c0.4-0.5,0.1-1.2,1-1.7c0.2,0.4,0.3,0.7,0.6,1c0.7,0.8,2,0.9,2.7,0.1
		s1.5-1.1,2.5-1.6c0.5,0.5,0.9,1,1.4,1.5c-0.6,0.8-1.9,1.3-1.7,2.4c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1
		c0.6,0.4,1.3,0.6,2.3,0.3c0.2-0.1,0.5,0.3,0.8,0.4c0.3-0.2,0.6-0.4,0.9-0.6c0.2,0.1,0.3,0.1,0.5,0.2s0.4,0.2,0.7,0.3
		c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.1-0.6,0.2-1c0.6,0.1,1.2,0.1,2,0.2c-0.2-0.4-0.3-0.6-0.5-0.9c0-0.1,0.1-0.2,0.1-0.2
		c0.4-0.4,0.8-0.7,1.2-1.1c-3-4.7-6.1-9.3-9.1-14c-16.1-24.6-32.2-49.3-48.3-73.9c-1.1-1.7-1-1.8,0.9-2.2c3.8-0.7,7.5-1.4,11.3-2.2
		c-0.5-0.2-0.9-0.5-1.3-0.9c-0.5,0.4-0.9,0.8-1.3,1.2c0-0.9,0.3-1.5,1.1-2c0,0,0.1,0,0.1-0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.4
		c0.2-0.2,0.4-0.4,0.4-0.6c0-0.1-0.1-0.2-0.3-0.3l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0c-0.2-0.8-0.7-1.4-1.4-1.6
		c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2c0.1-0.3,0.1-0.5,0.2-0.7c0.1-0.3,0.2-0.7,0.3-1c0.1-0.1,0.2-0.3,0.4-0.4
		c0.1-0.1,0.3-0.2,0.5-0.3s0.5-0.2,0.8-0.3c0.1,0,0.3-0.1,0.4-0.1l0,0c0.2-0.2,0.5-0.7,0.6-0.7c1.1,0.2,1.4-0.7,2.2-1.1
		c-0.7-0.4-1.3-0.8-2.1-0.9c-0.5-0.1-1,0-1.6,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.5c-0.3,0.5-0.7,0.9-1.4,0.9h-0.1
		c-0.4,0-1,0.4-1.4,0.7c-0.5,0.4-1.1,0.6-1.4,0.2c-0.8-0.9-2.1-1.2-3.3-1.4l0,0c-0.4-0.1-0.9-0.1-1.3-0.2c-0.7-0.1-0.8-0.4-0.9-0.8
		c-2.6,0.4-5.1,0.8-7.7,1.3c-1.2,0.2-1.8-0.1-2.4-1.1c-0.9-1.5-1.9-3-2.9-4.5c-0.6,0.5-1,1-1.2,1.6c-0.3,0.7-0.3,1.5-0.1,2.3
		c0,0.1,0,0.2,0.1,0.3l-0.1,0.1c-0.9,0.2-0.9,0.2-1.3-1.3c-0.5,0.1-1.1,0.2-1.8,0.3c0.2,0.7,0.8,1,1.4,1.2c-0.7,0.9-1.5,1.7-2,2.6
		c-0.5,1-0.2,2,0.7,3c-1.5,0-2.7,0.3-3.5,1.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.5,0.5-0.7,0.9c-0.3-0.4-0.5-0.8-0.9-1.1
		c-0.6-0.5-1.4-0.2-1.7,0.5c-0.1,0.2-0.1,0.4-0.1,0.6l0,0c0,0.3,0.2,0.6,0.5,0.9c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1
		c0.1,0.3,0.2,0.7,0.4,1c0.2,0.5,0.6,1,1.3,1.3c0.4,0.1,0.7,0.4,1,0.7c0.2,0.2,0.5,0.5,0.7,0.7c-0.4,0.4,0,0.6,0.1,0.9
		c0.1,0.2,0.1,0.3,0.1,0.5c0,0.4-0.1,0.7-0.9,0.9c-0.3-0.6-0.8-1.1-1-1.7c-0.7-1.8-1.6-2.3-3.3-1.7c7,15.8,14,31.5,21,47.3
		c2.9,6.6,5.8,13.1,8.8,19.7c2.1,4.6,4.1,9.2,6.1,13.9c4.5,10.2,9.1,20.5,13.6,30.7c0.2,0,0.3,0.1,0.4,0.1s0.1,0,0.2,0.1
		c0-0.2,0-0.5,0-0.8c0-0.1,0-0.1,0-0.2c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5
		c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9
		c0.4,0,0.9-0.5,1.4-0.8c0.1,0.4,0.3,0.9,0.4,1.5c-0.8,0.3-1.4,0.5-2.3,0.9c0,0,0.1,0,0.1,0.1c0.5,0.4,0.8,0.8,1.2,1.2
		c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.6,0.5,0.9,0.7c0.4,0.2,0.9,0.4,1.6,0.4c0.4-0.4,1.1-0.9,1.5-1.5c0.1-0.1,0.2-0.2,0.2-0.3
		c0.6-0.6,1.5-0.6,2.3-0.8c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4c-0.4,0.3-0.7,0.8-0.7,1.2c-0.1,0.7,0,1.4,0,2.2
		c0,0.2,0,0.4,0,0.6c0.9-0.2,1.6-0.4,2.4-0.7c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1c0.6-0.1,1.1-0.2,1.6-0.3
		c-0.2,0.7-0.3,1.5-0.6,2.5c-0.6,0.3-1.4,0.6-2.3,1c0,0.2,0,0.4,0.1,0.7c0,0.3,0.1,0.6,0.1,0.9v0.1c0.1,1.1,0.7,2,2,2.3
		c1.1,0.3,2.6-0.1,3.4-0.9c0.9-1,1.1-2,0.4-3c-0.1-0.2-0.2-0.3-0.4-0.5c0.9-0.9,2.3-0.7,3.4-1.2c0.5-0.6,1.1-1.2,1.3-1.8
		c0.3-0.8,0-1.6-0.7-2.2c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7c-0.1,0.4-0.2,0.8-0.3,1.2
		c0.3,0.3,0.5,0.6,0.9,0.9c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.2,0.2
		c0,0,0.1,0.1,0.2,0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.1,1.3,0.1c0.3-0.3,0.7-0.5,1.1-0.8
		c0.2,0.1,0.3,0.2,0.4,0.3c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1c0.3-0.1,0.9-0.1,1.2,0.1
		c0.8,0.7,1.8,0.3,2.8,0.6c-0.1-0.4-0.2-0.7-0.3-1c0.3,0,0.5,0,0.8-0.1C124.4,295.3,123.4,293.6,122.3,292z M61.2,173.3L61.2,173.3
		L61.2,173.3L61.2,173.3z M34.7,184.4C34.7,184.4,34.7,184.3,34.7,184.4L34.7,184.4C34.8,184.4,34.8,184.4,34.7,184.4z M102.9,293
		c-0.1,0.2-0.1,0.6-0.3,0.6c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0c-1,0.6-1.5,1.5-2.3,2.2c-0.3,0.3-0.7,0.5-1.2,0.7
		c0.1-0.3,0.2-0.6,0.3-0.9c0.2-0.5,0.3-1,0.5-1.5c0.4-0.9,0.3-1.7-0.2-2.5c0.9,0,1.6-0.1,2.1,0C101.6,291.6,102.1,292,102.9,293
		c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1C103.1,292.8,103,292.9,102.9,293z"
      />
      <path
        class="st3"
        d="M279.3,139.2c-0.3-0.7-0.6-1.6-0.6-2.4c0-0.1,0-0.2,0-0.3c0-0.8-0.2-1.4-0.9-1.9c-0.2-0.1-0.3-0.3-0.5-0.5
		c-0.4,0.1-0.8,0.1-1.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.2,0.4,0.5,0.6,0.7c0.1,0.1,0.2,0.3,0.4,0.4c-0.1,0.4-0.2,0.9-0.2,1.4
		c0,0.2-0.1,0.5-0.1,0.7c0,0.1-0.3,0.2-0.5,0.3c-0.7,0.4-0.7,0.4-0.1,1c0.2-0.2,0.5-0.3,0.9-0.5c0.1,0.4,0.1,0.7,0.2,1.1
		c0.6-0.1,1.3-0.3,1.9-0.4C279.4,139.3,279.4,139.2,279.3,139.2z"
      />
      <path
        class="st3"
        d="M258.8,128.5c-2.9,0.4-5.8,0.8-8.8,1.2c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1,0.1-0.2,0.3-0.3,0.4
		c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2,0,0.8-0.9,0.6c-0.5-0.1-1,0.7-0.9,1.3c0,0.1,0,0.2,0.1,0.3
		c0.2,0.3,0.5,0.5,0.7,0.7c-0.1,0.4-0.4,0.9-0.4,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.4,0.6,0.5c0.1,0,0.2,0.1,0.3,0.1
		c0.2,0,0.5,0.1,0.6,0.3c0.7,1,0.6,1,2,1.2c-0.1-0.9-0.3-1.9,1.2-2.5c-0.2,0.6-0.7,1.4-0.5,1.8c0.2,0.4,0,0.8,0,1.2
		c0.1,0,0.1,0,0.2,0c1.3-0.2,2.6-0.4,3.9-0.6c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0.1c3.6-0.6,7.2-1.2,10.8-1.8
		c0.1-0.1,0.2-0.3,0.4-0.4c0.4-0.4,0.8-0.9,1.1-1.3l0,0c0.2-0.2,0.4-0.5,0.6-0.7s0.4-0.5,0.6-0.8c-0.1-0.1-0.2-0.2-0.4-0.4
		c-0.1-0.1-0.2-0.2-0.4-0.3c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.4-0.9,0.6-1.4c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2
		c0.6-0.8,1.4-1.3,2.2-1.2c0.9,0.2,1.3-0.3,1.9-0.6C267.9,127.2,263.4,127.8,258.8,128.5z M250.3,131.1c-0.1,0-0.3-0.1-0.4-0.1
		c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0C250.4,130.9,250.3,131.1,250.3,131.1z"
      />
      <path
        class="st3"
        d="M308.2,131.9c0.4,0.2,0.8,0.4,1.2,0.6c0-0.1,0.1-0.3,0.3-0.7c0.7,0.1,1.5,0.3,2.1,0.4c0.1,0.3,0.2,0.6,0.2,0.9
		c0.2,0,0.3-0.1,0.5-0.1c0.1-0.2,0.2-0.3,0.3-0.5c0.6,0.1,1.3-0.1,1.9,0.1c7.8-1.5,15.5-3,23.3-4.5c-2.4-0.4-0.9-2.5-1.7-3.6
		c-4.2,0.7-8.5,1.4-12.8,2.1c0,0.1,0.1,0.3,0,0.4c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2l0,0h-0.1
		c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.1-0.1-0.3-0.1-0.4s0-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2c-6.2,1-12.4,2-18.6,3.1
		c-0.3,0.9-0.5,1.8-0.5,2.8c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.8-0.2-1.4-0.3-2.2-0.5c0.3-0.4,0.5-0.7,0.7-1
		c0.4,0.1,0.8,0.2,1.2,0.3c0.1-0.2,0.2-0.3,0.1-0.4c0-0.1-0.1-0.2-0.1-0.3c-3.2,0.5-6.5,1.1-9.7,1.6c0.2,1.8,0.3,3.4,0.5,5.2
		c4.8-0.9,9.6-1.8,14.3-2.8v-3.4h0.1c0.6,0.3,1.2,0.6,1.8,0.9C308.1,131.9,308.1,131.9,308.2,131.9z"
      />
      <path
        class="st3"
        d="M285.7,128.9c-0.4,0.4-0.6,0.8-0.6,1.2s0.2,0.8,0.5,1.2c0.1,0.1,0.2,0.2,0.3,0.2c4.1-0.7,8.2-1.4,12.3-2
		c0.5-0.1,1-0.2,1.6-0.3c-0.3-0.5-0.7-1-1.5-1c-0.4,0-0.8-0.4-1-0.7c-0.4-0.5-0.7-1.1-1.1-1.7c-0.6-0.7-0.9-1.5-1.1-2.3
		c-1,0.1-2,0.3-3,0.4c-1.2,0.8-1.6,1.5-1.3,2.4c0.3,1,1.2,1.4,3,1.3c0.2,0,0.3,0,0.6,0c0,0.5,0,1,0.1,1.5c0,0-0.1,0.1-0.1,0.3
		c-0.5-0.2-1.1-0.2-1.5-0.2c-0.5,0-1.1,0.2-1.6,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5
		s0-0.2-0.1-0.3c-0.3-1.1-1-1.6-2.4-1.6c-0.4,0-0.7,0.1-1.1,0.1l0.1-0.1l0,0l0,0C286.2,128.4,286,128.6,285.7,128.9z"
      />
      <path
        class="st3"
        d="M252.6,138.2c-1.6,0.3-2.3,0.5-2.6,1.3c0.1,0.1,0.1,0.2,0.2,0.2c0.4-0.3,0.8-0.6,1.3-0.8
		C251.9,138.7,252.3,138.5,252.6,138.2z"
      />
      <path
        class="st3"
        d="M257.6,137.8c0-0.2,0.1-0.3,0.2-0.4c-0.2,0-0.3,0.1-0.5,0.1c0,0.1,0,0.1,0,0.2
		C257.5,137.7,257.6,137.7,257.6,137.8z"
      />
      <path
        class="st3"
        d="M256.5,199.2c-1.1,1-2.4,1.8-3.8,3c0.6-0.1,0.8,0,1-0.2c1.7-1.4,3.6-2.6,5-4.2c1.8-2.1,1.3-4.1-1.3-6.1
		C259.4,195.1,259.3,196.7,256.5,199.2z"
      />
      <path
        class="st3"
        d="M505.8,190.1c2.4,0.9,2.4,0.9,3.4,2c0.3-0.2,0.9-0.5,0.9-0.7c0.1-1.1-0.2-2.1-1.3-2.8c0,0.3,0.1,0.6,0.1,0.9
		c0,0.1-0.3,0.3-0.5,0.5c-0.3-0.5-0.6-1.1-0.9-1.7c-0.3,0.1-0.6,0.2-0.8,0.3c-0.1,0-0.3,0.1-0.4,0.2c-0.3-0.2-0.6-0.5-1-0.9
		c0.7-0.2,1.3-0.7,2-1.4c0.1-0.1,0.2-0.3,0.3-0.4c0.3-0.3,0.3-0.8,0.4-1.1l0,0c0.2-1.4-0.3-2.7-1.3-3.8c-0.5-0.5-0.4-1.1-0.2-1.7
		c0.2-0.6,0.4-1.1,0.6-1.7c0.3-0.1,1-0.2,1.1-0.4c0.1-0.4-0.1-0.8-0.2-1.3c-0.5,0.4-0.8,0.7-1.1,0.9c-0.1,0-0.2-0.1-0.2-0.1
		c-0.2-2-0.9-3.9-0.3-6c0.9,0.1,2,0.2,3.2,0.3l0,0l0,0h-0.1c1.5,0.4,1.1,1.7,1.4,2.6c0.5,0.1,1,0.4,1.3,0.3c1.2-0.4,1.7,0.1,2,0.9
		c0.1,0.2,0.7,0.4,0.3,0.7c-0.5,0.4,0.4,1.3-1.1,1.4c0.5,0.6,0.9,1.1,1.2,1.6c0.2,0.3,0.5,0.7,0.5,1.1c0,0.3-0.4,0.7-0.7,0.8
		c-0.6,0.2-0.8-0.2-0.9-0.6c-0.7,0.7-0.8,1.4-0.3,2.2c1-0.8,1.8,0.1,2.7,0c-0.2-0.2-0.4-0.4-0.8-0.7c1.1-0.4,2-0.7,3.4-1.2
		c-0.5,0.5-0.7,0.7-1,0.9c0,0,0,0.1,0.1,0.1c0.6-0.3,1.2-0.6,1.9-0.9c5.4-6.7,10.9-13.5,16.3-20.2c1.6-1.9,3.1-3.9,4.8-6.1
		c-0.7,0.1-1.1,0.2-1.5,0.3c-12.4,3.5-24.9,7-37.3,10.5c-0.8,0.2-1.5,0.7-2.1,1.1c-3.2,2.5-6.4,5-9.7,7.6c-4.1,3.3-8.3,6.5-12.4,9.8
		c0.8,0,1.6-0.1,1.8,1c0,0-0.3,0.4-0.7,0.7l0,0h-0.1c-0.4-0.2-0.8-0.4-1.2-0.6c-0.2,0.2-0.3,0.3-0.3,0.5c-0.1,0.4,0.1,0.6,0.5,0.8
		l0,0c0.3,0.1,0.7,0.3,0.7,0.5c0.1,0.5,0.3,0.9,0.7,1.2l0.1,0.1c0.5,0.3,1.1,0.5,1.8,0.6c0.1,0.1,0.1,0.2,0.2,0.3
		c0.3,0.6,0.6,1.2,0.9,1.7c0.2,0.3,0.4,0.7,0.6,1c0.8,1.3,1.2,2.7,1.1,4.1c0,0.5,0,1,0.1,1.5c0.2,0.7,0.5,1.3,1.3,1.8
		c-0.7,0.2-1.3,0.3-1.8,0.4l0,0c-0.4,0.1-0.7,0.2-1,0.4c-1.3,0.7-2.1,2.1-1.8,3.4c0.3,1.4,1.8,2.3,3.5,2.2c0.3,0,0.6,0,1-0.1
		c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.5,0.3-1.1,0.2-1.8c-0.1-0.2-0.1-0.4-0.2-0.5
		c-0.3-0.8-0.7-1.6-1.3-2.3c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.7-1-1-2,0-3.4c0.2-0.1,0.6-0.3,1-0.5
		c2.2-0.9,2.7-1.9,2-3.8c0-0.1,0-0.2-0.1-0.4c1.4-0.9,0.6-1.9,0.4-2.9c0.6-0.6,1.1-1.1,1.6-1.6c0.4-1,0.6-2,0.2-2.9
		c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.2-0.6,0.3-1c1.3,1,2.6,1.9,4,2.9c0.5,0.4,1,0.7,1.5,1.1
		c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8c0.5,0.1,0.8,0.2,1.2,0.3c1-0.8,1.1-1.1,0.7-1.5s-0.7-0.4-2,0.2
		c-0.6-0.4-0.8-0.8,0-1.2c1-0.6,1.9-1.3,3.2-0.7c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9c0,0.8,0,1.4,0.7,1.9s1,1.2,1.1,2
		c0.1,0.9,0,1.1-0.9,1.5c-0.5,0.2-1,0.3-1.4,0.3c-1.5,0.1-1.5,0-2.1,1.2l0.1,0.1c1.1,0.9,2.1,1.2,2.9,1
		C504.8,189.2,505,189.8,505.8,190.1L505.8,190.1z"
      />
      <path
        class="st3"
        d="M134.9,227.8c-0.1,0-0.2-0.1-0.4-0.1c-3,4.6-6,9.2-9.2,14.1c3.6-0.7,6.8-1.3,10.1-1.9
		C135.2,235.9,135.1,231.8,134.9,227.8z"
      />
      <path
        class="st3"
        d="M247.2,187.5c-3.1-0.2-6.2-0.3-9.3-0.5c0,0.1,0,0.1,0,0.2c3.1,0.3,6.2,0.5,9.3,0.8
		C247.2,187.7,247.2,187.6,247.2,187.5z"
      />
      <path
        class="st3"
        d="M482,178.7c5.1-4,10.2-8,15.3-12c-0.1-0.2-0.1-0.4-0.2-0.5c-2,0.8-4.3,1.2-6,2.5
		c-10.4,7.7-20.8,15.4-31.2,23.1c0.4,0.3,1,0.5,1.8,0.7c-0.7,1.1-1.4,2.2-1.5,3.4c1.4-1.1,2.9-2.2,4.3-3.4c-0.3-0.2-0.7-0.3-1.1-0.4
		c0.6-0.7,0.9-1.2,1.9-1.5c0.1,0,0.1-0.1,0.2-0.1c0.5-0.1,0.9-0.4,1.3-0.7s0.8-0.6,1.3-0.8c0.2,0.1,0.4,0.2,0.5,0.3
		c2.3-1.8,4.6-3.6,6.9-5.4c0.1-0.4,0.2-0.9,0.3-1.4c0.2-0.1,0.3-0.1,0.5-0.2c0.4-0.1,0.8-0.3,1.2-0.4c0,0.2,0,0.3,0,0.5
		C478.9,181.1,480.5,179.9,482,178.7z"
      />
      <path
        class="st3"
        d="M470.9,173.7c-2.3,0.7-4.6,1.2-6.6,2.6c-5.6,3.9-11.2,7.8-16.9,11.7c0,0.1-0.1,0.1-0.1,0.2
		c-0.7,0.9-0.6,1.8,0.1,2.6c0.6,0.6,1.8,0.8,2.7,0.5c1.2-0.5,1.9-1.3,1.7-2.4v-0.1c0-0.1,0-0.1,0.1-0.2c0.5,0.1,0.9,0.3,0.7,0.8
		c0,0.1,0,0.1-0.1,0.2c-0.2,0.5-0.3,1-0.5,1.5c-0.3,0.6-0.6,1.3-0.8,1.9c-0.3,0.6-0.5,1.3-0.7,1.9c-0.6-0.6-0.4-1.7-1.6-2.1
		c-0.1,0.2-0.2,0.4-0.2,0.5c0.1,1.3,1.3,2.3,1.1,3.7c0,0.1,0.1,0.2,0.3,0.3c2-1.5,4.1-3,6.1-4.5c-0.4-0.2-0.9-0.3-1.5-0.3
		c-0.2,0-0.4,0-0.5,0c0.7-2.1,2.1-3,4-2.5c0.3,0.1,0.7,0.3,0.8,0.5c0,0.1,0.1,0.2,0.1,0.3c7.1-5.2,14.1-10.5,21.2-15.7
		c2.6-1.9,5.2-3.9,7.8-5.8c-0.1-0.1-0.1-0.2-0.2-0.3C482.3,170.5,476.6,172.1,470.9,173.7z"
      />
      <path
        class="st3"
        d="M121.9,213.4c0,3.8,0,7.6,0,11.4c0.1,0,0.2,0,0.3,0c0-3.8,0-7.6,0-11.4C122.1,213.4,122,213.4,121.9,213.4z"
      />
      <path
        class="st3"
        d="M226.6,189.5c0.5,0.3,1,0.5,1.6,0.8c6.5,3.1,13.2,6,19.6,9.5c3.2,1.7,5.3,1.1,7.6-1c0.1-0.1,0.3-0.3,0.5-0.4
		c2.7-2.5,2.5-4.5-0.7-6.4c-0.6-0.4-1.3-0.8-1.9-0.9c-3.4-0.8-6.8-1.9-10.3-2.3C237.5,188.1,232.1,188.5,226.6,189.5z"
      />
      <path
        class="st3"
        d="M120.7,224.6c0-2.9,0-5.8,0-8.8c-0.2,0-0.3-0.1-0.5-0.1c-2.2,3.7-4.5,7.3-7,11.4c2.6-0.6,4.7-1.1,6.8-1.7
		C120.3,225.4,120.7,224.9,120.7,224.6z"
      />
      <path
        class="st3"
        d="M123.5,240.2c3.7-5.9,7.2-11.4,10.8-17.1c-3.6-3.3-7.1-6.6-10.5-9.8c0,3.5,0,6.9,0,10.3c0,2.3,0,2.3-2.1,2.8
		c-2.6,0.7-5.3,1.3-8.3,2.1C117.9,231.5,120.7,235.7,123.5,240.2z"
      />
      <path
        class="st3"
        d="M427.7,180.5c-0.6,0.2-1.2,0.3-1.8,0.6c-4.3,2.4-8.5,4.9-12.7,7.4c-20.9,12.2-41.8,24.3-62.7,36.5
		c0.5,0.5,0.9,0.9,1.3,1c25.4-15,50.7-30,76.1-45C427.8,180.8,427.7,180.7,427.7,180.5z"
      />
      <path
        class="st3"
        d="M144.3,265.9c-0.4-0.9-1.2-1.3-2.3-1.5c-0.3-0.1-0.9,0-1-0.2c-0.1-0.3-0.2-0.5-0.4-0.6
		c-0.3-0.3-0.8-0.4-1.3-0.5c-0.2,0-0.5-0.1-0.7-0.1h-0.1c0-0.1,0-0.1,0-0.2c0.1-1,1.5-1.3,2.1-2.2c-0.5,0.1-0.9,0.2-1.3,0.3
		c-0.8-0.6-1.1-1.3-0.6-2.1c-0.3-0.3-0.6-0.5-1-0.6c-0.3-0.1-0.6-0.2-0.9-0.4c-0.6-0.3-1.2-0.6-1.5-1.3l0.1-0.1
		c0.4-0.3,0.7-0.6,1.1-0.9l0,0c0.2-0.2,0.5-0.4,0.7-0.6c-0.2-0.2-0.5-0.3-0.8-0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1,0-0.1-0.1-0.2
		c-0.2-0.4-0.1-0.9-0.2-1.5c0.9,0.2,1.5,0.5,2.2,0.5s1.5-0.2,2.1-0.5c0.1,0,0.2-0.1,0.3-0.1c0.2-0.2,0.2-0.3-0.3-0.5
		c0-0.2,0-0.4,0.1-0.8c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0.2,0.9,0.3,1.2,0.5c0.1,0.1,0.3,0.2,0.4,0.3c-2.8-3.1-5.7-6.2-8.5-9.4
		c-0.8-0.8-1.5-1.1-2.5-0.8c-1.5,0.4-3,0.7-4.5,1c-1.6,0.3-2.9,0.1-3.8-1.5c-0.5-0.9-1.2-1.6-1.7-2.5c-2.3-3.8-5.1-7-8.7-9.5
		c-0.3-0.2-0.6-0.5-1-0.8c-1-0.8-1.2-1.7-0.5-2.8c0.7-1.2,1.3-2.4,2.1-3.6c0.6-0.9,0.5-1.5-0.2-2.2c-5.3-5.7-10.6-11.3-15.8-17.1
		c-1.2-1.4-2.3-2-4-1.2c-0.6,0.2-1.2,0.2-1.9,0.2c0-0.2-0.1-0.4-0.1-0.6c0.5-0.2,1-0.5,1.5-0.7s1.1-0.3,1.9-0.5
		c-3.5-3.8-6.7-7.3-10.2-11.1c1-0.3,1.5-0.5,2-0.6c47.9-10.2,95.7-20.5,143.6-30.7c26.2-5.6,52.4-11.2,78.5-16.8c0,0,0,0-0.1,0H308
		c-0.5-0.1-1-0.3-1.4-0.5c-1.3,0.3-2.7,0.6-4,0.8c-0.7,0.1-1.5,0.1-2.2,0c-2.7-0.7-5.4-1.5-8.1-2.1c-0.9-0.2-1.8-0.3-2.7-0.1
		c-1.7,0.3-3.5,0.7-5.2,1c-1.1,1.5-2.4,1.4-4,1.2c-0.1-0.1-0.2-0.3-0.3-0.4c-0.8,0.2-1.6,0.3-2.4,0.5c0.1,0.9,0.3,1.8,0.4,2.7
		c-0.9,0-1.5,0.1-2.3,0.1c-0.1-0.3-0.2-0.6-0.3-1.1c-0.3,0.3-0.5,0.4-0.8,0.8c-0.2-0.6-0.5-1.1-0.7-1.7c-3.7,0.7-7.3,1.4-11,2.1
		c-1,0.2-2.1,0.4-3.1,0.7c2.7,0.9,5.4,1.5,8.1,2.1c0.5,0.1,1,0.6,1.4,0.8c-0.5,0.2-0.9,0.6-1.4,0.7c-21.5,4.5-42.9,8.9-64.4,13.3
		c-0.7,0.2-1.6,0-2.3-0.3c-2.5-1-5-2.2-7.5-3.2c-0.8-0.3-1.8-0.5-2.6-0.3c-13.9,2.6-27.7,5.3-41.5,8c-20.7,4-41.3,8-62,12
		c0,0.4,0,0.8,0.1,1.2c-0.3,0.1-0.6,0.1-1,0.2c0-0.3,0-0.5,0-0.7c-0.6-0.2-1.1-0.2-1.5-0.2c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0.1
		c-0.3,0.2-0.6,0.5-0.9,1.1c-0.2-0.1-0.4-0.2-0.6-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.1-0.9,0.3c-0.3,0.2-0.5,0.4-0.5,0.7
		c-0.1,0.5-0.3,0.6-0.8,0.9c-0.7,0.4-0.8,1.1-0.5,1.9c0.1,0,0.2-0.1,0.2-0.1c1.2-0.5,2.2-0.5,3,0.2l0,0c0,0,0,0,0.1,0.1h-0.1
		c0,0,0,0-0.1,0c-0.8,0.2-1.8-0.2-2.6,0.4l0,0c-0.2,0.1-0.9-0.1-1.2-0.6c-0.4-0.7-1.3-1.1-1.8-1.8c-0.2-0.2-0.7,0-0.9-0.1
		c-0.1,0-0.2-0.1-0.1-0.4l0,0c0-0.2,0.1-0.4,0.1-0.5v-0.1c-0.2,0-0.5,0-0.6,0.2c0,0.1,0,0.1,0,0.2c-0.4,0.1-0.8,0.3-1.2,0.4
		c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.3-0.4-0.4-0.6c-1.1,0.2-2.2,0.4-3.3,0.6c-0.3,0.4-0.7,0.6-1.4,0.4c0.1,0.5,0.2,0.8,0.3,1.3
		c0.5-0.1,1-0.1,1.8-0.2c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.5,0.6-0.8,1.1c-0.3-0.2-0.5-0.4-0.7-0.6
		c-0.4-0.5-0.7-1-1.1-1.6c-0.2-0.3-0.4-0.5-0.7-0.7c-2.1,0.4-4.3,0.8-6.4,1.2c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.1-0.1-0.2-0.2-0.3-0.2l-0.1-0.1c-0.3,0.1-0.6,0.1-0.9,0.2c-1.9,0.4-3.8,0.8-5.9,1.2c19.3,29.6,38.6,59.1,57.8,88.5h0.1
		c0.1,0.1,0.2,0.2,0.2,0.3c0.7,1.1,1.4,2.2,2.1,3.2c0.4,0,0.8,0.1,1.2,0c0,0.4-0.3,0.9-0.3,1.4c0.2,0.3,0.4,0.5,0.5,0.8
		c0.1,0,0.1,0.1,0.2,0.1s0.1,0.2,0.1,0.4c0.5,0.7,0.9,1.4,1.4,2.1c0.8,0.1,1.4-0.3,2-0.9c2.6,1.3,4-0.8,5.7-1.8
		c1,0.8,1.7,1.6,0.8,2.9c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.3,0.1,0.5,0.2c0.7,1.4,0.5,3,0.7,4.8c1.1-0.9,1.1-1.8,0.8-2.7
		c-0.4-1.1-0.9-2.2-1-3.4c-0.1-0.7-0.1-1.2-0.1-1.6c0.1-1.4,0.7-1.5,2.9-2c1.1-0.3,2.2-0.5,3.4-1.1c-0.4,0-0.8,0-1.3-0.1
		c0-0.1-0.1-0.2,0-0.2c0.4-0.3,0.8-0.6,1.2-0.9c1.3,1,1.9,1.1,2.6,0.5c0.7-0.7,0.4-1.1-1-2c0.7-1,0.7-1,0.4-2.5c0.6,0,1.2,0,1.8,0
		l0,0c0.1-0.1,0.3-0.2,0.4-0.3c1-0.9,1.1-1.1,2.1-0.8c0.2,0,0.4,0.1,0.6,0.2c1.3,0.4,2.5,0.2,3.6-0.7
		C144.4,268.1,144.7,266.9,144.3,265.9z M87.6,178.8c0.6,0.3,1.3,0.6,1.3,1.4c-0.8,0.1-1.5,0.3-2.3,0.4
		C86.3,179.9,87.5,179.5,87.6,178.8z M130.7,275.9c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0v0.1C130.8,275.9,130.8,275.9,130.7,275.9z"
      />
      <path
        class="st3"
        d="M207.4,204.8c-1.7-0.5-3.2-0.1-4.7,1.1C204.6,206.5,206.4,206.1,207.4,204.8z"
      />
      <path
        class="st3"
        d="M134.5,241.7c0.4,0.4,0.7,0.9,1.1,1.3c4.5,5,9.1,10,13.6,15c0.7-0.7,1.7-0.9,2.8-0.7c0.3,0.1,0.7,0.3,0.8,0.5
		c0.3,1.1,1.2,1.7,2.6,1.9c-0.7,1.1-1.4,2.3-1.5,3.4c2.9,3.1,5.7,6.3,8.6,9.4c0-0.1,0-0.1,0-0.2c1.4-0.3,2.8-0.6,4.1-1
		c-9.1-9.6-18.2-19.2-27.4-28.8C137.8,241.1,136.5,240.8,134.5,241.7z"
      />
      <path
        class="st3"
        d="M198.8,178.5c-3,0.6-6,1.4-8.9,2.2c-28.4,7-56.9,14-85.3,21.1c-0.5,0.1-0.9,0.3-1.4,0.4
		c4.7-0.8,9.3-1.9,13.9-3c26.7-6.6,53.4-13.1,80.1-19.7c1.4-0.3,2.6-0.3,4,0.4c24.3,11.6,48.7,23.2,73.1,34.8c3,1.4,6.1,2.9,9.1,4.4
		c0.3,0.2,0.6,0.5,0.8,0.8c-0.3,0.3-0.5,0.6-0.8,0.8s-0.7,0.4-1.1,0.5c-8.7,3.9-17.3,7.7-26,11.6c0,0.1-0.1,0.1-0.1,0.2
		c0,0.1-0.2,0.1-0.3,0.1V233c-0.7,0.3-1.3,0.6-2,0.9c0.1,0.2,0,0.4,0,0.7c1.9-0.8,3.8-1.7,5.6-2.5c8.6-3.9,17.2-7.7,25.9-11.6
		c0.3-0.2,0.6-0.4,1.2-0.7c-1.8-0.9-3.4-1.6-4.9-2.3c-26.8-12.8-53.5-25.6-80.3-38.4C200.5,178.4,199.6,178.4,198.8,178.5z
        M254.6,233.4C254.6,233.4,254.6,233.3,254.6,233.4c0-0.1,0-0.1,0.1-0.1l0.1,0.1C254.7,233.3,254.7,233.4,254.6,233.4z
        M255.7,233.1C255.7,233,255.7,233,255.7,233.1C255.7,233,255.7,233,255.7,233.1C255.7,233,255.7,233,255.7,233.1z"
      />
      <path
        class="st3"
        d="M201.5,255.7c-0.3,0.1-0.6,0.2-0.8,0.3c-0.1,0-0.3,0.1-0.4,0.2c-0.3-0.2-0.6-0.5-1-0.9c0.7-0.2,1.3-0.7,2-1.4
		c0.1-0.1,0.2-0.3,0.3-0.4c0.3-0.3,0.3-0.8,0.4-1.1l0,0c0.2-1.4-0.3-2.7-1.3-3.8c-0.5-0.5-0.4-1.1-0.2-1.7c0.2-0.6,0.4-1.1,0.6-1.7
		c0.3-0.1,1-0.2,1.1-0.4c0.1-0.4-0.1-0.8-0.2-1.3c-0.5,0.4-0.8,0.7-1.1,0.9c-0.1,0-0.2-0.1-0.2-0.1c-0.2-2-0.9-3.9-0.3-6
		c0.9,0.1,2,0.2,3.2,0.3l0,0l0,0h-0.1c1.5,0.4,1.1,1.7,1.4,2.6c0.5,0.1,1,0.4,1.3,0.3c1.2-0.4,1.7,0.1,2,0.9
		c0.1,0.2,0.7,0.4,0.3,0.7c-0.5,0.4,0.4,1.3-1.1,1.4c0.5,0.6,0.9,1.1,1.2,1.6c0.2,0.3,0.5,0.7,0.5,1.1c0,0.3-0.4,0.7-0.7,0.8
		c-0.6,0.2-0.8-0.2-0.9-0.6c-0.7,0.7-0.8,1.4-0.3,2.2c1-0.8,1.8,0.1,2.7,0c-0.2-0.2-0.4-0.4-0.8-0.7c1.1-0.4,2-0.7,3.4-1.2
		c-0.5,0.5-0.7,0.7-1,0.9c0,0,0,0.1,0.1,0.1c0.7-0.4,1.5-0.7,2.2-1.1c0,0.1,0.1,0.3,0.1,0.4c0.1,0.3,0.2,0.9,0.1,0.9
		c-0.7,0.2-0.6,1-1.2,1.2c-0.5,0.2-0.9,0.5-1.1,0.9c1.9-0.9,3.9-1.7,5.8-2.6c-0.3-0.1-0.6-0.2-0.8-0.2c0.2-0.1,0.4-0.2,0.7-0.4
		c-0.5-0.1-0.8-0.2-1.1-0.3v-0.1c0.5-0.3,1.1-0.7,1.6-1c0.1-0.1,0.4,0.2,0.7,0.4c0.2-0.1,0.4-0.1,0.5-0.2c0.6-1.2,0.3-1.2,1.9-1.3
		c0.4,0,0.7-0.1,1.1-0.2c0.2,0.3,0.3,0.6,0.5,0.9l0.1,0.1c0.4-0.2,0.9-0.4,1.3-0.6c0-0.4-0.1-0.7-0.1-1.1c0.6,0.1,0.9,0.3,1,0.7
		c0.4-0.2,0.8-0.4,1.3-0.6c-0.3-0.5-0.1-1.1,0.2-1.6c0.3-0.6,1.3-1,2.1-1.6c0.2,0,0.7,0.1,1.4,0.2c0-1,0-2,0-2.9c0.5,0,1.1,0,1.6,0
		c-0.5-0.4,0.8-0.9,0.1-1.3c0.4-0.4,0.7-0.8,1.1-1.3c0.8,0.3,1.1-0.1,1.4-0.6c1.2,0.7,0.9,1.7,0.4,2.8c-0.7,0.2-1.6,0.5-2.5,0.8
		c0-0.3,0-0.6-0.5-0.5c-0.1,0.3-0.3,0.8,0.4,0.5c0,0.2-0.1,0.5-0.1,0.7c0.1,0.8,0.3,1.3,0.6,1.7c0,0,0.1,0,0.1,0.1
		c1.4-0.6,2.9-1.3,4.3-1.9c-0.1-0.1-0.2-0.3-0.3-0.4c0.2-0.4,0.3-0.7,0.5-1.1c-0.7,0.1-1.2,0.1-1.8,0.2c0.5-0.6,0.9-1.3,1.5-1.8
		c0.7-0.5,1.6-0.9,2.3-1.3c0-0.4-0.1-0.8,0.1-1c0.1-0.2,0.6-0.1,0.9-0.2c0.6-0.1,1.1-0.2,2-0.4c0.1,0,0.4,0.2,0.8,0.5
		c0.4-0.2,0.9-0.5,1.4-0.7c-0.1-0.5-0.1-0.9-0.2-1.3c0.3,0.1,0.7,0.1,0.9,0.3c0.4,0.3,0.7,0.7,1,1c-1.6,0.4-2.9,1.2-3.9,3
		c1-0.5,1.8-0.8,2.4-1.3c1.2-0.9,1.9-1.2,3.3-1.4c1.3-0.1,1.9-0.5,2.9-2.1c0.7,0.3,1.1,0.9,2,1.1c0.8-0.3,1.5-0.7,2.3-1
		c0.3-0.7,0.6-1.3,1.7-1.7c0.7-0.2,1.3-0.8,1.9-1.3c0.6-0.6,1.1-1.3,1.7-2c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.1,0.2-0.2
		c0.4-0.3,0.9-0.2,1.4-0.2c0.1,0.5,0.1,0.9-0.5,1.1c-1.5,0.5-2.1,1.4-2.1,2.6c6.9-3.1,13.8-6.2,20.7-9.3c0.5-0.2,1-0.5,1.7-0.8
		c-1-0.5-1.8-0.9-2.6-1.3c-26.3-12.5-52.7-25-79-37.5c-0.8-0.4-1.9-0.5-2.7-0.3c-27.3,6.7-54.7,13.4-82,20.1
		c-3.9,0.9-7.7,1.9-11.9,2.9c3.4,3.6,6.6,6.9,9.8,10.2c0.2,0.2,0.7,0.3,1.1,0.3c2.3-0.5,4.3-1.2,5.6-3.6c1.9-3.8,1.7-3.2,4.4-0.6
		c0.9,0.8,1.6,1.1,2.8,0.7c7.9-2.3,15.8-4.5,23.7-6.9c1.5-0.5,2.6-0.2,3.9,0.8c11.3,8.7,22.6,17.3,34,26c0.5,0.4,0.9,0.9,1.3,1.4
		c-0.5,0.3-1,0.8-1.6,1c-13.6,5-27.2,9.9-40.7,14.8c-0.5,0.2-1,0.4-1.6,0.7c0.5,0.5,0.8,0.9,1.1,1.3c6.3,6.7,12.7,13.3,19,20
		c0.8,0.8,1.4,1,2.3,0.7c0.3-0.4,0.5-0.8,0.7-1.3c0.3-1.1-0.2-1.9-1.1-2.5c-1.1-0.8-2.3-1.5-3.5-2.3c-0.1,0-0.1-0.1-0.2-0.1
		c-0.5-0.3-0.8-0.7-0.9-1.3c-0.1-1.3-1.2-2.1-2.8-2c-1.7,0.2-2.4-0.9-3.7-1.2c0.6-0.7,0.9-1.2,1.9-1.5c0.1,0,0.1-0.1,0.2-0.1
		c0.5-0.1,0.9-0.4,1.3-0.7c0.4-0.3,0.8-0.6,1.3-0.8c1.2,0.4,1.3,1.2,1.1,2.1c-0.6,0.3-1.4-0.1-1.8,0.7c0.4,0.2,0.8,0.3,1.1,0.6
		c0.3,0.3,0.6,0.7,1.1,1.4c0.2-0.7,0.3-1.1,0.3-1.4c1-0.1,1.9-0.1,2.7,0.5c0.9,0.7,2.1,0.4,3.1-0.2c0.4-0.2,0.6-0.4,1.2-0.3
		c1.2,0.1,2.4-1,2.4-1.9c0,0,0,0,0-0.1c0-1-0.8-1.5-2-1.5c-0.2,0-0.4,0-0.6,0.1c-0.5,0.1-0.8,0.1-1.2-0.1c-1.4-0.6-2.6-0.3-3.6,0.8
		c-0.3,0.3-0.6,0.4-0.8,0c0.7-0.8,1.9-1.1,2.5-2.1c0.5-0.8,1.2-1.6,1.5-2.5c0.4-0.8,0.4-1.7,0.7-2.7c0.2-0.1,0.3-0.1,0.5-0.2
		c0.4-0.1,0.8-0.3,1.2-0.4c0,0.5-0.1,1-0.1,1.6c0.9,0.2,2.1-0.4,2.3,1.1c0,0-0.3,0.4-0.7,0.7l0,0h-0.1c-0.4-0.2-0.8-0.4-1.2-0.6
		c-0.2,0.2-0.3,0.3-0.3,0.5c-0.1,0.4,0.1,0.6,0.5,0.8l0,0c0.3,0.1,0.7,0.3,0.7,0.5c0.1,0.5,0.3,0.9,0.7,1.2l0.1,0.1
		c0.5,0.3,1.1,0.5,1.8,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.6,0.6,1.2,0.9,1.7c0.2,0.3,0.4,0.7,0.6,1c0.8,1.3,1.2,2.7,1.1,4.1
		c0,0.5,0,1,0.1,1.5c0.1,0.6,0.4,1.1,1,1.5c0.4-0.2,0.8-0.3,1.2-0.5c-0.7-0.9-1-1.9,0-3.3c0.2-0.1,0.6-0.3,1-0.5
		c2.2-0.9,2.7-1.9,2-3.8c0-0.1,0-0.2-0.1-0.4c1.4-0.9,0.6-1.9,0.4-2.9c0.6-0.6,1.1-1.1,1.6-1.6c0.4-1,0.6-2,0.2-2.9
		c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.2-0.6,0.3-1c1.3,1,2.6,1.9,4,2.9c0.5,0.4,1,0.7,1.5,1.1
		c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8c0.5,0.1,0.8,0.2,1.2,0.3c1-0.8,1.1-1.1,0.7-1.5c-0.4-0.4-0.7-0.4-2,0.2
		c-0.6-0.4-0.8-0.8,0-1.2c1-0.6,1.9-1.3,3.2-0.7c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9c0,0.8,0,1.4,0.7,1.9s1,1.2,1.1,2
		c0.1,0.9,0,1.1-0.9,1.5c-0.5,0.2-1,0.3-1.4,0.3c-1.5,0.1-1.5,0-2.1,1.2l0.1,0.1c1.1,0.9,2.1,1.2,2.9,1c-0.3,0.7-0.3,1.2-0.2,1.5
		C199.8,256.4,200.6,256,201.5,255.7L201.5,255.7z M243.7,231.8c0,0.1,0.1,0.1,0.1,0.2c-0.1,0-0.2,0-0.2,0
		C243.6,231.9,243.6,231.9,243.7,231.8z M239.8,231c0.6-1.1,1.9-1.3,3-1.9c0.2,0.7,0.3,1.4,0.5,2.3c-0.6-0.5-0.9-0.8-1.2-1
		c-0.5-0.3-1-0.1-1.1,0.4c-0.2,0.5-0.2,1.1-0.3,1.7c-0.9,0.2-1.7,0.4-2.9,0.6C238.6,232.2,239.2,231.6,239.8,231z M214,247.5h0.1
		H214L214,247.5z M203.2,204.1c1.3-0.4,2.7-0.6,4-0.6c0.5,0,1.3,0.8,1.4,1.3c0.1,0.4-0.4,1.3-0.9,1.6c-1.2,0.6-2.5,0.9-4,1.4
		c-0.7-0.5-1.7-0.9-2-1.6C201.2,205.1,202.3,204.3,203.2,204.1z M163.8,257c0.4-0.5,0.7-0.3,1-0.1C164.5,257,164.1,257,163.8,257z"
      />
      <path
        class="st3"
        d="M350.5,228.8c0-0.1-0.1-0.3-0.2-0.4c-3.6,2.2-7.3,4.3-10.9,6.5c0.2,0.5,0.4,0.9,0.6,1.4
		c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2c0.1,0.1,0.3,0.1,0.5,0.2
		c0.4,0.2,0.7,0.4,1,0.3c0.3-0.1,0.5-0.1,0.7-0.1c0.3,0,0.6,0,0.9,0.3c0.3-0.6,1.1-0.3,1.5-0.6c0.2-0.2,0.4-0.3,0.6-0.5
		c0.3-0.2,0.6-0.4,1.1-0.5c0.2,0,0.3-0.6,0.5-0.8c0.3-0.2,0.6-0.3,1-0.5c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1
		c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.4,0.6-0.7,0.6-0.9c-0.1-0.3-0.1-0.6-0.1-0.9C350.4,229.7,350.5,229.2,350.5,228.8z"
      />
      <path
        class="st3"
        d="M258.1,234.6c0.1,0.2,0.1,0.5,0.3,0.6c1,0.4,2.7-0.5,3.2-1.4v-0.1c0-0.1,0.1-0.2,0.1-0.3
		c0-0.2-0.4-0.3-0.6-0.5c0-0.2,0.1-0.3,0.2-0.5c-0.5,0.2-1,0.5-1.6,0.7c0,0,0,0,0,0.1c-0.5,0.5-1,1-1.6,1.5c0-0.3,0-0.6,0-0.9
		c-1.4,0.6-2.9,1.3-4.3,1.9v0.1c0.3,0,0.5,0,0.7,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.3-0.2,0.7-0.2,1.1
		c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.2-0.1c0.1,0,0.3-0.1,0.5-0.1c0.1,0.3,0.3,0.6,0.4,0.8c0.2,0,0.3,0,0.4,0c0.3-0.3,0.6-0.5,1-0.8
		c0.3-0.2,0.6-0.5,0.9-0.7l0,0c0.6-0.5,1-0.9,0.6-1.5l-0.1-0.1C257.5,235.1,257.9,234.8,258.1,234.6z M254.6,235.6L254.6,235.6
		C254.6,235.6,254.6,235.5,254.6,235.6C254.6,235.5,254.6,235.6,254.6,235.6z"
      />
      <path
        class="st3"
        d="M346.5,227.4c-3,1.8-6.1,3.5-9.1,5.3c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2,0,0.2,0
		c0.3,0,0.4,0,0.5,0.1s0.1,0.3-0.1,0.6c0,0.1,0.1,0.1,0.3,0.2c3.2-1.9,6.3-3.7,9.5-5.6C347.6,227.9,347.1,227.6,346.5,227.4z"
      />
      <path
        class="st3"
        d="M395.6,116.2c-2,0.3-3.8,0.5-5.7,0.8C394.1,118.1,395.3,118.4,395.6,116.2z"
      />
      <path
        class="st3"
        d="M457.7,91.2c1.5,0,2.9,0,4.3,0c0.3,0,0.7-0.2,0.9-0.4c0.7-1.2,1.2-2.5,2-4c-2.6,0-4.8,0-7.1,0
		C457.7,88.2,457.7,89.5,457.7,91.2z"
      />
      <path
        class="st3"
        d="M420.6,57c0,0.3,0.1,0.6,0.1,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1
		c0,0.1,0.1,0.2,0.1,0.2c0.7,1.1,2,1.3,3.4,1.2c0,0.2,0,0.4,0,0.6c-0.1,2-0.1,4-0.2,6.1c-1.2,0.4-2.2,1.1-2.2,2.3
		c0,1.1,0.9,1.6,2.1,1.7c0.2,1,0.4,1.8,0.6,2.7c0,0.3-0.1,0.7-0.3,1c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6
		c0.3,0.3,0.4,0.7,0.4,1.2c0,0.1,0,0.1,0,0.2c0,1.1-0.1,2.1-0.3,3.2c-0.1,0.4,0.1,0.7,0.3,1.1c0.1,0.2,0.2,0.3,0.2,0.5
		c1.3,0,2.5,0,3.8,0.1c0.1-0.2,0.1-0.5-0.2-0.7c-0.5-0.5-1-0.9-1.3-1.1c-0.2-1.2-0.4-2.2-0.6-3.3c0-0.1,0-0.2-0.1-0.3
		c-0.1-0.2-0.1-0.5-0.1-0.7c0.1-0.4,0.1-0.7,0.1-1.1c0-0.9-0.3-1.8-0.6-2.7c0-0.1,0-0.1,0-0.2c-0.1,0-0.2,0-0.3,0
		c0-0.3,0-0.5-0.1-0.8c0.1,0,0.1,0,0.2,0c-0.2-0.9,0-1.8,0.7-2.8c0.2,0,0.4,0.1,0.6,0c0.3-0.1,0.6-0.3,0.8-0.5
		c-0.2-0.3-0.4-0.6-0.7-0.7c-0.1-0.1-0.5,0.1-0.7,0.1c-0.8,0.1-1.2-0.1-1.2-0.7c-0.2-1.9-0.4-3.9-0.6-5.9c0-0.2,0-0.4-0.1-0.6
		c0.9,0.1,1.7,0.1,2.4-0.3c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.4,0.6-1,0.7-1.4c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5
		c-0.2-0.3-0.2-0.7-0.3-1.1C421.4,57.7,421.2,57.3,420.6,57z"
      />
      <path
        class="st3"
        d="M355.7,98.8c-2-1.6-3.7-3-5.5-4.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.3,0.3-0.6,0.6-0.8,1c-0.2,0.4-0.3,0.8-0.4,1.2
		c-0.2,1-0.8,1.8-1.7,2.3c-0.3,0.2-0.5,0.3-0.7,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.2,0,0.3,0C349.2,99.3,352.3,99.1,355.7,98.8z"
      />
      <path
        class="st3"
        d="M456.3,90.9c0-1,0-1.9,0-2.9c-0.1,0-0.2,0-0.2,0c-0.3,0.9-0.7,1.9-1.1,2.9C455.5,90.9,455.9,90.9,456.3,90.9z"
      />
      <path
        class="st3"
        d="M550.3,68.6c0-0.1,0-0.2,0-0.3c-0.4,0.4-0.6,0.6-1,0.8c-0.2-0.2-0.4-0.4-0.6-0.6c-2,0.6-2.1,0.6-3.4,0.5
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.8,0.8c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.4,0.2-0.6,0.3
		l0,0c-0.2,0.1-0.5,0.2-0.7,0.1c-0.9-0.1-0.9-0.2-1.9,0.2c0,0.4,0,0.8-0.1,1.2c-0.1,0-0.2,0-0.3,0c-1.4,0.1-2.6,0.6-3.9,1.4
		c0.2,0.3,0.4,0.6,0.6,0.9c0.2,0.3,0.4,0.6,0.6,0.9c0.7,0,1.5,0,2.2,0l0,0c0.1-0.2,0.3-0.3,0.7-0.2c0.1,0.1,0.2,0.2,0.2,0.3
		c1.4,0,2.8,0,4.3,0c0.6,0,1.4-0.4,1.7-0.9C547.4,72.2,548.9,70.4,550.3,68.6z M542.6,70.7c0-0.2-0.1-0.4-0.1-0.5
		C542.9,70.3,543.1,70.4,542.6,70.7z"
      />
      <path
        class="st3"
        d="M357.8,96.4c0-1.3-0.7-2.3-1.8-3.1c-1.5,0.1-3.1,0.2-4.6,0.3c2.8,1.5,4.3,5.2,8.2,4.8c0.1,0,0.2,0.2,0.5,0.3
		c-0.4,0.3-0.8,0.5-1.2,0.8c0.8,0.6,1.6,1.3,2.5,1.9c0.4-0.4,0.7-0.7,0.9-1.2c0.2-0.3,0.2-0.7,0.2-1.1c0-1.5-0.7-2.2-2.6-2.2
		c-0.6,0-1.2,0.1-1.9,0.1C357.9,96.9,357.8,96.7,357.8,96.4z"
      />
      <path
        class="st3"
        d="M250.9,146.2c-14.6,2.6-29.2,5.5-43.8,8.3c-3.1,0.6-6.2,1.2-9.4,1.8c0,0.1,0,0.3,0,0.4
		c2.3,0.4,4.1,2.2,6.8,1.6c17.4-3.7,34.9-7.2,52.3-10.8c0.6-0.1,1.1-0.3,1.7-0.4c0-0.2,0-0.4,0-0.6
		C256,146.4,253.4,145.7,250.9,146.2z"
      />
      <path
        class="st3"
        d="M467,86.9c-0.3,0-0.9,0.2-1,0.4c-0.7,1.2-1.2,2.5-1.9,3.8c0.3,0.1,0.4,0.2,0.4,0.2c13.5,0.5,27,0.9,40.6,1.4
		c0.4,0,0.9-0.2,1-0.4c0.8-1.5,1.5-3,2.2-4.5c-0.3-0.2-0.4-0.2-0.4-0.2C494.3,87.3,480.6,87.1,467,86.9z"
      />
      <path
        class="st3"
        d="M192.7,123.8c-0.1,0.2-0.1,0.5-0.2,0.7c0.2,0,0.4,0,0.6-0.1c0.1-0.4,0.3-0.8,0.5-1.2
		C193.1,123.5,192.7,123.6,192.7,123.8z"
      />
      <path
        class="st3"
        d="M508.9,89.4c-0.5,1.1-0.9,2.1-1.4,3.1C509,92.9,509.5,91.7,508.9,89.4z"
      />
      <path
        class="st3"
        d="M157,117.1c-0.4-0.3-1.1-0.4-1.7-0.4c-2.8,0.2-5.6,0.5-8.4,0.7c0,0,0,0,0,0.1c-0.8,0.2-1.2,1.4-2.5,1
		c0.3-0.3,0.5-0.6,0.8-0.9c-2.5,0.2-5,0.4-7.5,0.6c0.5,0.3,1.4,0.4,2.6,0.3l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8c1.2,0,1-1.5,2.3-1.4
		c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6c-0.5,0.8-1,1.5-1.5,2.2
		c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.4,1.6-0.6c0.3,0.8-0.7,1.6-0.7,2.5
		c0,0,0,0-0.1,0c0,0,0,0,0.1,0.1v-0.1c0.2,1.4,0.6,1.7,2.9,1.9c-1.2,0.5-1.6,1.2-1.7,2v0.1c4.7-0.5,9.4-1.1,14.2-1.7
		c1.5-0.2,3.1-0.2,4.8-0.4c-0.3-0.4-0.4-0.6-0.5-0.7C164.3,123.3,160.7,120.2,157,117.1z M151.7,127.2c0-0.1,0-0.2,0-0.3
		c0.1,0,0.1,0.1,0.2,0.1C151.8,127,151.7,127.1,151.7,127.2z"
      />
      <path
        class="st3"
        d="M477.3,188.8c-0.2,0-0.4,0-0.6,0.1c-0.5,0.1-0.8,0.1-1.2-0.1c-1.4-0.6-2.6-0.3-3.6,0.8c-0.3,0.3-0.6,0.4-0.8,0
		c0.7-0.8,1.9-1.1,2.5-2.1c0.3-0.5,0.7-1,1-1.6c-1.8,1.4-3.6,2.8-5.4,4.2c0,0.3,0,0.5-0.1,0.8c-0.4,0.2-0.9,0.1-1.3,0.3
		c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.1-0.1,0.1-0.1,0.2c0.4,0.2,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.7,1.1,1.4c0.2-0.7,0.3-1.1,0.3-1.4
		c1-0.1,1.9-0.1,2.7,0.5c0.9,0.7,2.1,0.4,3.1-0.2c0.4-0.2,0.6-0.4,1.2-0.3c1.2,0.1,2.4-1,2.4-1.9c0,0,0,0,0-0.1
		C479.2,189.3,478.5,188.8,477.3,188.8z M470,189.7c0.4-0.5,0.7-0.3,1-0.1C470.6,189.7,470.3,189.7,470,189.7z"
      />
      <path
        class="st3"
        d="M204,160.1c18.1-3.7,36.3-7.5,54.4-11.2c2.3-0.5,4.5-1,6.8-1.5c0-0.1,0-0.3,0-0.4c-0.8,0-1.5-0.1-2.3,0
		c-0.5,0.1-1,0.6-1.5,0.7c-18.1,3.8-36.2,7.4-54.2,11.3c-3,0.6-5.7,0.7-8.4-0.7c-0.4-0.2-0.9-0.3-1.3-0.4c0,0.1-0.1,0.2-0.1,0.2
		c1.3,0.6,2.6,1.2,3.9,1.7C202.1,160.1,203.1,160.3,204,160.1z"
      />
      <path
        class="st3"
        d="M437.4,101.8c-3-0.5-4.2,0.1-5.4,2.8C434.9,105.9,435.9,103.6,437.4,101.8z"
      />
      <path
        class="st3"
        d="M146,116.7c-0.8-0.5-1.4-1.1-2.4-1c-0.1,0.4-0.2,0.8-0.3,1.3c0.6-0.1,1.3-0.1,1.9-0.2
		C145.4,116.8,145.7,116.8,146,116.7L146,116.7z"
      />
      <path
        class="st3"
        d="M453.9,124.3c0.4,0,1,0,1.3-0.3c1.7-1.8,3.3-3.7,5.1-5.7c-1.6-0.2-2.8-0.4-4.1-0.6c0-0.2,0-0.4,0-0.7
		c0.4-0.1,0.8-0.3,1.2-0.3c0.8,0,1.5,0.1,2.3,0.2c1.2,0.2,2-0.1,2.8-1c3-3.5,6.1-6.9,9.1-10.3c0.4-0.4,0.7-0.8,1.1-1.4
		c-0.6-0.1-1-0.2-1.3-0.2c-9.8-0.7-19.7-1.2-29.5-2.1c-2.8-0.3-4,1.1-5.4,3.1c0.4,0.1,0.7,0.2,1,0.2c4.6,0.4,9.2,0.7,13.7,1.1
		c0.4,0,0.8,0,1.2,0.2c0.2,0.1,0.4,0.4,0.4,0.5c0,0.2-0.3,0.5-0.5,0.5c-0.6,0-1.2,0-1.8-0.1c-4.7-0.4-9.4-0.8-14.1-1.1
		c-0.6,0-1.5,0.3-1.9,0.8c-2.5,2.6-4.9,5.2-7.2,7.9c-1.6,1.8-3.2,3.7-5.1,6c5,0.5,9.6,0.9,14.1,1.4C442.1,123,448,123.7,453.9,124.3
		z M453.5,116.5c0.4,0,0.8,0.4,1.1,0.6c-0.4,0.2-0.8,0.4-1.3,0.7c-0.9-0.4-1.6-0.7-2.4-1C451.6,115.6,452.6,116.6,453.5,116.5z"
      />
      <path
        class="st3"
        d="M428.1,104.5c2.2,0.2,3.7-0.8,4.5-3.1c-1-0.1-1.9-0.2-2.9-0.2c-5.3-0.4-10.6-0.7-15.9-1.1
		c-2.8-0.2-3.3,0-4.9,2.8c0.5,0.1,1,0.2,1.5,0.2C416.3,103.6,422.2,104,428.1,104.5z"
      />
      <path
        class="st3"
        d="M444.6,34.2c-0.1-0.2-0.3-0.6-0.4-1c-0.1,0-0.2,0-0.3,0c0,0.2-0.2,0.6-0.1,0.7c1,0.5,0.8,1.4,0.8,2.2
		c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0.1,0.8,0.2,1.6,0.3,2.4c-0.4,0.2-0.8,0.2-1.1-0.3c-0.3-0.7-0.9-1-1.9-0.8
		c-0.6,0.8,0,1.4,0.5,2.1c-0.3,0.3-0.6,0.6-1,1c0.3,0.3,0.5,0.6,0.9,1c1.2-1.1,1.4-1.2,2.6-0.7c1.7,0.6,1.7,0.6,3.5,0.2
		c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7
		c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5
		c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1c0.5-0.6,1-1.1,1.5-1.7c-0.8-0.5-1.4-1.1-2.4-1
		c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.1-0.9,0.1-1.3c0.1-0.2-0.1-0.6-0.2-1.1
		c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.3-1.2-0.4c0.2-0.4,0.5-0.8,0.5-1.2
		s-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6
		c0.5,0.1,0.6,0.3,0.6,0.6s-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1c-0.1-0.1-0.2-0.1-0.3-0.1c-0.8-0.3-1.4,0-2,0.8
		c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8c0,0.3,0,0.6,0.1,0.9c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8
		c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6
		c-0.5,0.8-1,1.5-1.5,2.2c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.4,1.6-0.6
		c0.3,0.8-0.7,1.6-0.7,2.5c0,0,0,0-0.1,0c0,0,0,0,0.1,0.1v-0.1c0.2,1.4,0.6,1.7,2.9,1.9c-1.2,0.5-1.6,1.2-1.7,2c0,0.3,0,0.6,0,1
		c0.1,0.5-0.2,1-0.3,1.4c-0.5,0.1-0.9,0.2-1.5,0.3c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3c0.3-0.5,0.6-0.8,0.8-1.2
		c0,0,0-0.1,0.1-0.1l0,0c0.9-0.1,1.9,0.5,2.8-0.3c0.1-0.4,0.2-0.9,0.3-1.4c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1
		c-0.3,0.5-0.5,0.9-0.7,1.2c0.2-0.1,0.3-0.1,0.5-0.2l0,0c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0
		c-0.1,0-0.2,0-0.2-0.1c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.5-0.6,1.1-1.1,1.8c0.1,0.1,0.1,0.3,0.2,0.5
		s0.2,0.4,0.4,0.6c0.3,0.4,0.7,0.8,0.7,1.3c0.1,0.7,0.7,1.1,1.5,1c1.3-0.2,1.7,0.5,2.3,1.3c0.3-0.1,0.6-0.2,0.9-0.3
		c0.1,0.1,0.2,0.2,0.1,0.2c-0.5,0.6-0.9,1.2-0.8,1.9c9.1,0.1,18.1,0.2,27.2,0.3c0.7,0,1.5-0.5,2-1c2.4-2.9,4.6-5.9,6.9-8.8
		c0.2-0.3,0.8-0.3,1.2-0.5c-0.1,0.4-0.1,0.9-0.3,1.2c-0.7,1-1.4,1.9-2.1,2.8c-1.6,2-3.1,4.1-4.8,6.3c0.5,0.1,0.7,0.1,0.8,0.1
		c11.4,0.1,22.8,0.2,34.2,0.3c0.5-0.3,1-0.7,1.2-1.3c0.2-0.5,0.2-1.2,0.1-1.6c-0.1-0.4-0.4-0.7-0.8-1c-0.3-0.2-0.7-0.3-1.1-0.4
		c-0.6-0.1-1.3-0.1-2,0.1c-0.2-0.6-0.6-1.1,0-1.6c-0.5-0.1-1-0.1-1.6-0.2c0.1-0.4,0.2-0.8,0.3-1.2c0.3-1,0.5-2,1.2-2.9
		c0,0,0.1,0,0.1,0.1c1.3,0.6,2.5,1.1,4,0.4c0.7-0.3,1.4-0.8,1.8-1.3l0.1-0.1c0.4-0.6,0.6-1.2,0.4-1.8c-0.2-0.7-0.8-1.4-1.8-2.1
		c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.8c0.6,1.4,1.7,2.4,3.4,2.5c0.2,0,0.4,0,0.6,0
		c2-0.1,3.3-1.1,4.3-2.6c0.2,0.1,0.4,0.2,0.6,0.3l0,0c1,0.1,1.9,0.1,2.9,0.1c0.7,0,1.2,0,1.7,0.2c0.1-0.5,0.2-0.9,0.4-1.4
		c0.2-0.6-0.2-0.9-0.8-1.2c-1.2-0.6-2.3,0.1-3.5,0.3c-0.2,0.3-0.4,0.7-0.5,1c-0.7-0.9-1.3-1.9-2.1-2.6c-0.4-0.3-0.9-0.5-1.4-0.7
		c-0.4-0.1-0.8-0.2-1.1-0.4c0.2-0.4,0.4-0.9,0.6-1.4c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.5-0.3l0,0
		c0.1,0,0.2-0.1,0.3-0.1c1-0.3,1.9-0.9,2.5-1.6c0.4-0.5,0.7-1,0.8-1.7l0,0c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.3,0-0.4
		c0-1-0.5-1.8-1.3-2.5l0,0c-0.3-0.3-0.7-0.5-1.1-0.6c-0.2-0.1-0.3-0.1-0.5-0.2c-1.9-0.6-4.2,0.1-5.5,1.5c-0.3,0.3-0.5,0.6-0.7,0.9
		c-0.5,0.7-1.2,1.2-2.1,1.4c0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.3,0.3,0.4,0.4c0.2,0,0.4-0.2,0.9-0.5c0.1,0.4,0.2,0.8,0.4,1.3
		c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1,0c-1.1,0-2,0.2-2.8,0.5c-0.8,0.4-1.4,0.9-1.8,1.6l-0.1,0.1c-0.3,0.7-0.5,1.5-0.3,2.4
		c0,0.2,0.2,0.4,0.2,0.6c0,0.4-0.6,0.7-0.9,0.5c-0.5-0.3-1-0.7-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1
		c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4c0.1-0.1-0.2-0.3-0.3-0.6c-0.6,0.3-1.1,0.8-1.6,1c-0.3,0.1-0.7,0.1-1.1,0v-0.1
		c0-1.3-0.5-2.4-2.1-2.9s-2.9,0.2-4,1.1c-0.2,0.2-0.4,0.3-0.6,0.5c0,0.4-0.1,0.9-0.1,1.4c-0.3-0.1-0.5-0.1-0.8-0.2
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1-1.4,1.5c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2c-0.5,0.3-1,0.6-1.5,0.8
		c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.9-0.6c-0.2-0.1-2.2,0.5-2.3,0.6c-0.4,0.6-0.1,1.3,0.8,1.9
		l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.4c0,0,0,0,0-0.1c0,0,0,0,0.1,0
		c0.2,0.1,0.5,0.1,0.6,0.2c-0.3,0.9-0.5,1.7-0.8,2.7c-0.2,0.1-0.4,0.1-0.6,0.2c-0.8,0.3-1.5,0.6-1.8,1.5c-1-0.1-2-0.1-3-0.6
		s-2-0.1-2.5,0.9c-0.2,0.4-0.3,0.9-0.5,1.3c-0.3,0.5-0.7,1-1.1,1.6c-0.4-1.6-0.4-1.8,1.2-6c-0.4,0.3-0.8,0.4-0.9,0.6
		c-0.2,0.5-0.2,1-0.4,1.5c-0.2,0.5-0.6,1-0.9,1.7c-0.3-0.5-0.5-0.8-0.8-1.2c-0.6,1.5-0.7,2.8,0,4c-0.2,0.2-0.4,0.5-0.7,0.6
		c-0.4,0.3-0.8,0.5-1.2,0.6c-0.8,0.2-1.3-0.1-1.8-1.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0
		c0.4-0.4,0.5-0.7,0-1s-1-0.1-1.3,0.5c-0.7,1.2-1.7,1.6-3.4,1.1c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8c-0.1-0.3-0.2-0.7-0.3-1
		c-0.2-0.4-0.8-0.5-1.2-0.1c0,0,0,0-0.1,0.1c-0.3,0.3-0.6,0.6-0.8,0.9c-0.3-0.2-0.6-0.4-1.1-0.8c-0.3,0.8-0.5,1.4-0.2,2
		c0.4,0.7,0.7,1.4-0.6,1.9c-0.1,0.9-0.7,1.4-1.4,1.9c-0.6,0.4-1.2,0.7-1.6,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.8
		c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.8,0.2-1.6,0.3-2.4c-0.5,0-0.9,0-1.2,0c0.1-0.2,0.1-0.4,0.2-0.5
		c0.3-0.2,0.7-0.3,1-0.5c-0.4-0.2-0.7-0.4-1.3-0.7c-0.2,1-0.8,1.4-1.8,1.6c-0.3,0.1-0.7,0.1-1.1,0.2c0.5-0.5,0.8-0.7,1-0.9
		c-0.3-0.1-0.6-0.2-1.2-0.3c0.7-0.2,1-0.3,1.3-0.5c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.3,1.3-0.7,1.4-1.5c0.1-0.4,0.4-0.7,0.8-1.2
		c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1c-1,0.4-1.7,0.7-2.4,1c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3,0-0.6c0.1-0.3,0.2-0.7,0.2-1.1c0.1-0.5,0.2-0.9,0.7-1.3
		c-0.2-1.1,1-2.3,0-3.3c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.1-0.2-0.2-0.5c-0.9,0.6-2,1-1.9,2.2c-0.9-0.1-1.4-0.9-2.4-0.6
		c-0.3,0.1-1-0.4-1-0.7c-0.1-0.8-0.9-1-1.5-1.4c0.2-0.3,0.4-0.7,0.7-1.2c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1
		c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.1-0.7-0.3-0.9-0.4c-0.2-0.1-0.6-0.1-0.6-0.2c-0.1-0.8-0.8-0.9-1.5-1.1
		c-0.1,0-0.2-0.1-0.4-0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.5,0.5-1.1,1.1-2.2,0.4c0.5-0.6,1-1.3,1.6-2c-0.1-0.2-0.2-0.6-0.3-0.9
		c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6c0.2-0.6,0.4-1.1,0.6-1.5c-0.7-0.5-1,0.3-1.5,0.4l0,0c0,0.1,0,0.3,0,0.4
		c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.5-0.3-0.9-0.6-1.4-0.9c-0.2,0.1-0.4,0.1-0.6,0.2c-0.5,0.1-0.9,0.3-1.5,0.4c0-0.8,0-1.5-0.1-2.2
		c-0.2-0.9-1.1-0.9-2-0.9c0.6-0.8,0.7-1.6,0.5-2.4c-0.7-0.6-1.3-0.1-2,0c-0.2-0.2-0.4-0.5-0.6-0.7c-1.5,0.3-2.4-0.1-3.2-1.2
		c-0.5-0.7-1.5-1.1-2.4-1.6c-0.1,0.5-0.2,1-0.3,1.5C446.2,35,445.5,34.6,444.6,34.2z M541.2,57.6c0,0.1,0,0.1,0,0.2
		c-0.1,0-0.1-0.1-0.2-0.1C541.1,57.7,541.1,57.6,541.2,57.6z M475.8,53c0.1-0.1,0.2-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2
		c-0.1,0.1-0.2,0.2-0.3,0.3l-0.3-0.1C475.6,53.2,475.7,53.1,475.8,53z M457.8,59.5c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.1,0.2-0.2,0.2
		C457.8,59.8,457.8,59.6,457.8,59.5z M457.7,62L457.7,62L457.7,62L457.7,62z"
      />
      <path
        class="st3"
        d="M487.7,128c0.7,0.1,1.6-0.4,2-0.9c5.9-6.4,11.7-12.9,17.6-19.4c0.2-0.3,0.4-0.6,0.7-1
		c-0.3-0.1-0.5-0.2-0.6-0.2c-10.8-0.7-21.5-1.5-32.3-2.2c-0.5,0-1.2,0.4-1.5,0.7c-3.3,3.6-6.5,7.3-9.8,11c-0.3,0.3-0.5,0.7-0.9,1.2
		c2.7,0.2,5.2,0.5,7.6,0.7c1.9,0.2,3.8,0.3,5.6,0.5c0.4,0,0.7,0.4,1.1,0.6c-0.4,0.2-0.8,0.4-1.2,0.5c-0.1,0-0.3,0-0.5,0
		c-4.2-0.4-8.4-0.7-12.7-1.1c-0.5,0-1.2-0.1-1.4,0.2c-1.7,1.8-3.3,3.7-5.2,5.7c0.6,0.1,0.8,0.2,1,0.2
		C467.5,125.8,477.6,126.9,487.7,128z"
      />
      <path
        class="st3"
        d="M419.2,120.6c0.7,0.1,1.7-0.3,2.2-0.9c3.9-4.2,7.6-8.5,11.4-12.7c0.2-0.2,0.3-0.5,0.5-0.8
		c-1.7-0.5-3-0.5-4.1,1.1c-0.5,0.8-1.3,1.5-2.1,2.2c-0.2,0.2-0.6,0.3-0.9,0.4c-0.1-0.1-0.2-0.3-0.3-0.4c0.9-1.2,1.8-2.4,2.8-3.7
		c-0.3-0.1-0.4-0.2-0.5-0.2c-6.6-0.5-13.2-1.1-19.9-1.5c-0.5,0-1.3,0.4-1.6,0.8c-3,3.5-6,7.1-8.9,10.7c-0.6,0.7-1.3,1.5-2.2,2.5
		c2.5,0.2,4.5,0.3,6.5,0.5C408,119.4,413.6,120.1,419.2,120.6z"
      />
      <path
        class="st3"
        d="M553.7,95.6c-0.5,0-1-0.1-1.5-0.1c-15.2-0.5-30.3-1-45.5-1.5c-20.9-0.7-41.9-1.5-62.8-2.2
		c-0.5,0-0.9,0.2-1.4,0.3c0,0.1,0,0.3,0.1,0.4c0.2,0,0.5,0.1,0.7,0.1c17.4,0.7,34.7,1.4,52.1,2c12.4,0.5,24.7,1,37.1,1.4
		c6.5,0.3,13.1,0.5,19.6,0.7c0.6,0,1.2-0.4,1.8-0.6C553.8,96,553.7,95.8,553.7,95.6z"
      />
      <path
        class="st3"
        d="M507,121.2c8.6,0.7,17.2,1.5,25.8,2.3c1,0.1,1.6-0.1,2.2-0.9c5.4-7.6,10.8-15.3,16.2-22.9c0.3-0.5,0.6-1,1-1.6
		c-0.5-0.1-0.7-0.2-1-0.2c-10.5-0.4-20.9-0.8-31.4-1.2c-0.6,0-1.3,0.4-1.7,0.8c-2.2,2.3-4.3,4.7-6.4,7c-0.2,0.2-0.4,0.5-0.6,0.9
		c1.1,0.2,2.1,0.4,3,0.6c0,0.2,0,0.5-0.1,0.7c-0.8,0-1.7,0.1-2.5,0c-1.2-0.2-2,0.1-2.8,1c-5.8,6.5-11.7,13-17.5,19.5
		c-0.2,0.3-0.4,0.6-0.7,1c12.4,1.3,24.5,2.6,36.7,3.9c0.3,0,0.8,0,1-0.2c1.7-2.3,3.4-4.7,5.2-7.3c-9.6-0.9-18.8-1.7-28.1-2.5
		c0-0.3,0-0.6,0-0.8C505.9,121.3,506.4,121.1,507,121.2z M516.3,106.3c1-0.6,2.2-0.2,3.2,0c0,0,0,0.9-0.1,0.9
		c-1.1,0-2.1-0.1-3.2-0.1C516.2,106.8,516.3,106.6,516.3,106.3z"
      />
      <path
        class="st3"
        d="M475.7,102.9c0.2,0.2,0.2,0.3,0.3,0.3c10.8,0.8,21.7,1.5,32.5,2.3c0.4,0,1-0.1,1.2-0.4
		c2.5-2.7,4.9-5.3,7.5-8.3c-0.7-0.1-1-0.1-1.3-0.1c-9.3-0.4-18.6-0.4-27.9-1.2c-4.5-0.4-7.5,0.9-9.8,4.4
		C477.6,100.9,476.6,101.9,475.7,102.9z"
      />
      <path
        class="st3"
        d="M555.2,93.9c1.3-1.7,2.5-3.5,3.8-5.3c-0.4-0.1-0.5-0.2-0.7-0.2c-12.5-0.2-24.9-0.4-37.4-0.6
		c-0.4,0-0.9,0.1-1.1,0.3c-1,1.6-1.9,3.2-2.9,4.8c0.4,0.1,0.5,0.2,0.6,0.2c12.1,0.4,24.3,0.8,36.4,1.2
		C554.4,94.4,555,94.2,555.2,93.9z"
      />
      <path
        class="st3"
        d="M515.7,92.6c0.9-1.5,1.8-3,3-5c-2.7,0-5,0-7.3,0c-0.3,0-0.8,0.4-0.8,0.6c-0.2,1.5-0.4,3-0.5,4.6
		c1.7,0.1,3.2,0.2,4.7,0.2C515.1,93,515.6,92.8,515.7,92.6z"
      />
      <path
        class="st3"
        d="M446.9,93.9c-0.3,0-0.8,0.1-1,0.3c-1.9,2-3.7,4.1-5.8,6.4c1.7,0.1,3,0.2,4.3,0.3c9.4,0.7,18.8,1.3,28.3,1.9
		c0.5,0,1.2,0,1.4-0.3c2.2-2.3,4.3-4.7,6.5-7.2c-0.4-0.1-0.5-0.2-0.6-0.2C469,94.8,458,94.3,446.9,93.9z"
      />
      <path
        class="st3"
        d="M433.1,100.2c0.4,0,0.9,0,1.1-0.3c1.8-2,3.5-4,5.5-6.3c-7.6-0.3-14.8-0.6-22-0.8c-0.4,0-0.8,0.2-1.1,0.4
		c-1.5,1.7-2.9,3.4-4.4,5.3c0.3,0.1,0.4,0.2,0.5,0.2C419.5,99.2,426.3,99.7,433.1,100.2z"
      />
      <path
        class="st3"
        d="M441,94.1c-1.9,1.8-3.6,4-5.5,6.1c1.8,0.4,3.1,0.6,4.3-1c1.4-1.8,3-3.5,4.6-5.2c-0.1-0.1-0.2-0.3-0.2-0.4
		C443.1,93.8,441.7,93.5,441,94.1z"
      />
      <path
        class="st3"
        d="M453.4,216.5c1.7-0.2,3.3-0.3,5-0.5c0.1,0.7,0.1,1.5,0.2,2.2c6.9-1.2,13.8-2.4,20.7-3.7
		c-0.8-0.8-2-1.3-3.4-1.3c-0.6,0-1.2,0.1-1.8,0.1c0.2-1,0.6-2.1,0.5-3c-0.1-0.6-1-1.2-1.7-1.6c-1.3-0.8-2.7-0.9-4.2-0.2
		c-0.1,0-0.2,0.1-0.3,0.1c-1.8,0.9-2.4,2.1-2.3,3.5c0,0.4,0,0.7,0.1,1.1c-0.9-0.3-1.7-0.5-2.5-0.7c0.1-0.5,0.3-1,0.4-1.6
		s0.3-1.1,0.4-1.7c1.4-0.1,2.6-0.5,3.5-1.4c0.3-0.4,0.6-0.7,0.7-1.1c0.2-0.6,0.2-1.2,0.1-1.8c1.6-0.4,3.1-0.7,4.6-1.1
		c1.3-0.4,2-1.3,2.3-2.4c0.3-1.1-0.2-1.9-1.1-2.5c-1.1-0.8-2.3-1.5-3.5-2.3c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-0.8-0.7-0.9-1.3
		c-0.1-1.3-1.2-2.1-2.8-2c-0.6,0.1-1-0.1-1.4-0.2c-1.8,1.4-3.6,2.8-5.4,4.2c0,0.1,0.1,0.3,0.1,0.4c-0.3,0.1-0.6,0.1-0.9,0.2
		c-1,0.8-2,1.6-3,2.3c-0.1,0.3-0.1,0.6-0.1,0.9c0.1,1.2,1.4,2.1,2.9,2.2c1.6,0.1,3-0.8,3.5-2.2c0.1-0.3,0.2-0.7,0.3-1.1
		c0.6-0.1,0.9,0.1,0.9,0.6c0,0.8,0.1,1.5,0.1,2.4c-1.3,0.5-2.5,1.3-3,2.8c-0.4-0.5-0.7-0.8-1-1.1c-0.1,0-0.3-0.1-0.4,0
		c-1.7,0.6-2.9,0.4-3.8-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-0.5-0.6-1.2-0.9-2-1c-1.5,1.2-3.1,2.4-4.6,3.6c0.1,0.4,0.2,0.8,0.5,1.1
		c0.2,0.3,0.5,0.5,0.8,0.8c-0.4,1.4-1,2.9-0.7,4.4c0.1,0.4,0.2,0.7,0.4,1.1c-1.4,0.7-2.5,1.7-2.1,3.2c0.3,0.9,1,1.5,2.1,1.6
		C451.6,218.4,452.7,217.6,453.4,216.5z"
      />
      <path
        class="st3"
        d="M133.9,109.9c1.2-1.1,1.4-1.2,2.6-0.7c1.7,0.6,1.7,0.6,3.5,0.2c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2
		c-0.5,0.4-0.8,0.6-1.3,1c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8
		c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5c-0.2,0-0.4-0.1-0.7-0.2c-0.4,0.9,0.3,1.5,0.7,2.1
		c2.9-0.3,5.8-0.6,8.9-0.9c-3.7-3.2-7.1-6.1-10.4-9.1c-0.8-0.7-1.6-1-2.7-1c-2,0.1-4.1,0.2-6.1,0.4c0,0.3,0.1,0.6,0.1,0.9
		c-0.4,0.2-0.8,0.2-1.1-0.3c-0.1-0.2-0.2-0.4-0.4-0.5c-0.6,0-1.1,0.1-1.7,0.1c-0.2,0.6,0.3,1.1,0.7,1.7c-0.3,0.3-0.6,0.6-1,1
		C133.3,109.2,133.6,109.5,133.9,109.9z"
      />
      <path
        class="st3"
        d="M401.5,104.8c-0.2-1.9-0.1-3.8-0.1-5.7c-0.3-0.1-0.6,0.1-0.8,0.5c-0.2,0.5-0.5,0.7-0.9,0.1
		c-1.7,2.2-3.5,4.5-5.2,6.7c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.3,0,0.6-0.2,0.9c-0.3,0.4-0.8,0.8-1.2,1.2c-0.1,0.1-0.2,0.2-0.3,0.3
		c0.5,0.7,0.4,1.5,0.5,2.3c-0.3,0.1-0.6,0.1-1,0.2c0-0.3,0-0.5,0-0.7c-0.7-0.2-1.2-0.3-1.6-0.2c-1.1,1.5-2.3,2.9-3.4,4.4
		c0.7-0.1,1.3,0,1.8,0.5l0,0c0,0,0,0,0.1,0.1h-0.1c0,0,0,0-0.1,0c-0.8,0.2-1.8-0.2-2.6,0.4l0,0l0,0c2.9-0.4,5.3-0.7,7.8-1
		c1.6-0.1,2.6-0.8,3.7-1.9C400.9,110.9,401.9,108.2,401.5,104.8z M392.8,113.3c-0.3-0.7,0.9-1.1,1-1.8c0.6,0.3,1.3,0.6,1.3,1.4
		C394.3,113,393.6,113.2,392.8,113.3z"
      />
      <path
        class="st3"
        d="M452.9,219.3c1.8-0.3,3.6-0.6,5.4-1c-0.4-0.1-0.8-0.2-1.1-0.3C455.6,217.8,454,218.3,452.9,219.3z"
      />
      <path
        class="st3"
        d="M575.1,103.2c-6-0.2-12-0.4-18.4-0.7c0,4.1,0,8,0,12.2c6.2-3.8,12.3-7.5,18.4-11.2
		C575.2,103.4,575.1,103.3,575.1,103.2z"
      />
      <path
        class="st3"
        d="M138.4,101.5c0-0.1-0.1-0.2-0.2-0.4c-0.2,0-0.5,0-0.7,0l0,0c1,0.5,0.8,1.4,0.8,2.2c-1.5,0.7-2.9,0.1-4.4,0.4
		c0.8,0.3,1.6,0.5,2.3,0.7c0,0.1,0,0.2,0,0.3c3.6-0.2,7.1-0.4,10.7-0.6c-0.1-0.1-0.2-0.2-0.3-0.3c-1.5,0.3-2.4-0.1-3.2-1.2
		c-0.5-0.7-1.5-1.1-2.4-1.6c-0.1,0.5-0.2,1-0.3,1.5C140,102.3,139.3,101.9,138.4,101.5z"
      />
      <path
        class="st3"
        d="M540.3,124.7c4.8-2.9,9.6-5.8,14.3-8.8c0.3-0.2,0.7-0.6,0.7-0.9c0-3.3,0-6.7,0-10.2
		c-5.2,6.6-10.2,13.1-15.3,19.6C540.1,124.5,540.2,124.6,540.3,124.7z"
      />
      <path
        class="st3"
        d="M114.4,124.3c0,0.3,0.1,0.6,0.1,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1
		c0,0.1,0.1,0.2,0.1,0.2c0.7,1.1,2,1.3,3.4,1.2c0,0.2,0,0.4,0,0.6c0,0.8,0,1.5-0.1,2.3c0.3,0,0.6-0.1,1-0.1c-0.1-0.7-0.1-1.3-0.2-2
		c0-0.2,0-0.4-0.1-0.6c0.9,0.1,1.7,0.1,2.4-0.3c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.4,0.6-1,0.7-1.4c0-0.5-0.1-0.9-0.5-1.2
		c-0.6-0.5-1.6-0.6-3.2-0.5c-0.2-0.3-0.2-0.7-0.3-1.1C115.2,125,115,124.6,114.4,124.3z"
      />
      <path
        class="st3"
        d="M146.3,105.5c-0.1,0.1-0.1,0.3-0.2,0.4c3.4,2.9,6.7,5.9,10.1,8.8c0.4,0.3,0.9,0.5,1.4,0.7
		c0.4-0.5,0.7-0.9,1.2-1.4c-0.1-0.2-0.2-0.6-0.3-0.9c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6c0.2-0.6,0.4-1.1,0.6-1.5
		c-0.7-0.5-1,0.3-1.5,0.4l0,0c0,0.1,0,0.3,0,0.4c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.5-0.3-0.9-0.6-1.4-0.9c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.5,0.1-0.9,0.3-1.5,0.4c0-0.8,0-1.5-0.1-2.2c-0.2-0.9-1.1-0.9-2-0.9c0.4-0.6,0.6-1.1,0.6-1.7
		C148.4,105.4,147.3,105.4,146.3,105.5z"
      />
      <path
        class="st3"
        d="M137,116.8c0,0.3,0.1,0.5,0.2,0.7c1.9-0.2,3.8-0.3,5.7-0.5c-0.1-0.2-0.2-0.3-0.2-0.5c-0.1-0.4-0.1-0.9,0.1-1.3
		c0.1-0.2-0.1-0.6-0.2-1.1c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.3-1.2-0.4
		c0.2-0.4,0.5-0.8,0.5-1.2c0-0.4-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2,0.2-0.6,0.4-0.7,0.7
		c-0.1,0.2,0.1,0.6,0.2,0.6c0.5,0.1,0.6,0.3,0.6,0.6c0,0.3-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1c-0.1-0.1-0.2-0.1-0.3-0.1
		c-0.8-0.3-1.4,0-2,0.8c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8C136.9,116.3,136.9,116.5,137,116.8z"
      />
      <path
        class="st3"
        d="M178.9,130c-0.1,0.9-0.7,1.4-1.4,1.9c-0.3,0.2-0.7,0.4-1,0.7c1.6,1.4,3.1,2.8,4.7,4.2c1,1,2,1.3,3.4,1.1
		c10.5-1.4,21-2.8,31.4-4.2c1.1-0.1,2.2-0.3,3.3-0.5c0.2-0.5,0.4-0.9,0.8-1.4c0,0,0.1,0,0.1,0.1c1.3,0.6,2.5,1.1,4,0.4
		c0.7-0.3,1.4-0.8,1.8-1.3l0.1-0.1c0.4-0.6,0.6-1.2,0.4-1.8c-0.2-0.7-0.8-1.4-1.8-2.1c-0.1-0.1-0.2-0.1-0.3-0.2
		c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.8c0.6,1.4,1.7,2.4,3.4,2.5c0.2,0,0.4,0,0.6,0c1.9-0.1,3.2-1.1,4.2-2.4
		c-1.7-1.4-3.3-2.8-4.9-4.2c-0.2-0.2-0.6-0.3-0.8-0.3c-1.1,0-2.1,0.1-3.2,0.2c-4,0.5-7.9,1-11.9,1.4c-3.8,0.4-7.6,0.8-11.4,1.2v0.1
		c-0.2,0.1-0.4,0.1-0.6,0.2c-0.8,0.3-1.5,0.6-1.8,1.5c-1-0.1-2-0.1-3-0.6s-2-0.1-2.5,0.9c-0.2,0.4-0.3,0.9-0.5,1.3
		c-0.3,0.5-0.7,1-1.1,1.6c-0.4-1.3-0.4-1.7,0.5-4.1c-0.2,0-0.4,0-0.5,0.1c0,0.1,0,0.1,0,0.2c-0.2,0.5-0.6,1-0.9,1.7
		c-0.3-0.5-0.5-0.8-0.8-1.2c-0.6,1.5-0.7,2.8,0,4c-0.2,0.2-0.4,0.5-0.7,0.6c-0.4,0.3-0.8,0.5-1.2,0.6c-0.8,0.2-1.3-0.1-1.8-1.1
		c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0c0.4-0.4,0.5-0.7,0-1s-1-0.1-1.3,0.5
		c-0.7,1.2-1.7,1.6-3.4,1.1c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8s-0.1-0.6-0.3-0.9c-0.6,0.1-1.1,0.1-1.6,0.2
		c-0.2,0.2-0.4,0.4-0.5,0.6c-0.1-0.1-0.4-0.3-0.6-0.4c-0.2,0-0.4,0-0.7,0.1c-0.2,0.6-0.3,1.1,0,1.5
		C179.9,128.8,180.1,129.5,178.9,130z"
      />
      <path
        class="st3"
        d="M170.1,126.6c0.4,0.1,0.9,0.1,1.3,0.1c0.9-0.1,1.8-0.2,2.8-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.4,0.4-0.7,0.8-1.2
		c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1c-1,0.4-1.7,0.7-2.4,1c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		C170.8,126.4,170.5,126.5,170.1,126.6z"
      />
      <path
        class="st3"
        d="M388.8,111.9c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3,0.2-0.5,0.4-0.5,0.7c-0.1,0.5-0.3,0.6-0.8,0.9
		c-0.6,0.3-0.7,0.9-0.6,1.5C387.1,114.1,388,113,388.8,111.9z"
      />
      <path
        class="st3"
        d="M51.6,163.7c0.1-1.4-0.8-2.4-2-3.2c-1.2-0.9-2.7-0.5-4,0c-1.3,0.4-2.2,1.2-2.7,2.1c-0.2,0.4-0.3,0.8-0.4,1.2
		c-0.2,1-0.7,1.7-1.6,2.3c0.7,1.2,1.5,2.3,2.2,3.5c0.8,1.4,1.7,1.7,3.3,1.4c2.6-0.4,5.2-0.9,7.8-1.3c0.6-0.7,1.4-1.2,1.8-2
		c0.2-0.3,0.2-0.7,0.2-1.1c0-1.5-0.7-2.2-2.6-2.2c-0.6,0-1.2,0.1-1.9,0.1C51.7,164.2,51.6,164,51.6,163.7z"
      />
      <path
        class="st3"
        d="M449.5,204.2c0.6-0.5,1.3-1,1.9-1.5c-0.3,0.1-0.6,0.2-0.8,0.3C450.1,203.3,449.7,203.7,449.5,204.2z"
      />
      <path
        class="st3"
        d="M2,297.7c1-0.4,1.2-1.2,1.2-2c0.7-0.3,1.3-0.6,2-1c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1
		c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4c0.2-0.9,1.1-1,1.8-1.2c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6
		c0.9-0.7,1.8-0.6,2.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0.2,1,0.5,2.1,0.7,3.2c0,0.2,0.1,0.4,0.1,0.6c-0.1,0.1-0.2,0.2-0.4,0.4
		c-0.1,0.1-0.3,0.3-0.3,0.5c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2
		c0.2,0,0.4-0.1,0.6-0.1c0,0.1,0,0.1,0,0.2c0.1,0.5,0.1,1,0.4,1.4C17,280,12.9,260.6,8.8,241.3c-2.4-11.1-4.7-22.2-7.1-33.4
		c-0.7-0.2-1.3-0.4-1.7-0.8v2.5v2.1v0.7v3v82.1C0.5,297.8,1.1,298.1,2,297.7z"
      />
      <path
        class="st3"
        d="M204.1,120.9c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.9-0.6
		c-0.2-0.1-2.2,0.5-2.3,0.6c-0.4,0.6-0.1,1.3,0.8,1.9l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.4
		c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.2,0.1,0.5,0.1,0.6,0.2c-0.2,0.6-0.4,1.3-0.6,1.9c6-0.6,12-1.3,18-2h-0.1c-0.5-0.3-1-0.7-1.4-1
		c-0.1-0.1-0.2-0.1-0.3-0.2s-0.3-0.2-0.4-0.3l-0.1-0.1c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4c0.1-0.1-0.2-0.3-0.3-0.6
		c-0.6,0.3-1.1,0.8-1.6,1c-0.3,0.1-0.7,0.1-1.1,0v-0.1c0-1.3-0.5-2.4-2.1-2.9s-2.9,0.2-4,1.1c-0.2,0.2-0.4,0.3-0.6,0.5
		c0,0.4-0.1,0.9-0.1,1.4c-0.3-0.1-0.5-0.1-0.8-0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1-1.4,1.5c-0.2-0.1-0.4-0.1-0.5-0.2
		c-0.2-0.1-0.4-0.1-0.5-0.2C205.1,120.4,204.6,120.6,204.1,120.9z"
      />
      <path
        class="st3"
        d="M536.8,201.2C536.9,201.2,536.9,201.2,536.8,201.2C536.9,201.1,536.9,201.1,536.8,201.2L536.8,201.2z"
      />
      <path
        class="st3"
        d="M612,20.1c-1.4,0.3-2.6,1.4-3.6,3c-0.3-0.3-0.6-0.6-0.9-0.9c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.3,0.4-0.1,0.6,0.7,1.2c0.2-0.1,0.4-0.2,0.7-0.4l0,0c0.1,0.3,0.1,0.6,0.2,1.1c-0.4,0.1-0.7,0.1-1,0.1c-2.2,0-4.4,2.1-3.9,4.2
		c0.1,0.3,0.2,0.6,0.4,0.8c0.6,0.9,1.5,1.4,2.7,1.5c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0v0.1c0,0.5-0.1,1-0.1,1.5
		c0,0.1,0,0.2,0,0.3c-0.4,0-0.7,0.1-1.1,0.1c-0.2,0-0.4,0-0.5,0c-0.5,0.1-0.9,0.2-1.3,0.4c-2,0.9-2.9,3-2,4.5
		c0.1,0.2,0.2,0.4,0.3,0.6c-0.4-0.1-0.7-0.2-1.1-0.3c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5c-0.4,1.1,0.1,2.2,1.2,2.7
		c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.9-0.9,0.5-1.8,0.3-2.7c1.3,0.3,2.6,0.7,4.4,0.2c-0.6,1.4-0.3,2.5,0.3,3.5
		c0.3,0.1,0.6,0.2,0.9,0.3c0.9,0.4,1.9,0.5,2.9,0.3v-4v-3.2v-4.3v-1v-1.7v-6.5V22v-1.4L612,20.1C612.1,20.1,612,20.1,612,20.1z"
      />
      <path
        class="st3"
        d="M411.9,233.6c1.6-1.2,3.2-2.5,4.8-3.7c-0.8-0.6-1.8-0.7-2.9-0.4c-0.5,0.1-0.9,0.3-1.3,0.4
		c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4c-0.2,0.5-0.6,1-0.7,1.6c-0.1,0.5,0.2,1.1,0.3,1.5c-0.7,0.4-1.2,0.6-1.7,0.9
		c-0.9,0.7-1.7,1.4-2.6,2.1c-0.5,0.4-0.4,1.1,0.2,1.2c0.1-0.1,0.2-0.1,0.3-0.2c1.7-1.3,3.4-2.7,5.1-4c-0.1,0-0.2,0-0.3,0
		c0.2-0.4,0.3-0.7,0.6-1.2C411.6,233.3,411.8,233.4,411.9,233.6z"
      />
      <path
        class="st3"
        d="M415.9,237.3c-0.1,0-0.1,0-0.2,0.1c-0.4,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.4,0.2-0.7,0.2
		c0.1-0.2,0.1-0.3,0.1-0.5c0.2-1.1-0.4-2-1.2-2.7c0,0-0.1,0-0.1-0.1c-1.8,1.4-3.7,2.9-5.5,4.3c0.3,0.2,0.5,0.4,0.8,0.6
		c0.5,0.4,1,0.6,1.5,0.7c0.7,0.1,1.4,0,2.2-0.2c0.3-0.1,0.6-0.2,1-0.4c0,0.6,0,1.1,0.1,1.6c0.3,1.4,1.8,2.3,3.4,2.2
		c0.3,0,0.7,0,1-0.1c1.8-0.4,3-1.8,3-3.4c0-0.1,0-0.2,0-0.4C419.8,237.9,418,236.9,415.9,237.3z"
      />
      <path
        class="st3"
        d="M414,234.6c1.2,0.1,2.2-0.3,2.9-1c0.1-0.1,0.3-0.3,0.4-0.4c0.6-0.8,0.6-1.6,0.2-2.4c-1.6,1.2-3.1,2.4-4.7,3.7
		h0.1C413.3,234.5,413.6,234.6,414,234.6z"
      />
      <path
        class="st3"
        d="M386.5,251.6c-0.4,0.2-0.6,0.5-0.8,0.7c-0.5,0.6-0.5,1.3,0,1.8c1-0.7,1.9-1.5,2.8-2.2c0,0,0-0.1-0.1-0.1
		C388,251.3,387.1,251.3,386.5,251.6z"
      />
      <path
        class="st3"
        d="M393,254c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.4,0-2.1,0c-1.1,0.9-2.3,1.8-3.4,2.7
		c-0.6,0.6-0.5,0.9,0.1,1.9c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1c0-0.1,0-0.2,0-0.3
		c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6c0.7-0.3,0.5-0.8,0.4-1.2C393.2,254.9,393.1,254.5,393,254z"
      />
      <path
        class="st3"
        d="M476.6,203.8c-2.4,0.6-3.5,2-3.1,4c0.3,1.8,2.5,2.8,4.6,2.3c2.2-0.5,3.6-2.3,3.2-4.1c0-0.2-0.1-0.3-0.2-0.5
		s-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.5c-0.6-0.5-1.3-0.8-2.1-0.9C477.7,203.6,477.1,203.6,476.6,203.8z"
      />
      <path
        class="st3"
        d="M485.9,211.1c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.1,0.5,0.4,0.9,0.8,1.3
		c2.1-0.4,4.1-0.7,6.2-1.1c0.1-0.2,0.2-0.3,0.2-0.5c0.1-0.4,0.1-0.8,0.1-1.2C486.1,211.6,486,211.3,485.9,211.1z"
      />
      <path
        class="st3"
        d="M483.2,215.5c0.5-0.1,0.9-0.3,1.3-0.5c-1,0.2-1.9,0.3-2.9,0.5C482.1,215.6,482.6,215.6,483.2,215.5z"
      />
      <path
        class="st3"
        d="M408.3,241.1c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.1,0-0.2,0.1-0.3,0.2c-1.1,0.9-2.2,1.7-3.3,2.6c0.2,0,0.3,0.1,0.5,0.1
		s0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1
		c0.8-0.8,1.5-1.5,2.2-2.2c0.4,0.2,0.8,0.4,1.2,0.5c1.2,0.4,2.1,0.3,2.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.1-0.2,0.2-0.3
		c0,0,0-0.1,0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3s0-0.3-0.1-0.4C408.6,241.6,408.5,241.3,408.3,241.1z"
      />
      <path
        class="st3"
        d="M398.8,242.7c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.1,0.4-0.1,0.7,0.1,1
		c0.8-0.7,1.7-1.3,2.5-2l-0.1-0.1C399.6,242.6,399.2,242.6,398.8,242.7z"
      />
      <path
        class="st3"
        d="M482.5,196.8c0.1-0.3,0.1-0.7,0-1.1c-0.2-0.9-1.1-1.6-2.2-1.8c-0.5-0.1-1.1-0.1-1.7,0
		c-1.4,0.3-2.3,1.3-2.5,2.3c-0.1,0.3-0.1,0.6,0,0.9c0.2,1.1,1.1,1.8,2.3,2c0.5,0.1,1,0.1,1.5,0C481.2,198.8,482.2,197.9,482.5,196.8
		z"
      />
      <path
        class="st3"
        d="M454.2,270c-1.4,0.2-2.4,1.1-2.6,2.1h5.9c0-0.1,0-0.2,0-0.3C457.3,270.6,455.8,269.7,454.2,270z"
      />
      <path
        class="st3"
        d="M552.1,169.4c-0.5,0.9-1,1.8-1.6,2.7c1,0,1.7-0.7,2.5-1.2c0.1,0.5,0.3,1,0.7,1.3c0.2,0.1,0.5,0.2,0.8,0.3
		c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.3,1-0.5c0.1,0.3,0.1,0.5,0.1,0.7c1.1-0.2,1.8-0.4,2.2-0.7s0.5-0.8,0.4-1.6
		c-0.6-0.1-1.2-0.1-1.8-0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.5,0-0.7,0c-0.8,0.1-1.5,0.4-2.4,1.1
		C553.1,170,552.5,169.8,552.1,169.4z"
      />
      <path
        class="st3"
        d="M551,168.9c-0.4,0-0.9,0.1-1.3,0.2c-0.7,0.2-1.3,0.6-1.9,0.8c0.2,0.9,0.6,1.5,1.4,1.9
		C549.9,170.9,550.5,169.9,551,168.9z"
      />
      <path
        class="st3"
        d="M539,227.6c0.6-1.2-0.1-2.4-1.5-2.8c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6
		c-0.1-0.2-0.4-0.4-0.7-0.4s-0.7,0-1,0.2c-0.2,0.1-0.2,0.5-0.2,0.7l0,0c0.1,0.3,0.4,0.6,0.6,0.9c-0.2,0.4-0.4,0.8-0.5,1.2
		c-0.3,1.3,0.5,2.3,2,2.6C537.1,229.5,538.5,228.8,539,227.6z"
      />
      <path
        class="st3"
        d="M492.3,189.1c1.1,0.4,2.6,0,3.4-0.8s1-2,0.4-2.9c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9
		c-0.1,0.4-0.3,0.8-0.4,1.2C490.5,187.7,491.1,188.7,492.3,189.1z"
      />
      <path
        class="st3"
        d="M500.5,190.5c-0.1-0.4-0.7-0.8-1.2-1c-0.9-0.3-1.8-0.4-2.7-0.6c-0.8-0.1-1.5,0.1-2,0.7
		c-0.6,0.6-0.5,1.3-0.2,1.9c0.3,0.5,1,0.7,1.9,0.5c0.4-0.1,0.8-0.2,1.3-0.3c0.3,0.4,0.5,0.8,0.8,1.2c0.4,0,0.8-0.1,1.1-0.1
		c0.3,0,0.7,0.2,1.1,0.4c0.4-0.5,0.8-1,1.2-1.6C501.2,191.4,500.7,191.1,500.5,190.5z"
      />
      <path
        class="st3"
        d="M529.9,224.9c-0.2-0.4-0.5-0.8-1.1-1.1c-0.4,0.4-0.6,0.8-0.6,1.1c-0.1,0.6,0.4,1.2,0.8,1.7
		C529.2,226.1,529.6,225.5,529.9,224.9z"
      />
      <path
        class="st3"
        d="M532.1,227.2c-0.2-0.1-0.5-0.3-0.7-0.3c-0.3-0.1-0.7-0.1-1.1-0.2c-0.5,0.9-0.9,1.7-1.4,2.6
		c0.2,0.2,0.4,0.4,0.6,0.6c0.5,0.4,1.1,0.8,1.6,1.2c0,0,0.1,0,0.1,0.1c0.8,0.1,1.3-0.3,1.6-0.9c0.1-0.1,0.1-0.2,0.2-0.4
		C533.4,228.9,533,227.8,532.1,227.2z"
      />
      <path
        class="st3"
        d="M528.1,228.2c0.2-0.3,0.3-0.6,0.5-0.9c-0.2,0.2-0.4,0.4-0.6,0.6C528,228,528.1,228.1,528.1,228.2z"
      />
      <path
        class="st3"
        d="M402.8,240.1c0.2-0.4,0.2-0.7,0.2-1.1c-0.2-1.2-1.6-2-3.1-1.7s-2.5,1.4-2.4,2.7c0,0.3,0.2,0.6,0.3,0.9
		c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1C401.7,241.4,402.5,240.8,402.8,240.1z"
      />
      <path
        class="st3"
        d="M494.2,196.5c-0.4-1.1-1.5-1.6-2.8-1.5c-1,0.1-2,0.9-2.3,1.7c-0.4,1,0.1,2,1.1,2.5c1.1,0.5,2.2,0.3,3.2-0.5
		c0.5-0.4,1-0.8,1.7-1.3C494.2,197.5,494.4,196.9,494.2,196.5z"
      />
      <path
        class="st3"
        d="M399,233.2c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1c0.7-0.7,0.8-1.9,0.2-2.7c-1.6,0.3-3.2,0.6-4.8,0.8
		c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.6,0,1.2,0.5,1.7c0.3,0.3,0.6,0.5,1,0.6C397.8,233.4,398.4,233.4,399,233.2z"
      />
      <path
        class="st3"
        d="M394.3,246.8c-0.6-1.5-1.3-1.9-2.8-1.6c-0.3,0.1-0.6,0.2-1,0.4c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5
		c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9c0.5,0.2,1,0.2,1.7-0.1c0.9-0.7,1.8-1.4,2.7-2.1
		C395,246.7,394.6,246.7,394.3,246.8z"
      />
      <path
        class="st3"
        d="M396.8,247c-0.7,0.5-1.4,1.1-2.1,1.6c0.7,0.4,1.2,0.4,1.7,0C397.1,248.2,397.2,247.5,396.8,247z"
      />
      <path
        class="st3"
        d="M579.7,179.8c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5c-0.2-1.2-1.6-2-3-1.7c-0.1,0-0.1,0-0.1,0
		c-1.2,0.3-2.1,1.3-2,2.4c0,0.1,0,0.1,0,0.2c0.1,0.9,1,1.6,2,1.7c0.3,0,0.7,0,1,0c0.2,0,0.5-0.1,0.7-0.2
		C579,180.9,579.5,180.4,579.7,179.8z"
      />
      <path
        class="st3"
        d="M310.7,243.6c-0.4,0.1-0.8,0.3-1.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.6,0.7-0.7,1.2
		c-0.1,0.2-0.1,0.5,0,0.7c0,0.1,0,0.1,0.1,0.2c0.1,0.5,0.5,0.8,0.9,1.1c1.4-0.8,2.7-1.6,4.1-2.4C313.3,244,312,243.3,310.7,243.6z"
      />
      <path
        class="st3"
        d="M311.4,247.8c0.5-0.1,0.9-0.3,1.2-0.5c0.1-0.1,0.3-0.2,0.4-0.3s0.1-0.2,0.2-0.3
		C312.6,247.1,312,247.5,311.4,247.8L311.4,247.8z"
      />
      <path
        class="st3"
        d="M394.5,227.3c-0.2-0.6-1-1-1.7-1.1c-0.8,0.6-1.7,1.2-2.5,1.8v0.1c0,0.1,0,0.2,0,0.2c0,0.1,0,0.3,0.1,0.4
		c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.6,0.3,0.9,0.3c0.1,0,0.3,0,0.4,0c1.3-0.2,2.6-0.5,3.8-0.7
		c0-0.1,0.1-0.1,0.1-0.2c-0.6-0.2-1.1-0.3-1.6-0.4C394.7,228.1,394.7,227.7,394.5,227.3z"
      />
      <path
        class="st3"
        d="M555.5,197.6c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C555,198.3,555.3,198,555.5,197.6z"
      />
      <path
        class="st3"
        d="M513.4,201.7c-0.5-0.7-0.1-1.2,0.2-1.8c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9
		c-0.9,0.1-1.4,0.6-2,1.2c0.2,0.5,0.3,0.9,0.5,1.3c0.2,0.4,0.4,0.8,0.7,1.2c0.2,0.3,0.6,0.5,0.9,0.5
		C512.3,203.3,513.7,202.1,513.4,201.7z"
      />
      <path
        class="st3"
        d="M414.1,244.4c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3
		c0.3,1.1,1.5,1.6,2.8,1.3c1.2-0.3,1.9-1.3,1.7-2.3C414.4,244.9,414.3,244.6,414.1,244.4z"
      />
      <path
        class="st3"
        d="M555.9,215.1c0.5-0.2,1-0.4,1.5-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.6-0.5,0.8-1.2,0.6-1.8
		c-0.1-0.4-0.4-0.7-0.9-0.9c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7C554.6,215.4,555.3,215.4,555.9,215.1z"
      />
      <path
        class="st3"
        d="M316.5,238.7c-0.4-0.2-1-0.3-1.5-0.2c-1.3,0.2-2.1,1.3-1.9,2.4c0.2,1,1.3,1.6,2.5,1.3c0.6-0.1,1.2-0.4,1.5-0.8
		c0.3-0.4,0.5-0.9,0.4-1.4C317.5,239.5,317.1,239,316.5,238.7z"
      />
      <path
        class="st3"
        d="M584.4,201.2c0.2,0,0.5,0,0.7,0c-0.1-1-0.4-1.7-1-2.1c-0.2-0.2-0.4-0.3-0.7-0.4c-0.1,0-0.3-0.1-0.4-0.1
		c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.4,0,2.7-0.1,4.2-0.1
		C583.7,201.2,584.1,201.2,584.4,201.2z"
      />
      <path
        class="st3"
        d="M309.6,239.2c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.3-1-1.4-1.6-2.6-1.3c-0.8,0.2-1.4,0.7-1.7,1.4
		c-0.1,0.3-0.2,0.7-0.1,1v0.1C307.4,238.9,308.4,239.4,309.6,239.2z"
      />
      <path
        class="st3"
        d="M508.9,194c-0.2-0.3-0.5-0.6-0.8-0.9c-1.4,1.1-2.7,2.3-1.7,3.9v0.1C507.3,196,508.1,195,508.9,194z"
      />
      <path
        class="st3"
        d="M508.1,198.9c0.6-0.2,0.6-0.6,0.5-1.1c0-0.4-0.2-0.9,0-1.2c0.4-0.5,0.6-0.9,0.7-1.3c-0.8,1-1.6,2-2.5,3.1
		C507.1,198.8,507.5,199.1,508.1,198.9z"
      />
      <path
        class="st3"
        d="M321.2,234.5L321.2,234.5v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.7c-0.1,0.1-0.1,0.3-0.2,0.4
		c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9s0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4
		c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3s0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6
		C321.4,235.7,321.5,235,321.2,234.5z"
      />
      <path
        class="st3"
        d="M471.1,236.5c-1.2,0.3-1.9,1.4-1.6,2.4c0.3,0.9,1.4,1.4,2.5,1.1c0.6-0.7,1.1-1.4,1.7-2.1c0-0.1,0-0.1,0-0.2
		C473.4,236.8,472.1,236.2,471.1,236.5z"
      />
      <path
        class="st3"
        d="M601.7,187.1L601.7,187.1c0.6-0.1,1.1-0.4,1.4-0.7c0.4-0.4,0.6-0.9,0.5-1.5c-0.2-0.9-1.2-1.5-2.4-1.3
		c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0.3-1.4,1.1-1.3,2c0,0.2,0.1,0.3,0.1,0.4C599.9,186.8,600.8,187.3,601.7,187.1z"
      />
      <path
        class="st3"
        d="M563,182.6L563,182.6c-0.1-0.2-0.3-0.3-0.4-0.4c-0.3-0.3-0.6-0.5-1-0.7c-0.1,0-0.2-0.1-0.3-0.1
		c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7
		c0.2,0.1,0.4,0.2,0.6,0.3c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.5-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.3l0.1-0.1
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.2-0.1-0.2-0.2C563.3,182.9,563.2,182.8,563,182.6z"
      />
      <path
        class="st3"
        d="M501.2,183.5c0.2,0,0.4,0.1,0.5,0.2l0,0c0.3,0.2,0.5,0.3,0.7,0.3s0.4-0.2,0.7-0.8c-0.1-0.1-0.2-0.1-0.3-0.2
		l0,0c-0.1-0.1-0.3-0.2-0.4-0.3c0.4-1.3,0.3-1.8-0.5-2.2c-0.9-0.5-1.8-0.2-2.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		C498.5,183,498.8,183.4,501.2,183.5z"
      />
      <path
        class="st3"
        d="M589.5,181.9c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5s-0.8-0.2-1.3-0.1c-0.3,1.2-0.6,2.4-0.8,3.5
		c-0.1,0.4,0.4,0.9,0.9,0.6c0.9-0.4,1.8-0.9,2.6-1.5C589.9,183,589.9,182.3,589.5,181.9z"
      />
      <path
        class="st3"
        d="M553.8,177.3c0.2-0.2,0.5-0.3,0.7-0.5s0.4-0.3,0.6-0.5c-0.3-0.7-0.5-1.5-0.8-2.1c0-0.1-0.1-0.2-0.1-0.2
		c-0.2-0.4-0.6-0.8-1.2-0.7c-0.1,0-0.1,0-0.2,0c-0.3,0.3-0.5,0.6-0.7,0.9c-0.4,0.6-0.5,1.3-0.8,2c-0.2,0.6,0.3,1,0.9,1.4
		C552.8,177.8,553.3,177.6,553.8,177.3z"
      />
      <path
        class="st3"
        d="M566.5,189.6L566.5,189.6c0.6-0.1,1-0.5,1.3-0.9s0.4-0.8,0.3-1.1l0,0c-0.2-0.9-1.3-1.5-2.4-1.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0.2-1,0.5-1.2,0.9c-0.1,0.3-0.2,0.6-0.1,1c0,0.2,0.1,0.3,0.2,0.4
		C564.7,189.5,565.6,189.9,566.5,189.6z"
      />
      <path
        class="st3"
        d="M550.7,186.9c0,0.1,0,0.2,0,0.3l0,0c0.3,0.3,0.6,0.5,1,0.7c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2h0.1
		c0.6-0.2,1.1-0.3,1.7-0.4c0.6-0.2,1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6,0.1c-0.5-1-0.6-1.1-1.5-1.3
		c0,0,0,0-0.1,0s-0.2,0-0.4-0.1c-0.3,0-0.5-0.2-0.7-0.3c-0.7-0.6-1.3-0.3-2,0.1c0.1,0.5,0.3,1,0.6,1.3
		C550.6,186.9,550.7,186.9,550.7,186.9z"
      />
      <path
        class="st3"
        d="M347.4,265c-1.1,0.3-1.8,1.2-1.5,2c0.2,0.8,1.2,1.3,2.2,1.1c1.1-0.2,1.9-1.1,1.7-2
		C349.5,265.2,348.5,264.7,347.4,265z"
      />
      <path
        class="st3"
        d="M342.8,271c-0.8,0.1-1.4,0.6-1.6,1.1h3.7C344.8,271.4,343.8,270.8,342.8,271z"
      />
      <path
        class="st3"
        d="M446.2,208.7c-0.2,0-0.4,0-0.6,0c-0.7,0.5-1.4,1.1-2,1.6c0,0.1,0,0.2,0,0.3c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C447.2,209.3,446.8,208.9,446.2,208.7z"
      />
      <path
        class="st3"
        d="M325.4,238.2c0.5-0.3,1.1-0.6,1.6-0.9c-0.4-0.5-1.1-0.8-1.9-0.6c-1,0.2-1.7,1.1-1.5,1.9c0,0.2,0.1,0.4,0.2,0.5
		C324.4,238.8,324.9,238.5,325.4,238.2z"
      />
      <path
        class="st3"
        d="M325.8,239.7c0.7-0.2,1.2-0.6,1.4-1.1c-0.7,0.4-1.3,0.8-2,1.1C325.4,239.8,325.6,239.7,325.8,239.7z"
      />
      <path
        class="st3"
        d="M314.6,230.8c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C315.2,231.3,315,231,314.6,230.8z"
      />
      <path
        class="st3"
        d="M482.4,222.5c-0.2-0.8-1.2-1.3-2.2-1c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0.2,0.8,1.2,1.3,2.2,1.1
		c0.5-0.1,0.9-0.4,1.2-0.8c0.1-0.1,0.2-0.3,0.2-0.4C482.4,223,482.5,222.8,482.4,222.5L482.4,222.5z"
      />
      <path
        class="st3"
        d="M582.6,188.3c0.1,0.8,1,1.3,1.9,1.2c1-0.2,1.9-1.2,1.7-2c-0.1-0.7-1.4-1.2-2.3-1
		C583,186.8,582.4,187.5,582.6,188.3z"
      />
      <path
        class="st3"
        d="M531.3,210.5c-0.1-0.4-0.5-0.8-0.4-1.1c0.4-0.8-0.1-1.1-0.5-1.5c-0.3,0.1-0.4,0.2-0.6,0.3
		c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.3,0.1,0.6,0.1,0.8c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.6-0.7,1.2-1,1.7c0.4,0.6,0.7,0.6,1.9,0.7
		C531,211.5,531.5,211.1,531.3,210.5z"
      />
      <path
        class="st3"
        d="M526.8,233.8c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.8-0.8,1.5-1.2,2.3c0.2,0.2,0.4,0.4,0.6,0.5
		c0.9-0.4,1.6-0.8,2.3-1.1c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.4-0.4,0.4-0.8c-0.4-0.2-0.8-0.5-1.3-0.7
		C527.5,233.7,527.1,233.7,526.8,233.8z"
      />
      <path
        class="st3"
        d="M579.1,197.4c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5s-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C578.4,197,578.7,197.3,579.1,197.4z"
      />
      <path
        class="st3"
        d="M592.6,220.8c0-0.2-0.2-0.4-0.3-0.6c-0.4-0.3-0.9-0.5-1.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.2,0.9-1.1,1.5
		c0.1,0.8,0.9,1.3,1.8,1.1C591.9,222.4,592.7,221.6,592.6,220.8z"
      />
      <path
        class="st3"
        d="M517.7,247.9c-0.1,0-0.1,0-0.2,0c-0.8,0-1.5,0-2.3,0.1c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0
		c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8c0.3,0,0.6-0.1,0.9-0.2C517.2,248.8,517.5,248.4,517.7,247.9z"
      />
      <path
        class="st3"
        d="M518.7,248.4c0.2-0.1,0.3-0.2,0.5-0.4c-0.1,0-0.2,0-0.3,0C518.8,248.1,518.8,248.2,518.7,248.4z"
      />
      <path
        class="st3"
        d="M584.5,222.1c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.2,0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9c0.2,0,0.5,0.1,0.8,0
		c0.9-0.2,1.4-1,1.3-1.7C586.2,222.3,585.4,221.9,584.5,222.1z"
      />
      <path
        class="st3"
        d="M417.8,247.4c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C419.6,247.6,418.7,247.1,417.8,247.4z"
      />
      <path
        class="st3"
        d="M517.9,249.8c-0.4,0.7-0.7,1.3-1.1,2c0.3,0.5,1,0.8,1.7,0.6c0.9-0.2,1.4-1,1.3-1.7
		C519.6,249.9,518.8,249.6,517.9,249.8z"
      />
      <path
        class="st3"
        d="M602.2,189.6c-0.8,0-1.6,0.3-2,1.2c0.3,0.3,0.5,0.7,0.8,0.9c0.6,0.4,1.2,0.3,1.9-0.1c0.5-0.3,0.8-0.6,0.7-1.2
		C603.5,189.9,603,189.6,602.2,189.6z"
      />
      <path
        class="st3"
        d="M544.1,187.7c0,0,0,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.2,0.3,0.3,0.5,0.3c0.3,0.1,0.6,0.1,0.9-0.1
		c0.7-0.3,0.8-0.8,0.7-1.4c-0.1-0.2-0.3-0.5-0.5-0.7c-0.5-0.5-1.3-0.6-1.9-0.1C543.8,186.8,543.7,187.2,544.1,187.7z"
      />
      <path
        class="st3"
        d="M317.9,228c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C316.3,227.8,317,228.2,317.9,228z"
      />
      <path
        class="st3"
        d="M306.7,269.4c-0.2,0-0.4,0-0.5,0v2.4c0.1,0,0.3,0,0.4,0h0.1c0.8-0.2,1.3-0.9,1.1-1.5
		C307.7,269.8,307.2,269.5,306.7,269.4z"
      />
      <path
        class="st3"
        d="M306.2,258.1v1.6c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.3-0.1c0.5-0.3,0.9-0.9,0.8-1.3c-0.1-0.3-0.3-0.5-0.6-0.7
		c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.1-0.7-0.1v0.7H306.2z"
      />
      <path
        class="st3"
        d="M565.8,190.2c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5C566.5,190.2,566.1,190.1,565.8,190.2z"
      />
      <path
        class="st3"
        d="M324,269.6C323.9,269.6,323.9,269.6,324,269.6c-0.2,0.1-0.4,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8
		c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3c0.6-0.2,1-0.4,1.2-0.7C324.6,271,324.5,270.4,324,269.6L324,269.6z"
      />
      <path
        class="st3"
        d="M584.5,218.4c-1.4,0.1-2.6,0.3-4,0.4c0.7,1.2,1.1,1.5,2.2,1.3C583.7,219.9,584.3,219.4,584.5,218.4z"
      />
      <path
        class="st3"
        d="M592.9,225.1c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7s1.1-0.8,1-1.3
		C594.3,225.3,593.5,225,592.9,225.1z"
      />
      <path
        class="st3"
        d="M518.5,238c-0.7,0.1-1.2,0.7-1.2,1.3c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0s0.5-0.2,0.7-0.4
		c0.3-0.2,0.4-0.6,0.3-0.9C519.8,238.2,519.2,237.9,518.5,238z"
      />
      <path
        class="st3"
        d="M322,242.6c-0.9-0.3-1.5,0.1-2,0.6c0,0.6,0.2,1.1,0.8,1.3c0.6-0.4,1.2-0.7,1.9-1.1
		C322.6,243,322.4,242.7,322,242.6z"
      />
      <path
        class="st3"
        d="M522.5,245c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		S522.9,244.8,522.5,245z"
      />
      <path
        class="st3"
        d="M489.4,206.7c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.1,0,0.2-0.1,0.3-0.2
		c0.5-0.3,0.7-0.7,0.6-1.2S490.1,206.5,489.4,206.7z"
      />
      <path
        class="st3"
        d="M567.3,201.5C567.2,201.5,567.2,201.5,567.3,201.5c-0.2,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.2,0.8,0.1,1.3
		c0.3,0.4,0.8,0.6,1.4,0.3c0.4-0.2,0.7-0.4,1.2-0.7c-0.2-0.3-0.3-0.4-0.4-0.6C568.8,201.4,567.9,201.2,567.3,201.5z"
      />
      <path
        class="st3"
        d="M589.5,198.6c0-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.5-0.1-0.7,0
		c-0.4,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.5-0.1,0.8c0.2,0.5,0.8,0.8,1.4,0.7c0.5-0.1,1-0.6,1-1
		C589.5,198.8,589.5,198.7,589.5,198.6z"
      />
      <path
        class="st3"
        d="M464.1,242c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.8,0.9,1.5,0.7c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C465.6,242.2,464.8,241.9,464.1,242z"
      />
      <path
        class="st3"
        d="M503.1,198.5c-0.4,0.5-0.7,1.1-1.1,1.6c-0.4,0.1-0.8,0.2-1.3,0.3c0.3,0.5,0.6,0.9,0.9,1.5
		c0.8-0.9,1.5-1.5,2-2.2C504.1,199.1,504.1,198.7,503.1,198.5z"
      />
      <path
        class="st3"
        d="M525.2,204c-0.4-0.8-0.9-1.5-0.9-2.3c0-0.2-0.4-0.4-0.7-0.7c0.2,1.3,0.2,1.3-0.6,2.6c0.1,0.1,0.1,0.1,0.1,0.2
		c0.8,0.9,0.9,0.9,2.2,0.5C525.3,204.2,525.3,204.1,525.2,204z"
      />
      <path
        class="st3"
        d="M390.8,251.7c0.2,0.4,0.7,0.6,1.3,0.5c0.6-0.1,1.1-0.6,1-1.1c0-0.3-0.3-0.6-0.6-0.8
		C392,250.8,391.4,251.2,390.8,251.7z"
      />
      <path
        class="st3"
        d="M611.5,218.4c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.5,0.8,0.8,1.4,0.7c0.1,0,0.2,0,0.3-0.1v-1.9
		C611.9,218.4,611.7,218.4,611.5,218.4z"
      />
      <path
        class="st3"
        d="M519,202.5c0-0.1-0.6-0.1-0.9-0.1c-0.2,0.7-0.3,1.5,0.6,1.9c0.3-0.2,0.7-0.5,0.8-0.4c0.8,0.5,1-0.1,1.1-0.5
		c0.1-0.3-0.1-0.6-0.1-0.8C519.8,202.5,519.3,203.3,519,202.5z"
      />
      <path
        class="st3"
        d="M495.9,181.5c-0.6,0.3-0.7,0.8-0.6,1.2c0.1,0.5,0.3,1,1.2,0.8c0.3-0.7,0.6-1.4,0.9-2
		C496.9,180.7,496.4,181.2,495.9,181.5z"
      />
      <path
        class="st3"
        d="M539.8,218.1c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C540.6,217.9,540.1,217.9,539.8,218.1z"
      />
      <path
        class="st3"
        d="M539.5,205.3c-0.8,0.1-1.6,0.3-2.3,0.4c0.2,0.3,0.4,0.6,0.6,0.8c0.5,0,0.9,0,1.2,0
		C539.7,206.1,539.7,205.7,539.5,205.3z"
      />
      <path
        class="st3"
        d="M396.4,242.2c0.4-0.3,0.6-0.8,0.5-1.5c-0.5,0.2-0.9,0.3-1.3,0.5c-0.3,0.1-0.5,0.2-0.8,0.4
		c-0.3,0.1-0.5,0.3-0.7,0.5l0,0c0.4,0.7,1,0.8,1.7,0.5C396.1,242.5,396.3,242.4,396.4,242.2z"
      />
      <path
        class="st3"
        d="M474,233.8c-0.3-0.5-0.6-0.8-1-1.3c-0.5,0.5-0.8,0.9-1.2,1.2c0.3,0.5,0.5,0.9,0.9,1.6
		C473.3,234.7,473.7,234.2,474,233.8z"
      />
      <path
        class="st3"
        d="M554.9,253.8c0.2,0.8,0.6,1.5,0.8,2.3c0.1-1.3,0.2-2.6,0.3-4C554.9,252.9,554.7,253.1,554.9,253.8z"
      />
      <path
        class="st3"
        d="M535.7,204.4c-0.5,0-0.9,0-1.3-0.1c0.1-0.2,0.2-0.4,0.5-0.8c-0.5,0.2-0.8,0.3-1.1,0.4l0,0l0,0
		c0.1,0.3,0.3,0.6,0.4,0.9c0.5-0.1,1-0.2,1.4-0.2C535.6,204.6,535.6,204.5,535.7,204.4z"
      />
      <path
        class="st3"
        d="M535.4,206.5c0-0.2,0-0.3,0-0.4c-0.1,0-0.2,0-0.4,0.1C535.2,206.2,535.3,206.3,535.4,206.5z"
      />
      <path
        class="st3"
        d="M507.6,192.3c-0.5-0.1-0.8-0.3-1.1-0.3c-0.6-0.1-0.9,0.3-1.1,0.7s-0.1,0.8,0.3,0.9c0.4,0.1,0.9,0,1.3-0.2
		C507.3,193.1,507.4,192.7,507.6,192.3z"
      />
      <path
        class="st3"
        d="M509.6,176c0.3-0.4,0.6-0.8,0.9-1.2c-0.4-0.1-0.9,0.2-0.9-0.3c-0.6,0.1-1.1,0.2-1.7,0.4
		C508.3,175.7,508.3,175.7,509.6,176z"
      />
      <path
        class="st3"
        d="M380.9,259.5c0,0.1,0,0.1,0,0.2c1-0.6,1.8-1.1,2.7-1.6c-0.2-0.1-0.4-0.1-0.6-0.2
		C382.3,258.4,381.6,258.9,380.9,259.5z"
      />
      <path
        class="st3"
        d="M334.1,269.4c1.5-0.5,1.7-0.8,1.2-1.9C334.1,268.2,334.1,268.2,334.1,269.4z"
      />
      <path
        class="st3"
        d="M516.4,200.9c-0.1,0.1-0.3,0.4-0.2,0.5c0.1,0.8,0.7,1.1,1.8,0.9c-0.2-0.5-0.5-1-0.8-1.5
		C517.1,200.8,516.7,200.8,516.4,200.9z"
      />
      <path
        class="st3"
        d="M523,228.3c0.6-0.1,0.9-0.4,0.9-0.8c0-0.6-0.5-0.9-1.1-0.8c-0.6,0.1-0.9,0.4-0.9,0.9
		C522,228.1,522.4,228.4,523,228.3z"
      />
      <path
        class="st3"
        d="M523.9,211c-0.2-0.2-0.4-0.3-0.8-0.5c-0.4,0.9-0.4,1.4,0.2,1.7c0.2,0.1,0.6,0.3,1,0.4
		C524.4,212,524.4,211.4,523.9,211z"
      />
      <path
        class="st3"
        d="M557.8,215.9c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C557.9,215.8,557.9,215.8,557.8,215.9z"
      />
      <path
        class="st3"
        d="M538.3,230.9c-0.3,0.5-0.5,0.8-0.6,1.1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3c0.2,0.2,0.7,0.3,1,0.2
		c0.6-0.1,0.9-0.5,0.7-0.9C539.4,231.5,538.9,231.3,538.3,230.9z"
      />
      <path
        class="st3"
        d="M531.4,205.5c0.4-0.1,0.7-0.1,1.1-0.2c-0.3-0.1-0.5-0.2-0.8-0.3C531.5,205.2,531.5,205.3,531.4,205.5z"
      />
      <path
        class="st3"
        d="M533.6,206.4c-0.2,0-0.3,0.1-0.5,0.1c0.1,0,0.2,0.1,0.3,0.1C533.4,206.5,533.5,206.5,533.6,206.4z"
      />
      <path
        class="st3"
        d="M500.3,187.6L500.3,187.6c-0.2-0.2-0.5-0.3-0.7-0.3h-0.1c-0.3,0.1-0.6,0.5-0.6,0.7c0,0.4,0.2,0.8,0.6,1
		c0.4,0.3,0.9,0,1.3-0.5C500.6,188.2,500.5,187.9,500.3,187.6z"
      />
      <path
        class="st3"
        d="M443.7,216.2c0.1,0.9,0.1,0.9,0.8,1.3c0.6-0.2,1.2-0.6,0.9-1.2C445.1,215.9,444.5,215.9,443.7,216.2z"
      />
      <path
        class="st3"
        d="M542.3,213.6c-0.3-0.5-0.6-1-0.9-1.5c-0.6,0.1-1.1,0.2-1.8,0.4C540.7,212.8,540.8,214.1,542.3,213.6z"
      />
      <path
        class="st3"
        d="M422.2,242.7c-0.3,0.2-0.6,0.5-0.7,0.8c-0.1,0.4,0.5,0.7,1,0.6c0.5-0.1,0.9-0.5,0.8-0.9
		C423.2,242.8,422.6,242.5,422.2,242.7z"
      />
      <path
        class="st3"
        d="M335.5,235.3c-0.5,0-0.9,0.5-0.8,0.8c0.4-0.2,0.8-0.5,1.2-0.7c0,0,0,0-0.1,0
		C335.8,235.4,335.6,235.3,335.5,235.3z"
      />
      <path
        class="st3"
        d="M459,236.8c-0.3,0.2-0.7,0.6-0.6,0.8s0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C460,236.9,459.4,236.6,459,236.8z"
      />
      <path
        class="st3"
        d="M593.4,208.5c0.6,0.6,0.6,1.5,2.1,1.2C594.8,208.3,594.8,208.3,593.4,208.5z"
      />
      <path
        class="st3"
        d="M380.6,248.8L380.6,248.8c-0.2-0.1-0.4-0.2-0.5-0.1c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2
		c0.2,0.1,0.3,0.1,0.5,0.2c0.4-0.3,0.7-0.5,1.1-0.8C380.7,248.8,380.7,248.8,380.6,248.8z"
      />
      <path
        class="st3"
        d="M526.8,206.3c0.2,0,0.5-0.1,0.7-0.1c0.2-0.8,0-1.1-1.1-1.4C526.9,205.2,526.2,205.9,526.8,206.3z"
      />
      <path
        class="st3"
        d="M541.6,214.8c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C542.7,215.8,542.3,215.3,541.6,214.8z"
      />
      <path
        class="st3"
        d="M539.4,212.1C539.4,212.1,539.5,212.1,539.4,212.1c0.2,0,0.3-0.4,0.2-0.5c-0.2-0.3-0.5-0.5-0.8-0.8
		c-0.2,0.3-0.3,0.6-0.5,0.9c0.1,0.2,0.3,0.3,0.4,0.5C538.8,212.2,539.2,212.1,539.4,212.1z"
      />
      <path
        class="st3"
        d="M546.6,196L546.6,196c-0.2,0.3-0.4,0.7-0.6,1.1c0.2,0.2,0.4,0.3,0.8,0.3l0,0c0,0,0,0,0.1,0l0,0
		C547.3,196.9,546.1,196.5,546.6,196z"
      />
      <path
        class="st3"
        d="M511.5,186.2c-0.2-0.6-0.5-1.2-0.9-2.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		c0.2,0.3,0.3,0.7,0.8,0.7C511.2,186.2,511.3,186.2,511.5,186.2z"
      />
      <path
        class="st3"
        d="M557.8,207.7c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5c-0.3,0.4-0.6,0.7-0.6,1
		C557,207.5,557.7,207.8,557.8,207.7z"
      />
      <path
        class="st3"
        d="M555.3,167.5c-0.3,0.4-0.6,0.8-0.8,1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.6-0.3,1.3-0.5,2-0.9
		C556.1,167.8,555.8,167.7,555.3,167.5z"
      />
      <path
        class="st3"
        d="M384.8,264.2c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C385.5,264.4,385.1,264.3,384.8,264.2z"
      />
      <path
        class="st3"
        d="M611.2,162.9c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C612,163,611.7,162.6,611.2,162.9z"
      />
      <path
        class="st3"
        d="M514,183.5c-0.6-0.1-1.1-0.7-1.8,0.1C513.2,184.3,513.2,184.3,514,183.5z"
      />
      <path
        class="st3"
        d="M385.3,258.4c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C384.9,258.8,385.3,258.6,385.3,258.4z"
      />
      <path
        class="st3"
        d="M512.8,177.7c0.7-0.4,0.4-1,0.4-1.5C512,176.7,512,176.8,512.8,177.7z"
      />
      <path
        class="st3"
        d="M558.2,174c-0.8,1-1.3,1.7-1.2,2.5C557.5,175.9,558.4,175.4,558.2,174z"
      />
      <path
        class="st3"
        d="M533.3,212.5c-0.3,0.3-0.5,0.5-0.7,0.8c0.3,0.1,0.6,0.4,0.8,0.3c0.3-0.1,0.5-0.4,0.6-0.7
		C534,212.9,533.6,212.7,533.3,212.5z"
      />
      <path
        class="st3"
        d="M539.5,177.9c-0.4,0.4-0.8,0.8-1.1,1.2c0.7,0.5,1.1-0.3,1.7-0.3c0.1-0.2,0.1-0.4,0.2-0.6
		C540,178.1,539.7,178,539.5,177.9z"
      />
      <path
        class="st3"
        d="M547.7,190.9c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.6
		c-0.1,0.1-0.2,0.1-0.3,0.2C547.8,190.8,547.8,190.8,547.7,190.9z"
      />
      <path
        class="st3"
        d="M351.9,260.7c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7c-0.4-0.1-0.7-0.3-1-0.3
		C352.1,260.1,352,260.5,351.9,260.7z"
      />
      <path
        class="st3"
        d="M318.1,260c0.7-0.7,0.8-1.2,0.2-1.9C317.6,258.7,317.6,259.2,318.1,260z"
      />
      <path
        class="st3"
        d="M532.9,223.3c0.1-0.3,0.1-0.5,0-0.7c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.3-0.3,0.6-0.4,0.8
		c0.1,0.2,0.3,0.3,0.6,0.4C532.8,223.5,532.9,223.4,532.9,223.3z"
      />
      <path
        class="st3"
        d="M420.5,234.3c-0.2,0.4-0.6,0.7-0.5,0.9s0.5,0.3,0.8,0.4c0.1,0,0.5-0.4,0.4-0.6
		C421.1,234.8,420.8,234.6,420.5,234.3z"
      />
      <path
        class="st3"
        d="M495,201.2c1.3-0.8,0.1-1.1,0.1-1.7C493.9,200.3,495,200.5,495,201.2z"
      />
      <path
        class="st3"
        d="M583.5,205.5c0.5,0.4,0.3,1.1,1.3,1.3C584.7,205.5,584.7,205.5,583.5,205.5z"
      />
      <path
        class="st3"
        d="M564.4,210.5c0.9,0,1.6,0.1,2.2,0.1c-0.5-0.3-0.9-0.5-1.3-0.8C565,210.1,564.8,210.2,564.4,210.5z"
      />
      <path
        class="st3"
        d="M534.9,174.6c-0.5,0.4-0.8,0.6-1.2,0.9c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4
		C535.4,175.8,535.1,175.3,534.9,174.6z"
      />
      <path
        class="st3"
        d="M396.6,249.9c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C397.7,249.1,397.2,249.5,396.6,249.9z"
      />
      <path
        class="st3"
        d="M554.8,178c-0.4,0.3-0.6,0.5-1,0.7c0.5,0.5,0.9,0.7,1.4,0.2C555.4,178.8,555,178.4,554.8,178z"
      />
      <path
        class="st3"
        d="M562.3,218.7c0.1,0.8,0.1,0.8,0.9,1.3C563.1,219.5,563.1,219,562.3,218.7z"
      />
      <path
        class="st3"
        d="M511.9,253.8c0,0.7,0.2,1.1,1,1.7C513,254.5,512.7,254.1,511.9,253.8z"
      />
      <path
        class="st3"
        d="M537.1,177c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C537.7,176.8,537.3,176.9,537.1,177L537.1,177z"
      />
      <path
        class="st3"
        d="M518.4,219.7c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C519,220.1,518.6,220,518.4,219.7z"
      />
      <path
        class="st3"
        d="M388,261.3c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C388.4,260.8,388.2,261.1,388,261.3z"
      />
      <path
        class="st3"
        d="M595.2,203.3c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2,0.2-0.5,0.4-0.4,0.5c0.2,0.2,0.4,0.4,0.8,0.6
		C595,203.6,595.3,203.4,595.2,203.3z"
      />
      <path
        class="st3"
        d="M558.5,193.9c-0.2-0.7-0.3-1.2-1.2-1.2C557.2,193.3,557.6,193.6,558.5,193.9z"
      />
      <path
        class="st3"
        d="M611.8,174c0.1,0,0.2,0,0.3,0v-1c0,0,0,0-0.1,0C612,173.3,611.9,173.6,611.8,174z"
      />
      <path
        class="st3"
        d="M540.8,206.9c-0.1,0.2-0.2,0.4-0.3,0.5c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.2,0.3-0.4
		C541.1,207.1,541,206.9,540.8,206.9z"
      />
      <path
        class="st3"
        d="M579.4,184c-0.4-0.2-0.7-0.3-1-0.4c-0.1,0.2-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.3,0.8,0.3
		C579,184.5,579.2,184.2,579.4,184z"
      />
      <path
        class="st3"
        d="M522.3,206.1c0.1,0,0.3,0.1,0.5,0.1c-0.2-0.2-0.3-0.4-0.5-0.6c-0.2-0.3-0.5-0.5-0.8-0.9
		C521.7,205.7,521.7,205.9,522.3,206.1z"
      />
      <path
        class="st3"
        d="M547.6,179.1c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2s0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.8-0.6
		c0.1-0.1-0.2-0.3-0.3-0.5C548.1,178.6,547.8,178.9,547.6,179.1z"
      />
      <path
        class="st3"
        d="M546.8,168.4c-0.2,0.3-0.5,0.6-0.4,0.7c0.1,0.2,0.4,0.2,0.6,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		C547.4,168.7,547.1,168.6,546.8,168.4z"
      />
      <path
        class="st3"
        d="M380.8,261.6c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C381.4,261.7,381,261.5,380.8,261.6z"
      />
      <path
        class="st3"
        d="M322.9,233.7c0.1-0.1,0.1-0.2,0.2-0.3s-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1c0.2,0.1,0.3,0.1,0.4,0.2
		C322.6,234,322.8,233.9,322.9,233.7z"
      />
      <path
        class="st3"
        d="M335.5,255.1c0.8-0.2,0.9-0.5,0.6-1.2C335.5,254.2,335.2,254.5,335.5,255.1z"
      />
      <path
        class="st3"
        d="M514.5,187.1c0.2-0.2,0.4-0.5,0.6-0.7c0-0.1,0.1-0.1,0.1-0.2c-0.2,0-0.4,0.1-0.6,0.1
		C514.4,186.7,514.4,186.9,514.5,187.1z"
      />
      <path
        class="st3"
        d="M516.4,208.2c0.1-0.2,0.1-0.4,0.2-0.5c-0.2,0-0.4,0-0.6-0.1c0,0.2-0.1,0.5-0.1,0.7
		C516,208.2,516.2,208.2,516.4,208.2z"
      />
      <path
        class="st3"
        d="M539.1,228.6c0,0.1,0,0.3,0.1,0.4c0.1,0.4,0.4,0.7,1,1.1c0-0.2,0-0.3-0.1-0.4
		C540,229.1,539.8,228.7,539.1,228.6z"
      />
      <path
        class="st3"
        d="M395.8,253.4c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C396.3,253.8,396.1,253.7,395.8,253.4z"
      />
      <path
        class="st3"
        d="M488.9,213c0.1,0,0.2,0,0.4-0.1c0-0.1,0-0.3-0.1-0.4C489.1,212.7,489,212.8,488.9,213z"
      />
      <path
        class="st3"
        d="M509.4,172.4c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C509.1,171.5,509.2,171.9,509.4,172.4z"
      />
      <path
        class="st3"
        d="M508.3,173.9c-0.3,0-0.5,0-0.7,0.1s-0.3,0.3-0.5,0.6C507.8,174.6,508.2,174.6,508.3,173.9z"
      />
      <path
        class="st3"
        d="M499.2,184.7c0.7,0.2,1.1,0.3,1.8,0.5C500.6,184.4,500.2,184.3,499.2,184.7z"
      />
      <path
        class="st3"
        d="M490.3,191.7c0.4,0.2,0.8,0.4,1.5,0.8C491.5,191.7,491.1,191.6,490.3,191.7z"
      />
      <path
        class="st3"
        d="M519.7,222.4c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C519.8,221.7,519.7,222,519.7,222.4z"
      />
      <path
        class="st3"
        d="M558.9,187.1c0.7-0.1,1.1-0.1,1.9-0.2C560,186.7,559.5,186.4,558.9,187.1z"
      />
      <path
        class="st3"
        d="M486.4,220.9c0.3-0.5,0.4-0.8,0.6-1.1C486.4,220,486,220.3,486.4,220.9z"
      />
      <path
        class="st3"
        d="M501.7,185.3c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3c-0.2,0.4-0.4,0.6-0.6,0.9
		C501.5,185.4,501.6,185.3,501.7,185.3z"
      />
      <path
        class="st3"
        d="M598.4,170.5L598.4,170.5c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C598.9,170.4,598.6,170.2,598.4,170.5z"
      />
      <path
        class="st3"
        d="M523.3,208.5c-0.4,0-0.7-0.1-0.9,0s-0.3,0.3-0.3,0.5c0,0.1,0.3,0.3,0.5,0.3
		C522.7,209.2,522.9,208.9,523.3,208.5z"
      />
      <path
        class="st3"
        d="M351.1,253c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.5,0.4c0.1,0,0.1-0.1,0.2-0.1c0.1-0.2,0.2-0.3,0.2-0.4
		C351.5,253.1,351.2,253,351.1,253z"
      />
      <path
        class="st3"
        d="M337.1,270.5c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.3,0.7-0.6,1-0.9c-0.1-0.1-0.1-0.1-0.2-0.2
		C337.8,269.9,337.5,270.2,337.1,270.5z"
      />
      <path
        class="st3"
        d="M560.3,188.6c-0.2,0.5,0,0.7,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0-0.3,0-0.5
		C560.9,188.8,560.7,188.7,560.3,188.6z"
      />
      <path
        class="st3"
        d="M596,188.8c-0.1-0.4-0.3-0.8,0.3-0.9c-0.2,0-0.5,0-1-0.1C595.6,188.3,595.8,188.5,596,188.8z"
      />
      <path
        class="st3"
        d="M384.1,252.3c0.3,0.1,0.5,0.3,0.7,0.2s0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3
		C384.5,251.8,384.3,252,384.1,252.3z"
      />
      <path
        class="st3"
        d="M556.9,178.4c0,0-0.1-0.1-0.1-0.3c-0.4,0.1-0.7,0.3-1.1,0.5C556.2,179.2,556.6,178.8,556.9,178.4z"
      />
      <path
        class="st3"
        d="M373,256.1c0.1,0,0.3,0,0.7,0c-0.1-0.1-0.2-0.2-0.3-0.3C373.2,255.9,373.1,256,373,256.1z"
      />
      <path
        class="st3"
        d="M578.5,197.8c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1
		C578.9,198.3,578.7,198.1,578.5,197.8C578.5,197.9,578.5,197.8,578.5,197.8z"
      />
      <path
        class="st3"
        d="M398.7,224.9c0-0.1-0.2-0.2-0.4-0.3c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C398.6,225.2,398.7,225.1,398.7,224.9z"
      />
      <path
        class="st3"
        d="M527.7,244.2c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C528,243.9,527.8,244.1,527.7,244.2z"
      />
      <path
        class="st3"
        d="M343.1,238.8c-0.3-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2,0.2-0.3,0.3c0.2,0.1,0.3,0.2,0.5,0.2
		C342.8,239.1,342.9,238.9,343.1,238.8z"
      />
      <path
        class="st3"
        d="M388.8,267.2c0,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.4,0.5c0.2-0.3,0.4-0.5,0.4-0.6
		C389.2,267.3,389,267.3,388.8,267.2z"
      />
      <path
        class="st3"
        d="M510,182.8c0.1,0.2,0.1,0.4,0.2,0.6c1.1-0.9,1.1-0.9,0.5-1.4c-0.1,0.2-0.3,0.3-0.4,0.5l0,0l0,0
		c-0.2,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8C509.7,183,509.9,182.9,510,182.8L510,182.8L510,182.8z"
      />
      <path
        class="st3"
        d="M511.6,175.6l0.2,0.1c0.1-0.1,0.3-0.3,0.4-0.4c-0.2-0.1-0.3-0.1-0.4-0.2C511.8,175.3,511.7,175.4,511.6,175.6z
		"
      />
      <path
        class="st3"
        d="M558.7,189.6c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C559.2,189.2,558.9,189.4,558.7,189.6z"
      />
      <path
        class="st3"
        d="M399.2,250.5c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C399.4,250.2,399.2,250.4,399.2,250.5z"
      />
      <path
        class="st3"
        d="M609.2,214.5c0.2,0.1,0.3,0.3,0.5,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.4-0.2-0.5-0.1
		C609.5,214.3,609.4,214.4,609.2,214.5z"
      />
      <path
        class="st3"
        d="M551.9,173.2c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.1,0.9-0.2c0-0.2,0.1-0.3,0.2-0.7
		C552.5,172.8,552.2,173,551.9,173.2z"
      />
      <path
        class="st3"
        d="M316.5,229c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2,0.1-0.3,0.2-0.4,0.2
		C316.2,228.8,316.4,228.9,316.5,229z"
      />
      <path
        class="st3"
        d="M605.6,205.1c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C606,205.2,605.8,205.2,605.6,205.1z"
      />
      <path
        class="st3"
        d="M515.8,202.9c0,0.1,0.1,0.3,0.2,0.4c0.1-0.2,0.2-0.4,0.2-0.6c-0.1,0-0.2,0-0.3,0
		C515.9,202.8,515.8,202.9,515.8,202.9z"
      />
      <path
        class="st3"
        d="M544.2,178.2c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.3,0,0.5,0.1,0.6,0c0.2,0,0.4-0.2,0.5-0.5C544.1,178.4,544.1,178.3,544.2,178.2z"
      />
      <path
        class="st3"
        d="M540.8,179.9c0.3-0.1,0.6-0.2,0.9-0.3c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.2-0.6,0.3-0.9,0.5
		C540.7,179.7,540.8,179.8,540.8,179.9z"
      />
      <path
        class="st3"
        d="M520.6,213.3c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C520.6,212.8,520.6,213,520.6,213.3z"
      />
      <path
        class="st3"
        d="M611.2,169.7c0,0.3,0,0.6,0,0.9C611.6,170.3,611.7,170,611.2,169.7z"
      />
      <path
        class="st3"
        d="M611.2,170.6C611.2,170.6,611.1,170.6,611.2,170.6c-0.1,0.1-0.1,0.1-0.1,0.1
		C611.1,170.7,611.1,170.6,611.2,170.6L611.2,170.6z"
      />
      <path
        class="st3"
        d="M331.6,262.5c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C331.7,262.4,331.6,262.4,331.6,262.5z"
      />
      <path
        class="st3"
        d="M551.2,182.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.3-0.2,0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		C551.4,182.1,551.3,182.2,551.2,182.2z"
      />
      <path
        class="st3"
        d="M505.6,184.1c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6
		C505.8,184.2,505.7,184.1,505.6,184.1z"
      />
      <path
        class="st3"
        d="M389.6,250.4c0.1,0,0.2,0,0.3-0.1c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0-0.2,0-0.3,0.1
		C389.5,250,389.6,250.2,389.6,250.4z"
      />
      <path
        class="st3"
        d="M512.2,189.8c-0.1,0-0.1,0.1-0.1,0.2C512.1,190,512.2,189.9,512.2,189.8C512.2,189.9,512.2,189.8,512.2,189.8z
		"
      />
      <path
        class="st3"
        d="M571.5,179.1c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0C571.5,179.2,571.5,179.1,571.5,179.1z"
      />
      <path
        class="st3"
        d="M571.9,178.5c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C572.1,178.6,572,178.6,571.9,178.5z"
      />
      <path
        class="st3"
        d="M536.4,203.4c0-0.1-0.2-0.2-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.3s0.2,0.2,0.4,0.3
		C536.4,203.6,536.4,203.5,536.4,203.4z"
      />
      <path
        class="st3"
        d="M507.2,263.5c0.2,0.2,0.4,0.4,0.6,0.6C507.8,263.8,508.1,263.4,507.2,263.5z"
      />
      <path
        class="st3"
        d="M507.8,264.1C507.7,264.1,507.7,264.2,507.8,264.1c0,0.1,0.1,0.1,0.1,0.1C507.8,264.2,507.8,264.2,507.8,264.1
		L507.8,264.1z"
      />
      <path
        class="st3"
        d="M398.7,234.2c0,0.1,0.2,0.1,0.4,0.1l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.4C398.9,234,398.7,234.1,398.7,234.2z"
      />
      <path
        class="st3"
        d="M535.3,247.1c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C535.4,246.9,535.3,247,535.3,247.1z"
      />
      <path
        class="st3"
        d="M569.5,165.3c-0.1,0-0.2,0.2-0.2,0.2c0,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.4-0.3
		C569.8,165.4,569.7,165.3,569.5,165.3z"
      />
      <path
        class="st3"
        d="M609.3,167.6c-0.1,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.2,0.1h0.1l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4
		C609.4,167.5,609.3,167.6,609.3,167.6z"
      />
      <path
        class="st3"
        d="M519.9,211.4c-0.2,0-0.4,0-0.6-0.1c0.1,0.1,0.2,0.3,0.4,0.4C519.7,211.6,519.8,211.5,519.9,211.4z"
      />
      <path
        class="st3"
        d="M612.1,165v-0.5c-0.1,0.1-0.2,0.2-0.3,0.3C611.9,164.8,612,164.9,612.1,165z"
      />
      <path
        class="st3"
        d="M510.3,189.4c0.1,0,0.1,0,0.2,0c0.1-0.2,0.2-0.4,0.3-0.5c-0.1,0-0.2-0.1-0.3-0.1
		C510.4,189,510.4,189.2,510.3,189.4z"
      />
      <path
        class="st3"
        d="M508.3,201.8c0.2,0,0.3,0.1,0.5,0c0.1,0,0.2-0.2,0.5-0.4c-0.4,0-0.5,0-0.6,0.1
		C508.5,201.6,508.4,201.7,508.3,201.8z"
      />
      <path
        class="st3"
        d="M610.8,165.9c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5c-0.1,0.3-0.2,0.5-0.1,0.6
		C610.6,165.8,610.7,165.9,610.8,165.9z"
      />
      <path
        class="st3"
        d="M511,213.4c0.1,0,0.2,0,0.3,0c0.1-0.2,0.2-0.4,0.3-0.7c-0.1,0-0.2,0-0.4,0C511.1,212.9,511.1,213.2,511,213.4z
		"
      />
      <path
        class="st3"
        d="M433.2,229.6c0.2,0.2,0.4,0.5,0.6,0.8C434.1,229.6,433.6,229.7,433.2,229.6z"
      />
      <path
        class="st3"
        d="M433.2,229.6C433.2,229.6,433.2,229.5,433.2,229.6c-0.1-0.1-0.1-0.1-0.1-0.1l0,0
		C433.1,229.6,433.2,229.6,433.2,229.6z"
      />
      <path
        class="st3"
        d="M490.1,216c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C490.3,216.2,490.1,216.1,490.1,216z"
      />
      <path
        class="st3"
        d="M336.4,243.4c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.2,0-0.3,0C336.5,243.3,336.4,243.3,336.4,243.4z
		"
      />
      <path
        class="st3"
        d="M519.2,211.3C519.2,211.3,519.2,211.2,519.2,211.3c-0.1-0.1-0.1-0.1-0.1-0.1L519.2,211.3
		C519.2,211.3,519.2,211.3,519.2,211.3z"
      />
      <path
        class="st3"
        d="M519,210.7c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C519.2,210.7,519.1,210.7,519,210.7z"
      />
      <path
        class="st3"
        d="M550.4,193.2l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1H551c-0.1,0-0.3,0-0.4,0
		C550.5,193.2,550.4,193.2,550.4,193.2z"
      />
      <path
        class="st3"
        d="M504.2,207.1l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C504.3,206.8,504.3,206.9,504.2,207.1z"
      />
      <path
        class="st3"
        d="M554.6,184.2c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.4S554.7,184.2,554.6,184.2z
		"
      />
      <path
        class="st3"
        d="M397.1,244.8c-0.1,0-0.2-0.1-0.4-0.1l-0.1,0.2c0.1,0.1,0.2,0.1,0.4,0.2C397,245.1,397,245,397.1,244.8z"
      />
      <path
        class="st3"
        d="M509.8,173.9c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C510.1,174,509.9,174,509.8,173.9z"
      />
      <path
        class="st3"
        d="M544.8,223.3l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C544.9,223.1,544.9,223.2,544.8,223.3z"
      />
      <path
        class="st3"
        d="M597.1,188.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C597.1,188.3,597.1,188.3,597.1,188.2z"
      />
      <path
        class="st3"
        d="M544.4,179.3C544.4,179.3,544.4,179.2,544.4,179.3c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.1,0,0.2,0,0.3
		C544,179.5,544.2,179.4,544.4,179.3z"
      />
      <path
        class="st3"
        d="M603.7,169.3c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1-0.1-0.1-0.2-0.1C603.6,168.9,603.6,169,603.7,169.3z"
      />
      <path
        class="st3"
        d="M436.1,267.7c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1
		C436.2,267.8,436.1,267.7,436.1,267.7z"
      />
      <path
        class="st3"
        d="M373.3,243.5c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C373.4,243.3,373.4,243.4,373.3,243.5z"
      />
      <path
        class="st3"
        d="M511.8,189.6c0.1,0,0.2-0.1,0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		C511.7,189.5,511.8,189.6,511.8,189.6z"
      />
      <path
        class="st3"
        d="M536.8,204.1c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.4,0.1
		C536.7,204.3,536.8,204.2,536.8,204.1z"
      />
      <path
        class="st3"
        d="M554.4,183.6c-0.6,0.2-0.8,0.3-1,0.3c0.1,0.1,0.1,0.2,0.2,0.3C553.8,184.1,553.9,184,554.4,183.6z"
      />
      <path
        class="st3"
        d="M598.7,188.8c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C598.7,188.9,598.7,188.9,598.7,188.8z"
      />
      <path
        class="st3"
        d="M611.1,170.7c-0.1,0.1-0.3,0.3-0.4,0.4c0.1,0,0.2,0.1,0.3,0.1C611,171.1,611,170.9,611.1,170.7z"
      />
      <path
        class="st3"
        d="M468.4,243.4L468.4,243.4c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.3-0.2
		C468.5,243.3,468.4,243.3,468.4,243.4z"
      />
      <path
        class="st3"
        d="M557.7,186.8C557.7,186.9,557.8,186.9,557.7,186.8c0.1,0.2,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2l0,0
		c-0.1-0.1-0.1-0.2-0.2-0.2C557.9,186.7,557.7,186.8,557.7,186.8z"
      />
      <path
        class="st3"
        d="M368.7,253.7c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C368.9,253.4,368.8,253.5,368.7,253.7z"
      />
      <path
        class="st3"
        d="M515.5,199.5c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
		C515.7,199.4,515.6,199.4,515.5,199.5z"
      />
      <path
        class="st3"
        d="M501.9,205.6c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C501.8,205.4,501.8,205.5,501.9,205.6z"
      />
      <path
        class="st3"
        d="M604.1,188.2c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C604.3,188.2,604.2,188.2,604.1,188.2z"
      />
      <path
        class="st3"
        d="M598.1,189.6c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C598.2,189.8,598.2,189.7,598.1,189.6z"
      />
      <path
        class="st3"
        d="M599.9,215.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C600,215.1,600,215.3,599.9,215.4z"
      />
      <path
        class="st3"
        d="M555.3,198.7C555.4,198.7,555.4,198.7,555.3,198.7C555.4,198.7,555.4,198.7,555.3,198.7
		C555.4,198.6,555.4,198.7,555.3,198.7C555.4,198.7,555.4,198.7,555.3,198.7z"
      />
      <path
        class="st3"
        d="M555.2,199c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1C555,198.9,555.1,198.9,555.2,199z"
      />
      <path
        class="st3"
        d="M555.4,173c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L555.4,173z"
      />
      <path
        class="st3"
        d="M346.1,243.9c-0.1,0-0.2-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0C346.2,244.1,346.2,244,346.1,243.9z
		"
      />
      <path
        class="st3"
        d="M508,264.6c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C507.9,264.3,507.9,264.5,508,264.6z"
      />
      <path
        class="st3"
        d="M537.4,176C537.4,176,537.4,176.1,537.4,176c0,0.1,0.1,0.1,0.1,0.1L537.4,176C537.6,176,537.5,176,537.4,176z"
      />
      <path
        class="st3"
        d="M534.4,176.3L534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3
		C534.5,176.2,534.5,176.3,534.4,176.3z"
      />
      <path
        class="st3"
        d="M534.1,176.6c0.1-0.1,0.2-0.2,0.4-0.3c-0.2,0-0.3,0.1-0.5,0.1C534,176.5,534,176.6,534.1,176.6z"
      />
      <path
        class="st3"
        d="M548.5,173c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C548.2,173,548.3,173,548.5,173C548.4,173.2,548.5,173.1,548.5,173
		z"
      />
      <path
        class="st3"
        d="M565.1,174l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C565.3,174,565.2,174,565.1,174z"
      />
      <path
        class="st3"
        d="M559.6,169l0.1,0.1c0.1,0,0.1,0,0.2,0C559.8,169.1,559.8,169,559.6,169C559.8,169,559.7,169,559.6,169z"
      />
      <path
        class="st3"
        d="M504.2,180.1c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2C504.1,180.2,504.1,180.2,504.2,180.1
		C504.2,180.2,504.2,180.1,504.2,180.1z"
      />
      <path
        class="st3"
        d="M498.8,181c0,0,0.1,0.1,0.1,0.2l0,0l0,0C498.9,181.1,498.9,181,498.8,181z"
      />
      <path
        class="st3"
        d="M420.5,229.7c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2C420.4,229.7,420.5,229.7,420.5,229.7z"
      />
      <path
        class="st3"
        d="M316.9,248.9l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1C317.1,248.8,317,248.8,316.9,248.9z"
      />
      <path
        class="st3"
        d="M513.2,176.1C513.2,176.1,513.1,176.2,513.2,176.1c0,0.1,0,0.1,0,0.1l0,0C513.2,176.2,513.2,176.1,513.2,176.1
		z"
      />
      <path
        class="st3"
        d="M513.2,175.8v0.1c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.2C513.3,175.9,513.2,175.8,513.2,175.8z"
      />
      <path
        class="st3"
        d="M507,173.5l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C507.3,173.5,507.1,173.5,507,173.5z"
      />
      <path
        class="st3"
        d="M450.3,225.3c0.1,0,0.1,0.1,0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C450.5,225.2,450.4,225.3,450.3,225.3z"
      />
      <path
        class="st3"
        d="M428,230.5c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C428.1,230.4,428,230.5,428,230.5z"
      />
      <path
        class="st3"
        d="M510.5,242.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C510.5,242.7,510.5,242.8,510.5,242.8z"
      />
      <path
        class="st3"
        d="M487.4,218.6c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C487.5,218.5,487.5,218.5,487.4,218.6z"
      />
      <path
        class="st3"
        d="M495,193.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2
		C494.9,193.4,495.1,193.4,495,193.3z"
      />
      <path
        class="st3"
        d="M532.2,210.3c0-0.1-0.1-0.3-0.1-0.4H532c0,0.2,0,0.3,0.1,0.5C532.1,210.3,532.2,210.3,532.2,210.3z"
      />
      <path
        class="st3"
        d="M394.5,240.2c-0.1,0-0.1,0.1-0.2,0.1h0.1L394.5,240.2z"
      />
      <path
        class="st3"
        d="M542.2,208.4c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C542.3,208.2,542.2,208.3,542.2,208.4z"
      />
      <path
        class="st3"
        d="M560.5,192.3c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1C560.7,192.4,560.7,192.3,560.5,192.3
		C560.6,192.2,560.6,192.3,560.5,192.3z"
      />
      <path
        class="st3"
        d="M536.3,211.6L536.3,211.6c0-0.1,0-0.1,0-0.2l0,0C536.2,211.5,536.2,211.5,536.3,211.6
		C536.2,211.6,536.2,211.6,536.3,211.6C536.3,211.7,536.3,211.6,536.3,211.6z"
      />
      <path
        class="st3"
        d="M508,203.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C508,203.3,508,203.3,508,203.3z"
      />
      <path
        class="st3"
        d="M331.4,241.4c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1l0.1-0.1c0,0,0-0.1-0.1-0.1C331.4,241.5,331.4,241.5,331.4,241.4z"
      />
      <path
        class="st3"
        d="M468.1,242.8c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1S468,242.7,468.1,242.8z"
      />
      <path
        class="st3"
        d="M573.6,179.4l-0.1,0.1c0.1,0,0.2,0,0.3,0.1l0.1-0.1C573.8,179.4,573.7,179.4,573.6,179.4z"
      />
      <path
        class="st3"
        d="M522.3,216.5c0.1,0,0.2,0,0.2,0v-0.1c0,0-0.1-0.1-0.2-0.1C522.3,216.4,522.3,216.5,522.3,216.5z"
      />
      <path
        class="st3"
        d="M549.2,185.3c0,0,0,0.1,0.1,0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1S549.2,185.2,549.2,185.3z"
      />
      <path
        class="st3"
        d="M544.3,222.6c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C544.4,222.4,544.4,222.5,544.3,222.6z"
      />
      <path
        class="st3"
        d="M584,178.4c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L584,178.4z"
      />
      <path
        class="st3"
        d="M528.6,215.3v0.1h0.1C528.7,215.5,528.7,215.4,528.6,215.3C528.7,215.3,528.7,215.3,528.6,215.3z"
      />
      <path
        class="st3"
        d="M528.9,216.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1C529.1,216.1,529,216.1,528.9,216.1z"
      />
      <path
        class="st3"
        d="M357,254.6l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0C357.1,254.5,357.1,254.6,357,254.6z"
      />
      <path
        class="st3"
        d="M504.7,196.8c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C504.7,196.7,504.7,196.7,504.7,196.8z"
      />
      <path
        class="st3"
        d="M558.4,185L558.4,185c-0.5,0-0.6,0-0.8,0c0,0.1,0,0.1,0,0.2C557.8,185.3,557.9,185.2,558.4,185L558.4,185z"
      />
      <path
        class="st3"
        d="M358.9,229.1c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C358.9,229.2,358.9,229.2,358.9,229.1z"
      />
      <path
        class="st3"
        d="M580.2,181c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C580.4,180.9,580.3,180.9,580.2,181z"
      />
      <path
        class="st3"
        d="M580.6,181.2L580.6,181.2C580.6,181.2,580.6,181.3,580.6,181.2C580.6,181.3,580.6,181.3,580.6,181.2
		C580.6,181.3,580.6,181.3,580.6,181.2C580.7,181.3,580.7,181.3,580.6,181.2C580.6,181.3,580.6,181.3,580.6,181.2z"
      />
      <path
        class="st3"
        d="M549.4,187.9c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0.1-0.1c0,0,0,0,0.1-0.1C549.5,187.8,549.4,187.8,549.4,187.9
		C549.3,187.9,549.3,187.9,549.4,187.9z"
      />
      <path
        class="st3"
        d="M585.8,205.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C586.1,205.6,586,205.6,585.8,205.7
		C585.8,205.6,585.8,205.7,585.8,205.7z"
      />
      <path
        class="st3"
        d="M574.5,182.7c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0-0.1-0.1-0.1C574.6,182.8,574.6,182.7,574.5,182.7z"
      />
      <path
        class="st3"
        d="M574.4,182.6c-0.4-0.2-0.9-0.5-1.3-0.7c-0.7-0.3-1.5-0.3-2.2-0.1c-0.3,0.1-0.5,0.2-0.7,0.4
		c-0.9,0.6-1.1,1.6-0.6,2.5c0.2,0.4,0.6,0.7,0.8,1.1c0.4,0,0.7-0.1,1-0.1c1.5-0.1,2.3-0.7,2.7-1.8c0-0.2,0.1-0.3,0.1-0.5
		S574.3,182.9,574.4,182.6C574.5,182.7,574.5,182.7,574.4,182.6C574.5,182.7,574.5,182.6,574.4,182.6L574.4,182.6z"
      />
      <path
        class="st3"
        d="M580.7,181.6c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C580.7,181.4,580.6,181.5,580.7,181.6z"
      />
      <path
        class="st3"
        d="M567.4,211.2c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C567.3,211,567.3,211.1,567.4,211.2z"
      />
      <polygon class="st3" points="366.3,255 366.4,255 366.3,254.9 	" />
      <path
        class="st3"
        d="M510.7,198.4c-0.1,0-0.1,0-0.2,0.1c0.1,0,0.1,0,0.2,0s0.1-0.1,0.2-0.1C510.8,198.5,510.7,198.4,510.7,198.4z"
      />
      <path
        class="st3"
        d="M403.3,246.7c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C403.4,246.8,403.4,246.8,403.3,246.7
		C403.4,246.8,403.3,246.7,403.3,246.7z"
      />
      <path
        class="st3"
        d="M575.4,184.7l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C575.4,184.6,575.3,184.7,575.4,184.7z"
      />
      <path
        class="st3"
        d="M308.1,243.8C308.1,243.8,308.2,243.8,308.1,243.8c0.1,0.1,0.1,0.1,0.1,0l0,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1
		C308.2,243.7,308.2,243.7,308.1,243.8z"
      />
      <path
        class="st3"
        d="M395.7,225c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C395.8,225.1,395.8,225.1,395.7,225z"
      />
      <path
        class="st3"
        d="M319.1,237.5L319.1,237.5L319.1,237.5c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C319.1,237.4,319.1,237.4,319.1,237.5z"
      />
      <path
        class="st3"
        d="M502.8,197.5v0.1V197.5c0.1,0,0.1-0.1,0.1-0.1S502.9,197.5,502.8,197.5z"
      />
      <path
        class="st3"
        d="M351.2,228.6c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2h0.1C351.2,228.7,351.2,228.7,351.2,228.6z"
      />
      <polygon class="st3" points="552.2,193.3 552.1,193.2 552.1,193.3 	" />
      <polygon class="st3" points="499.6,194.3 499.8,194.3 499.7,194.2 	" />
      <path
        class="st3"
        d="M578.2,176.6c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.1,0-0.2C578.4,176.5,578.3,176.5,578.2,176.6z"
      />
      <path
        class="st3"
        d="M578.8,176.1C578.8,176.1,578.8,176,578.8,176.1C578.8,176,578.7,176,578.8,176.1c-0.1,0.1-0.2,0.2-0.3,0.4
		l0,0l0,0l0,0C578.6,176.3,578.7,176.2,578.8,176.1z"
      />
      <path
        class="st3"
        d="M578.8,175.8c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1S578.9,175.9,578.8,175.8z"
      />
      <path
        class="st3"
        d="M552.5,181c0,0,0,0.1-0.1,0.1C552.5,181.1,552.5,181.1,552.5,181L552.5,181z"
      />
      <polygon class="st3" points="597,185.4 597,185.5 597.1,185.4 	" />
      <polygon class="st3" points="610.6,167.2 610.6,167.1 610.5,167.1 	" />
      <path
        class="st3"
        d="M547,197.4c-0.1,0-0.2,0-0.3,0c0,0.1,0.1,0.1,0.1,0.2C547,197.6,547,197.5,547,197.4z"
      />
      <polygon class="st3" points="315.1,230.2 315.2,230.2 315.2,230.1 	" />
      <path
        class="st3"
        d="M506.1,206.7l0.1,0.1l0.1-0.1l-0.1-0.1C506.2,206.6,506.1,206.6,506.1,206.7z"
      />
      <path
        class="st3"
        d="M352.2,240.7c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.1,0,0.2C352.2,240.7,352.2,240.7,352.2,240.7z"
      />
      <polygon class="st3" points="506.6,207.2 506.7,207.3 506.7,207.2 	" />
      <path
        class="st3"
        d="M500.4,189.4c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C500.5,189.3,500.5,189.4,500.4,189.4z"
      />
      <path
        class="st3"
        d="M596.6,187.8c-0.1,0-0.2,0-0.3,0C596.4,187.9,596.5,187.9,596.6,187.8c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C596.9,188,596.7,187.9,596.6,187.8z"
      />
      <path
        class="st3"
        d="M514.5,186.1C514.5,186.2,514.5,186.2,514.5,186.1C514.6,186.2,514.6,186.2,514.5,186.1
		C514.6,186.2,514.6,186.1,514.5,186.1C514.5,186.2,514.5,186.2,514.5,186.1z"
      />
      <path
        class="st3"
        d="M510.6,187.1c0-0.1,0-0.2,0-0.2C510.6,186.9,510.5,187,510.6,187.1C510.5,187.1,510.6,187.1,510.6,187.1
		L510.6,187.1L510.6,187.1z"
      />
      <polygon class="st3" points="602.5,166.7 602.4,166.6 602.4,166.7 	" />
      <polygon class="st3" points="348.4,242.7 348.5,242.8 348.5,242.7 	" />
      <path
        class="st3"
        d="M596.4,189.2L596.4,189.2C596.5,189.2,596.5,189.2,596.4,189.2c-0.1-0.1-0.2-0.2-0.4-0.3c0,0,0-0.1-0.1-0.1
		c0,0.1,0,0.1,0,0.2C596.1,189,596.3,189.1,596.4,189.2z"
      />
      <path
        class="st3"
        d="M546.7,200.2l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C546.6,200.1,546.7,200.2,546.7,200.2z"
      />
      <path
        class="st3"
        d="M596.7,189.2L596.7,189.2L596.7,189.2C596.6,189.3,596.6,189.2,596.7,189.2z"
      />
      <path
        class="st3"
        d="M540.2,178.9c0,0-0.1-0.1-0.2-0.1l0,0l0,0C540.1,178.9,540.2,178.9,540.2,178.9z"
      />
      <path
        class="st3"
        d="M555.4,198.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C555.4,198.5,555.4,198.6,555.4,198.6z"
      />
      <path
        class="st3"
        d="M447.6,195.8l0.1,0.1l0.1-0.1l-0.1-0.1L447.6,195.8z"
      />
      <path
        class="st3"
        d="M558.8,170L558.8,170c-0.1,0.1-0.1,0.1-0.1,0.1l0,0L558.8,170z"
      />
      <path
        class="st3"
        d="M546.1,172.7l0.1-0.1l-0.1-0.1l-0.1,0.1C546.1,172.7,546.1,172.7,546.1,172.7z"
      />
      <path
        class="st3"
        d="M569,167.3c0,0.1,0,0.2,0.1,0.2l0.1-0.1C569.2,167.3,569.1,167.3,569,167.3z"
      />
      <path
        class="st3"
        d="M507.4,179.4c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C507.5,179.3,507.4,179.4,507.4,179.4z"
      />
      <path
        class="st3"
        d="M559.6,167.8l0.1-0.1C559.7,167.7,559.6,167.7,559.6,167.8C559.6,167.7,559.6,167.8,559.6,167.8z"
      />
      <path
        class="st3"
        d="M559.7,167.7L559.7,167.7c0.1-0.1,0.1-0.1,0.1-0.1C559.8,167.6,559.8,167.6,559.7,167.7
		C559.7,167.6,559.7,167.7,559.7,167.7z"
      />
      <polygon class="st3" points="509.8,177.4 509.8,177.3 509.7,177.4 	" />
      <path
        class="st3"
        d="M421.1,230.4l-0.1-0.1l-0.1,0.1l0.1,0.1C421,230.5,421,230.5,421.1,230.4z"
      />
      <polygon class="st3" points="391.5,238.7 391.4,238.7 391.4,238.8 	" />
      <polygon class="st3" points="486,219.5 486.1,219.5 486.1,219.4 	" />
      <polygon class="st3" points="487.9,219.4 488,219.4 488,219.3 	" />
      <path
        class="st3"
        d="M541.9,207.8l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C541.8,207.7,541.9,207.8,541.9,207.8z"
      />
      <path
        class="st3"
        d="M598.2,198.4l0.1,0.1l0.1-0.1l-0.1-0.1C598.2,198.3,598.2,198.3,598.2,198.4z"
      />
      <polygon class="st3" points="376.1,247.5 376.2,247.4 376.1,247.4 	" />
      <path
        class="st3"
        d="M598.8,199l-0.1,0.1l0.1,0.1l0.1-0.1C598.9,199.1,598.8,199,598.8,199z"
      />
      <polygon class="st3" points="543.9,211.7 544,211.7 544,211.6 	" />
      <path
        class="st3"
        d="M566.8,210.6L566.8,210.6C566.7,210.6,566.7,210.6,566.8,210.6c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0.1,0v-0.1
		C567.1,210.8,566.9,210.7,566.8,210.6z"
      />
      <polygon
        class="st3"
        points="478.3,234.9 478.4,235 478.4,234.9 478.4,234.9 478.4,234.9 	"
      />
      <path
        class="st3"
        d="M584.1,216.1c0.1,0,0.2,0.1,0.2,0.1h0.1c0,0,0,0,0-0.1C584.3,216.2,584.2,216.2,584.1,216.1z"
      />
      <path
        class="st3"
        d="M350.2,267.4c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C350.3,267.3,350.3,267.4,350.2,267.4z"
      />
      <path
        class="st3"
        d="M531.1,231.3L531.1,231.3c0.1-0.1,0.1-0.1,0.1-0.1l0,0L531.1,231.3z"
      />
      <path
        class="st3"
        d="M603.1,221.5c0,0.1,0,0.2-0.1,0.3C603.1,221.7,603.1,221.7,603.1,221.5c0.1,0,0.1-0.1,0.1-0.1
		C603.1,221.5,603.1,221.5,603.1,221.5L603.1,221.5z"
      />
      <path
        class="st3"
        d="M509.9,248.8l0.1,0.1l0.1-0.1C510,248.7,510,248.7,509.9,248.8C509.9,248.7,509.9,248.7,509.9,248.8z"
      />
      <path
        class="st3"
        d="M535.5,246.4l-0.1-0.1l-0.1,0.1l0.1,0.1C535.5,246.5,535.5,246.5,535.5,246.4z"
      />
      <polygon class="st3" points="500,266.3 500.1,266.3 500,266.2 	" />
      <path
        class="st3"
        d="M534.3,200.7c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C534.4,200.5,534.3,200.6,534.3,200.7z"
      />
      <path
        class="st3"
        d="M363.9,76.8c0.6,0.6,1.4,0.7,2.3,0.4c1.9-0.5,3.2-2,3.1-3.6c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6
		c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.3-0.7,0.4-1.1c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7
		c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5
		c-0.7,0-1.2-0.1-1.7-0.1c-1.9,0.2-3.3,1.2-3.8,2.7c-0.2,0.6-0.1,1.1,0.4,1.5C362.6,75.6,363.3,76.2,363.9,76.8z"
      />
      <path
        class="st3"
        d="M426.6,68c0.2,0.3,0.5,0.5,0.9,0.8c0.8-0.3,1.6-0.5,2.4-0.9c1.1-0.6,0.6-1.6,0.9-2.5c1.6,0.2,2.8,0.8,4,1.3
		c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9c0.5,1.3,0.8,2.5,1.2,3.6c0,0.1,0.1,0.3,0.1,0.4c-1.2,0.2-1.9,0.6-2.2,1.2
		c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,1.1,1.2,2,1.1c0.1,0,0.1,0,0.2,0c1.2-0.3,1.7-1.2,1.3-2.9
		c1,0.1,2,0.2,3.2,0.2c-0.8-0.8-1-1-0.9-1.7c0-0.2,0.1-0.4,0.2-0.7c1.8,0.5,3.7,1.1,5.6,1.7c0-0.4,0.1-0.5,0-0.6
		c-0.5-0.9-1.2-1.6-1.1-2.8c0.1-0.9-1.4-1.4-2.4-0.8c-0.8,0.5-1.5,0.4-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.3c-1.5-0.4-2.9-1.1-4.4-1.8
		c0.6-0.2,0.9-0.3,1.7-0.6c-0.7-0.1-1.4-0.3-2-0.4c-0.7-0.1-1.3-0.2-1.9-0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0
		c0,0.5-0.4,0.6-0.7,0.8c-0.5,0.3-0.9,0.7-1,1.1C425.9,66.7,426,67.3,426.6,68z"
      />
      <path
        class="st3"
        d="M310.8,113.1c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.7-0.1,1.4-0.2,1.9-0.5
		c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4s0-0.2,0-0.4
		c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.5-0.1-0.7c-0.1-1.3-0.9-2.3-2.2-3c-0.1,0-0.1,0-0.2-0.1c-2.4-1.1-5.4-0.3-6.6,1.9
		C310.3,111.7,310.2,112.4,310.8,113.1C310.7,113,310.7,113,310.8,113.1z"
      />
      <path
        class="st3"
        d="M389,54.7c0.4,2,2.4,3.1,4.8,2.6s3.9-2.3,3.6-4.3c-0.4-1.9-2.6-3.1-4.9-2.6C390,51,388.6,53,389,54.7z"
      />
      <path
        class="st3"
        d="M499.4,42.5c0.8,0.9,1.6,1.9,3.1,2c0.2,0,0.4,0.2,0.5,0.3c0,0.8-0.3,1.3-1.1,1.8c-1.2,0.8-1.3,2-0.3,2.8
		c0.8,0.7,1.9,0.6,2.8-0.2s0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8c0.4-0.9,0.9-1.6,1.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2
		c0.4-0.2,0.7-0.6,1-1l0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.7,0.3-1.7-0.3-2.1c-0.6-0.5-1.4-1-2.2-1.3
		c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C499,41.8,499.1,42.2,499.4,42.5z"
      />
      <path
        class="st3"
        d="M487,42.7c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0,1.1-0.1,1.6c-0.1,0.2,0,0.5,0.1,1c0.3-0.7,0.4-1.1,0.6-1.6
		c0.5,0.6,0.4,1.1,0.3,1.7c0,0.1,0,0.2,0,0.2c-0.1,0.5-0.2,1,0,1.5c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1
		c1,0.6,1.7,1.4,1.4,2.6c0,0.2,0.5,0.4,0.8,0.6c0.2-0.3,0.6-0.6,0.6-0.9c0-0.4-0.2-0.7-0.4-1.1c0.1-0.1,0.2-0.2,0.3-0.2
		c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.3,1.6,2.6,2.5,3.9c0.4,0.6,0.6,1,0.1,1.7s0,1.3,0.4,1.8s0.9,1,1.9,0.7c0.1-0.4,0.2-0.9,0.3-1.3
		c0.2,0,0.4,0,0.8,0.1c0-0.4,0.2-0.8,0-1c-0.4-0.8-0.3-2-1.6-2.3c-0.2-0.8-0.8-1.4-1.7-1.8c-0.1,0,0.1-0.3,0.1-0.4
		c-0.9-0.3-1.1-1.1-1.6-1.7c-0.2-0.2-0.5-0.5-0.8-0.5c-1.3-0.2-2.1-0.8-2.4-1.7c-0.2-0.7-0.6-1.3-0.9-2c-0.1-0.3-0.4-0.6-0.4-0.8
		c0.3-1.3-0.6-2.1-1.4-2.9c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C486.9,41.7,486.7,42.2,487,42.7z
        M497.4,56.3c-0.5-0.4-0.6-0.9-0.8-1.4C497.2,55.3,497.2,55.4,497.4,56.3z"
      />
      <path
        class="st3"
        d="M402,57.9c-1.7-1.7-3.5-2.1-5.3-1.1c-1.6,0.8-2.4,2.5-1.9,3.8c0.6,1.5,2.4,2.4,4.3,2c2-0.4,3.1-1.8,3.2-4.2
		c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2C402.7,57.8,402.3,57.9,402,57.9z"
      />
      <path
        class="st3"
        d="M370.7,75.4c-2.1,0.5-3.4,2.1-3,3.8c0.3,1.7,2.2,2.7,4.3,2.3c2-0.4,3.5-2.1,3.2-3.8
		C374.8,76,372.8,74.9,370.7,75.4z"
      />
      <path
        class="st3"
        d="M532.4,65.7c-0.3,0.2-0.6,0.4-0.8,0.7c-0.6,0.7-0.8,1.6-0.5,2.5c0,0.1,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2
		c0.2,0.5,0.6,0.8,1.1,1.1c0.3,0.2,0.7,0.3,1.1,0.4c0.1,0,0.2,0,0.3,0c1.2,0.2,2.4,0,3.3-1c0.1-0.1,0.1-0.2,0.2-0.3
		c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.3-0.9,0.4-1.3c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.2-0.1
		c-0.4-0.3-0.9-0.6-1.3-0.9c0,0,0,0-0.1,0c-1.2-0.6-2.6-0.5-3.8,0.2C532.5,65.7,532.5,65.7,532.4,65.7z"
      />
      <path
        class="st3"
        d="M402.9,56.4c0.8,0.9,1.9,1.1,3.1,1c1.5-0.3,3.5-2.3,3.5-3.4c0-0.7-0.4-1.3-1.2-1.5c-0.7-0.2-1.5-0.4-2.3-0.4
		c-1.3-0.1-2.4,0.4-3.2,1.4C402.1,54.3,402.1,55.5,402.9,56.4z"
      />
      <path
        class="st3"
        d="M603.9,43.3c-0.6,0.4-1.1,0.9-1.3,1.6c-0.5,1.5,0.6,3,2.4,3.3c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4
		c0.1-0.9-0.5-1.5-0.7-2.3c-0.5-0.2-0.9-0.4-1.4-0.5C605.9,42.5,604.8,42.8,603.9,43.3z"
      />
      <path
        class="st3"
        d="M406.7,63.9c-0.5-1.2-2.1-1.8-3.6-1.5c-1.8,0.4-3,1.9-2.6,3.4c0.3,1.3,2.1,2.2,3.7,1.9c1-0.2,1.9-0.8,2.4-1.6
		c0.3-0.5,0.5-1.1,0.4-1.7C406.8,64.2,406.7,64.1,406.7,63.9z"
      />
      <path
        class="st3"
        d="M410.1,57.6c-1.7,0.4-2.8,1.8-2.6,3.2c0.3,1.5,1.9,2.4,3.7,2c1.8-0.4,3-1.8,2.6-3.3
		C413.6,58.1,411.9,57.2,410.1,57.6z"
      />
      <path
        class="st3"
        d="M526.5,48.8c1.7-0.4,2.8-1.9,2.5-3.3c-0.3-1.4-2-2.2-3.7-1.9l0,0h-0.1c-0.3,0.1-0.5,0.2-0.8,0.3
		c-0.2,0.1-0.3,0.1-0.4,0.2c-1,0.6-1.5,1.6-1.3,2.7C523,48.4,524.7,49.3,526.5,48.8z"
      />
      <path
        class="st3"
        d="M393.4,70.6c0.2,0.8,0.8,1.4,1.6,1.7c0.6,0.3,1.4,0.4,2.1,0.2c1-0.2,1.9-0.9,2.3-1.7c0.3-0.5,0.4-1,0.2-1.6
		c-0.3-1.3-1.7-2.1-3.4-1.9c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6C393.6,68.7,393.1,69.6,393.4,70.6z"
      />
      <path
        class="st3"
        d="M346.5,95.4c0.5,0.2,1,0.1,1.5-0.1c0.6-0.3,1.1-0.7,1.3-1.2c-0.5-0.2-1.1-0.3-1.6-0.3
		c-1.7,0.1-3.5,0.2-5.2,0.3c0.5,0.3,1.3,0.4,2.4,0.3C345.5,94.9,346,95.2,346.5,95.4z"
      />
      <path
        class="st3"
        d="M341.7,92.8c2.4-0.1,4.8-0.3,7.2-0.4c-0.3-0.2-0.6-0.4-1.1-0.5c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0
		c0,0,0,0-0.1-0.1c-1.5,0.1-2.9,0.1-4.4,0.2C341.8,92.2,341.7,92.5,341.7,92.8z"
      />
      <path
        class="st3"
        d="M343.5,90.7c0.3,0,0.7,0,1,0C344.2,90.5,343.9,90.6,343.5,90.7z"
      />
      <path
        class="st3"
        d="M416,63.5c-1.2,0.1-2.1,0.7-2.6,1.6c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.2,0.4,0.4,0.8,0.6c-0.9,0.4-2.1,0.5-2,1.5
		c0,0.5,0.3,0.9,0.9,1c1.1,0.2,1.6-0.5,1.9-1.2c0.7,0.1,1.2,0.2,1.8,0.1c0.3,0,0.6-0.1,0.9-0.2c1.1-0.4,1.7-1.2,1.7-2.2
		c0-0.6-0.3-1.2-0.7-1.5C417.5,63.7,416.8,63.5,416,63.5z"
      />
      <path
        class="st3"
        d="M531.6,43.7c0.8,0.3,1.7,0.3,2.5-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.9-0.8,1.2-1.9,0.7-2.8c-0.2-0.3-0.4-0.6-0.6-1
		c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.6,0-1.3,0-2,0.1c-1,0.1-1.8,0.6-2.2,1.2c-0.2,0.2-0.3,0.5-0.4,0.8
		C529.9,42.1,530.5,43.2,531.6,43.7z"
      />
      <path
        class="st3"
        d="M331.5,68.4c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9c-0.2-1.2-1.8-2-3.2-1.7
		C332.5,65.9,331.3,67.2,331.5,68.4z"
      />
      <path
        class="st3"
        d="M404.3,76.1c0.1-0.3,0.2-0.6,0.1-1c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.8-0.6-2-0.6-3-0.2h-0.1
		c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.2-0.4,0.3-0.5,0.5c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2s0,0.2,0,0.3
		c0.1,0.6,0.4,1.1,0.6,1.8c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c0.1,0,0.3,0,0.4,0
		C402.9,77.7,403.9,77.1,404.3,76.1z"
      />
      <path
        class="st3"
        d="M406.7,69.4c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5
		c0.3-0.1,0.6-0.2,0.8-0.3c0.5-0.3,0.9-0.7,1.1-1.2c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.9-1.1-1.5-2.1-1.6c-0.3,0-0.7,0-1,0.1
		s-0.6,0.2-0.8,0.3C407.2,69,406.9,69.2,406.7,69.4z"
      />
      <path
        class="st3"
        d="M341.2,76.4c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-1.5,0.4-2.5,1.8-2.1,3C338,76.3,339.7,77,341.2,76.4z"
      />
      <path
        class="st3"
        d="M365.4,66.6c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1.5,0.3-2.6,1.5-2.4,2.8
		C362.6,66.1,363.9,66.9,365.4,66.6z"
      />
      <path
        class="st3"
        d="M552.3,7.6c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C552.1,6,552.1,6.9,552.3,7.6z"
      />
      <path
        class="st3"
        d="M602.2,54.4c0,0.1,0,0.1,0,0.2c0.2,1.2,1.6,1.9,3.1,1.6c1.4-0.3,2.4-1.5,2.2-2.6c-0.2-1.2-1.5-2-3-1.7
		c-1,0.2-1.7,0.8-2.1,1.5C602.2,53.7,602.2,54.1,602.2,54.4z"
      />
      <path
        class="st3"
        d="M517,37.1c0.6-0.1,1.2-0.1,1.7-0.2c0.2,0,0.4-0.1,0.6-0.1c0.9-0.3,1.3-1.2,1.1-2c-0.1-0.3-0.2-0.6-0.5-0.9
		c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.1l0,0c-0.5,0-1,0.2-1.5,0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.2,0.5-0.3,1-0.4,1.4c-0.3,0.1-0.7,0.2-0.9,0.4c-0.1,0-0.1,0.1-0.1,0.1c-0.8,0.6-0.7,1.2,0.1,1.8c0.2,0.1,0.3,0.2,0.5,0.3
		c0.1,0,0.3,0,0.4-0.1C516.7,38.4,517.1,37.8,517,37.1z"
      />
      <path
        class="st3"
        d="M406.6,78c-0.9-0.2-1.4,0.1-2.3,1.3c0.2,0.3,0.5,0.6,0.7,0.9c-0.1,0.1-0.2,0.1-0.2,0.2
		c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.5,1.3,2.2s1.3,0.8,2.2,0.7c0.9-0.2,1.5-0.7,1.8-1.5s0-1.4-0.7-1.9
		c-0.4-0.2-0.8-0.4-1.3-0.6C407.1,78.6,407.4,78.1,406.6,78z"
      />
      <path
        class="st3"
        d="M325.6,96.8c0.3-0.2,0.6-0.4,0.9-0.7c0.2-0.2,0.4-0.3,0.6-0.5c-0.1-0.2-0.2-0.5-0.3-0.7
		c-1.5,0.1-2.9,0.2-4.4,0.3c0,0.4,0.1,0.8,0.3,1.2C323.3,97.4,324.5,97.6,325.6,96.8z"
      />
      <path
        class="st3"
        d="M326,93.5c-0.3-0.3-0.6-0.5-0.5-0.9c-0.5,0-1.1,0-1.6,0.1c0,0.4-0.4,0.6-0.7,1c-0.1,0.1-0.1,0.2-0.2,0.2
		c1-0.1,2.1-0.1,3.1-0.2C326.1,93.7,326.1,93.6,326,93.5z"
      />
      <path
        class="st3"
        d="M375.3,111.2c0-0.1,0-0.2,0-0.3c-0.1-0.7-0.9-1-1.6-1.3c0.2-0.2,0.3-0.3,0.4-0.4l0.1-0.1
		c0.4-0.5,0.3-0.7-0.1-1.3l-0.1-0.1c0-0.1-0.1-0.2,0-0.2c0.6-0.4,0.1-0.8-0.1-1c-0.3-0.2-0.7-0.4-1.1-0.5h-0.1
		c-0.6-0.1-1.3,0.4-1.1,0.8c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.6,0.1,1.3,0.6,1.8c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2
		l-0.1,0.1c-0.2,0.2-0.4,0.4-0.5,0.6c0.8,0.6,1.6,1.2,2.4,1.9C375.1,111.9,375.2,111.6,375.3,111.2z"
      />
      <path
        class="st3"
        d="M372.1,111.4c0,0.2,0,0.4,0.1,0.6c0.2,0.4,0.7,0.8,1.5,1.2c0.2-0.1,0.3-0.1,0.4-0.2c-0.5-0.4-1.1-0.8-1.6-1.2
		C372.3,111.6,372.2,111.5,372.1,111.4z"
      />
      <path
        class="st3"
        d="M378.3,100.3h-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.8,0.7-1.6,1.5-2.6,2.4c0.4,0.1,0.8,0.2,1.2,0.2
		c0.4,0.1,0.7,0.2,1,0.3l0,0c0.1,0,0.3,0.1,0.4,0.1c0.8,0.4,1.6,0.5,2.4,0c1,1.3,1,1.3,2.6,1c0.1-0.5,0.2-1,0.3-1.6c0,0,0,0-0.1,0
		c-0.7-0.1-1.3-0.3-2-0.4c-0.3-0.9-0.7-1.4-1.6-1.7c-0.1,0-0.2-0.1-0.2-0.1C378.8,100.4,378.6,100.4,378.3,100.3z"
      />
      <path
        class="st3"
        d="M537.7,37.1c0.2,1.1,1.6,1.8,3,1.5s2.2-1.4,2-2.5s-1.5-1.7-2.9-1.5C538.4,34.9,537.5,36,537.7,37.1z"
      />
      <path
        class="st3"
        d="M557.6,32.1c0.3-1.2-1.2-2.2-2.6-1.9c-1,0.2-1.7,0.9-1.9,1.8c-0.1,0.8,0.3,1.6,1.2,1.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.5,0.1,1,0.3,1.4,0.6c0.1,0.1,0.6-0.1,0.8-0.2c0.1-0.1,0.2-0.5,0.1-0.5c-0.2-0.2-0.3-0.4-0.3-0.5
		C557.4,33,557.5,32.5,557.6,32.1z"
      />
      <path
        class="st3"
        d="M413.8,74.3c-0.7-1.1-0.7-1.1-2.3-1.2c0.5,1.1,1,1.9,0.4,3c-0.4,0.9,0.5,1.8,1.6,1.9c0.8,0.1,1.5-0.1,2-0.5
		c0.1-0.1,0.3-0.3,0.4-0.4s0.1-0.2,0.2-0.2c0.2-0.4,0.3-0.8,0.2-1.2c-0.1-0.5-0.5-0.9-1.1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2
		C414.1,74.4,414,74.4,413.8,74.3z"
      />
      <path
        class="st3"
        d="M544.5,44.2c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.7-0.8,2-1.6c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3
		c-0.2-1.1-1.5-1.8-2.8-1.5c-0.9,0.2-1.5,0.8-1.8,1.5c-0.2,0.4-0.2,0.7-0.1,1.1C543.2,43.4,543.8,44,544.5,44.2z"
      />
      <path
        class="st3"
        d="M572.7,21.7c-0.6,0.2-1.2,0.6-1.7,1c-0.7,0.6-0.8,1.5-0.3,2.1s1.8,0.9,2.6,0.6s1.5-0.7,2.2-1.1
		c-0.2-1.1-0.5-1.6-0.9-2.2C574.1,21.6,573.4,21.4,572.7,21.7z"
      />
      <path
        class="st3"
        d="M432.2,42.7c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.2,0.2-0.5,0.3-0.8,0.4C431.4,42.2,431.6,42.6,432.2,42.7z"
      />
      <path
        class="st3"
        d="M371.3,60.8c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C368.7,60.6,370,61.2,371.3,60.8z"
      />
      <path
        class="st3"
        d="M388.4,50.2c1.2-0.3,2.1-1.4,1.9-2.4s-1.5-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C386,49.8,387.2,50.4,388.4,50.2z"
      />
      <path
        class="st3"
        d="M592.6,58.8c-0.8-0.6-1.6-0.1-2.5,0.1c-0.3-1.3-1.7-0.7-2.7-1c-0.3,0.4-0.5,0.8-0.8,1.1c0.8,0.7,1.6,1.3,2.3,2
		c0.5,0,1-0.2,1.4-0.1c0.8,0.3,1.6,0.1,2.4-0.1C592.9,60.1,593.4,59.4,592.6,58.8z"
      />
      <path
        class="st3"
        d="M374.7,64.2c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3
		c-1.3,0.2-2.1,1.1-2,2.2C374.5,63.9,374.6,64,374.7,64.2z"
      />
      <path
        class="st3"
        d="M401.9,86.2c0-0.2,0-0.3,0-0.5c-1.5,0-2.9,0-4.4-0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.2,0,0.3,0,0.5
		c0.2,1.1,1.3,1.7,2.6,1.5c0.1,0,0.2-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5C401.6,86.9,401.9,86.6,401.9,86.2z"
      />
      <path
        class="st3"
        d="M399.4,84.1c-0.3,0.1-0.6,0.2-0.8,0.3c0.9,0,1.8,0,2.7,0C400.8,84.1,400.2,84,399.4,84.1z"
      />
      <path
        class="st3"
        d="M558.6,31.3c0.5,0.3,1.2,0.5,2.2,0.7c-0.2,1,0.1,1.7,1.2,2.2c0.6-1.2,0.6-1.2-0.5-2.5c0.9-0.9,0.9-1,0.6-1.4
		c-0.4-0.4-0.8-0.9-1.3-1.2c-0.5-0.4-1.1-0.7-1.8-0.8C557.7,29.7,557.6,30.7,558.6,31.3z"
      />
      <path
        class="st3"
        d="M592.4,54.4c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C592.1,54.1,592.3,54.2,592.4,54.4z"
      />
      <path
        class="st3"
        d="M334.4,79.3c-0.2-0.9-1.4-1.6-2.5-1.4c-0.2,0-0.4,0.1-0.6,0.2c1,0.8,2,1.5,2.9,2.3
		C334.4,80.1,334.5,79.7,334.4,79.3z"
      />
      <path
        class="st3"
        d="M333.2,81.3c-1-0.8-2-1.6-3-2.3c-0.3,0.4-0.5,0.9-0.4,1.3c0.2,1,1.4,1.5,2.6,1.3
		C332.8,81.5,333,81.4,333.2,81.3z"
      />
      <path
        class="st3"
        d="M387.4,60.8c-0.4-1.6-0.1-3.4-0.8-5c-2.1,0.8-3,1.8-2.6,3.2C384.2,60.4,385.3,61,387.4,60.8z"
      />
      <path
        class="st3"
        d="M340.1,86.6c-1.4,0-2.8,0.1-4.2,0.1c0.3,0.9,1.5,1.5,2.5,1.2C339.3,87.8,339.9,87.3,340.1,86.6z"
      />
      <path
        class="st3"
        d="M335.9,85.8c0.7,0,1.4,0,2.1,0c0.1-0.2,0.1-0.3,0.2-0.5c-0.3-0.3-0.6-0.5-0.9-0.8
		C336.6,84.7,336.1,85.2,335.9,85.8z"
      />
      <path
        class="st3"
        d="M349.6,90.4c0.4,0,0.7,0,1.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.7,0,1.4-0.2,1.9-0.7c0.2-0.2,0.3-0.3,0.4-0.6
		c0-0.1,0.1-0.1,0.1-0.2c0.3-1.1-0.7-1.6-1.5-2.1c-0.9,0.4-1.6,0.7-2.4,1.1C349.5,88.4,349.4,89.4,349.6,90.4z"
      />
      <path
        class="st3"
        d="M390.9,62.6c-1.2,0.2-2,1.3-1.8,2.3c0.2,0.9,1.5,1.5,2.5,1.2c1.1-0.3,1.9-1.3,1.7-2.2
		C393.2,62.9,392,62.4,390.9,62.6z"
      />
      <path
        class="st3"
        d="M571.1,44.5C571.1,44.5,571.1,44.4,571.1,44.5c-0.2-0.4-0.3-0.6-0.4-0.9c-0.7,0.4-1.4,0.8-2,1.2
		c0.2-0.5,0.5-0.8,0.8-1.1c0.4-0.4,0.8-0.8,0.3-1.2c-0.4-0.3-0.9,0-1.3,0.3c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4-0.2-0.7-0.3-1.6-0.6
		c0.6,1.2,0.3,2-0.5,2.7c-0.3,0.3-0.2,0.7-0.4,1.4c0.9-0.5,1.5-0.7,2.2-1.1c0.2,0.2,0.4,0.5,0.6,0.7
		C569.1,45.7,569.3,44.4,571.1,44.5L571.1,44.5z"
      />
      <path
        class="st3"
        d="M308.4,65.7c-0.2-0.8-1.2-1.4-2.2-1.3V68c0.2,0,0.3,0,0.5-0.1C307.9,67.7,308.6,66.7,308.4,65.7z"
      />
      <path
        class="st3"
        d="M576.7,54.6c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2c-0.4,0.1-0.8,0.3-1.1,0.5
		c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5c0.4,0.8-0.2,1.5-0.5,2.2l0,0C576.2,54,576.4,54.3,576.7,54.6z"
      />
      <path
        class="st3"
        d="M394.9,82.6C394.9,82.6,395,82.6,394.9,82.6c0.5,0.2,1.1,0.1,1.7-0.2c-0.7-1.2-0.1-2.8-1.6-3.9
		c-0.6,0.4-1.2,0.7-1.5,1.1c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.8-0.3,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.3,0.6,0.6,0.9,0.9
		C394.5,82.4,394.7,82.5,394.9,82.6z"
      />
      <path
        class="st3"
        d="M376.8,71.6c-0.1,0-0.3,0.1-0.4,0.2c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c1,0.7,1.9,1.4,2.9,2
		c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2s0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		C378.1,71.7,377.4,71.5,376.8,71.6z"
      />
      <path
        class="st3"
        d="M363.9,103.6c0.7,0.6,1.4,1.1,2.2,1.7c0.2,0,0.4-0.1,0.6-0.2c0.1-0.9-1.7-1.1-0.5-2.2c0.7,0.4,1.3,0.9,2.2,0.1
		c-0.1-0.9-0.7-1.3-1.7-1.5c-0.3,0-0.8,0-0.8,0.2c-0.2,0.4-0.5,0.5-1,0.6C364.1,102.5,363.8,103,363.9,103.6z"
      />
      <path
        class="st3"
        d="M449.4,61.1c0,0.1,0.1,0.1,0.2,0.2c0.7,0.2,1.5,0.3,2.3,0.5c0.1-0.2,0.2-0.5,0.2-0.6s0.1-0.2,0.1-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.5,1-0.7
		c0.2-0.1,0.5-0.2,0.7-0.2c-0.6-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.7,0.5-1.3,0.8-1.8,1.3c-0.2,0.1-0.2,0.3-0.3,0.4
		c-0.1,0.3,0.1,0.7,0.2,1c0,0.1-0.2,0.3-0.4,0.5C449.3,60.7,449.3,61,449.4,61.1z"
      />
      <path
        class="st3"
        d="M544,51.2c-0.3,0-0.5,0-0.8,0c-1.1,0.2-1.7,1-1.5,1.9c0.1,0.4,0.3,0.8,0.7,1s0.9,0.3,1.4,0.2
		c1-0.2,1.7-1.1,1.6-1.9C545.3,51.7,544.7,51.3,544,51.2z"
      />
      <path
        class="st3"
        d="M497.9,31.9c1-0.2,1.7-0.8,1.5-1.3c-0.3-1.1-1.2-1.6-2.5-1.3c-1.1,0.3-1.6,0.8-1.5,1.5
		C495.5,31.7,496.6,32.2,497.9,31.9z"
      />
      <path
        class="st3"
        d="M557.8,38.3c-0.2-0.8-1.2-1.3-2.2-1.1s-1.7,1.1-1.5,1.9c0.2,0.8,1.2,1.2,2.1,1C557.3,39.8,558,39.1,557.8,38.3
		z"
      />
      <path
        class="st3"
        d="M442.8,32.9c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5C441.4,32,441.8,32.5,442.8,32.9z"
      />
      <path
        class="st3"
        d="M580.5,54.6c0.1,0.3,0.2,0.6,0,0.8c-1,1.3-0.4,2.1,0.8,2.9c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.1
		c0.6-0.6,1.4-1.2,1-1.9c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1s-0.5-0.6-1.2-0.7C580.4,54.2,580.4,54.2,580.5,54.6z"
      />
      <path
        class="st3"
        d="M428.2,76.6c-0.2-0.8-1.1-1.2-2.1-1.1c-1,0.2-1.6,0.9-1.6,1.7c0,0.1,0,0.2,0.1,0.3c0.2,0.6,0.9,1,1.6,1
		c0.1,0,0.3,0,0.4,0C427.6,78.4,428.4,77.4,428.2,76.6z"
      />
      <path
        class="st3"
        d="M364.9,59.3c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C362.9,58.9,363.9,59.5,364.9,59.3z"
      />
      <path
        class="st3"
        d="M606.6,20.3c0.4,0.5,1.1,0.8,1.9,0.7c0.9-0.2,1.6-1,1.5-1.8c-0.1-0.3-0.2-0.6-0.5-0.8
		c-0.4-0.3-0.9-0.4-1.5-0.4c-1,0.1-1.8,1.1-1.6,1.9C606.5,20.1,606.6,20.2,606.6,20.3z"
      />
      <path
        class="st3"
        d="M332.4,96.2c-0.1-0.4-0.5-0.7-0.7-1.1c-0.6,0.1-1,0.1-1.4,0.3c-1,0.3-1.5,1.1-1.2,1.9c0.3,0.7,1.3,1.1,2.2,0.8
		C332.2,97.8,332.7,97,332.4,96.2z"
      />
      <path
        class="st3"
        d="M586.2,66c0.9,0.5,0,1.4,0.5,1.9c1.5,0.6,1.5,0.6,2.9-0.2c0.1-0.5,0.2-1.1,0.3-1.5c-0.8-0.9-2.2-0.3-3-0.9
		C586.6,65.2,585.9,65.9,586.2,66z"
      />
      <path
        class="st3"
        d="M420.6,80.9c-0.4-0.4-1-0.6-1.6-0.5c-0.9,0.2-1.6,1-1.5,1.8s0.9,1.3,1.9,1.2c0.1,0,0.1,0,0.1,0
		c1-0.2,1.6-1,1.4-1.8C420.9,81.3,420.8,81,420.6,80.9z"
      />
      <path
        class="st3"
        d="M541.2,34c0.9-0.3,1.6-1.3,1.4-2c-0.2-0.7-0.9-1.1-1.7-0.9c-1.1,0.3-2,1.4-1.8,2.2
		C539.2,33.7,540.6,34.2,541.2,34z"
      />
      <path
        class="st3"
        d="M348.8,68.5c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C347.7,67.1,348,67.9,348.8,68.5z"
      />
      <path
        class="st3"
        d="M500,46.6c-0.9,0.5-1.6,0.8-2.1,1.2c-0.7,0.4-1.1,1-1.1,1.7c0.1,0.8,0.8,1.1,1.6,0.8c0.6-0.3,1.1-0.7,1.6-0.9
		C500,48.5,500,47.7,500,46.6z"
      />
      <path
        class="st3"
        d="M329.8,90.2c-0.1,0-0.1,0-0.2,0c-0.7,0.1-1.2,0.6-1.4,1.2c1.2-0.1,2.3-0.1,3.5-0.2
		C331.6,90.5,330.7,90.1,329.8,90.2z"
      />
      <path
        class="st3"
        d="M330.3,93h0.1c0.4-0.1,0.7-0.3,0.9-0.6c-1,0-1.9,0.1-2.9,0.1C328.9,93,329.6,93.2,330.3,93z"
      />
      <path
        class="st3"
        d="M357.4,75.3c0.3-1.9-0.6-2.7-3-2.8C353.6,74.5,354.6,75.5,357.4,75.3z"
      />
      <path
        class="st3"
        d="M381.5,62.7c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8
		C379.8,62.5,380.6,62.9,381.5,62.7z"
      />
      <path
        class="st3"
        d="M400.7,50.4c0.9-0.2,1.4-1,1.3-1.7s-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7C398.8,50.2,399.7,50.6,400.7,50.4z"
      />
      <path
        class="st3"
        d="M375.8,109.5c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0c0.5,0,1.1,0,1.6,0c0.4,0,0.7,0,0.9-0.1c0.7-0.1,0.8-0.4,1.3-1.5
		c-0.6-0.3-1.2-0.7-1.7-1c-0.5,0.2-0.8,0.2-1,0.4l0,0c-0.3,0.2-0.6,0.5-1,0.8c-0.5,0.3-0.8,0.7-0.6,1.2l0,0l0,0
		c-0.1,0.2-0.1,0.4-0.1,0.6C375.5,109.4,375.8,109.5,375.8,109.5z"
      />
      <path
        class="st3"
        d="M411.6,51.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C412,49.8,411.4,50.5,411.6,51.3z"
      />
      <path
        class="st3"
        d="M410.4,47.7L410.4,47.7c1-0.2,1.5-0.9,1.4-1.6c0-0.1,0-0.2-0.1-0.3c-0.2-0.6-0.9-0.9-1.7-0.8
		c-0.9,0.1-1.6,1-1.5,1.7C408.6,47.4,409.5,47.9,410.4,47.7z"
      />
      <path
        class="st3"
        d="M549.5,56.7C549.5,56.7,549.4,56.7,549.5,56.7C549.4,56.7,549.4,56.7,549.5,56.7
		C549.5,56.8,549.5,56.8,549.5,56.7L549.5,56.7z"
      />
      <path
        class="st3"
        d="M551.6,57.3c0.7,0.9,1.2,0.8,2.1-0.3c-0.7-1.1-2-1.5-3.3-1.9c-0.3-0.1-0.9,0-1.2,0.2c-0.4,0.3-0.2,0.6,0,0.9
		c0.1,0.1,0.1,0.3,0.2,0.5C550.3,56.6,551,56.6,551.6,57.3z"
      />
      <path
        class="st3"
        d="M337.6,97.3c-0.3-0.6-0.9-0.9-1.7-0.9c-0.9,0.1-1.5,0.4-1.7,1.3c0.8,0.5,1.5,1.1,2.4,1.7
		C337.6,98.8,338,98.1,337.6,97.3z"
      />
      <path
        class="st3"
        d="M440.1,31c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C439.9,33,440.4,32,440.1,31z"
      />
      <path
        class="st3"
        d="M577.5,26.5c0.6,0.3,1.3,0.2,1.8-0.3c0.4-0.3,0.7-0.7,1-1.2c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7
		c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C577.1,26.2,577.3,26.4,577.5,26.5z"
      />
      <path
        class="st3"
        d="M346.6,82.7c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.4,0.7-0.4,1.4,0.1,2.1C344.5,82.8,345.1,83,346.6,82.7z"
      />
      <path
        class="st3"
        d="M460.4,72c-1-0.7-1.2-0.7-1.7,0.2c-0.2,0.4-0.7,0.4-0.9,0.7c-0.3,0.3-0.7,0.7-0.7,1V74c0.7,0,1.4,0,2.1,0
		c0.1-0.2,0.1-0.4,0.2-0.6c0.2-0.3,0.4-0.6,0.6-1C460.2,72.4,460.3,72.2,460.4,72z"
      />
      <path
        class="st3"
        d="M378.8,82.5c-0.2-0.7-1-1.1-1.8-0.8c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3
		c0.3,0.4,0.9,0.6,1.5,0.4C378.4,83.8,378.9,83.2,378.8,82.5z"
      />
      <path
        class="st3"
        d="M602,33.7c0.8-0.1,1.4-0.8,1.3-1.5c-0.1-0.7-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4
		C600.4,33.4,601.1,33.9,602,33.7z"
      />
      <path
        class="st3"
        d="M562,47.7c0.1-0.7,0.2-1.1,0.3-1.5c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.7-1.5,0.4-2.1-1.1-2.2c-0.1,0-0.3,0-0.4,0
		c-0.7,0-1.1,0.4-0.8,0.9s0.5,0.9,0.4,1.4C561.1,47,561.5,47.2,562,47.7z"
      />
      <path
        class="st3"
        d="M438.6,76.6c-0.8,0.2-1.4,0.8-1.2,1.5c0.1,0.7,1,1.1,1.8,0.9c0.7-0.2,1.3-0.8,1.2-1.4
		C440.2,76.9,439.4,76.5,438.6,76.6z"
      />
      <path
        class="st3"
        d="M366.2,93.4c0.7,0.4,1.5,0.5,2.3-0.1c-0.1-0.3-0.2-0.5-0.3-0.7c-0.9,0.1-1.9,0.1-2.8,0.2
		C365.6,93,365.9,93.2,366.2,93.4z"
      />
      <path
        class="st3"
        d="M348.8,80.7c0.1-1.6-0.4-2.1-2.6-2.4C346,80.2,346.7,80.8,348.8,80.7z"
      />
      <path
        class="st3"
        d="M342.4,99.9c0.4,0,0.9-0.1,1.3-0.1c0.8-0.7,1-1.1,0.6-1.5c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.3-0.7-0.4-1.2-0.3
		c-0.7,0.1-1.1,0.5-1.2,1.1C341.6,99.4,341.9,99.7,342.4,99.9z"
      />
      <path
        class="st3"
        d="M562.4,26.2c0.7-0.4,1.3-0.7,1.9-0.9c0.1-0.8-0.2-1.3-1.2-1.8c-0.1,1.1-2.1,0.7-2.2,2.1
		C561.4,25.8,561.9,26,562.4,26.2z"
      />
      <path
        class="st3"
        d="M445.2,68.9c0.6,0.1,1.4-0.2,2-0.4c0.1-0.8,0.1-1.5,0.2-2.3c-0.6,0.3-1.2,0.5-1.7,0.8
		c-0.6,0.2-1.1,0.5-1.7,0.7C444.4,68.2,444.7,68.8,445.2,68.9z"
      />
      <path
        class="st3"
        d="M430.9,83.6c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8s-1.2-0.4-2.1,0.2c-0.2,0.2-0.4,0.3-0.7,0.6
		C430.3,83.1,430.6,83.4,430.9,83.6z"
      />
      <path
        class="st3"
        d="M316.2,120.5c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7c-0.1-0.2-0.1-0.4-0.3-0.5
		c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C315.1,119.8,315.5,120.3,316.2,120.5z"
      />
      <path
        class="st3"
        d="M324.8,101c-0.4,0.1-0.7,0.3-0.9,0.5c0.7-0.1,1.5-0.1,2.2-0.2C325.8,101,325.3,100.9,324.8,101z"
      />
      <path
        class="st3"
        d="M323.6,102.4c0,0.3,0.3,0.6,0.6,0.7c0.2,0.1,0.4,0.2,0.7,0.2c0.2,0,0.3,0,0.5,0c0.6-0.1,1-0.7,1.1-1.2
		C325.5,102.2,324.5,102.3,323.6,102.4C323.6,102.3,323.6,102.4,323.6,102.4z"
      />
      <path
        class="st3"
        d="M374,97.8c0.2-0.1,0.3-0.1,0.5-0.2c0-0.1,0-0.1-0.1-0.2c-0.5-1.5-1-1.7-2.9-1.6c-0.6,0.7-0.2,1.3,0.5,1.7
		C372.6,97.9,373.3,98.1,374,97.8z"
      />
      <path
        class="st3"
        d="M568.1,14.1c0.6-0.1,1.2-0.1,1.8-0.2c1.1-0.1,2.3-0.2,3.5-0.3c-1.5-1.2-3-1.3-4.3-0.5
		C568.8,13.4,568.5,13.7,568.1,14.1z"
      />
      <path
        class="st3"
        d="M417.4,70.8c-0.2-0.5-0.9-0.8-1.6-0.6c-0.7,0.2-1.1,0.7-1,1.3c0.1,0.7,0.8,1,1.6,0.8c0.3-0.1,0.6-0.2,0.8-0.4
		c0.3-0.3,0.4-0.6,0.3-1C417.5,70.9,417.4,70.9,417.4,70.8z"
      />
      <path
        class="st3"
        d="M393,83.3c-0.1-0.6-0.8-1-1.6-0.8c-0.8,0.1-1.3,0.8-1.2,1.4c0,0.2,0.2,0.4,0.3,0.5c0.7,0,1.3,0,2,0
		C392.9,84.1,393.1,83.7,393,83.3z"
      />
      <path
        class="st3"
        d="M550.4,45c0.5-0.3,1-0.6,1.5-0.9c0.4,0.5,1,0.4,1.6,0c-0.5-0.9-1.4-1-2.5-1c-0.8,0-1.2,0.2-1.5,0.7
		c0,0.1-0.1,0.2-0.1,0.3s0,0.2,0.1,0.3C549.6,44.7,549.9,44.9,550.4,45z"
      />
      <path
        class="st3"
        d="M438.2,54.1c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3s-0.2,0.2-0.3,0.4
		c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C437.8,55.1,438.1,54.7,438.2,54.1z"
      />
      <path
        class="st3"
        d="M509.3,39.9c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.4-0.3,0.6-0.7,0.6-1.1
		c-0.1-0.6-0.9-1-1.6-0.8C509.7,38.7,509.1,39.4,509.3,39.9z"
      />
      <path
        class="st3"
        d="M513.4,43.8c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.8-1.1,0.9-1.5,0.3-1.9l0,0c-0.4-0.3-0.8-0.4-1.3-0.2
		h-0.1c-0.5,0.2-0.8,0.5-0.8,1C512.4,43.3,512.7,43.6,513.4,43.8z"
      />
      <path
        class="st3"
        d="M416.2,44.4c0.7-0.2,1.1-0.8,0.9-1.4c-0.2-0.5-0.9-0.9-1.5-0.7c-0.7,0.2-1.1,0.8-1,1.4
		C414.7,44.3,415.5,44.7,416.2,44.4z"
      />
      <path
        class="st3"
        d="M568.9,12.5c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C567.5,12.4,568.2,12.6,568.9,12.5z"
      />
      <path
        class="st3"
        d="M322.2,108.1c0.6-0.1,1.2-0.8,1-1.3c-0.1-0.5-0.7-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.2
		C320.9,107.8,321.6,108.2,322.2,108.1z"
      />
      <path
        class="st3"
        d="M416.7,55.2c-0.1,0.2-0.1,0.4,0,0.5c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3
		c-0.1-0.3-0.4-0.6-0.8-0.7c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1C417.1,54.6,416.8,54.9,416.7,55.2z"
      />
      <path
        class="st3"
        d="M332.7,43.5c0.7-0.1,1.2-0.7,1.1-1.3s-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C331.3,43.2,332,43.6,332.7,43.5z"
      />
      <path
        class="st3"
        d="M445.7,56.9c-0.7,0.2-1.3,0.5-1.3,1.2c0.5,0.5,1,0.9,1.5,1.5c0.7,0,1.1-0.3,1-0.8
		C446.7,58.2,446.5,57.4,445.7,56.9z"
      />
      <path
        class="st3"
        d="M451.9,66.6c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.4,0.5-0.8,1-1.2,1.6c0.1,0.1,0.3,0.3,0.6,0.3
		c0.6,0,1.1-0.1,1.7-0.1C452.4,67.5,452.4,66.9,451.9,66.6z"
      />
      <path
        class="st3"
        d="M406.7,30.6c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C405.4,30.3,406.1,30.7,406.7,30.6z"
      />
      <path
        class="st3"
        d="M550.5,63.8c-0.5,0.1-0.9,0.6-0.8,1.1c0,0.2,0.1,0.4,0.3,0.6c0.3,0.4,0.8,0.6,1.2,0.5c0.5-0.1,1-0.7,0.9-1.1
		c0-0.1,0-0.1-0.1-0.2C551.7,64.2,551,63.7,550.5,63.8z"
      />
      <path
        class="st3"
        d="M384,54.7c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C382.7,54.5,383.4,54.8,384,54.7z"
      />
      <path
        class="st3"
        d="M514.8,40.7c1.2-0.2,1.5-1.1,0.6-2c-0.5,0.2-1.1,0.4-1.6,0.7c-0.2,0.2-0.4,0.8-0.2,0.9
		C513.8,40.6,514.4,40.8,514.8,40.7z"
      />
      <path
        class="st3"
        d="M452.3,68.1c0.2,0.2,0.4,0.5,0.7,0.6c0.5,0.1,0.9,0.2,1.1,0.6s0.7,0.5,1.2,0.2c0.4-0.2,0.4-0.9-0.1-1.2
		c-0.5-0.3-1.1-0.6-1.7-0.9C453.1,67.6,452.7,67.9,452.3,68.1z"
      />
      <path
        class="st3"
        d="M390.1,110.2c0.4-0.6,0.9-1.1,1.3-1.7c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.1-0.9,0l-0.1,0.1
		c-0.4,0.3-0.8,0.7-0.9,1.2C389.2,109.9,389.6,110.1,390.1,110.2z"
      />
      <path
        class="st3"
        d="M330.3,59.8c-0.2,1.2-0.3,2.4-0.4,3.5C331.8,61.9,331.8,60.9,330.3,59.8z"
      />
      <path
        class="st3"
        d="M544.5,65.6c0.4,0.6,0.7,1.2,1.5,1.3c0.3,0.1,0.7-0.2,1.1-0.3C546.3,64.9,546.2,64.8,544.5,65.6z"
      />
      <path
        class="st3"
        d="M443,83.1L443,83.1c-0.3,0.5-0.1,1.1,0.5,1.2c0.7,0.2,1.2-0.1,1.9-1.4c-0.2-0.1-0.4-0.1-0.6-0.2
		c-0.3-0.1-0.5-0.1-0.7-0.1s-0.3,0-0.4,0C443.3,82.6,443.2,82.8,443,83.1z"
      />
      <path
        class="st3"
        d="M309,117.4c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C309,117.3,309,117.4,309,117.4z"
      />
      <path
        class="st3"
        d="M353.4,85c-0.2-0.1-0.5-0.1-0.9-0.2c0,0.1,0,0.2,0,0.3C352.9,85,353.1,85,353.4,85z"
      />
      <path
        class="st3"
        d="M352.9,86.2c0.3,0.4,0.9,0.5,1.8,0.3c0-0.1-0.1-0.3-0.1-0.4C354.1,86.2,353.5,86.2,352.9,86.2z"
      />
      <path
        class="st3"
        d="M552.8,3.5c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C551.8,3.2,552.3,3.6,552.8,3.5z"
      />
      <path
        class="st3"
        d="M442.2,36c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2S441.5,35.9,442.2,36z"
      />
      <path
        class="st3"
        d="M435.1,34.1c0.1,0.5,0.7,0.9,1.2,0.8c0.5-0.1,0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C435.3,32.9,435,33.6,435.1,34.1z"
      />
      <path
        class="st3"
        d="M387.6,106.3c0.5-0.6,0.9-1.1,1.4-1.7c-0.1-0.1-0.2-0.2-0.4-0.3C387.2,105.5,387,105.7,387.6,106.3z"
      />
      <path
        class="st3"
        d="M486.5,37.9c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C487.2,38.6,487.2,38.3,486.5,37.9z"
      />
      <path
        class="st3"
        d="M517.6,40.1c-0.8,0.2-1.3,0.6-1.5,1.5c1.2-0.2,2.3-0.2,3.3-0.7C519,40.2,518.4,39.9,517.6,40.1z"
      />
      <path
        class="st3"
        d="M398.9,96.4c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.2-0.4-0.3-0.7-0.3c-0.4,0.4-0.7,0.9-1.1,1.4
		c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.5,0.3,0.9,0.2C398.4,97.3,398.8,96.8,398.9,96.4z"
      />
      <path
        class="st3"
        d="M595.4,44.6c-0.6,0.1-1.1,0.6-1,1.1c0.1,0.4,0.7,0.7,1.2,0.6c0.5-0.1,0.9-0.6,0.9-1.1
		C596.5,44.9,595.9,44.5,595.4,44.6z"
      />
      <path
        class="st3"
        d="M565.3,16.8c0.7-0.3,1-0.8,0.9-1.5c-1.1,0-2,0.2-2.6,1.1C564.1,16.9,564.7,17,565.3,16.8z"
      />
      <path
        class="st3"
        d="M399.7,88.2c-0.4,0.5-0.7,0.7-0.7,1c0.7,0,1.3,0,2,0.1C401.1,88.9,400.7,88.6,399.7,88.2z"
      />
      <path
        class="st3"
        d="M570.3,21c-0.1-0.5-0.8-0.8-1.4-0.6c-0.5,0.2-0.9,0.7-0.7,1.2c0.1,0.4,0.7,0.7,1.3,0.6
		C570,22,570.4,21.5,570.3,21z"
      />
      <path
        class="st3"
        d="M345.6,61.4c-0.1-0.9-0.7-1.4-1.9-1.6C343.3,61.5,343.8,61.9,345.6,61.4z"
      />
      <path
        class="st3"
        d="M493.8,42.9c0.5-0.1,1.1-0.7,0.8-1.1c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-1,0.5-0.9,1
		C492.6,42.7,493.2,43,493.8,42.9z"
      />
      <path
        class="st3"
        d="M485.3,46.1c0.2-0.3,0.2-0.7,0.1-1l-0.1-0.1c-0.2,0-0.6,0-0.8,0c-0.5,0.2-0.9,0.5-1.4,0.9
		c0.4,0.3,0.7,0.5,1,0.6C484.6,46.7,485,46.6,485.3,46.1z"
      />
      <path
        class="st3"
        d="M507.5,35.8c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C507.9,34.7,507.4,35.3,507.5,35.8z"
      />
      <path
        class="st3"
        d="M493,54.7c0.2-0.8,0.1-1.5-1-2.2c0.1,1.1-0.8,2.1,0.3,3.1C492.6,55.2,492.9,54.9,493,54.7z"
      />
      <path
        class="st3"
        d="M393.5,77c-0.1-0.4-0.7-0.7-1.2-0.6s-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6C393.1,78.1,393.6,77.4,393.5,77z"
      />
      <path
        class="st3"
        d="M567.7,50c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C568.2,50.6,568,50.3,567.7,50z"
      />
      <path
        class="st3"
        d="M356.4,91.7c0.1,0.1,0.2,0.1,0.3,0.2c0.5,0,1-0.1,1.4-0.1c0,0,0,0,0.1-0.1c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.7,0-1.3,0.1-2,0.1C356.3,91.4,356.3,91.6,356.4,91.7z"
      />
      <path
        class="st3"
        d="M585,53.7c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C584.6,53.6,584.8,53.7,585,53.7z"
      />
      <path
        class="st3"
        d="M476.2,34.4c-0.2-0.9-0.8-1.3-2.1-1.1C474.6,34.8,474.9,34.9,476.2,34.4z"
      />
      <path
        class="st3"
        d="M482.4,62.8c0.1,0.5,0.3,0.7,0.4,0.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1
		C484.1,62.2,483.6,62.3,482.4,62.8z"
      />
      <path
        class="st3"
        d="M413.4,36.4c-1.3,0.9-1.3,0.9-0.8,2C414.2,37.3,414.2,37.3,413.4,36.4z"
      />
      <path
        class="st3"
        d="M454.9,66.3c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2s0.7-0.7,0.6-1.4
		C455.8,66.1,455.3,66.1,454.9,66.3z"
      />
      <path
        class="st3"
        d="M421.1,43.6c-0.3-0.7-0.8-1-1.5-1c-0.2,0-0.5,0.1-0.6,0.3c-0.1,0.1-0.1,0.4,0,0.6
		C419.3,44,419.9,44,421.1,43.6z"
      />
      <path
        class="st3"
        d="M592.7,66.6c0.1-0.6-0.2-0.9-1.1-1c-0.2,0.6-0.4,1.2-0.7,2.2C592,67.5,592.6,67.2,592.7,66.6z"
      />
      <path
        class="st3"
        d="M552.4,14.9c0.3-0.5,0.7-0.8,0.7-1.2s-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C551.5,14.5,551.9,14.6,552.4,14.9z"
      />
      <path
        class="st3"
        d="M570.7,51.1c0.6-0.6,0.9,0.3,1.4,0.1c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2c-0.1,0-0.1,0-0.2,0
		c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3C570.3,50.9,570.6,51,570.7,51.1z"
      />
      <path
        class="st3"
        d="M553.3,39.5c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C552.6,39.7,553.2,39.6,553.3,39.5z"
      />
      <path
        class="st3"
        d="M435.6,62.5c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C434.5,62.2,435.1,62.7,435.6,62.5z"
      />
      <path
        class="st3"
        d="M307.3,106.1c0.1-0.1,0.1-0.3,0.1-0.4c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1s0,0,0,0.1v1.2
		c0.2,0.1,0.5,0.3,0.7,0.5C307.1,106.6,307.2,106.3,307.3,106.1z"
      />
      <path
        class="st3"
        d="M434.8,21.6c0.5-1.1,0.5-1.1-0.8-1.8C433.7,21.2,433.7,21.2,434.8,21.6z"
      />
      <path
        class="st3"
        d="M308.7,55c0.6-0.1,0.8-0.5,0.7-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c-0.3,0.2-0.7,0.6-0.7,1S308.1,55.2,308.7,55z"
      />
      <path
        class="st3"
        d="M492.8,47.7c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C492.4,46.9,492.2,47.4,492.8,47.7z"
      />
      <path
        class="st3"
        d="M557.6,48.4c0.1,0.7,0.2,1.1,0.1,1.4c0,0.1,0,0.1,0,0.2c0,0.5,0.4,0.6,0.9,0.7l0,0c0.2,0,0.5,0.1,0.7,0.1
		c0-0.5-0.3-0.9-0.7-1.3C558.3,49.2,557.9,48.8,557.6,48.4z"
      />
      <path
        class="st3"
        d="M582,58.4c-0.1,0.2,0.1,0.6,0.3,0.7c0.9,0.3,1.1-0.3,1.4-0.9C582.6,57.8,582.1,57.8,582,58.4z"
      />
      <path
        class="st3"
        d="M444.6,30.2c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9S444.3,30,444.6,30.2z"
      />
      <path
        class="st3"
        d="M581.3,72.4c-0.2,0.3-0.5,0.6-0.6,0.9c0,0.1,0.2,0.2,0.4,0.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0.1,0.3,0.1
		c0.5-0.1,1.1,0,1.4-0.7C582.5,72.5,581.9,72.4,581.3,72.4z"
      />
      <path
        class="st3"
        d="M362.4,88c-0.5-0.6-1-1-1.9-1C360.4,88.4,360.8,88.6,362.4,88z"
      />
      <path
        class="st3"
        d="M425.4,39.5c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C423.9,39.1,424.5,39.3,425.4,39.5z"
      />
      <path
        class="st3"
        d="M485.7,42.4c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C484.5,42.3,485.2,42.2,485.7,42.4z"
      />
      <path
        class="st3"
        d="M483.7,50.9c0.2-0.3,0.4-0.5,0-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.4-1.2,0.9c0.4,0.2,0.6,0.4,1,0.7
		C483.3,51.3,483.6,51.1,483.7,50.9z"
      />
      <path
        class="st3"
        d="M434.3,50.3C434.3,50.3,434.2,50.3,434.3,50.3c-0.3-0.2-0.5-0.4-0.8-0.4c-0.4,0-0.8,0.2-1.3,0.3
		c0.3,0.2,0.5,0.5,0.7,0.6c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.7,0,1-0.2C434.2,50.7,434.4,50.4,434.3,50.3z"
      />
      <path
        class="st3"
        d="M565.7,31c0,0.2,0.5,0.6,0.8,0.6s0.6-0.4,1.1-0.8c-0.5-0.2-0.9-0.6-1.2-0.5C566.1,30.3,565.7,30.8,565.7,31z"
      />
      <path
        class="st3"
        d="M435.6,37.3c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3c-0.1-0.1-0.7-0.1-0.9,0
		c-0.2,0.1-0.2,0.6-0.1,0.8C434.8,36.8,435.2,37,435.6,37.3z"
      />
      <path
        class="st3"
        d="M587.7,61.8c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C588.4,61.2,587.8,61.2,587.7,61.8z"
      />
      <path
        class="st3"
        d="M561.3,49.5c-0.3-0.8-1.4-0.5-1.9-1l0,0l0,0C559.1,49.5,559.5,49.7,561.3,49.5z"
      />
      <path
        class="st3"
        d="M319.4,98.4c1-1,0.8-1.3-0.7-1.4C318.6,97.6,318.8,98.1,319.4,98.4z"
      />
      <path
        class="st3"
        d="M427.8,33.2c0.3-1.1,0.3-1.1-1.3-1.4C426.6,32.5,426.8,33,427.8,33.2z"
      />
      <path
        class="st3"
        d="M572.9,52.2L572.9,52.2c0.2,0.2,0.7,0.3,0.9,0.2c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C572.1,51.5,572.5,51.9,572.9,52.2z"
      />
      <path
        class="st3"
        d="M538.1,11.7c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C537.7,12.1,538.1,11.9,538.1,11.7z"
      />
      <path
        class="st3"
        d="M307.1,85.5c-0.2,0.4-0.3,0.6-0.4,0.9c0.4,0,0.8,0,1.2,0C307.9,85.9,307.7,85.6,307.1,85.5z"
      />
      <path
        class="st3"
        d="M330.7,87.7c0.2-0.3,0.5-0.6,0.5-0.8c-0.5,0-1,0-1.4,0c0,0.1,0,0.2,0.1,0.3C329.9,87.4,330.3,87.5,330.7,87.7z
		"
      />
      <path
        class="st3"
        d="M380.7,106.4c0.1-1-0.2-1.4-1.2-1.8c0.3,0.3,0.7,0.6,0.6,0.9C380,106,379.9,106.3,380.7,106.4z"
      />
      <path
        class="st3"
        d="M553.4,28.6c0.3-0.1,0.4-0.4,0.7-0.9c-0.5-0.1-0.9-0.3-1.2-0.2c-0.2,0.1-0.5,0.5-0.4,0.7
		C552.5,28.7,553,28.8,553.4,28.6z"
      />
      <path
        class="st3"
        d="M408,84.2c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0-0.1,0.3-0.1,0.4c0.4,0,0.8,0,1.3,0C408.3,84.4,408.2,84.3,408,84.2z"
      />
      <path
        class="st3"
        d="M430.9,53.2c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C430.1,53.8,430.6,53.9,430.9,53.2z"
      />
      <path
        class="st3"
        d="M310.5,133.4c-0.1,0-0.1-0.1-0.2,0l-0.1,0.1C310.4,133.4,310.4,133.4,310.5,133.4z"
      />
      <path
        class="st3"
        d="M524.5,40.8c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.2,0.4-0.4,0.8-0.8c0,0-0.1,0-0.1-0.1c-0.4-0.2-0.7-0.4-1-0.4
		c-0.1,0-0.2,0.1-0.3,0.3c-0.1,0.1-0.2,0.3-0.1,0.3c0,0.1,0.1,0.1,0.2,0.2C524.4,40.7,524.4,40.7,524.5,40.8z"
      />
      <path
        class="st3"
        d="M460.6,32.6c0.4-0.5,0.8-0.9,0.2-1.4C459.8,32,459.8,32,460.6,32.6z"
      />
      <path
        class="st3"
        d="M471.8,50c0.2,0.1,0.4,0.2,0.6,0.3c-0.1-0.5,0.2-0.9-0.1-1.3l0,0c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0,0-0.1,0.1
		s-0.2,0.2-0.3,0.3c-0.4,0.4-0.5,0.6-0.2,0.8C471.6,49.9,471.7,50,471.8,50z"
      />
      <path
        class="st3"
        d="M440.1,72c0.3,0.1,0.7-0.1,1.1-0.1c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6
		C439.4,71.6,439.6,71.9,440.1,72z"
      />
      <path
        class="st3"
        d="M423.8,40.9c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C422.7,40.7,423,41.1,423.8,40.9z"
      />
      <path
        class="st3"
        d="M564.6,49.5c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5
		C564.2,48.8,564.4,49.2,564.6,49.5z"
      />
      <path
        class="st3"
        d="M507.9,49.2c0.2,0.5,0.3,0.8,0.5,0.9c0.2,0.1,0.5,0.1,1.2,0.1l0,0C509,49.7,508.9,49,507.9,49.2z"
      />
      <path
        class="st3"
        d="M551.7,40.8C551.7,40.8,551.6,40.8,551.7,40.8c-0.1,0-0.2,0-0.2,0.1c-0.2,0.4-0.2,0.6,0.1,0.8
		c0.2,0.1,0.4,0.3,0.8,0.5c0-0.3,0-0.5,0-0.7C552.2,41.3,552,41,551.7,40.8z"
      />
      <path
        class="st3"
        d="M481.9,45c-0.4,0.3-0.8,0.5-1.2,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.3-0.4,0.6-0.8,0.8-1.2
		C482.2,45.4,482,45.3,481.9,45z"
      />
      <path
        class="st3"
        d="M481.3,46.7L481.3,46.7C481.2,46.7,481.2,46.7,481.3,46.7C481.2,46.8,481.3,46.8,481.3,46.7L481.3,46.7z"
      />
      <path
        class="st3"
        d="M508.5,15.7c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C507.9,16.3,508.1,16.1,508.5,15.7z"
      />
      <path
        class="st3"
        d="M400.5,70.6c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C400,69.7,400,69.7,400.5,70.6z"
      />
      <path
        class="st3"
        d="M429.5,43.6c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C429.7,43.2,429.4,43.5,429.5,43.6z"
      />
      <path
        class="st3"
        d="M438.7,29.6c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4C438,29.1,438,29.5,438.7,29.6z
		"
      />
      <path
        class="st3"
        d="M555.3,45.3c-0.3-0.4-0.6-0.8-1.2-1.4c-0.1,0.6-0.3,0.9-0.2,1.1C554.2,45.3,554.4,45.8,555.3,45.3z"
      />
      <path
        class="st3"
        d="M339.1,101.7c0.1-0.3,0.1-0.5,0-0.7c-0.2,0-0.3,0-0.5,0l-0.1,0.1c-0.2,0.3,0,0.4,0.4,0.9
		C339,101.9,339,101.8,339.1,101.7z"
      />
      <path
        class="st3"
        d="M372.3,90.5c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c0,0.2,0,0.4,0,0.6c0.4,0,0.7,0,1.1-0.1
		C372.8,90.8,372.6,90.6,372.3,90.5z"
      />
      <path
        class="st3"
        d="M428.6,27.1c0.4-0.9-0.2-1.1-1-1.3C427.5,26.5,427.6,27.1,428.6,27.1z"
      />
      <path
        class="st3"
        d="M441.3,79.8c0.5,0.1,0.8,0.3,1.2,0.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.3-0.4-0.5-0.8-0.9-1.4
		C441.7,79.1,441.5,79.4,441.3,79.8z"
      />
      <path
        class="st3"
        d="M489.6,55.1c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C489.7,54.7,489.5,55,489.6,55.1z"
      />
      <path
        class="st3"
        d="M579.8,65.8c0.4-1.2,0.4-1.2-0.9-1.7C579.2,64.7,579.4,65.1,579.8,65.8z"
      />
      <path
        class="st3"
        d="M592.1,52.1c-0.2-0.3-0.4-0.6-0.8-1.1C590.8,51.9,591.2,52.1,592.1,52.1z"
      />
      <path
        class="st3"
        d="M579.2,67.3c0.1,0.1,0.2,0.2,0.3,0.3c0.5-0.1,1.2-0.1,1.5-0.8c-0.4-0.1-0.7-0.2-0.9-0.2
		C579.8,66.8,579.5,67.1,579.2,67.3z"
      />
      <path
        class="st3"
        d="M490.8,53c-0.2-0.1-0.6-0.3-0.7-0.2c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C490.5,53.4,490.6,53.2,490.8,53z"
      />
      <path
        class="st3"
        d="M330.6,109.7c0.6,0,0.9,0,1.2,0c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.2-0.1-0.3
		c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2,0.2-0.4,0.4-0.7,0.7C331,109.3,330.8,109.5,330.6,109.7z"
      />
      <path
        class="st3"
        d="M441.9,57.3c0,0,0-0.1,0.1-0.3c-1-0.3-1.1-0.3-1.3,0c-0.1,0.1-0.1,0.3-0.1,0.4C441,57.8,441.5,57.6,441.9,57.3
		z"
      />
      <path
        class="st3"
        d="M494.7,12.8c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C494,12.8,494.3,12.9,494.7,12.8z"
      />
      <path
        class="st3"
        d="M444.4,71c0.3,0,0.7,0,1,0.1c0-0.2,0.1-0.3,0.1-0.5c-0.3,0-0.7-0.1-1-0.1C444.5,70.7,444.5,70.9,444.4,71z"
      />
      <path
        class="st3"
        d="M437.1,43.7c0.1,0,0.4-0.1,0.4-0.2c0.2-0.5-0.1-0.7-0.8-0.8C436.5,43.2,436.4,43.6,437.1,43.7z"
      />
      <path
        class="st3"
        d="M463.3,31.8c0.1-0.3,0.3-0.5,0.4-0.8c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.4-0.3,0.7-0.3,0.9
		C462.7,31.7,463.1,31.7,463.3,31.8z"
      />
      <path
        class="st3"
        d="M476.4,38.2c-0.4-0.1-0.7-0.2-0.8-0.2c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2C475.8,38.7,476.1,38.5,476.4,38.2z"
      />
      <path
        class="st3"
        d="M391.9,79.2c0.7,0.3,1.1,0.1,1.4-0.6C392.5,78.4,392.1,78.6,391.9,79.2z"
      />
      <path
        class="st3"
        d="M441.3,60.7c0.2-0.1,0.4-0.3,0.7-0.5c-0.3-0.1-0.6-0.3-0.7-0.3c-0.2,0.1-0.4,0.3-0.5,0.5
		C440.8,60.4,441.2,60.7,441.3,60.7z"
      />
      <path
        class="st3"
        d="M440.8,48.6L440.8,48.6c-0.2-0.1-0.5-0.2-0.7-0.2s-0.4,0.2-0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.3c0.1,0,0.2,0,0.3,0
		c0.1,0,0.3,0,0.4-0.1C440.8,48.9,440.9,48.6,440.8,48.6z"
      />
      <path
        class="st3"
        d="M318.8,87.9c-0.2,0.2-0.3,0.3-0.3,0.5c0.2,0.2,0.4,0.4,0.6,0.6C318.9,88.6,318.8,88.3,318.8,87.9z"
      />
      <path
        class="st3"
        d="M313.9,102.2c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C312.8,101.3,312.9,101.7,313.9,102.2z"
      />
      <path
        class="st3"
        d="M578.6,66.3c-0.4-0.4-0.8-0.6-1.6,0.1C577.7,66.6,578.1,67.1,578.6,66.3z"
      />
      <path
        class="st3"
        d="M498.8,55.4c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.4,0.6-0.6c-0.3-0.1-0.6-0.3-0.7-0.2
		C499,54.9,498.8,55.2,498.8,55.4z"
      />
      <path
        class="st3"
        d="M390.6,102.6L390.6,102.6c0.2-0.2,0.4-0.4,0.6-0.7c-0.3-0.1-0.6-0.2-0.7-0.1s-0.2,0.2-0.2,0.3
		c-0.1,0.1-0.1,0.2-0.2,0.3C390.2,102.5,390.5,102.7,390.6,102.6z"
      />
      <path
        class="st3"
        d="M393.1,99.5c0.2-0.2,0.4-0.4,0.5-0.7C393.1,99,393,99.1,393.1,99.5z"
      />
      <path
        class="st3"
        d="M470.3,43.1c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C470.1,42.5,470.2,42.8,470.3,43.1z"
      />
      <path
        class="st3"
        d="M477.1,51.2c-0.7,0.5-1,1-0.6,1.6C476.9,52.3,477.3,51.8,477.1,51.2z"
      />
      <path
        class="st3"
        d="M573.7,8.7c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C573.5,8.8,573.6,8.7,573.7,8.7z"
      />
      <path
        class="st3"
        d="M465.3,41.6c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C464.9,41.4,465.1,41.5,465.3,41.6z"
      />
      <path
        class="st3"
        d="M550.1,57.8c-0.2-0.3-0.4-0.7-0.7-1c-0.1,0-0.2,0-0.4,0C548.6,57.6,549.2,57.7,550.1,57.8z"
      />
      <path
        class="st3"
        d="M558.9,43.8c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C558.4,43.4,558.7,43.6,558.9,43.8z"
      />
      <path
        class="st3"
        d="M393.1,106.4c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.3-0.1-0.5-0.1
		c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1C392.6,106.1,392.8,106.2,393.1,106.4z"
      />
      <path
        class="st3"
        d="M578.6,71.1c-0.5,0.5-0.5,0.9,0,1.3C579.2,71.9,579,71.5,578.6,71.1z"
      />
      <path
        class="st3"
        d="M437.4,58.5c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C436.9,58.2,437.1,58.3,437.4,58.5z"
      />
      <path
        class="st3"
        d="M571.1,37.1c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C570.8,37.1,571,37.1,571.1,37.1z"
      />
      <path
        class="st3"
        d="M480.5,48.1c0.2-0.5,0.5-0.9,0.7-1.4c-0.4,0.1-0.7,0.1-0.8,0.2c-0.1,0-0.1,0.1-0.1,0.1l0,0
		c-0.1,0.2,0,0.5,0.2,0.9C480.5,48.1,480.5,48.1,480.5,48.1z"
      />
      <path
        class="st3"
        d="M543.3,63.7c-0.1-1.2-0.7-2.1-2.5-2c-0.2,0.3-0.5,0.6-0.7,0.9c-0.5,1,0.2,1.9,1.5,1.8c0.4,0,0.7-0.2,1.1-0.3
		v0.1c0,0,0,0,0.1,0c0.4,0.7,0.5,0.7,1.4-0.1C543.8,63.9,543.6,63.8,543.3,63.7L543.3,63.7L543.3,63.7z"
      />
      <path
        class="st3"
        d="M339.4,104.1c0-0.2-0.3-0.3-0.7-0.5c-0.2,0.3-0.3,0.6-0.3,0.8c0,0.1,0.4,0.3,0.5,0.3
		C339.1,104.4,339.4,104.2,339.4,104.1z"
      />
      <path
        class="st3"
        d="M401.4,32.3c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C401.2,32.7,401.3,32.5,401.4,32.3z"
      />
      <path
        class="st3"
        d="M356,81.6c-0.3,0.3-0.6,0.5-0.8,0.8c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1
		C356.2,81.7,356.1,81.7,356,81.6z"
      />
      <path
        class="st3"
        d="M333.5,105.5l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.3-0.5,0.4s-0.2,0.1-0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3C333.1,106,333.3,105.7,333.5,105.5z"
      />
      <path
        class="st3"
        d="M553,48.3c0,0.8,0.8,0.6,1.2,0.8C554,48.6,553.7,48.2,553,48.3z"
      />
      <path
        class="st3"
        d="M410.7,64.3c0.3,0.4,0.4,0.7,0.7,1.2C411.6,64.7,411.6,64.3,410.7,64.3z"
      />
      <path
        class="st3"
        d="M547.3,63.2c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C547.6,62.2,547.4,62.5,547.3,63.2z"
      />
      <path
        class="st3"
        d="M434.4,46.8L434.4,46.8c-0.1,0-0.1,0.1-0.1,0.1C434.3,46.9,434.4,46.9,434.4,46.8
		C434.4,46.9,434.4,46.8,434.4,46.8z"
      />
      <path
        class="st3"
        d="M434.4,46.8c0.6-0.1,1.1-0.2,1.7-0.4C435.3,46,435.3,46,434.4,46.8z"
      />
      <path
        class="st3"
        d="M381.9,101c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.4
		c-0.2,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.1,0,0.2,0,0.2C381.8,100.7,381.8,100.8,381.9,101z"
      />
      <path
        class="st3"
        d="M437.3,56.6c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C437,57,437.2,56.8,437.3,56.6z"
      />
      <path
        class="st3"
        d="M416.7,80.3c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.6-0.3,0.9-0.5c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.2,0.1-0.4,0.1-0.6,0.2C416.8,80,416.8,80.2,416.7,80.3z"
      />
      <path
        class="st3"
        d="M335,108.9c0.5-0.1,0.7-0.3,0.6-0.8c0-0.1-0.4-0.2-0.4-0.1C334.7,108.3,334.6,108.6,335,108.9z"
      />
      <path
        class="st3"
        d="M568.4,48c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C569,48.6,568.8,48.4,568.4,48z"
      />
      <path
        class="st3"
        d="M475,47.2c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0.2-0.3,0.4-0.4,0.6c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1
		c0.2-0.1,0.4-0.3,0.7-0.6C475.3,47.3,475.2,47.2,475,47.2z"
      />
      <path
        class="st3"
        d="M481.7,61.1C481.7,61,481.7,61,481.7,61.1h-0.1C481.7,61.1,481.7,61.1,481.7,61.1L481.7,61.1z"
      />
      <path
        class="st3"
        d="M482.6,61.7c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.6-0.7-0.3-1.1-0.3C481.8,61.5,481.9,61.8,482.6,61.7z"
      />
      <path
        class="st3"
        d="M484.1,60c-0.1,0.2-0.3,0.5-0.4,0.7c0.2,0,0.4,0.1,0.4,0.1c0.2-0.2,0.3-0.4,0.5-0.6
		C484.4,60.1,484.2,60,484.1,60z"
      />
      <path
        class="st3"
        d="M361.8,84.6c0,0.1,0,0.1,0,0.2c0.5,0,1,0,1.5,0c0-0.1,0-0.1,0-0.2c-0.4,0-0.8,0-1.3,0.1
		C362,84.5,361.9,84.5,361.8,84.6z"
      />
      <path
        class="st3"
        d="M589.5,56.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C588.7,56.9,589.1,56.8,589.5,56.6z"
      />
      <path
        class="st3"
        d="M370.1,108.4c0.3,0.2,0.6,0.5,0.9,0.7c-0.2-0.3-0.5-0.5-0.7-0.8C370.2,108.3,370.1,108.3,370.1,108.4z"
      />
      <path
        class="st3"
        d="M539.7,60.4c-0.1,0.6,0.3,0.8,1,1.1C540.6,60.8,540.4,60.5,539.7,60.4z"
      />
      <path
        class="st3"
        d="M432.6,21.4c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C432.4,21.5,432.5,21.5,432.6,21.4z"
      />
      <path
        class="st3"
        d="M385.7,112.2c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.7,0.2-1,0.3C385,112.4,385.5,112.7,385.7,112.2z"
      />
      <path
        class="st3"
        d="M559.4,35.6c-0.1-0.4-0.1-0.8-1.1-0.9c0.3,0.5,0.5,0.8,0.7,1.1C559.1,35.7,559.3,35.7,559.4,35.6z"
      />
      <path
        class="st3"
        d="M382.7,110.2C382.8,110.1,382.8,110.1,382.7,110.2c-0.1-0.2-0.3-0.2-0.5-0.2s-0.5,0.1-0.8,0.1
		c0.1,0,0.2,0.1,0.3,0.1C382.1,110.4,382.4,110.6,382.7,110.2z"
      />
      <path
        class="st3"
        d="M573.8,46c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0C573.7,46.6,573.8,46.3,573.8,46z"
      />
      <path
        class="st3"
        d="M557.2,51.5c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1,0-0.2,0.1-0.3,0.1
		C556.9,50.9,557,51.2,557.2,51.5z"
      />
      <path
        class="st3"
        d="M588,64.5c0,0.1-0.1,0.2-0.1,0.3c0.3,0,0.6,0.1,0.9,0.1c0-0.1,0.1-0.2,0.1-0.3C588.6,64.6,588.3,64.6,588,64.5
		z"
      />
      <path
        class="st3"
        d="M436.3,47.8c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C436.4,47.4,436.3,47.6,436.3,47.8z"
      />
      <path
        class="st3"
        d="M447.7,61.5c0,0.5,0.4,0.5,1,0.3c-0.3-0.2-0.4-0.4-0.6-0.6C448,61.2,447.7,61.4,447.7,61.5z"
      />
      <path
        class="st3"
        d="M473.7,44.5c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C473.4,44.8,473.5,44.6,473.7,44.5z"
      />
      <path
        class="st3"
        d="M420.5,39c0.4,0.2,0.7,0.4,1.2,0.7C421.6,38.8,421.2,38.7,420.5,39z"
      />
      <path
        class="st3"
        d="M484.4,20.8c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C483.8,21.3,484.1,21.3,484.4,20.8z"
      />
      <path
        class="st3"
        d="M523.7,50.5c0.2-0.3,0.5-0.5,0.7-0.8c0,0,0,0,0.1-0.1l0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.3,0.3-0.7,0.6-1,1
		C523.4,50.4,523.6,50.4,523.7,50.5z"
      />
      <path
        class="st3"
        d="M483.7,55.6c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C483.6,54.8,483.5,55.2,483.7,55.6z"
      />
      <path
        class="st3"
        d="M484.1,54.6L484.1,54.6c0.1-0.1,0.1-0.2,0.2-0.2C484.2,54.4,484.2,54.5,484.1,54.6L484.1,54.6z"
      />
      <path
        class="st3"
        d="M441.6,64.7C441.6,64.7,441.7,64.7,441.6,64.7c0.3,0,0.5-0.2,0.6-0.3l0,0c0-0.1-0.2-0.2-0.4-0.4
		c-0.2,0.2-0.4,0.4-0.5,0.5C441.3,64.5,441.5,64.7,441.6,64.7z"
      />
      <path
        class="st3"
        d="M533.6,63.3c-0.2,0.1-0.3,0.3-0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C534,63.5,533.7,63.3,533.6,63.3z"
      />
      <path
        class="st3"
        d="M465.4,75.6c0-0.1-0.1-0.2-0.3-0.3c-0.1,0-0.2,0-0.3,0c-0.1,0.2-0.2,0.4-0.1,0.5s0.3,0.2,0.5,0.3
		C465.3,75.9,465.4,75.8,465.4,75.6z"
      />
      <path
        class="st3"
        d="M408.2,88.7c-0.1-0.3-0.2-0.6-0.3-0.9C407.5,88.5,407.5,88.5,408.2,88.7z"
      />
      <path
        class="st3"
        d="M479.8,47c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2C479.6,47,479.7,47,479.8,47z"
      />
      <path
        class="st3"
        d="M553,30.7c-0.2-0.3-0.5-0.5-0.8-1C552.1,30.4,552.3,30.7,553,30.7z"
      />
      <path
        class="st3"
        d="M553.2,41.8c0,0,0.1,0.2,0.2,0.3c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2
		C553.6,41.5,553.4,41.6,553.2,41.8z"
      />
      <path
        class="st3"
        d="M442.9,65.7c0,0,0-0.2,0-0.3c-0.3,0.1-0.6,0.1-0.9,0.2c0,0.1,0.1,0.2,0.1,0.3
		C442.4,65.9,442.6,65.8,442.9,65.7z"
      />
      <path
        class="st3"
        d="M486,58.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.2-0.2-0.3-0.3-0.4-0.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.1,0.1-0.2,0.2-0.3,0.4C485.6,58,485.9,58.2,486,58.2z"
      />
      <path
        class="st3"
        d="M585.7,48.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0.1,0.1,0.1
		C585.4,48.2,585.5,48.4,585.7,48.6z"
      />
      <path
        class="st3"
        d="M594.9,58.4c0.4,0.2,0.6,0.3,1,0.4C595.6,58.3,595.6,58.3,594.9,58.4z"
      />
      <path
        class="st3"
        d="M447.9,59c0.2,0,0.4-0.2,0.6-0.3c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C447.6,58.9,447.7,59.1,447.9,59z"
      />
      <path
        class="st3"
        d="M576.7,0.6c-0.1-0.2-0.3-0.4-0.4-0.6H576l0,0c0.2,0.2,0.3,0.5,0.5,0.7C576.6,0.7,576.7,0.6,576.7,0.6z"
      />
      <path
        class="st3"
        d="M386.9,99.5L386.9,99.5c-0.1,0-0.2,0-0.2,0c0,0.1,0,0.1,0.1,0.2c0.1,0.2,0.2,0.4,0.2,0.6
		c0.1,0,0.2-0.1,0.3-0.1h0.1c0-0.1-0.1-0.1-0.1-0.2C387.1,99.8,387,99.6,386.9,99.5z"
      />
      <path
        class="st3"
        d="M538.5,70.4c-0.7-0.3-1.1-0.4-1.5-0.6C537.1,70.3,537.5,70.6,538.5,70.4z"
      />
      <path
        class="st3"
        d="M537.1,69.8C537,69.8,537,69.7,537.1,69.8C537,69.7,537,69.7,537.1,69.8C537,69.8,537,69.8,537.1,69.8
		C537,69.8,537,69.8,537.1,69.8z"
      />
      <path
        class="st3"
        d="M451,35.9c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8C450.7,35.9,450.8,35.9,451,35.9z"
      />
      <path
        class="st3"
        d="M430.1,30.7c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5
		C430,30.9,430.2,30.8,430.1,30.7z"
      />
      <path
        class="st3"
        d="M433.2,27c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C432.9,27.1,433.2,27,433.2,27z"
      />
      <path
        class="st3"
        d="M543.2,64.9c-0.5,0.3-0.8,0.5-1.3,0.8C542.8,65.6,542.8,65.6,543.2,64.9z"
      />
      <path
        class="st3"
        d="M388.9,99c0.1-0.3,0.3-0.5,0.4-0.8c-0.1,0-0.2-0.1-0.2-0.1c-0.2,0.2-0.4,0.5-0.6,0.7
		C388.7,98.9,388.8,99,388.9,99z"
      />
      <path
        class="st3"
        d="M333.8,95.5c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.3,0-0.4,0c0,0.2,0,0.4,0,0.6C333.6,95.5,333.7,95.5,333.8,95.5z
		"
      />
      <path
        class="st3"
        d="M495.3,46c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.2-0.1-0.4-0.2-0.5-0.2
		C495.5,45.8,495.4,45.9,495.3,46z"
      />
      <path
        class="st3"
        d="M433.5,22.7c0-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		C433,22.5,433.3,22.6,433.5,22.7z"
      />
      <path
        class="st3"
        d="M539.7,77.3c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4c0.1,0.1,0.2,0.3,0.2,0.3
		C539.2,77.6,539.5,77.5,539.7,77.3z"
      />
      <path
        class="st3"
        d="M557.5,73.4c0.6-0.3,1-0.5,1.4-0.6C558.3,72.6,557.8,72.6,557.5,73.4z"
      />
      <path
        class="st3"
        d="M537.7,64.2c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0.2,0.5,0.4c0.1-0.1,0.1-0.1,0.2-0.2l0,0
		c-0.2-0.2-0.4-0.4-0.5-0.6C537.9,64,537.8,64.1,537.7,64.2z"
      />
      <path
        class="st3"
        d="M538.4,66.3c0.3-0.1,0.7-0.1,1-0.2V66C539.1,66.1,538.7,66.1,538.4,66.3C538.4,66.2,538.4,66.2,538.4,66.3z"
      />
      <path
        class="st3"
        d="M469.9,36.4c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C469.7,36.7,469.8,36.5,469.9,36.4z"
      />
      <path
        class="st3"
        d="M462.1,8.8c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3C461.8,8.7,462,8.8,462.1,8.8z"
      />
      <path
        class="st3"
        d="M596,40.6c-0.1,0-0.3,0-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0,0.2,0,0.3,0C595.7,41,595.8,40.8,596,40.6z"
      />
      <path
        class="st3"
        d="M502.3,1.3c0.1-0.2,0.2-0.3,0.3-0.5c0,0-0.1-0.1-0.3-0.2c-0.1,0.2-0.2,0.3-0.3,0.5
		C501.9,1.1,502.2,1.2,502.3,1.3z"
      />
      <path
        class="st3"
        d="M477.4,44.4c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C477.1,44.8,477.2,44.6,477.4,44.4z"
      />
      <path
        class="st3"
        d="M453.5,57.8c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.3-0.3-0.4-0.4C453.7,57.6,453.6,57.7,453.5,57.8z"
      />
      <path
        class="st3"
        d="M459.7,37.3c0.1,0,0.3-0.2,0.3-0.3s-0.2-0.2-0.2-0.3c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1,0.1c0.2,0,0.3,0.1,0.4,0.1
		C459.7,37.3,459.7,37.3,459.7,37.3z"
      />
      <path
        class="st3"
        d="M433.9,30.1c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C433.9,29.9,433.8,30,433.9,30.1z"
      />
      <path
        class="st3"
        d="M610.7,15.7c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C610.6,15.7,610.7,15.7,610.7,15.7z"
      />
      <path
        class="st3"
        d="M550,38.7c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.1-0.1-0.2-0.1c0,0,0,0,0,0.1
		c-0.1,0.1-0.1,0.2-0.1,0.3C549.7,38.6,549.9,38.7,550,38.7z"
      />
      <path
        class="st3"
        d="M578.7,61.5c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.3,0.5,0.5,0.7
		C578.5,61.7,578.6,61.6,578.7,61.5z"
      />
      <path
        class="st3"
        d="M440.3,29.6c-0.1-0.3-0.1-0.7-0.7-0.7C439.7,29.2,439.6,29.6,440.3,29.6z"
      />
      <path
        class="st3"
        d="M569.4,35c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0
		C569.5,35.5,569.5,35.3,569.4,35C569.5,35,569.5,35,569.4,35C569.5,35,569.4,35,569.4,35z"
      />
      <path
        class="st3"
        d="M435.1,48.1c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1V48C435,48.1,435,48.1,435.1,48.1z"
      />
      <path
        class="st3"
        d="M435.8,48.6c-0.3-0.2-0.5-0.3-0.7-0.5C435.2,48.4,435.1,48.8,435.8,48.6z"
      />
      <path
        class="st3"
        d="M389.4,75l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3C389.1,74.8,389.2,74.9,389.4,75z"
      />
      <path
        class="st3"
        d="M388.2,102.4c-0.1,0.1-0.1,0.1-0.2,0.2l0.1,0.1c0.2,0.2,0.3,0.3,0.5,0.5c0.1-0.1,0.2-0.2,0.3-0.2
		c-0.2-0.1-0.3-0.3-0.5-0.4C388.4,102.4,388.3,102.4,388.2,102.4z"
      />
      <path
        class="st3"
        d="M383.7,42c-0.3-0.1-0.5-0.2-0.6-0.2s-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.3,0.4,0.3C383.2,42.3,383.4,42.1,383.7,42
		z"
      />
      <path
        class="st3"
        d="M518.4,14c0.1-0.2,0.2-0.3,0.2-0.4c0-0.1-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C518,13.8,518.2,13.8,518.4,14z"
      />
      <path
        class="st3"
        d="M580.5,51.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3
		c0.1,0,0.1,0.1,0.2,0.1C580.1,51.5,580.3,51.4,580.5,51.2L580.5,51.2z"
      />
      <path
        class="st3"
        d="M452.3,63c-0.1-0.1-0.2-0.1-0.4-0.1c-0.1,0.1-0.2,0.2-0.2,0.3s0.1,0.2,0.2,0.3C452.1,63.3,452.2,63.1,452.3,63
		z"
      />
      <path
        class="st3"
        d="M438,48.3c-0.1,0-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3
		C438.2,48.5,438.1,48.3,438,48.3z"
      />
      <path
        class="st3"
        d="M467.2,27.5c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c0,0-0.2,0.2-0.1,0.2
		C466.9,27.3,467,27.4,467.2,27.5z"
      />
      <path
        class="st3"
        d="M382.4,106.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.2,0.2
		C382.2,106.9,382.3,106.8,382.4,106.7z"
      />
      <path
        class="st3"
        d="M531.1,47c0.1,0.1,0.3,0.1,0.4,0.1h0.1c-0.2-0.1-0.5-0.2-0.7-0.4C531,46.8,531,46.9,531.1,47z"
      />
      <path
        class="st3"
        d="M561.3,17.5c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C561.2,17.7,561.3,17.6,561.3,17.5z
		"
      />
      <path
        class="st3"
        d="M477.5,24.5c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C477.3,24.6,477.4,24.6,477.5,24.5z"
      />
      <path
        class="st3"
        d="M530.7,46.6C530.7,46.6,530.8,46.6,530.7,46.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0-0.1
		C530.8,46.6,530.8,46.6,530.7,46.6z"
      />
      <path
        class="st3"
        d="M530,46.5c0.2,0,0.5,0.1,0.7,0.1c-0.2-0.1-0.4-0.3-0.6-0.4C530.1,46.3,530.1,46.4,530,46.5z"
      />
      <path
        class="st3"
        d="M464.7,28.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C464.5,29,464.6,28.9,464.7,28.8z"
      />
      <path
        class="st3"
        d="M384.4,106.7c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.2l0.1-0.1C384.6,106.8,384.5,106.8,384.4,106.7z
		"
      />
      <path
        class="st3"
        d="M537.2,9.4c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C537.3,9.3,537.2,9.3,537.2,9.4z"
      />
      <path
        class="st3"
        d="M537.3,9.7v0.1l0,0C537.3,9.8,537.3,9.8,537.3,9.7C537.4,9.8,537.4,9.7,537.3,9.7z"
      />
      <path
        class="st3"
        d="M432.6,36.5c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C432.4,36.3,432.5,36.4,432.6,36.5z"
      />
      <path
        class="st3"
        d="M541.3,42.8c0.2-0.1,0.4-0.2,0.6-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.7,0.2
		C541.2,42.7,541.3,42.7,541.3,42.8z"
      />
      <path
        class="st3"
        d="M576.2,63.1c0,0.4,0.1,0.7,0.1,0.9C576.8,63.8,576.4,63.5,576.2,63.1z"
      />
      <path
        class="st3"
        d="M574.1,50.8c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.3,0s0,0.2-0.1,0.2C573.9,50.8,574,50.8,574.1,50.8z"
      />
      <path
        class="st3"
        d="M331.5,105.5c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1
		C331.7,105.6,331.6,105.5,331.5,105.5z"
      />
      <path
        class="st3"
        d="M430.9,69.9c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1
		C430.8,70,430.9,69.9,430.9,69.9z"
      />
      <path
        class="st3"
        d="M389.9,106.1C389.9,106.2,389.9,106.2,389.9,106.1c0.1,0.2,0.2,0.2,0.2,0.3c0.1-0.1,0.1-0.1,0.2-0.2
		c0-0.1-0.1-0.2-0.1-0.2C390.1,106,390,106.1,389.9,106.1L389.9,106.1z"
      />
      <path
        class="st3"
        d="M484.7,53.5c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.3-0.4,0.5-0.6
		C484.8,53.6,484.8,53.6,484.7,53.5z"
      />
      <path
        class="st3"
        d="M491.9,57.1c0-0.1,0-0.2-0.1-0.4c0,0-0.1,0-0.1,0.1C491.8,56.9,491.8,57,491.9,57.1z"
      />
      <path
        class="st3"
        d="M479.5,41.2c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C479.3,41.3,479.4,41.3,479.5,41.2z"
      />
      <path
        class="st3"
        d="M582.9,74c0.1,0,0.2-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.3,0.2-0.4,0.2
		C582.7,73.9,582.8,74,582.9,74z"
      />
      <path
        class="st3"
        d="M492.7,57.4c-0.2,0-0.4-0.1-0.6-0.1c0.1,0.1,0.3,0.3,0.4,0.4C492.5,57.6,492.6,57.5,492.7,57.4z"
      />
      <path
        class="st3"
        d="M492.1,57.3C492,57.3,492,57.2,492.1,57.3c-0.1-0.1-0.1-0.1-0.1-0.2v0.1C492,57.3,492,57.3,492.1,57.3z"
      />
      <path
        class="st3"
        d="M381.3,75.7c0.1,0,0.2,0,0.2-0.1v-0.1c0,0,0,0-0.1,0.1C381.4,75.6,381.3,75.6,381.3,75.7z"
      />
      <path
        class="st3"
        d="M380.8,76c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C380.7,75.9,380.7,75.9,380.8,76z"
      />
      <path
        class="st3"
        d="M495.8,50.5c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C495.8,50.8,495.8,50.6,495.8,50.5z"
      />
      <path
        class="st3"
        d="M466,46.3l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1C466.2,46,466,46.1,466,46.3
		C466,46.2,466,46.3,466,46.3z"
      />
      <path
        class="st3"
        d="M505.8,47c0,0.1,0.2,0.2,0.3,0.3c0.1-0.2,0.2-0.3,0.2-0.5c-0.1,0-0.3-0.1-0.4-0.1
		C505.8,46.8,505.7,46.9,505.8,47z"
      />
      <path
        class="st3"
        d="M555.9,46.2c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2C556,45.9,555.9,46.1,555.9,46.2
		C555.8,46.1,555.8,46.2,555.9,46.2z"
      />
      <path
        class="st3"
        d="M427,41.5c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.2,0-0.3c0-0.1-0.2,0-0.3-0.1C427.1,41.4,427,41.5,427,41.5z"
      />
      <path
        class="st3"
        d="M427,63.7c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1S426.9,63.9,427,63.7z"
      />
      <path
        class="st3"
        d="M539.7,53.8c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.3-0.4c-0.1,0.2-0.1,0.4-0.2,0.5
		C539.5,53.7,539.6,53.7,539.7,53.8z"
      />
      <path
        class="st3"
        d="M544.5,68.1c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C544.3,68.2,544.4,68.2,544.5,68.1z"
      />
      <path
        class="st3"
        d="M421.1,45.4c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1l-0.1-0.1
		C421.2,45.5,421.1,45.4,421.1,45.4z"
      />
      <path
        class="st3"
        d="M526.1,22.6c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C526.1,23,526.1,22.8,526.1,22.6z"
      />
      <path
        class="st3"
        d="M387,95.2c0.1,0,0.2,0,0.4,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C387.2,95,387.1,95.1,387,95.2z"
      />
      <path
        class="st3"
        d="M581.3,43.7c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C581.2,44,581.2,43.8,581.3,43.7z"
      />
      <path
        class="st3"
        d="M540.5,67.4c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2S540.7,67.2,540.5,67.4
		C540.6,67.2,540.6,67.3,540.5,67.4z"
      />
      <path
        class="st3"
        d="M491.7,42.7c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.3,0C491.8,43.1,491.7,42.9,491.7,42.7z"
      />
      <path
        class="st3"
        d="M472.6,36.2h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C472.5,36.4,472.6,36.3,472.6,36.2z"
      />
      <path
        class="st3"
        d="M547.4,64.9c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C547.2,64.8,547.3,64.9,547.4,64.9z"
      />
      <path
        class="st3"
        d="M577,42.2c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2C577.1,42.1,577,42.2,577,42.2
		z"
      />
      <path
        class="st3"
        d="M329.3,111.2c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.2
		c0-0.1,0-0.2-0.1-0.2C329.5,111.2,329.4,111.2,329.3,111.2z"
      />
      <path
        class="st3"
        d="M494.2,33.4c0.1,0,0.3,0.1,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0-0.2-0.1-0.3-0.1
		C494.4,33.2,494.3,33.3,494.2,33.4z"
      />
      <path
        class="st3"
        d="M594.6,38.6c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C594.4,38.5,594.5,38.6,594.6,38.6z"
      />
      <path
        class="st3"
        d="M456.7,69.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.1-0.2-0.2l0,0l0,0c0,0,0,0,0,0.1l0,0l0,0
		c-0.1,0.1-0.2,0.3-0.3,0.4l0,0C456.4,69.9,456.5,69.9,456.7,69.9z"
      />
      <path
        class="st3"
        d="M474.7,51.1c0.1,0,0.2,0,0.2-0.1c-0.1-0.2-0.2-0.3-0.2-0.5h-0.1C474.7,50.8,474.7,50.9,474.7,51.1z"
      />
      <path
        class="st3"
        d="M447,56.4c0,0,0-0.1-0.1-0.1C446.9,56.3,446.9,56.3,447,56.4C446.9,56.4,446.9,56.5,447,56.4
		C447,56.4,447,56.4,447,56.4z"
      />
      <path
        class="st3"
        d="M448,55.2c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C448.1,55.3,448.1,55.2,448,55.2z"
      />
      <path
        class="st3"
        d="M547.4,32c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C547.2,31.9,547.3,32,547.4,32z"
      />
      <path
        class="st3"
        d="M471.8,52.5c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C471.7,52.4,471.7,52.5,471.8,52.5z"
      />
      <path
        class="st3"
        d="M390.4,70.4c0,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.1s0.1-0.1,0.2-0.1L390.4,70.4z"
      />
      <path
        class="st3"
        d="M412.1,66c0.2,0,0.3,0,0.5,0h0.1c0,0,0,0-0.1-0.1C412.4,66,412.3,66,412.1,66z"
      />
      <path
        class="st3"
        d="M489.6,42.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C489.6,42.1,489.5,42.2,489.6,42.2z"
      />
      <path
        class="st3"
        d="M382.1,73.7l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C382.1,73.9,382.1,73.8,382.1,73.7z"
      />
      <path
        class="st3"
        d="M381.6,75.2c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2C381.6,75.4,381.6,75.4,381.6,75.2
		C381.6,75.3,381.6,75.2,381.6,75.2z"
      />
      <path
        class="st3"
        d="M381.3,99c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.2-0.3c-0.1,0.1-0.1,0.2-0.1,0.2C381.2,98.9,381.3,98.9,381.3,99
		z"
      />
      <path
        class="st3"
        d="M502.8,37.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C502.8,37.5,502.8,37.5,502.8,37.5z"
      />
      <path
        class="st3"
        d="M477.5,55.9h0.1C477.6,55.9,477.6,55.8,477.5,55.9C477.5,55.8,477.5,55.8,477.5,55.9
		C477.4,55.9,477.5,55.9,477.5,55.9z"
      />
      <path
        class="st3"
        d="M418.2,53.4c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.3,0
		C418.1,53.5,418.2,53.4,418.2,53.4z"
      />
      <path
        class="st3"
        d="M438.7,48c0,0,0.1,0,0.2,0c0,0,0-0.1-0.1-0.1C438.8,47.9,438.7,47.9,438.7,48C438.7,47.9,438.7,48,438.7,48z"
      />
      <path
        class="st3"
        d="M477.4,58c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C477.5,57.9,477.5,58,477.4,58z"
      />
      <path
        class="st3"
        d="M454.8,63.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C454.7,63.4,454.8,63.3,454.8,63.3L454.8,63.3z"
      />
      <path
        class="st3"
        d="M446.1,46.1c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C446.2,46.1,446.1,46.1,446.1,46.1z"
      />
      <path
        class="st3"
        d="M567.9,39.9L567.9,39.9C567.9,39.8,567.8,39.8,567.9,39.9h-0.2l0,0C567.7,40,567.8,40,567.9,39.9
		C567.9,40,567.9,40,567.9,39.9z"
      />
      <path
        class="st3"
        d="M469.4,40.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C469.5,40.3,469.4,40.4,469.4,40.4z"
      />
      <path
        class="st3"
        d="M581.2,74.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0.1C581.1,73.8,581.1,73.9,581.2,74.1z"
      />
      <path
        class="st3"
        d="M581.3,73.7C581.3,73.7,581.4,73.6,581.3,73.7C581.4,73.6,581.3,73.6,581.3,73.7
		C581.3,73.6,581.3,73.6,581.3,73.7z"
      />
      <path
        class="st3"
        d="M597.1,35C597.1,35.1,597,35.1,597.1,35c-0.1,0.2-0.1,0.3-0.1,0.3S597,35.2,597.1,35
		C597.1,35.1,597.1,35.1,597.1,35z"
      />
      <path
        class="st3"
        d="M597.2,34.7c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C597.3,34.7,597.2,34.7,597.2,34.7z"
      />
      <path
        class="st3"
        d="M336.8,92.3l-0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C336.9,92.4,336.8,92.3,336.8,92.3z"
      />
      <path
        class="st3"
        d="M579.3,73.1L579.3,73.1c0.2,0,0.2,0,0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1C579.4,72.9,579.3,73,579.3,73.1z"
      />
      <path
        class="st3"
        d="M494.3,60.1l0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1C494.2,59.9,494.2,60,494.3,60.1z"
      />
      <path
        class="st3"
        d="M428.6,48.1c0,0.1,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1
		C428.6,47.9,428.6,48,428.6,48.1z"
      />
      <path
        class="st3"
        d="M560.1,45.6c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C560.2,45.6,560.2,45.5,560.1,45.6
		C560.1,45.5,560.1,45.6,560.1,45.6z"
      />
      <path
        class="st3"
        d="M551.5,47.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0
		C551.6,47.6,551.6,47.6,551.5,47.7z"
      />
      <path
        class="st3"
        d="M383.1,110.7c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C383.3,110.7,383.2,110.7,383.1,110.7z"
      />
      <path
        class="st3"
        d="M415.8,78.5L415.8,78.5C415.8,78.5,415.8,78.6,415.8,78.5c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C416.1,78.5,416,78.5,415.8,78.5C415.9,78.5,415.9,78.5,415.8,78.5z"
      />
      <path
        class="st3"
        d="M316.1,100.5H316v0.1c0.1,0,0.1,0,0.2,0C316.2,100.6,316.2,100.6,316.1,100.5z"
      />
      <path
        class="st3"
        d="M339.8,64.1L339.8,64.1C339.8,64.2,339.9,64.2,339.8,64.1C339.9,64.2,339.8,64.1,339.8,64.1z"
      />
      <path
        class="st3"
        d="M526.3,23.3l-0.1-0.1c0,0,0,0,0-0.1v0.1C526.2,23.3,526.2,23.3,526.3,23.3z"
      />
      <path
        class="st3"
        d="M526.6,23.6c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4L526.6,23.6z"
      />
      <path
        class="st3"
        d="M377.7,87.9c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0.1
		C377.7,87.9,377.7,87.9,377.7,87.9z"
      />
      <path
        class="st3"
        d="M377.6,88h0.1c0,0,0,0,0-0.1C377.7,88,377.7,88,377.6,88L377.6,88z"
      />
      <path
        class="st3"
        d="M377.3,88.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2C377.2,88.3,377.2,88.3,377.3,88.4z"
      />
      <path
        class="st3"
        d="M554.7,15.5c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C554.8,15.6,554.8,15.5,554.7,15.5z"
      />
      <path
        class="st3"
        d="M382.9,109.9c0,0,0,0.1-0.1,0.2l0,0c0,0,0,0,0.1,0C382.9,110,382.9,109.9,382.9,109.9z"
      />
      <path
        class="st3"
        d="M534.9,76.2c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C535.1,76.3,535,76.2,534.9,76.2z"
      />
      <path
        class="st3"
        d="M534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6
		C534.6,76.5,534.7,76.5,534.7,76.6L534.7,76.6L534.7,76.6z"
      />
      <path
        class="st3"
        d="M466.3,30.5c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C466.2,30.7,466.3,30.6,466.3,30.5z"
      />
      <path
        class="st3"
        d="M333,58.6l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C333.2,58.6,333.1,58.6,333,58.6z"
      />
      <path
        class="st3"
        d="M583.5,46.9c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1,0.1C583.3,46.9,583.4,46.9,583.5,46.9
		C583.4,46.9,583.4,46.9,583.5,46.9z"
      />
      <path
        class="st3"
        d="M583.8,65.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C583.9,65.1,583.8,65.2,583.8,65.3z"
      />
      <path
        class="st3"
        d="M450.6,32.9c0,0.1,0,0.1,0,0.2c0,0,0.1,0,0.1-0.1C450.7,33,450.7,33,450.6,32.9z"
      />
      <path
        class="st3"
        d="M555.1,71c-0.2,0-0.4,0.1-0.6,0.1v0.1C554.7,71.2,554.9,71.1,555.1,71C555.1,71,555.1,71,555.1,71z"
      />
      <path
        class="st3"
        d="M333.9,58.1c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C333.8,57.9,333.8,58,333.9,58.1z"
      />
      <path
        class="st3"
        d="M333.6,57.6C333.6,57.7,333.7,57.7,333.6,57.6c0.1,0.1,0.1,0.1,0.1,0.1C333.7,57.7,333.7,57.7,333.6,57.6
		C333.7,57.7,333.7,57.7,333.6,57.6z"
      />
      <path
        class="st3"
        d="M450.4,31.8l-0.1-0.1l-0.1,0.1l0.1,0.1C450.4,31.8,450.4,31.8,450.4,31.8z"
      />
      <path
        class="st3"
        d="M317.5,121.2c0,0,0.1,0,0.1-0.1V121c-0.1,0-0.1,0.1-0.2,0.1C317.4,121.1,317.4,121.2,317.5,121.2z"
      />
      <path
        class="st3"
        d="M402.8,40.6c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C402.7,40.6,402.7,40.6,402.8,40.6z"
      />
      <path
        class="st3"
        d="M402.5,40.4L402.5,40.4l-0.1-0.1C402.4,40.3,402.4,40.3,402.5,40.4C402.5,40.3,402.5,40.4,402.5,40.4z"
      />
      <path
        class="st3"
        d="M479.1,22.8c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C479,22.9,479,22.8,479.1,22.8z"
      />
      <path
        class="st3"
        d="M375.1,107.2L375.1,107.2c0,0.1,0,0.2,0.1,0.2v-0.1C375.2,107.3,375.2,107.3,375.1,107.2z"
      />
      <path
        class="st3"
        d="M576,62.8C576,62.8,576,62.7,576,62.8C576,62.7,575.9,62.7,576,62.8C575.9,62.7,575.9,62.7,576,62.8L576,62.8z
		"
      />
      <path
        class="st3"
        d="M426,33.8c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3L426,33.8z"
      />
      <path
        class="st3"
        d="M534.7,61.3c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1S534.6,61.4,534.7,61.3z"
      />
      <path
        class="st3"
        d="M550.4,67.6c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.1,0.1c0-0.1,0.1-0.1,0.1-0.2C550.6,67.7,550.5,67.7,550.4,67.6
		z"
      />
      <path
        class="st3"
        d="M463.7,77.4C463.7,77.3,463.7,77.4,463.7,77.4c-0.1,0.1,0,0.2,0,0.2l0.1-0.1C463.8,77.4,463.7,77.4,463.7,77.4
		z"
      />
      <path
        class="st3"
        d="M549.4,58.9C549.4,58.9,549.3,58.9,549.4,58.9c-0.1,0.1,0,0.1,0,0.2l0.1-0.1C549.4,58.9,549.4,58.9,549.4,58.9
		z"
      />
      <path
        class="st3"
        d="M574.4,53.4c0,0.1,0.1,0.1,0.2,0.2v-0.1C574.6,53.4,574.5,53.4,574.4,53.4C574.5,53.4,574.4,53.4,574.4,53.4z"
      />
      <path
        class="st3"
        d="M546,60.3L546,60.3c-0.1,0-0.2,0.1-0.2,0.2c0,0,0.1,0,0.1,0.1C545.9,60.4,546,60.3,546,60.3z"
      />
      <path
        class="st3"
        d="M592.2,57.7c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C592.2,57.4,592.1,57.5,592.2,57.7
		C592.1,57.6,592.2,57.6,592.2,57.7z"
      />
      <path
        class="st3"
        d="M413.3,30.1l-0.1-0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C413.1,30.1,413.2,30.1,413.3,30.1z"
      />
      <path
        class="st3"
        d="M386.1,101.7l-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.1l0.1,0.1C385.9,101.8,386,101.7,386.1,101.7z"
      />
      <path
        class="st3"
        d="M489.7,6.9C489.6,6.9,489.6,6.9,489.7,6.9c-0.1,0.1-0.1,0.2-0.1,0.2C489.7,7.1,489.7,7.1,489.7,6.9L489.7,6.9z
		"
      />
      <path
        class="st3"
        d="M332.5,107.6C332.5,107.5,332.6,107.5,332.5,107.6C332.6,107.5,332.5,107.5,332.5,107.6c0-0.2-0.1-0.2-0.1-0.2
		l-0.1,0.1C332.4,107.5,332.4,107.5,332.5,107.6L332.5,107.6z"
      />
      <path
        class="st3"
        d="M461,7.8c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C460.9,8,460.9,7.9,461,7.8z"
      />
      <path
        class="st3"
        d="M371.4,22.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.1,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C371.4,22.4,371.4,22.3,371.4,22.2z"
      />
      <path
        class="st3"
        d="M320.5,110.3c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C320.4,110.4,320.4,110.4,320.5,110.3z"
      />
      <path
        class="st3"
        d="M324.4,109.6c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1C324.5,109.4,324.4,109.4,324.4,109.6L324.4,109.6z"
      />
      <path
        class="st3"
        d="M445.9,83.5c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0-0.2,0-0.3,0.1C445.9,83.4,445.9,83.4,445.9,83.5z"
      />
      <path
        class="st3"
        d="M308.3,140.4c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0C308.2,140.6,308.2,140.5,308.3,140.4z"
      />
      <path
        class="st3"
        d="M583.7,74.2L583.7,74.2h-0.2H583.7C583.6,74.3,583.7,74.3,583.7,74.2z"
      />
      <path
        class="st3"
        d="M306.5,133.2v0.1V133.2C306.6,133.2,306.6,133.1,306.5,133.2C306.6,133.1,306.5,133.1,306.5,133.2z"
      />
      <path
        class="st3"
        d="M306.7,132.9c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C306.8,132.9,306.7,132.9,306.7,132.9z"
      />
      <path
        class="st3"
        d="M589.7,67.8C589.7,67.8,589.6,67.8,589.7,67.8L589.7,67.8L589.7,67.8C589.6,67.8,589.7,67.8,589.7,67.8z"
      />
      <path
        class="st3"
        d="M560.9,73.2L560.9,73.2C560.8,73.3,560.8,73.3,560.9,73.2C560.8,73.3,560.8,73.3,560.9,73.2z"
      />
      <path
        class="st3"
        d="M376.5,112C376.6,112,376.6,111.9,376.5,112c0.1-0.1,0-0.2,0-0.2C376.5,111.9,376.4,111.9,376.5,112
		C376.4,112,376.5,112,376.5,112z"
      />
      <path
        class="st3"
        d="M383.9,109.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C384,109.6,383.9,109.6,383.9,109.7z"
      />
      <path
        class="st3"
        d="M586.7,64.7c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.3l0,0C586.9,64.6,586.8,64.7,586.7,64.7z"
      />
      <path
        class="st3"
        d="M555.6,71.6L555.6,71.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0,0C555.7,71.6,555.6,71.6,555.6,71.6z"
      />
      <path
        class="st3"
        d="M587,64.6L587,64.6c0-0.1,0.1-0.2,0.1-0.3C587.1,64.4,587,64.5,587,64.6z"
      />
      <polygon class="st3" points="579.7,63.5 579.8,63.5 579.7,63.4 	" />
      <path
        class="st3"
        d="M576.1,64.3c0-0.1,0.1-0.2,0.1-0.2l0,0l0,0C576.2,64.2,576.2,64.2,576.1,64.3z"
      />
      <path
        class="st3"
        d="M385.5,104.8c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C385.7,104.8,385.6,104.8,385.5,104.8z"
      />
      <path
        class="st3"
        d="M385.4,104.7C385.5,104.8,385.5,104.8,385.4,104.7C385.5,104.8,385.5,104.8,385.4,104.7
		C385.5,104.8,385.5,104.8,385.4,104.7C385.5,104.8,385.5,104.8,385.4,104.7z"
      />
      <path
        class="st3"
        d="M385.3,104.7c0.1,0,0.1,0,0.2,0.1v-0.1C385.4,104.7,385.3,104.7,385.3,104.7z"
      />
      <path
        class="st3"
        d="M314.4,119.8h0.1l0.1-0.1l-0.1-0.1C314.5,119.7,314.5,119.7,314.4,119.8z"
      />
      <path
        class="st3"
        d="M579.5,61.8C579.5,61.8,579.5,61.9,579.5,61.8C579.5,61.9,579.6,61.9,579.5,61.8
		C579.6,61.8,579.6,61.7,579.5,61.8C579.6,61.7,579.6,61.8,579.5,61.8z"
      />
      <polygon class="st3" points="576.8,62 576.8,61.9 576.7,62 	" />
      <path
        class="st3"
        d="M389.8,99.6C389.7,99.5,389.7,99.5,389.8,99.6c-0.1-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1
		C389.7,99.5,389.7,99.5,389.8,99.6z"
      />
      <path
        class="st3"
        d="M389.6,99.3c-0.1,0-0.1,0.1-0.1,0.1l0,0l0,0c0.1,0,0.1,0,0.2,0C389.6,99.4,389.6,99.4,389.6,99.3z"
      />
      <polygon class="st3" points="372.4,103.1 372.4,103 372.3,103.1 	" />
      <polygon class="st3" points="338.7,108.3 338.7,108.2 338.6,108.2 	" />
      <path
        class="st3"
        d="M539.2,64c0,0.1,0,0.2-0.1,0.2C539.1,64.1,539.2,64.1,539.2,64c0.1-0.1,0.1-0.1,0.1-0.2
		C539.3,63.8,539.2,63.9,539.2,64z"
      />
      <polygon class="st3" points="335,105.3 335.1,105.2 335,105.2 	" />
      <polygon class="st3" points="394,92.2 394,92.1 393.9,92.1 	" />
      <polygon class="st3" points="459.4,77.3 459.5,77.3 459.5,77.2 	" />
      <path
        class="st3"
        d="M580.7,49.8c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C580.6,49.9,580.6,49.9,580.7,49.8z"
      />
      <path
        class="st3"
        d="M548.8,56.8c0.1,0,0.1,0,0.2,0C548.9,56.8,548.9,56.7,548.8,56.8C548.9,56.7,548.9,56.7,548.8,56.8z"
      />
      <path
        class="st3"
        d="M392.1,90.5l-0.1,0.1c0.1,0,0.2,0,0.3,0.1C392.2,90.7,392.2,90.6,392.1,90.5z"
      />
      <path
        class="st3"
        d="M408.1,86.8c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C408,87,408.1,86.9,408.1,86.8z"
      />
      <path
        class="st3"
        d="M541.5,56.4c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1,0-0.2C541.6,56.3,541.6,56.4,541.5,56.4z"
      />
      <polygon class="st3" points="462,73.6 462.1,73.7 462.1,73.6 	" />
      <polygon class="st3" points="548.7,54.6 548.8,54.5 548.8,54.5 	" />
      <path
        class="st3"
        d="M541.8,56c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1l0,0C541.8,56.1,541.8,56.1,541.8,56z"
      />
      <path
        class="st3"
        d="M381.9,90.4l-0.1-0.1l-0.1,0.1l0.1,0.1C381.8,90.4,381.9,90.4,381.9,90.4z"
      />
      <path
        class="st3"
        d="M596.5,36.3c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C596.4,36.4,596.4,36.4,596.5,36.3z"
      />
      <path
        class="st3"
        d="M493.1,57c0-0.1,0.1-0.2,0.1-0.3C493.1,56.9,493.1,56.9,493.1,57c-0.2,0.1-0.3,0.2-0.4,0.3l0,0c0,0,0,0,0.1,0
		C492.8,57.3,493,57.2,493.1,57z"
      />
      <path
        class="st3"
        d="M484.6,58.7c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1L484.6,58.7z"
      />
      <polygon class="st3" points="409.5,74 409.5,74.1 409.6,74 	" />
      <path
        class="st3"
        d="M488.8,55.6c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C488.7,55.7,488.8,55.6,488.8,55.6z"
      />
      <path
        class="st3"
        d="M444.4,65.1C444.4,65.1,444.4,65,444.4,65.1c0-0.1-0.1-0.1-0.1-0.1S444.4,65,444.4,65.1z"
      />
      <path
        class="st3"
        d="M514.7,46.3C514.7,46.3,514.6,46.3,514.7,46.3c-0.1,0-0.1,0-0.1,0.1C514.6,46.3,514.6,46.3,514.7,46.3z"
      />
      <path
        class="st3"
        d="M380.5,75.2l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1C380.5,75.2,380.5,75.2,380.5,75.2z"
      />
      <path
        class="st3"
        d="M380.7,75.1L380.7,75.1c0.1,0,0.1-0.1,0.1-0.1C380.7,75,380.7,75,380.7,75.1z"
      />
      <path
        class="st3"
        d="M514.1,45.8L514.1,45.8c0.1-0.1,0-0.1,0-0.2V45.8C514,45.8,514,45.8,514.1,45.8z"
      />
      <polygon class="st3" points="549,36 548.9,36 548.9,36.1 	" />
      <path
        class="st3"
        d="M400.5,67.8C400.5,67.8,400.4,67.9,400.5,67.8l0.1,0.2c0-0.1,0-0.1,0-0.2C400.6,67.7,400.5,67.8,400.5,67.8z"
      />
      <polygon class="st3" points="333.4,82.3 333.4,82.4 333.6,82.4 	" />
      <polygon class="st3" points="548.5,35.5 548.4,35.4 548.4,35.5 	" />
      <polygon class="st3" points="433.3,57 433.4,57 433.3,56.9 	" />
      <path
        class="st3"
        d="M434.7,49.5h0.1l0.1-0.1l-0.1-0.1C434.7,49.4,434.7,49.5,434.7,49.5z"
      />
      <path
        class="st3"
        d="M575.6,17.6c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C575.6,17.8,575.6,17.7,575.6,17.6z"
      />
      <polygon
        class="st3"
        points="533.2,26.6 533.2,26.5 533.2,26.5 533.1,26.5 533.1,26.5 	"
      />
      <polygon class="st3" points="438.4,47 438.3,47.1 438.4,47.1 	" />
      <path
        class="st3"
        d="M501.4,32.7c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C501.4,32.8,501.4,32.7,501.4,32.7z"
      />
      <path
        class="st3"
        d="M501.2,33L501.2,33c-0.1,0.1-0.1,0.2-0.1,0.3C501.2,33.2,501.2,33.1,501.2,33L501.2,33z"
      />
      <polygon class="st3" points="445.9,44.9 446,44.8 446,44.8 	" />
      <polygon class="st3" points="548.7,22.2 548.6,22.2 548.7,22.3 	" />
      <polygon class="st3" points="532.7,25.7 532.6,25.8 532.7,25.8 	" />
      <path
        class="st3"
        d="M434.3,47L434.3,47C434.3,46.9,434.3,46.9,434.3,47C434.2,47,434.3,47,434.3,47z"
      />
      <path
        class="st3"
        d="M421.4,49.6l0.1-0.1l-0.1-0.1l-0.1,0.1C421.3,49.6,421.4,49.6,421.4,49.6z"
      />
      <polygon
        class="st3"
        points="308.8,73.9 308.8,73.9 308.7,73.9 308.8,74 308.8,74 	"
      />
      <path
        class="st3"
        d="M575.8,12.9c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C575.7,13,575.7,13,575.8,12.9z"
      />
      <path
        class="st3"
        d="M376.5,53.5h-0.1v0.1l0.1,0.1C376.5,53.7,376.5,53.6,376.5,53.5z"
      />
      <path
        class="st3"
        d="M412.6,42.9c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C412.7,42.8,412.7,42.9,412.6,42.9z"
      />
      <path class="st3" d="M465.4,30.3l-0.1-0.1l-0.1,0.1l0.1,0.1L465.4,30.3z" />
      <polygon class="st3" points="427.4,38.1 427.3,38.3 427.4,38.2 	" />
      <polygon class="st3" points="445.3,33.7 445.5,33.7 445.4,33.6 	" />
      <path
        class="st3"
        d="M463.2,29.1l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C463.2,29.2,463.2,29.2,463.2,29.1z"
      />
      <path
        class="st3"
        d="M402.2,40.2L402.2,40.2c0.1,0.1,0.1,0.1,0.2,0.1C402.3,40.2,402.3,40.2,402.2,40.2z"
      />
      <path
        class="st3"
        d="M462,25.3l0.1-0.1v-0.1l-0.1,0.1C462.1,25.2,462,25.3,462,25.3z"
      />
      <polygon class="st3" points="440.8,29.9 440.8,30 440.9,30 	" />
      <path
        class="st3"
        d="M524.3,179.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C524.5,179.7,524.4,179.7,524.3,179.8z"
      />
      <path
        class="st3"
        d="M546.1,163.8c0,0-0.1,0-0.1-0.1l0,0l0,0C546,163.8,546,163.8,546.1,163.8z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "SoccerCover_c2",
  props: ["fill"],
};
</script>
